/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ForwardRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(791);
var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgSsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50 8.72815C50 5.42498 50.0243 2.98979 48.7353 1.56727C48.03 0.77157 47.0328 0.14462 45.3789 0.14462H40.9769V17.3116H45.3789C47.0328 17.3116 48.03 16.6847 48.7353 15.8891C50.0243 14.4664 50 12.0313 50 8.72814V8.72815ZM47.276 8.70398C47.276 11.6938 47.203 13.3815 46.6923 14.1771C46.4248 14.587 45.9628 14.8764 45.3061 14.8764H43.701V2.57988H45.3061C45.9628 2.57988 46.4248 2.86921 46.6923 3.27911C47.203 4.07475 47.276 5.71431 47.276 8.70398ZM41.6538 23.6529C40.8052 24.4709 40.5515 25.6077 40.5368 27.2797L40.5353 27.9624C40.5353 30.0386 41.3686 31.1811 42.9543 31.8265L44.0083 32.2506L44.0188 32.2547L45.3136 32.7666C46.2964 33.1507 46.7843 33.8152 46.7857 34.6546V35.1765C46.7857 35.1769 46.7857 35.1775 46.7857 35.1779C46.7857 36.0941 46.6885 36.6728 46.3236 37.0827C46.0561 37.396 45.6427 37.5649 45.0104 37.5649C44.4022 37.5649 43.9888 37.3719 43.7456 37.1067C43.3565 36.6728 43.2592 36.0941 43.2592 35.1779H40.5353C40.5353 36.9861 40.8271 38.0471 41.654 38.8668C42.3836 39.5901 43.5024 40 45.0104 40C46.5424 40 47.6857 39.542 48.3909 38.8668C49.2396 38.0488 49.4934 36.912 49.5081 35.24L49.5095 34.5259C49.5095 32.4497 48.6763 31.3387 47.0906 30.6932L46.0364 30.2691L46.0259 30.265L44.7312 29.753C43.7485 29.369 43.2606 28.6731 43.259 27.8337V27.3432C43.259 27.3427 43.2592 27.3423 43.2592 27.3418C43.2592 26.4256 43.3563 25.847 43.7212 25.4371C43.9888 25.1236 44.4022 24.9548 45.0345 24.9548C45.6427 24.9548 46.0561 25.1478 46.2991 25.413C46.6884 25.847 46.7857 26.4256 46.7857 27.3418H49.5095C49.5095 25.5335 49.2177 24.4726 48.3908 23.6529C47.6612 22.9295 46.5424 22.5197 45.0345 22.5197C43.5024 22.5197 42.3592 22.9778 41.6538 23.6529ZM33.472 39.8095H36.1991V22.6425H33.472V29.9629L33.3724 29.9737L29.7054 22.6425H26.957L31.1205 31.226L26.957 39.8095H29.7054L33.3724 32.4782L33.472 32.4891V39.8095ZM33.7914 17.3116H36.1991V0.14463H33.4752V10.3436L29.4135 0.14463H26.9815V17.3116H29.7055V7.11272L33.7914 17.3116ZM21.1409 39.8095H24.1565L20.8002 29.3694V22.6425H18.0763V29.3694L14.7199 39.8095H17.7114L19.4383 33.0102L21.1409 39.8095ZM20.342 17.3116H23.1875L18.9802 0.14463H16.3291L12.0729 17.3116H14.9428L15.6238 13.912H19.6367L20.342 17.3116ZM19.126 11.4768H16.1589L17.6423 4.29173L19.126 11.4768ZM11.46 39.8038L9.15811 36.1475C9.87035 34.89 10.4609 33.0178 10.6271 31.2259H8.36169C8.25146 32.1904 8.02567 33.1502 7.69778 33.841L5.59396 30.6264C6.97997 29.2033 7.84629 27.8782 7.84629 25.817C7.84629 23.7804 6.68293 22.1609 4.28208 22.1609C2.32659 22.1609 0.76723 23.4859 0.76723 26.0624C0.76723 27.5347 1.4851 28.7125 2.62363 30.234C0.94046 31.927 0 33.522 0 35.5096C0 38.3069 1.73259 40 4.13363 40C5.74241 40 6.78203 39.3374 7.74739 38.2578L8.71262 39.8038H11.46ZM5.49486 25.8661C5.49486 27.0438 5.07408 27.6819 4.28208 28.5408C3.53943 27.5593 3.11878 26.7249 3.11878 25.9643C3.11878 25.0563 3.56433 24.4921 4.30679 24.4921C4.97499 24.4921 5.49486 25.0317 5.49486 25.8661ZM6.46029 36.2702C5.81667 37.1781 5.14841 37.6689 4.35628 37.6689C3.2424 37.6689 2.4504 36.7119 2.4504 35.3377C2.4504 34.3564 2.89601 33.3748 3.91073 32.3442L6.46029 36.2702ZM2.79858 5.31399V4.82355C2.79858 4.82304 2.79864 4.82266 2.79864 4.8221C2.79864 3.90595 2.89582 3.3273 3.26071 2.91733C3.5283 2.60402 3.94184 2.43514 4.57406 2.43514C5.18221 2.43514 5.59562 2.62806 5.83869 2.89327C6.22791 3.32729 6.32521 3.90595 6.32521 4.82209H9.04915C9.04915 3.01385 8.7573 1.95287 7.93034 1.13319C7.20075 0.40977 6.08195 0 4.57405 0C3.04189 0 1.8987 0.45807 1.19337 1.13319C0.34471 1.95116 0.09102 3.0881 0.07623 4.76002L0.07476 5.44269C0.07476 7.519 0.90812 8.66139 2.49379 9.30688L3.54794 9.73087L3.55837 9.735L4.85316 10.247C5.83587 10.6311 6.3238 11.2955 6.32527 12.1349V12.6567C6.32527 12.6573 6.32521 12.6577 6.32521 12.6582C6.32521 13.5744 6.22803 14.1531 5.86314 14.563C5.59562 14.8764 5.1822 15.0452 4.54992 15.0452C3.94183 15.0452 3.52829 14.8523 3.28516 14.587C2.89607 14.1531 2.79864 13.5744 2.79864 12.6582H0.07477C0.07477 14.4664 0.36662 15.5274 1.19358 16.3471C1.92317 17.0705 3.04191 17.4803 4.54993 17.4803C6.08196 17.4803 7.22528 17.0223 7.93054 16.3471C8.7792 15.5291 9.03289 14.3922 9.04768 12.7203L9.04915 12.0063C9.04915 9.92994 8.21573 8.81895 6.63005 8.17348L5.57597 7.74949L5.56547 7.74536L4.27069 7.23334C3.28811 6.84927 2.80012 6.1534 2.79858 5.31398V5.31399Z",
    fill: "#FF6F8D"
  })));
}

var ForwardRef = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(SvgSsLogo);
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (__webpack_require__.p + "static/media/ss-logo.73eb6fc1e4934d9d2aafe2a25b029915.svg");


/***/ }),

/***/ 644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _assets_ss_logo_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(683);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(184);
var Footer=function Footer(){var amazonLp=window.location.pathname==='/range-amazon'||window.location.pathname==='/range-amazon/';return/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("footer",{className:"pt-4 pt-lg-4 ",children:/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div",{className:"container px-g",children:[!amazonLp&&/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment,{children:[/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a",{className:"navbar-brand mx-auto text-secondary mb-1 d-block text-center",href:"https://www.sandandsky.com",children:/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_assets_ss_logo_svg__WEBPACK_IMPORTED_MODULE_0__/* .ReactComponent */ .r,{})}),/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small",{className:"text-center d-block mb-5",children:"*Everyone\u2019s skin is different and results may vary from person to person"}),/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small",{className:"text-center d-block",children:"Sand & Sky respectfully acknowledges the Traditional Owners of the land on which we operate, the Boon Wurrung and Woiwurrung (Wurundjeri) peoples of the Kulin Nation, and their connections to land, sea and community. We pay our respect to their elders past, present and future extend that respect to all Aboriginal and Torres Strait Islander peoples today."})]}),/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("hr",{}),amazonLp&&/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("small",{className:"text-center d-block  mb-5 mb-lg-3",children:["\xA9 ",new Date().getFullYear()," Sand&Sky"]}),!amazonLp&&/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("small",{className:"text-center d-block  mb-5 mb-lg-3",children:["\xA9 ",new Date().getFullYear()," Sand&Sky | ",/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a",{href:"https://www.sandandsky.com/pages/term-condition",children:"Terms and Conditions"})," |",/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br",{className:"d-block d-lg-none"})," All rights reserved"]})]})});};/* harmony default export */ __webpack_exports__["default"] = (Footer);

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

/* unused harmony export Carousel */
/* harmony import */ var _Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(413);
/* harmony import */ var _Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(340);
/* harmony import */ var _Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_createSuper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(876);
/* harmony import */ var _Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(942);
/* harmony import */ var _Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(982);
/* harmony import */ var _Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(671);
/* harmony import */ var _Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(144);
/* harmony import */ var _Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(885);
/* module decorator */ module = __webpack_require__.hmd(module);
/*!
  * Bootstrap v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */var _require=__webpack_require__(651),Carousel=_require.Carousel;(function(global,factory){// eslint-disable-next-line no-unused-expressions
typeof exports==='object'&&"object"!=='undefined'?module.exports=factory():// eslint-disable-next-line no-undef
typeof define==='function'&&__webpack_require__.amdO?define(factory):(// eslint-disable-next-line no-restricted-globals, no-undef
global=typeof globalThis!=='undefined'?globalThis:global||self,global.bootstrap=factory());})(undefined,function(){'use strict';/**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */var _KEY_TO_DIRECTION;var MAX_UID=1000000;var MILLISECONDS_MULTIPLIER=1000;var TRANSITION_END='transitionend';// Shoutout AngusCroll (https://goo.gl/pxwQGp)
var toType=function toType(obj){if(obj===null||obj===undefined){return"".concat(obj);}return{}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();};/**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */var getSelector=function getSelector(element){var selector=element.getAttribute('data-bs-target');if(!selector||selector==='#'){var hrefAttr=element.getAttribute('href');// The only valid content that could double as a selector are IDs or classes,
// so everything starting with `#` or `.`. If a "real" URL is used as the selector,
// `document.querySelector` will rightfully complain it is invalid.
// See https://github.com/twbs/bootstrap/issues/32273
if(!hrefAttr||!hrefAttr.includes('#')&&!hrefAttr.startsWith('.')){return null;}// Just in case some CMS puts out a full URL with the anchor appended
if(hrefAttr.includes('#')&&!hrefAttr.startsWith('#')){hrefAttr="#".concat(hrefAttr.split('#')[1]);}selector=hrefAttr&&hrefAttr!=='#'?hrefAttr.trim():null;}return selector;};var getSelectorFromElement=function getSelectorFromElement(element){var selector=getSelector(element);if(selector){return document.querySelector(selector)?selector:null;}return null;};var getElementFromSelector=function getElementFromSelector(element){var selector=getSelector(element);return selector?document.querySelector(selector):null;};var getTransitionDurationFromElement=function getTransitionDurationFromElement(element){if(!element){return 0;}// Get transition-duration of the element
var _window$getComputedSt=window.getComputedStyle(element),transitionDuration=_window$getComputedSt.transitionDuration,transitionDelay=_window$getComputedSt.transitionDelay;var floatTransitionDuration=Number.parseFloat(transitionDuration);var floatTransitionDelay=Number.parseFloat(transitionDelay);// Return 0 if element or transition duration is not found
if(!floatTransitionDuration&&!floatTransitionDelay){return 0;}// If multiple durations are defined, take the first
transitionDuration=transitionDuration.split(',')[0];transitionDelay=transitionDelay.split(',')[0];return(Number.parseFloat(transitionDuration)+Number.parseFloat(transitionDelay))*MILLISECONDS_MULTIPLIER;};var triggerTransitionEnd=function triggerTransitionEnd(element){element.dispatchEvent(new Event(TRANSITION_END));};var isElement$1=function isElement$1(obj){if(!obj||typeof obj!=='object'){return false;}if(typeof obj.jquery!=='undefined'){obj=obj[0];}return typeof obj.nodeType!=='undefined';};var getElement=function getElement(obj){if(isElement$1(obj)){// it's a jQuery object or a node element
return obj.jquery?obj[0]:obj;}if(typeof obj==='string'&&obj.length>0){return document.querySelector(obj);}return null;};var typeCheckConfig=function typeCheckConfig(componentName,config,configTypes){Object.keys(configTypes).forEach(function(property){var expectedTypes=configTypes[property];var value=config[property];var valueType=value&&isElement$1(value)?'element':toType(value);if(!new RegExp(expectedTypes).test(valueType)){throw new TypeError("".concat(componentName.toUpperCase(),": Option \"").concat(property,"\" provided type \"").concat(valueType,"\" but expected type \"").concat(expectedTypes,"\"."));}});};var isVisible=function isVisible(element){if(!isElement$1(element)||element.getClientRects().length===0){return false;}return getComputedStyle(element).getPropertyValue('visibility')==='visible';};var isDisabled=function isDisabled(element){if(!element||element.nodeType!==Node.ELEMENT_NODE){return true;}if(element.classList.contains('disabled')){return true;}if(typeof element.disabled!=='undefined'){return element.disabled;}return element.hasAttribute('disabled')&&element.getAttribute('disabled')!=='false';};var noop=function noop(){};/**
   * Trick to restart an element's animation
   *
   * @param {HTMLElement} element
   * @return void
   *
   * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
   */var reflow=function reflow(element){// eslint-disable-next-line no-unused-expressions
element.offsetHeight;};var getjQuery=function getjQuery(){var _window=window,jQuery=_window.jQuery;if(jQuery&&!document.body.hasAttribute('data-bs-no-jquery')){return jQuery;}return null;};var DOMContentLoadedCallbacks=[];var onDOMContentLoaded=function onDOMContentLoaded(callback){if(document.readyState==='loading'){// add listener on the first call when the document is in loading state
if(!DOMContentLoadedCallbacks.length){document.addEventListener('DOMContentLoaded',function(){DOMContentLoadedCallbacks.forEach(function(callback){return callback();});});}DOMContentLoadedCallbacks.push(callback);}else{callback();}};var isRTL=function isRTL(){return document.documentElement.dir==='rtl';};var defineJQueryPlugin=function defineJQueryPlugin(plugin){onDOMContentLoaded(function(){var $=getjQuery();/* istanbul ignore if */if($){var name=plugin.NAME;var JQUERY_NO_CONFLICT=$.fn[name];$.fn[name]=plugin.jQueryInterface;$.fn[name].Constructor=plugin;$.fn[name].noConflict=function(){$.fn[name]=JQUERY_NO_CONFLICT;return plugin.jQueryInterface;};}});};var execute=function execute(callback){if(typeof callback==='function'){callback();}};var executeAfterTransition=function executeAfterTransition(callback,transitionElement){var waitForTransition=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;if(!waitForTransition){execute(callback);return;}var durationPadding=5;var emulatedDuration=getTransitionDurationFromElement(transitionElement)+durationPadding;var called=false;var handler=function handler(_ref5){var target=_ref5.target;if(target!==transitionElement){return;}called=true;transitionElement.removeEventListener(TRANSITION_END,handler);execute(callback);};transitionElement.addEventListener(TRANSITION_END,handler);setTimeout(function(){if(!called){triggerTransitionEnd(transitionElement);}},emulatedDuration);};/**
   * Return the previous/next element of a list.
   *
   * @param {array} list    The list of elements
   * @param activeElement   The active element
   * @param shouldGetNext   Choose to get next or previous element
   * @param isCycleAllowed
   * @return {Element|elem} The proper element
   */var getNextActiveElement=function getNextActiveElement(list,activeElement,shouldGetNext,isCycleAllowed){var index=list.indexOf(activeElement);// if the element does not exist in the list return an element depending on the direction and if cycle is allowed
if(index===-1){return list[!shouldGetNext&&isCycleAllowed?list.length-1:0];}var listLength=list.length;index+=shouldGetNext?1:-1;if(isCycleAllowed){index=(index+listLength)%listLength;}return list[Math.max(0,Math.min(index,listLength-1))];};/**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): dom/event-handler.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */var namespaceRegex=/[^.]*(?=\..*)\.|.*/;var stripNameRegex=/\..*/;var stripUidRegex=/::\d+$/;var eventRegistry={};// Events storage
var uidEvent=1;var customEvents={mouseenter:'mouseover',mouseleave:'mouseout'};var customEventsRegex=/^(mouseenter|mouseleave)/i;var nativeEvents=new Set(['click','dblclick','mouseup','mousedown','contextmenu','mousewheel','DOMMouseScroll','mouseover','mouseout','mousemove','selectstart','selectend','keydown','keypress','keyup','orientationchange','touchstart','touchmove','touchend','touchcancel','pointerdown','pointermove','pointerup','pointerleave','pointercancel','gesturestart','gesturechange','gestureend','focus','blur','change','reset','select','submit','focusin','focusout','load','unload','beforeunload','resize','move','DOMContentLoaded','readystatechange','error','abort','scroll']);/**
   * ------------------------------------------------------------------------
   * Private methods
   * ------------------------------------------------------------------------
   */function getUidEvent(element,uid){return uid&&"".concat(uid,"::").concat(uidEvent++)||element.uidEvent||uidEvent++;}function getEvent(element){var uid=getUidEvent(element);element.uidEvent=uid;eventRegistry[uid]=eventRegistry[uid]||{};return eventRegistry[uid];}function bootstrapHandler(element,fn){return function handler(event){event.delegateTarget=element;if(handler.oneOff){EventHandler.off(element,event.type,fn);}return fn.apply(element,[event]);};}function bootstrapDelegationHandler(element,selector,fn){return function handler(event){var domElements=element.querySelectorAll(selector);for(var target=event.target;target&&target!==this;target=target.parentNode){for(var i=domElements.length;i--;){if(domElements[i]===target){event.delegateTarget=target;if(handler.oneOff){EventHandler.off(element,event.type,selector,fn);}return fn.apply(target,[event]);}}}// To please ESLint
return null;};}function findHandler(events,handler){var delegationSelector=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var uidEventList=Object.keys(events);for(var i=0,len=uidEventList.length;i<len;i++){var event=events[uidEventList[i]];if(event.originalHandler===handler&&event.delegationSelector===delegationSelector){return event;}}return null;}function normalizeParams(originalTypeEvent,handler,delegationFn){var delegation=typeof handler==='string';var originalHandler=delegation?delegationFn:handler;var typeEvent=getTypeEvent(originalTypeEvent);var isNative=nativeEvents.has(typeEvent);if(!isNative){typeEvent=originalTypeEvent;}return[delegation,originalHandler,typeEvent];}function addHandler(element,originalTypeEvent,handler,delegationFn,oneOff){if(typeof originalTypeEvent!=='string'||!element){return;}if(!handler){handler=delegationFn;delegationFn=null;}// in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
// this prevents the handler from being dispatched the same way as mouseover or mouseout does
if(customEventsRegex.test(originalTypeEvent)){var wrapFn=function wrapFn(fn){return function(event){if(!event.relatedTarget||event.relatedTarget!==event.delegateTarget&&!event.delegateTarget.contains(event.relatedTarget)){return fn.call(this,event);}};};if(delegationFn){delegationFn=wrapFn(delegationFn);}else{handler=wrapFn(handler);}}var _normalizeParams=normalizeParams(originalTypeEvent,handler,delegationFn),_normalizeParams2=(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_normalizeParams,3),delegation=_normalizeParams2[0],originalHandler=_normalizeParams2[1],typeEvent=_normalizeParams2[2];var events=getEvent(element);var handlers=events[typeEvent]||(events[typeEvent]={});var previousFn=findHandler(handlers,originalHandler,delegation?handler:null);if(previousFn){previousFn.oneOff=previousFn.oneOff&&oneOff;return;}var uid=getUidEvent(originalHandler,originalTypeEvent.replace(namespaceRegex,''));var fn=delegation?bootstrapDelegationHandler(element,handler,delegationFn):bootstrapHandler(element,handler);fn.delegationSelector=delegation?handler:null;fn.originalHandler=originalHandler;fn.oneOff=oneOff;fn.uidEvent=uid;handlers[uid]=fn;element.addEventListener(typeEvent,fn,delegation);}function removeHandler(element,events,typeEvent,handler,delegationSelector){var fn=findHandler(events[typeEvent],handler,delegationSelector);if(!fn){return;}element.removeEventListener(typeEvent,fn,Boolean(delegationSelector));delete events[typeEvent][fn.uidEvent];}function removeNamespacedHandlers(element,events,typeEvent,namespace){var storeElementEvent=events[typeEvent]||{};Object.keys(storeElementEvent).forEach(function(handlerKey){if(handlerKey.includes(namespace)){var event=storeElementEvent[handlerKey];removeHandler(element,events,typeEvent,event.originalHandler,event.delegationSelector);}});}function getTypeEvent(event){// allow to get the native events from namespaced events ('click.bs.button' --> 'click')
event=event.replace(stripNameRegex,'');return customEvents[event]||event;}var EventHandler={on:function on(element,event,handler,delegationFn){addHandler(element,event,handler,delegationFn,false);},one:function one(element,event,handler,delegationFn){addHandler(element,event,handler,delegationFn,true);},off:function off(element,originalTypeEvent,handler,delegationFn){if(typeof originalTypeEvent!=='string'||!element){return;}var _normalizeParams3=normalizeParams(originalTypeEvent,handler,delegationFn),_normalizeParams4=(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_normalizeParams3,3),delegation=_normalizeParams4[0],originalHandler=_normalizeParams4[1],typeEvent=_normalizeParams4[2];var inNamespace=typeEvent!==originalTypeEvent;var events=getEvent(element);var isNamespace=originalTypeEvent.startsWith('.');if(typeof originalHandler!=='undefined'){// Simplest case: handler is passed, remove that listener ONLY.
if(!events||!events[typeEvent]){return;}removeHandler(element,events,typeEvent,originalHandler,delegation?handler:null);return;}if(isNamespace){Object.keys(events).forEach(function(elementEvent){removeNamespacedHandlers(element,events,elementEvent,originalTypeEvent.slice(1));});}var storeElementEvent=events[typeEvent]||{};Object.keys(storeElementEvent).forEach(function(keyHandlers){var handlerKey=keyHandlers.replace(stripUidRegex,'');if(!inNamespace||originalTypeEvent.includes(handlerKey)){var event=storeElementEvent[keyHandlers];removeHandler(element,events,typeEvent,event.originalHandler,event.delegationSelector);}});},trigger:function trigger(element,event,args){if(typeof event!=='string'||!element){return null;}var $=getjQuery();var typeEvent=getTypeEvent(event);var inNamespace=event!==typeEvent;var isNative=nativeEvents.has(typeEvent);var jQueryEvent;var bubbles=true;var nativeDispatch=true;var defaultPrevented=false;var evt=null;if(inNamespace&&$){jQueryEvent=$.Event(event,args);$(element).trigger(jQueryEvent);bubbles=!jQueryEvent.isPropagationStopped();nativeDispatch=!jQueryEvent.isImmediatePropagationStopped();defaultPrevented=jQueryEvent.isDefaultPrevented();}if(isNative){evt=document.createEvent('HTMLEvents');evt.initEvent(typeEvent,bubbles,true);}else{evt=new CustomEvent(event,{bubbles:bubbles,cancelable:true});}// merge custom information in our event
if(typeof args!=='undefined'){Object.keys(args).forEach(function(key){Object.defineProperty(evt,key,{get:function get(){return args[key];}});});}if(defaultPrevented){evt.preventDefault();}if(nativeDispatch){element.dispatchEvent(evt);}if(evt.defaultPrevented&&typeof jQueryEvent!=='undefined'){jQueryEvent.preventDefault();}return evt;}};/**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): dom/data.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */var elementMap=new Map();var Data={set:function set(element,key,instance){if(!elementMap.has(element)){elementMap.set(element,new Map());}var instanceMap=elementMap.get(element);// make it clear we only want one instance per element
// can be removed later when multiple key/instances are fine to be used
if(!instanceMap.has(key)&&instanceMap.size!==0){// eslint-disable-next-line no-console
console.error("Bootstrap doesn't allow more than one instance per element. Bound instance: ".concat(Array.from(instanceMap.keys())[0],"."));return;}instanceMap.set(key,instance);},get:function get(element,key){if(elementMap.has(element)){return elementMap.get(element).get(key)||null;}return null;},remove:function remove(element,key){if(!elementMap.has(element)){return;}var instanceMap=elementMap.get(element);instanceMap.delete(key);// free up element references if there are no instances left for an element
if(instanceMap.size===0){elementMap.delete(element);}}};/**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): base-component.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */var VERSION='5.1.3';var BaseComponent=/*#__PURE__*/function(){function BaseComponent(element){(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this,BaseComponent);element=getElement(element);if(!element){return;}this._element=element;Data.set(this._element,this.constructor.DATA_KEY,this);}(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(BaseComponent,[{key:"dispose",value:function dispose(){var _this=this;Data.remove(this._element,this.constructor.DATA_KEY);EventHandler.off(this._element,this.constructor.EVENT_KEY);Object.getOwnPropertyNames(this).forEach(function(propertyName){_this[propertyName]=null;});}},{key:"_queueCallback",value:function _queueCallback(callback,element){var isAnimated=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;executeAfterTransition(callback,element,isAnimated);}/** Static */}],[{key:"getInstance",value:function getInstance(element){return Data.get(getElement(element),this.DATA_KEY);}},{key:"getOrCreateInstance",value:function getOrCreateInstance(element){var config=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return this.getInstance(element)||new this(element,typeof config==='object'?config:null);}},{key:"VERSION",get:function get(){return VERSION;}},{key:"NAME",get:function get(){throw new Error('You have to implement the static method "NAME", for each component!');}},{key:"DATA_KEY",get:function get(){return"bs.".concat(this.NAME);}},{key:"EVENT_KEY",get:function get(){return".".concat(this.DATA_KEY);}}]);return BaseComponent;}();/**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/component-functions.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */var enableDismissTrigger=function enableDismissTrigger(component){var method=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'hide';var clickEvent="click.dismiss".concat(component.EVENT_KEY);var name=component.NAME;EventHandler.on(document,clickEvent,"[data-bs-dismiss=\"".concat(name,"\"]"),function(event){if(['A','AREA'].includes(this.tagName)){event.preventDefault();}if(isDisabled(this)){return;}var target=getElementFromSelector(this)||this.closest(".".concat(name));var instance=component.getOrCreateInstance(target);// Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
instance[method]();});};/**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): dom/manipulator.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */function normalizeData(val){if(val==='true'){return true;}if(val==='false'){return false;}if(val===Number(val).toString()){return Number(val);}if(val===''||val==='null'){return null;}return val;}function normalizeDataKey(key){return key.replace(/[A-Z]/g,function(chr){return"-".concat(chr.toLowerCase());});}var Manipulator={setDataAttribute:function setDataAttribute(element,key,value){element.setAttribute("data-bs-".concat(normalizeDataKey(key)),value);},removeDataAttribute:function removeDataAttribute(element,key){element.removeAttribute("data-bs-".concat(normalizeDataKey(key)));},getDataAttributes:function getDataAttributes(element){if(!element){return{};}var attributes={};Object.keys(element.dataset).filter(function(key){return key.startsWith('bs');}).forEach(function(key){var pureKey=key.replace(/^bs/,'');pureKey=pureKey.charAt(0).toLowerCase()+pureKey.slice(1,pureKey.length);attributes[pureKey]=normalizeData(element.dataset[key]);});return attributes;},getDataAttribute:function getDataAttribute(element,key){return normalizeData(element.getAttribute("data-bs-".concat(normalizeDataKey(key))));},offset:function offset(element){var rect=element.getBoundingClientRect();return{top:rect.top+window.pageYOffset,left:rect.left+window.pageXOffset};},position:function position(element){return{top:element.offsetTop,left:element.offsetLeft};}};/**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): dom/selector-engine.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */var NODE_TEXT=3;var SelectorEngine={find:function find(selector){var _ref6;var element=arguments.length>1&&arguments[1]!==undefined?arguments[1]:document.documentElement;return(_ref6=[]).concat.apply(_ref6,(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Element.prototype.querySelectorAll.call(element,selector)));},findOne:function findOne(selector){var element=arguments.length>1&&arguments[1]!==undefined?arguments[1]:document.documentElement;return Element.prototype.querySelector.call(element,selector);},children:function children(element,selector){var _ref7;return(_ref7=[]).concat.apply(_ref7,(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(element.children)).filter(function(child){return child.matches(selector);});},parents:function parents(element,selector){var parents=[];var ancestor=element.parentNode;while(ancestor&&ancestor.nodeType===Node.ELEMENT_NODE&&ancestor.nodeType!==NODE_TEXT){if(ancestor.matches(selector)){parents.push(ancestor);}ancestor=ancestor.parentNode;}return parents;},prev:function prev(element,selector){var previous=element.previousElementSibling;while(previous){if(previous.matches(selector)){return[previous];}previous=previous.previousElementSibling;}return[];},next:function next(element,selector){var next=element.nextElementSibling;while(next){if(next.matches(selector)){return[next];}next=next.nextElementSibling;}return[];},focusableChildren:function focusableChildren(element){var focusables=['a','button','input','textarea','select','details','[tabindex]','[contenteditable="true"]'].map(function(selector){return"".concat(selector,":not([tabindex^=\"-\"])");}).join(', ');return this.find(focusables,element).filter(function(el){return!isDisabled(el)&&isVisible(el);});}};/**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): carousel.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */var NAME$b='carousel';var DATA_KEY$a='bs.carousel';var EVENT_KEY$a=".".concat(DATA_KEY$a);var DATA_API_KEY$6='.data-api';var ARROW_LEFT_KEY='ArrowLeft';var ARROW_RIGHT_KEY='ArrowRight';var TOUCHEVENT_COMPAT_WAIT=500;// Time for mouse compat events to fire after touch
var SWIPE_THRESHOLD=40;var Default$a={interval:5000,keyboard:true,slide:false,pause:'hover',wrap:true,touch:true};var DefaultType$a={interval:'(number|boolean)',keyboard:'boolean',slide:'(boolean|string)',pause:'(string|boolean)',wrap:'boolean',touch:'boolean'};var ORDER_NEXT='next';var ORDER_PREV='prev';var DIRECTION_LEFT='left';var DIRECTION_RIGHT='right';var KEY_TO_DIRECTION=(_KEY_TO_DIRECTION={},(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_KEY_TO_DIRECTION,ARROW_LEFT_KEY,DIRECTION_RIGHT),(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_KEY_TO_DIRECTION,ARROW_RIGHT_KEY,DIRECTION_LEFT),_KEY_TO_DIRECTION);var EVENT_SLIDE="slide".concat(EVENT_KEY$a);var EVENT_SLID="slid".concat(EVENT_KEY$a);var EVENT_KEYDOWN="keydown".concat(EVENT_KEY$a);var EVENT_MOUSEENTER="mouseenter".concat(EVENT_KEY$a);var EVENT_MOUSELEAVE="mouseleave".concat(EVENT_KEY$a);var EVENT_TOUCHSTART="touchstart".concat(EVENT_KEY$a);var EVENT_TOUCHMOVE="touchmove".concat(EVENT_KEY$a);var EVENT_TOUCHEND="touchend".concat(EVENT_KEY$a);var EVENT_POINTERDOWN="pointerdown".concat(EVENT_KEY$a);var EVENT_POINTERUP="pointerup".concat(EVENT_KEY$a);var EVENT_DRAG_START="dragstart".concat(EVENT_KEY$a);var EVENT_LOAD_DATA_API$2="load".concat(EVENT_KEY$a).concat(DATA_API_KEY$6);var EVENT_CLICK_DATA_API$5="click".concat(EVENT_KEY$a).concat(DATA_API_KEY$6);var CLASS_NAME_CAROUSEL='carousel';var CLASS_NAME_ACTIVE$2='active';var CLASS_NAME_SLIDE='slide';var CLASS_NAME_END='carousel-item-end';var CLASS_NAME_START='carousel-item-start';var CLASS_NAME_NEXT='carousel-item-next';var CLASS_NAME_PREV='carousel-item-prev';var CLASS_NAME_POINTER_EVENT='pointer-event';var SELECTOR_ACTIVE$1='.active';var SELECTOR_ACTIVE_ITEM='.active.carousel-item';var SELECTOR_ITEM='.carousel-item';var SELECTOR_ITEM_IMG='.carousel-item img';var SELECTOR_NEXT_PREV='.carousel-item-next, .carousel-item-prev';var SELECTOR_INDICATORS='.carousel-indicators';var SELECTOR_INDICATOR='[data-bs-target]';var SELECTOR_DATA_SLIDE='[data-bs-slide], [data-bs-slide-to]';var SELECTOR_DATA_RIDE='[data-bs-ride="carousel"]';var POINTER_TYPE_TOUCH='touch';var POINTER_TYPE_PEN='pen';/**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */var Carousel=/*#__PURE__*/function(_BaseComponent){(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Carousel,_BaseComponent);var _super=(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_createSuper_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(Carousel);function Carousel(element,config){var _this2;(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this,Carousel);_this2=_super.call(this,element);_this2._items=null;_this2._interval=null;_this2._activeElement=null;_this2._isPaused=false;_this2._isSliding=false;_this2.touchTimeout=null;_this2.touchStartX=0;_this2.touchDeltaX=0;_this2._config=_this2._getConfig(config);_this2._indicatorsElement=SelectorEngine.findOne(SELECTOR_INDICATORS,_this2._element);_this2._touchSupported='ontouchstart'in document.documentElement||navigator.maxTouchPoints>0;_this2._pointerEvent=Boolean(window.PointerEvent);_this2._addEventListeners();return _this2;}// Getters
(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Carousel,[{key:"next",value:// Public
function next(){this._slide(ORDER_NEXT);}},{key:"nextWhenVisible",value:function nextWhenVisible(){// Don't call next when the page isn't visible
// or the carousel or its parent isn't visible
if(!document.hidden&&isVisible(this._element)){this.next();}}},{key:"prev",value:function prev(){this._slide(ORDER_PREV);}},{key:"pause",value:function pause(event){if(!event){this._isPaused=true;}if(SelectorEngine.findOne(SELECTOR_NEXT_PREV,this._element)){triggerTransitionEnd(this._element);this.cycle(true);}clearInterval(this._interval);this._interval=null;}},{key:"cycle",value:function cycle(event){if(!event){this._isPaused=false;}if(this._interval){clearInterval(this._interval);this._interval=null;}if(this._config&&this._config.interval&&!this._isPaused){this._updateInterval();this._interval=setInterval((document.visibilityState?this.nextWhenVisible:this.next).bind(this),this._config.interval);}}},{key:"to",value:function to(index){var _this3=this;this._activeElement=SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM,this._element);var activeIndex=this._getItemIndex(this._activeElement);if(index>this._items.length-1||index<0){return;}if(this._isSliding){EventHandler.one(this._element,EVENT_SLID,function(){return _this3.to(index);});return;}if(activeIndex===index){this.pause();this.cycle();return;}var order=index>activeIndex?ORDER_NEXT:ORDER_PREV;this._slide(order,this._items[index]);}// Private
},{key:"_getConfig",value:function _getConfig(config){config=(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({},Default$a),Manipulator.getDataAttributes(this._element)),typeof config==='object'?config:{});typeCheckConfig(NAME$b,config,DefaultType$a);return config;}},{key:"_handleSwipe",value:function _handleSwipe(){var absDeltax=Math.abs(this.touchDeltaX);if(absDeltax<=SWIPE_THRESHOLD){return;}var direction=absDeltax/this.touchDeltaX;this.touchDeltaX=0;if(!direction){return;}this._slide(direction>0?DIRECTION_RIGHT:DIRECTION_LEFT);}},{key:"_addEventListeners",value:function _addEventListeners(){var _this4=this;if(this._config.keyboard){EventHandler.on(this._element,EVENT_KEYDOWN,function(event){return _this4._keydown(event);});}if(this._config.pause==='hover'){EventHandler.on(this._element,EVENT_MOUSEENTER,function(event){return _this4.pause(event);});EventHandler.on(this._element,EVENT_MOUSELEAVE,function(event){return _this4.cycle(event);});}if(this._config.touch&&this._touchSupported){this._addTouchEventListeners();}}},{key:"_addTouchEventListeners",value:function _addTouchEventListeners(){var _this5=this;var hasPointerPenTouch=function hasPointerPenTouch(event){return _this5._pointerEvent&&(event.pointerType===POINTER_TYPE_PEN||event.pointerType===POINTER_TYPE_TOUCH);};var start=function start(event){if(hasPointerPenTouch(event)){_this5.touchStartX=event.clientX;}else if(!_this5._pointerEvent){_this5.touchStartX=event.touches[0].clientX;}};var move=function move(event){// ensure swiping with one touch and not pinching
_this5.touchDeltaX=event.touches&&event.touches.length>1?0:event.touches[0].clientX-_this5.touchStartX;};var end=function end(event){if(hasPointerPenTouch(event)){_this5.touchDeltaX=event.clientX-_this5.touchStartX;}_this5._handleSwipe();if(_this5._config.pause==='hover'){// If it's a touch-enabled device, mouseenter/leave are fired as
// part of the mouse compatibility events on first tap - the carousel
// would stop cycling until user tapped out of it;
// here, we listen for touchend, explicitly pause the carousel
// (as if it's the second time we tap on it, mouseenter compat event
// is NOT fired) and after a timeout (to allow for mouse compatibility
// events to fire) we explicitly restart cycling
_this5.pause();if(_this5.touchTimeout){clearTimeout(_this5.touchTimeout);}_this5.touchTimeout=setTimeout(function(event){return _this5.cycle(event);},TOUCHEVENT_COMPAT_WAIT+_this5._config.interval);}};SelectorEngine.find(SELECTOR_ITEM_IMG,this._element).forEach(function(itemImg){EventHandler.on(itemImg,EVENT_DRAG_START,function(event){return event.preventDefault();});});if(this._pointerEvent){EventHandler.on(this._element,EVENT_POINTERDOWN,function(event){return start(event);});EventHandler.on(this._element,EVENT_POINTERUP,function(event){return end(event);});this._element.classList.add(CLASS_NAME_POINTER_EVENT);}else{EventHandler.on(this._element,EVENT_TOUCHSTART,function(event){return start(event);});EventHandler.on(this._element,EVENT_TOUCHMOVE,function(event){return move(event);});EventHandler.on(this._element,EVENT_TOUCHEND,function(event){return end(event);});}}},{key:"_keydown",value:function _keydown(event){if(/input|textarea/i.test(event.target.tagName)){return;}var direction=KEY_TO_DIRECTION[event.key];if(direction){event.preventDefault();this._slide(direction);}}},{key:"_getItemIndex",value:function _getItemIndex(element){this._items=element&&element.parentNode?SelectorEngine.find(SELECTOR_ITEM,element.parentNode):[];return this._items.indexOf(element);}},{key:"_getItemByOrder",value:function _getItemByOrder(order,activeElement){var isNext=order===ORDER_NEXT;return getNextActiveElement(this._items,activeElement,isNext,this._config.wrap);}},{key:"_triggerSlideEvent",value:function _triggerSlideEvent(relatedTarget,eventDirectionName){var targetIndex=this._getItemIndex(relatedTarget);var fromIndex=this._getItemIndex(SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM,this._element));return EventHandler.trigger(this._element,EVENT_SLIDE,{relatedTarget:relatedTarget,direction:eventDirectionName,from:fromIndex,to:targetIndex});}},{key:"_setActiveIndicatorElement",value:function _setActiveIndicatorElement(element){if(this._indicatorsElement){var activeIndicator=SelectorEngine.findOne(SELECTOR_ACTIVE$1,this._indicatorsElement);activeIndicator.classList.remove(CLASS_NAME_ACTIVE$2);activeIndicator.removeAttribute('aria-current');var indicators=SelectorEngine.find(SELECTOR_INDICATOR,this._indicatorsElement);for(var i=0;i<indicators.length;i++){if(Number.parseInt(indicators[i].getAttribute('data-bs-slide-to'),10)===this._getItemIndex(element)){indicators[i].classList.add(CLASS_NAME_ACTIVE$2);indicators[i].setAttribute('aria-current','true');break;}}}}},{key:"_updateInterval",value:function _updateInterval(){var element=this._activeElement||SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM,this._element);if(!element){return;}var elementInterval=Number.parseInt(element.getAttribute('data-bs-interval'),10);if(elementInterval){this._config.defaultInterval=this._config.defaultInterval||this._config.interval;this._config.interval=elementInterval;}else{this._config.interval=this._config.defaultInterval||this._config.interval;}}},{key:"_slide",value:function _slide(directionOrOrder,element){var _this6=this;var order=this._directionToOrder(directionOrOrder);var activeElement=SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM,this._element);var activeElementIndex=this._getItemIndex(activeElement);var nextElement=element||this._getItemByOrder(order,activeElement);var nextElementIndex=this._getItemIndex(nextElement);var isCycling=Boolean(this._interval);var isNext=order===ORDER_NEXT;var directionalClassName=isNext?CLASS_NAME_START:CLASS_NAME_END;var orderClassName=isNext?CLASS_NAME_NEXT:CLASS_NAME_PREV;var eventDirectionName=this._orderToDirection(order);if(nextElement&&nextElement.classList.contains(CLASS_NAME_ACTIVE$2)){this._isSliding=false;return;}if(this._isSliding){return;}var slideEvent=this._triggerSlideEvent(nextElement,eventDirectionName);if(slideEvent.defaultPrevented){return;}if(!activeElement||!nextElement){// Some weirdness is happening, so we bail
return;}this._isSliding=true;if(isCycling){this.pause();}this._setActiveIndicatorElement(nextElement);this._activeElement=nextElement;var triggerSlidEvent=function triggerSlidEvent(){EventHandler.trigger(_this6._element,EVENT_SLID,{relatedTarget:nextElement,direction:eventDirectionName,from:activeElementIndex,to:nextElementIndex});};if(this._element.classList.contains(CLASS_NAME_SLIDE)){nextElement.classList.add(orderClassName);reflow(nextElement);activeElement.classList.add(directionalClassName);nextElement.classList.add(directionalClassName);var completeCallBack=function completeCallBack(){nextElement.classList.remove(directionalClassName,orderClassName);nextElement.classList.add(CLASS_NAME_ACTIVE$2);activeElement.classList.remove(CLASS_NAME_ACTIVE$2,orderClassName,directionalClassName);_this6._isSliding=false;setTimeout(triggerSlidEvent,0);};this._queueCallback(completeCallBack,activeElement,true);}else{activeElement.classList.remove(CLASS_NAME_ACTIVE$2);nextElement.classList.add(CLASS_NAME_ACTIVE$2);this._isSliding=false;triggerSlidEvent();}if(isCycling){this.cycle();}}},{key:"_directionToOrder",value:function _directionToOrder(direction){if(![DIRECTION_RIGHT,DIRECTION_LEFT].includes(direction)){return direction;}if(isRTL()){return direction===DIRECTION_LEFT?ORDER_PREV:ORDER_NEXT;}return direction===DIRECTION_LEFT?ORDER_NEXT:ORDER_PREV;}},{key:"_orderToDirection",value:function _orderToDirection(order){if(![ORDER_NEXT,ORDER_PREV].includes(order)){return order;}if(isRTL()){return order===ORDER_PREV?DIRECTION_LEFT:DIRECTION_RIGHT;}return order===ORDER_PREV?DIRECTION_RIGHT:DIRECTION_LEFT;}// Static
}],[{key:"Default",get:function get(){return Default$a;}},{key:"NAME",get:function get(){return NAME$b;}},{key:"carouselInterface",value:function carouselInterface(element,config){var data=Carousel.getOrCreateInstance(element,config);var _config=data._config;if(typeof config==='object'){_config=(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({},_config),config);}var action=typeof config==='string'?config:_config.slide;if(typeof config==='number'){data.to(config);}else if(typeof action==='string'){if(typeof data[action]==='undefined'){throw new TypeError("No method named \"".concat(action,"\""));}data[action]();}else if(_config.interval&&_config.ride){data.pause();data.cycle();}}},{key:"jQueryInterface",value:function jQueryInterface(config){return this.each(function(){Carousel.carouselInterface(this,config);});}},{key:"dataApiClickHandler",value:function dataApiClickHandler(event){var target=getElementFromSelector(this);if(!target||!target.classList.contains(CLASS_NAME_CAROUSEL)){return;}var config=(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({},Manipulator.getDataAttributes(target)),Manipulator.getDataAttributes(this));var slideIndex=this.getAttribute('data-bs-slide-to');if(slideIndex){config.interval=false;}Carousel.carouselInterface(target,config);if(slideIndex){Carousel.getInstance(target).to(slideIndex);}event.preventDefault();}}]);return Carousel;}(BaseComponent);/**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */EventHandler.on(document,EVENT_CLICK_DATA_API$5,SELECTOR_DATA_SLIDE,Carousel.dataApiClickHandler);EventHandler.on(window,EVENT_LOAD_DATA_API$2,function(){var carousels=SelectorEngine.find(SELECTOR_DATA_RIDE);for(var i=0,len=carousels.length;i<len;i++){Carousel.carouselInterface(carousels[i],Carousel.getInstance(carousels[i]));}});/**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   * add .Carousel to jQuery only if jQuery is present
   */defineJQueryPlugin(Carousel);/**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): collapse.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */var NAME$a='collapse';var DATA_KEY$9='bs.collapse';var EVENT_KEY$9=".".concat(DATA_KEY$9);var DATA_API_KEY$5='.data-api';var Default$9={toggle:true,parent:null};var DefaultType$9={toggle:'boolean',parent:'(null|element)'};var EVENT_SHOW$5="show".concat(EVENT_KEY$9);var EVENT_SHOWN$5="shown".concat(EVENT_KEY$9);var EVENT_HIDE$5="hide".concat(EVENT_KEY$9);var EVENT_HIDDEN$5="hidden".concat(EVENT_KEY$9);var EVENT_CLICK_DATA_API$4="click".concat(EVENT_KEY$9).concat(DATA_API_KEY$5);var CLASS_NAME_SHOW$7='show';var CLASS_NAME_COLLAPSE='collapse';var CLASS_NAME_COLLAPSING='collapsing';var CLASS_NAME_COLLAPSED='collapsed';var CLASS_NAME_DEEPER_CHILDREN=":scope .".concat(CLASS_NAME_COLLAPSE," .").concat(CLASS_NAME_COLLAPSE);var CLASS_NAME_HORIZONTAL='collapse-horizontal';var WIDTH='width';var HEIGHT='height';var SELECTOR_ACTIVES='.collapse.show, .collapse.collapsing';var SELECTOR_DATA_TOGGLE$4='[data-bs-toggle="collapse"]';/**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */var Collapse=/*#__PURE__*/function(_BaseComponent2){(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Collapse,_BaseComponent2);var _super2=(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_createSuper_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(Collapse);function Collapse(element,config){var _this7;(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this,Collapse);_this7=_super2.call(this,element);_this7._isTransitioning=false;_this7._config=_this7._getConfig(config);_this7._triggerArray=[];var toggleList=SelectorEngine.find(SELECTOR_DATA_TOGGLE$4);for(var i=0,len=toggleList.length;i<len;i++){var elem=toggleList[i];var selector=getSelectorFromElement(elem);var filterElement=SelectorEngine.find(selector).filter(function(foundElem){return foundElem===_this7._element;});if(selector!==null&&filterElement.length){_this7._selector=selector;_this7._triggerArray.push(elem);}}_this7._initializeChildren();if(!_this7._config.parent){_this7._addAriaAndCollapsedClass(_this7._triggerArray,_this7._isShown());}if(_this7._config.toggle){_this7.toggle();}return _this7;}// Getters
(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Collapse,[{key:"toggle",value:// Public
function toggle(){if(this._isShown()){this.hide();}else{this.show();}}},{key:"show",value:function show(){var _this8=this;if(this._isTransitioning||this._isShown()){return;}var actives=[];var activesData;if(this._config.parent){var children=SelectorEngine.find(CLASS_NAME_DEEPER_CHILDREN,this._config.parent);actives=SelectorEngine.find(SELECTOR_ACTIVES,this._config.parent).filter(function(elem){return!children.includes(elem);});// remove children if greater depth
}var container=SelectorEngine.findOne(this._selector);if(actives.length){var tempActiveData=actives.find(function(elem){return container!==elem;});activesData=tempActiveData?Collapse.getInstance(tempActiveData):null;if(activesData&&activesData._isTransitioning){return;}}var startEvent=EventHandler.trigger(this._element,EVENT_SHOW$5);if(startEvent.defaultPrevented){return;}actives.forEach(function(elemActive){if(container!==elemActive){Collapse.getOrCreateInstance(elemActive,{toggle:false}).hide();}if(!activesData){Data.set(elemActive,DATA_KEY$9,null);}});var dimension=this._getDimension();this._element.classList.remove(CLASS_NAME_COLLAPSE);this._element.classList.add(CLASS_NAME_COLLAPSING);this._element.style[dimension]=0;this._addAriaAndCollapsedClass(this._triggerArray,true);this._isTransitioning=true;var complete=function complete(){_this8._isTransitioning=false;_this8._element.classList.remove(CLASS_NAME_COLLAPSING);_this8._element.classList.add(CLASS_NAME_COLLAPSE,CLASS_NAME_SHOW$7);_this8._element.style[dimension]='';EventHandler.trigger(_this8._element,EVENT_SHOWN$5);};var capitalizedDimension=dimension[0].toUpperCase()+dimension.slice(1);var scrollSize="scroll".concat(capitalizedDimension);this._queueCallback(complete,this._element,true);this._element.style[dimension]="".concat(this._element[scrollSize],"px");}},{key:"hide",value:function hide(){var _this9=this;if(this._isTransitioning||!this._isShown()){return;}var startEvent=EventHandler.trigger(this._element,EVENT_HIDE$5);if(startEvent.defaultPrevented){return;}var dimension=this._getDimension();this._element.style[dimension]="".concat(this._element.getBoundingClientRect()[dimension],"px");reflow(this._element);this._element.classList.add(CLASS_NAME_COLLAPSING);this._element.classList.remove(CLASS_NAME_COLLAPSE,CLASS_NAME_SHOW$7);var triggerArrayLength=this._triggerArray.length;for(var i=0;i<triggerArrayLength;i++){var trigger=this._triggerArray[i];var elem=getElementFromSelector(trigger);if(elem&&!this._isShown(elem)){this._addAriaAndCollapsedClass([trigger],false);}}this._isTransitioning=true;var complete=function complete(){_this9._isTransitioning=false;_this9._element.classList.remove(CLASS_NAME_COLLAPSING);_this9._element.classList.add(CLASS_NAME_COLLAPSE);EventHandler.trigger(_this9._element,EVENT_HIDDEN$5);};this._element.style[dimension]='';this._queueCallback(complete,this._element,true);}},{key:"_isShown",value:function _isShown(){var element=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this._element;return element.classList.contains(CLASS_NAME_SHOW$7);}// Private
},{key:"_getConfig",value:function _getConfig(config){config=(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({},Default$9),Manipulator.getDataAttributes(this._element)),config);config.toggle=Boolean(config.toggle);// Coerce string values
config.parent=getElement(config.parent);typeCheckConfig(NAME$a,config,DefaultType$9);return config;}},{key:"_getDimension",value:function _getDimension(){return this._element.classList.contains(CLASS_NAME_HORIZONTAL)?WIDTH:HEIGHT;}},{key:"_initializeChildren",value:function _initializeChildren(){var _this10=this;if(!this._config.parent){return;}var children=SelectorEngine.find(CLASS_NAME_DEEPER_CHILDREN,this._config.parent);SelectorEngine.find(SELECTOR_DATA_TOGGLE$4,this._config.parent).filter(function(elem){return!children.includes(elem);}).forEach(function(element){var selected=getElementFromSelector(element);if(selected){_this10._addAriaAndCollapsedClass([element],_this10._isShown(selected));}});}},{key:"_addAriaAndCollapsedClass",value:function _addAriaAndCollapsedClass(triggerArray,isOpen){if(!triggerArray.length){return;}triggerArray.forEach(function(elem){if(isOpen){elem.classList.remove(CLASS_NAME_COLLAPSED);}else{elem.classList.add(CLASS_NAME_COLLAPSED);}elem.setAttribute('aria-expanded',isOpen);});}// Static
}],[{key:"Default",get:function get(){return Default$9;}},{key:"NAME",get:function get(){return NAME$a;}},{key:"jQueryInterface",value:function jQueryInterface(config){return this.each(function(){var _config={};if(typeof config==='string'&&/show|hide/.test(config)){_config.toggle=false;}var data=Collapse.getOrCreateInstance(this,_config);if(typeof config==='string'){if(typeof data[config]==='undefined'){throw new TypeError("No method named \"".concat(config,"\""));}data[config]();}});}}]);return Collapse;}(BaseComponent);/**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */EventHandler.on(document,EVENT_CLICK_DATA_API$4,SELECTOR_DATA_TOGGLE$4,function(event){// preventDefault only for <a> elements (which change the URL) not inside the collapsible element
if(event.target.tagName==='A'||event.delegateTarget&&event.delegateTarget.tagName==='A'){event.preventDefault();}var selector=getSelectorFromElement(this);var selectorElements=SelectorEngine.find(selector);selectorElements.forEach(function(element){Collapse.getOrCreateInstance(element,{toggle:false}).toggle();});});/**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   * add .Collapse to jQuery only if jQuery is present
   */defineJQueryPlugin(Collapse);var top='top';var bottom='bottom';var right='right';var left='left';var auto='auto';var basePlacements=[top,bottom,right,left];var start='start';var end='end';var clippingParents='clippingParents';var viewport='viewport';var popper='popper';var reference='reference';var variationPlacements=/*#__PURE__*/basePlacements.reduce(function(acc,placement){return acc.concat([placement+"-"+start,placement+"-"+end]);},[]);var placements=/*#__PURE__*/[].concat(basePlacements,[auto]).reduce(function(acc,placement){return acc.concat([placement,placement+"-"+start,placement+"-"+end]);},[]);// modifiers that need to read the DOM
var beforeRead='beforeRead';var read='read';var afterRead='afterRead';// pure-logic modifiers
var beforeMain='beforeMain';var main='main';var afterMain='afterMain';// modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite='beforeWrite';var write='write';var afterWrite='afterWrite';var modifierPhases=[beforeRead,read,afterRead,beforeMain,main,afterMain,beforeWrite,write,afterWrite];function getNodeName(element){return element?(element.nodeName||'').toLowerCase():null;}function getWindow(node){if(node==null){return window;}if(node.toString()!=='[object Window]'){var ownerDocument=node.ownerDocument;return ownerDocument?ownerDocument.defaultView||window:window;}return node;}function isElement(node){var OwnElement=getWindow(node).Element;return node instanceof OwnElement||node instanceof Element;}function isHTMLElement(node){var OwnElement=getWindow(node).HTMLElement;return node instanceof OwnElement||node instanceof HTMLElement;}function isShadowRoot(node){// IE 11 has no ShadowRoot
if(typeof ShadowRoot==='undefined'){return false;}var OwnElement=getWindow(node).ShadowRoot;return node instanceof OwnElement||node instanceof ShadowRoot;}// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref){var state=_ref.state;Object.keys(state.elements).forEach(function(name){var style=state.styles[name]||{};var attributes=state.attributes[name]||{};var element=state.elements[name];// arrow is optional + virtual elements
if(!isHTMLElement(element)||!getNodeName(element)){return;}// Flow doesn't support to extend this property, but it's the most
// effective way to apply styles to an HTMLElement
// $FlowFixMe[cannot-write]
Object.assign(element.style,style);Object.keys(attributes).forEach(function(name){var value=attributes[name];if(value===false){element.removeAttribute(name);}else{element.setAttribute(name,value===true?'':value);}});});}function effect$2(_ref2){var state=_ref2.state;var initialStyles={popper:{position:state.options.strategy,left:'0',top:'0',margin:'0'},arrow:{position:'absolute'},reference:{}};Object.assign(state.elements.popper.style,initialStyles.popper);state.styles=initialStyles;if(state.elements.arrow){Object.assign(state.elements.arrow.style,initialStyles.arrow);}return function(){Object.keys(state.elements).forEach(function(name){var element=state.elements[name];var attributes=state.attributes[name]||{};var styleProperties=Object.keys(state.styles.hasOwnProperty(name)?state.styles[name]:initialStyles[name]);// Set all values to an empty string to unset them
var style=styleProperties.reduce(function(style,property){style[property]='';return style;},{});// arrow is optional + virtual elements
if(!isHTMLElement(element)||!getNodeName(element)){return;}Object.assign(element.style,style);Object.keys(attributes).forEach(function(attribute){element.removeAttribute(attribute);});});};}// eslint-disable-next-line import/no-unused-modules
var applyStyles$1={name:'applyStyles',enabled:true,phase:'write',fn:applyStyles,effect:effect$2,requires:['computeStyles']};function getBasePlacement(placement){return placement.split('-')[0];}// import { isHTMLElement } from './instanceOf';
function getBoundingClientRect(element,includeScale){var rect=element.getBoundingClientRect();var scaleX=1;var scaleY=1;// FIXME:
// `offsetWidth` returns an integer while `getBoundingClientRect`
// returns a float. This results in `scaleX` or `scaleY` being
// non-1 when it should be for elements that aren't a full pixel in
// width or height.
// if (isHTMLElement(element) && includeScale) {
//   const offsetHeight = element.offsetHeight;
//   const offsetWidth = element.offsetWidth;
//   // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
//   // Fallback to 1 in case both values are `0`
//   if (offsetWidth > 0) {
//     scaleX = rect.width / offsetWidth || 1;
//   }
//   if (offsetHeight > 0) {
//     scaleY = rect.height / offsetHeight || 1;
//   }
// }
return{width:rect.width/scaleX,height:rect.height/scaleY,top:rect.top/scaleY,right:rect.right/scaleX,bottom:rect.bottom/scaleY,left:rect.left/scaleX,x:rect.left/scaleX,y:rect.top/scaleY};}// means it doesn't take into account transforms.
function getLayoutRect(element){var clientRect=getBoundingClientRect(element);// Use the clientRect sizes if it's not been transformed.
// Fixes https://github.com/popperjs/popper-core/issues/1223
var width=element.offsetWidth;var height=element.offsetHeight;if(Math.abs(clientRect.width-width)<=1){width=clientRect.width;}if(Math.abs(clientRect.height-height)<=1){height=clientRect.height;}return{x:element.offsetLeft,y:element.offsetTop,width:width,height:height};}function contains(parent,child){var rootNode=child.getRootNode&&child.getRootNode();// First, attempt with faster native method
if(parent.contains(child)){return true;}// then fallback to custom implementation with Shadow DOM support
else if(rootNode&&isShadowRoot(rootNode)){var next=child;do{if(next&&parent.isSameNode(next)){return true;}// $FlowFixMe[prop-missing]: need a better way to handle this...
next=next.parentNode||next.host;}while(next);}// Give up, the result is false
return false;}function getComputedStyle$1(element){return getWindow(element).getComputedStyle(element);}function isTableElement(element){return['table','td','th'].indexOf(getNodeName(element))>=0;}function getDocumentElement(element){// $FlowFixMe[incompatible-return]: assume body is always available
return((isElement(element)?element.ownerDocument:// $FlowFixMe[prop-missing]
element.document)||window.document).documentElement;}function getParentNode(element){if(getNodeName(element)==='html'){return element;}return(// this is a quicker (but less type safe) way to save quite some bytes from the bundle
// $FlowFixMe[incompatible-return]
// $FlowFixMe[prop-missing]
element.assignedSlot||// step into the shadow DOM of the parent of a slotted node
element.parentNode||(// DOM Element detected
isShadowRoot(element)?element.host:null)||// ShadowRoot detected
// $FlowFixMe[incompatible-call]: HTMLElement is a Node
getDocumentElement(element)// fallback
);}function getTrueOffsetParent(element){if(!isHTMLElement(element)||// https://github.com/popperjs/popper-core/issues/837
getComputedStyle$1(element).position==='fixed'){return null;}return element.offsetParent;}// `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element){var isFirefox=navigator.userAgent.toLowerCase().indexOf('firefox')!==-1;var isIE=navigator.userAgent.indexOf('Trident')!==-1;if(isIE&&isHTMLElement(element)){// In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
var elementCss=getComputedStyle$1(element);if(elementCss.position==='fixed'){return null;}}var currentNode=getParentNode(element);while(isHTMLElement(currentNode)&&['html','body'].indexOf(getNodeName(currentNode))<0){var css=getComputedStyle$1(currentNode);// This is non-exhaustive but covers the most common CSS properties that
// create a containing block.
// https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
if(css.transform!=='none'||css.perspective!=='none'||css.contain==='paint'||['transform','perspective'].indexOf(css.willChange)!==-1||isFirefox&&css.willChange==='filter'||isFirefox&&css.filter&&css.filter!=='none'){return currentNode;}else{currentNode=currentNode.parentNode;}}return null;}// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element){var window=getWindow(element);var offsetParent=getTrueOffsetParent(element);while(offsetParent&&isTableElement(offsetParent)&&getComputedStyle$1(offsetParent).position==='static'){offsetParent=getTrueOffsetParent(offsetParent);}if(offsetParent&&(getNodeName(offsetParent)==='html'||getNodeName(offsetParent)==='body'&&getComputedStyle$1(offsetParent).position==='static')){return window;}return offsetParent||getContainingBlock(element)||window;}function getMainAxisFromPlacement(placement){return['top','bottom'].indexOf(placement)>=0?'x':'y';}var max=Math.max;var min=Math.min;var round=Math.round;function within(min$1,value,max$1){return max(min$1,min(value,max$1));}function getFreshSideObject(){return{top:0,right:0,bottom:0,left:0};}function mergePaddingObject(paddingObject){return Object.assign({},getFreshSideObject(),paddingObject);}function expandToHashMap(value,keys){return keys.reduce(function(hashMap,key){hashMap[key]=value;return hashMap;},{});}var toPaddingObject=function toPaddingObject(padding,state){padding=typeof padding==='function'?padding(Object.assign({},state.rects,{placement:state.placement})):padding;return mergePaddingObject(typeof padding!=='number'?padding:expandToHashMap(padding,basePlacements));};function arrow(_ref){var _state$modifiersData$;var state=_ref.state,name=_ref.name,options=_ref.options;var arrowElement=state.elements.arrow;var popperOffsets=state.modifiersData.popperOffsets;var basePlacement=getBasePlacement(state.placement);var axis=getMainAxisFromPlacement(basePlacement);var isVertical=[left,right].indexOf(basePlacement)>=0;var len=isVertical?'height':'width';if(!arrowElement||!popperOffsets){return;}var paddingObject=toPaddingObject(options.padding,state);var arrowRect=getLayoutRect(arrowElement);var minProp=axis==='y'?top:left;var maxProp=axis==='y'?bottom:right;var endDiff=state.rects.reference[len]+state.rects.reference[axis]-popperOffsets[axis]-state.rects.popper[len];var startDiff=popperOffsets[axis]-state.rects.reference[axis];var arrowOffsetParent=getOffsetParent(arrowElement);var clientSize=arrowOffsetParent?axis==='y'?arrowOffsetParent.clientHeight||0:arrowOffsetParent.clientWidth||0:0;var centerToReference=endDiff/2-startDiff/2;// Make sure the arrow doesn't overflow the popper if the center point is
// outside of the popper bounds
var min=paddingObject[minProp];var max=clientSize-arrowRect[len]-paddingObject[maxProp];var center=clientSize/2-arrowRect[len]/2+centerToReference;var offset=within(min,center,max);// Prevents breaking syntax highlighting...
var axisProp=axis;state.modifiersData[name]=(_state$modifiersData$={},_state$modifiersData$[axisProp]=offset,_state$modifiersData$.centerOffset=offset-center,_state$modifiersData$);}function effect$1(_ref2){var state=_ref2.state,options=_ref2.options;var _options$element=options.element,arrowElement=_options$element===void 0?'[data-popper-arrow]':_options$element;if(arrowElement==null){return;}// CSS selector
if(typeof arrowElement==='string'){arrowElement=state.elements.popper.querySelector(arrowElement);if(!arrowElement){return;}}if(!contains(state.elements.popper,arrowElement)){return;}state.elements.arrow=arrowElement;}// eslint-disable-next-line import/no-unused-modules
var arrow$1={name:'arrow',enabled:true,phase:'main',fn:arrow,effect:effect$1,requires:['popperOffsets'],requiresIfExists:['preventOverflow']};function getVariation(placement){return placement.split('-')[1];}var unsetSides={top:'auto',right:'auto',bottom:'auto',left:'auto'};// Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref){var x=_ref.x,y=_ref.y;var win=window;var dpr=win.devicePixelRatio||1;return{x:round(round(x*dpr)/dpr)||0,y:round(round(y*dpr)/dpr)||0};}function mapToStyles(_ref2){var _Object$assign2;var popper=_ref2.popper,popperRect=_ref2.popperRect,placement=_ref2.placement,variation=_ref2.variation,offsets=_ref2.offsets,position=_ref2.position,gpuAcceleration=_ref2.gpuAcceleration,adaptive=_ref2.adaptive,roundOffsets=_ref2.roundOffsets;var _ref3=roundOffsets===true?roundOffsetsByDPR(offsets):typeof roundOffsets==='function'?roundOffsets(offsets):offsets,_ref3$x=_ref3.x,x=_ref3$x===void 0?0:_ref3$x,_ref3$y=_ref3.y,y=_ref3$y===void 0?0:_ref3$y;var hasX=offsets.hasOwnProperty('x');var hasY=offsets.hasOwnProperty('y');var sideX=left;var sideY=top;var win=window;if(adaptive){var offsetParent=getOffsetParent(popper);var heightProp='clientHeight';var widthProp='clientWidth';if(offsetParent===getWindow(popper)){offsetParent=getDocumentElement(popper);if(getComputedStyle$1(offsetParent).position!=='static'&&position==='absolute'){heightProp='scrollHeight';widthProp='scrollWidth';}}// $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
offsetParent=offsetParent;if(placement===top||(placement===left||placement===right)&&variation===end){sideY=bottom;// $FlowFixMe[prop-missing]
y-=offsetParent[heightProp]-popperRect.height;y*=gpuAcceleration?1:-1;}if(placement===left||(placement===top||placement===bottom)&&variation===end){sideX=right;// $FlowFixMe[prop-missing]
x-=offsetParent[widthProp]-popperRect.width;x*=gpuAcceleration?1:-1;}}var commonStyles=Object.assign({position:position},adaptive&&unsetSides);if(gpuAcceleration){var _Object$assign;return Object.assign({},commonStyles,(_Object$assign={},_Object$assign[sideY]=hasY?'0':'',_Object$assign[sideX]=hasX?'0':'',_Object$assign.transform=(win.devicePixelRatio||1)<=1?"translate("+x+"px, "+y+"px)":"translate3d("+x+"px, "+y+"px, 0)",_Object$assign));}return Object.assign({},commonStyles,(_Object$assign2={},_Object$assign2[sideY]=hasY?y+"px":'',_Object$assign2[sideX]=hasX?x+"px":'',_Object$assign2.transform='',_Object$assign2));}function computeStyles(_ref4){var state=_ref4.state,options=_ref4.options;var _options$gpuAccelerat=options.gpuAcceleration,gpuAcceleration=_options$gpuAccelerat===void 0?true:_options$gpuAccelerat,_options$adaptive=options.adaptive,adaptive=_options$adaptive===void 0?true:_options$adaptive,_options$roundOffsets=options.roundOffsets,roundOffsets=_options$roundOffsets===void 0?true:_options$roundOffsets;var commonStyles={placement:getBasePlacement(state.placement),variation:getVariation(state.placement),popper:state.elements.popper,popperRect:state.rects.popper,gpuAcceleration:gpuAcceleration};if(state.modifiersData.popperOffsets!=null){state.styles.popper=Object.assign({},state.styles.popper,mapToStyles(Object.assign({},commonStyles,{offsets:state.modifiersData.popperOffsets,position:state.options.strategy,adaptive:adaptive,roundOffsets:roundOffsets})));}if(state.modifiersData.arrow!=null){state.styles.arrow=Object.assign({},state.styles.arrow,mapToStyles(Object.assign({},commonStyles,{offsets:state.modifiersData.arrow,position:'absolute',adaptive:false,roundOffsets:roundOffsets})));}state.attributes.popper=Object.assign({},state.attributes.popper,{'data-popper-placement':state.placement});}// eslint-disable-next-line import/no-unused-modules
var computeStyles$1={name:'computeStyles',enabled:true,phase:'beforeWrite',fn:computeStyles,data:{}};var passive={passive:true};function effect(_ref){var state=_ref.state,instance=_ref.instance,options=_ref.options;var _options$scroll=options.scroll,scroll=_options$scroll===void 0?true:_options$scroll,_options$resize=options.resize,resize=_options$resize===void 0?true:_options$resize;var window=getWindow(state.elements.popper);var scrollParents=[].concat(state.scrollParents.reference,state.scrollParents.popper);if(scroll){scrollParents.forEach(function(scrollParent){scrollParent.addEventListener('scroll',instance.update,passive);});}if(resize){window.addEventListener('resize',instance.update,passive);}return function(){if(scroll){scrollParents.forEach(function(scrollParent){scrollParent.removeEventListener('scroll',instance.update,passive);});}if(resize){window.removeEventListener('resize',instance.update,passive);}};}// eslint-disable-next-line import/no-unused-modules
var eventListeners={name:'eventListeners',enabled:true,phase:'write',fn:function fn(){},effect:effect,data:{}};var hash$1={left:'right',right:'left',bottom:'top',top:'bottom'};function getOppositePlacement(placement){return placement.replace(/left|right|bottom|top/g,function(matched){return hash$1[matched];});}var hash={start:'end',end:'start'};function getOppositeVariationPlacement(placement){return placement.replace(/start|end/g,function(matched){return hash[matched];});}function getWindowScroll(node){var win=getWindow(node);var scrollLeft=win.pageXOffset;var scrollTop=win.pageYOffset;return{scrollLeft:scrollLeft,scrollTop:scrollTop};}function getWindowScrollBarX(element){// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
// Popper 1 is broken in this case and never had a bug report so let's assume
// it's not an issue. I don't think anyone ever specifies width on <html>
// anyway.
// Browsers where the left scrollbar doesn't cause an issue report `0` for
// this (e.g. Edge 2019, IE11, Safari)
return getBoundingClientRect(getDocumentElement(element)).left+getWindowScroll(element).scrollLeft;}function getViewportRect(element){var win=getWindow(element);var html=getDocumentElement(element);var visualViewport=win.visualViewport;var width=html.clientWidth;var height=html.clientHeight;var x=0;var y=0;// NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
// can be obscured underneath it.
// Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
// if it isn't open, so if this isn't available, the popper will be detected
// to overflow the bottom of the screen too early.
if(visualViewport){width=visualViewport.width;height=visualViewport.height;// Uses Layout Viewport (like Chrome; Safari does not currently)
// In Chrome, it returns a value very close to 0 (+/-) but contains rounding
// errors due to floating point numbers, so we need to check precision.
// Safari returns a number <= 0, usually < -1 when pinch-zoomed
// Feature detection fails in mobile emulation mode in Chrome.
// Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
// 0.001
// Fallback here: "Not Safari" userAgent
if(!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)){x=visualViewport.offsetLeft;y=visualViewport.offsetTop;}}return{width:width,height:height,x:x+getWindowScrollBarX(element),y:y};}// of the `<html>` and `<body>` rect bounds if horizontally scrollable
function getDocumentRect(element){var _element$ownerDocumen;var html=getDocumentElement(element);var winScroll=getWindowScroll(element);var body=(_element$ownerDocumen=element.ownerDocument)==null?void 0:_element$ownerDocumen.body;var width=max(html.scrollWidth,html.clientWidth,body?body.scrollWidth:0,body?body.clientWidth:0);var height=max(html.scrollHeight,html.clientHeight,body?body.scrollHeight:0,body?body.clientHeight:0);var x=-winScroll.scrollLeft+getWindowScrollBarX(element);var y=-winScroll.scrollTop;if(getComputedStyle$1(body||html).direction==='rtl'){x+=max(html.clientWidth,body?body.clientWidth:0)-width;}return{width:width,height:height,x:x,y:y};}function isScrollParent(element){// Firefox wants us to check `-x` and `-y` variations as well
var _getComputedStyle=getComputedStyle$1(element),overflow=_getComputedStyle.overflow,overflowX=_getComputedStyle.overflowX,overflowY=_getComputedStyle.overflowY;return /auto|scroll|overlay|hidden/.test(overflow+overflowY+overflowX);}function getScrollParent(node){if(['html','body','#document'].indexOf(getNodeName(node))>=0){// $FlowFixMe[incompatible-return]: assume body is always available
return node.ownerDocument.body;}if(isHTMLElement(node)&&isScrollParent(node)){return node;}return getScrollParent(getParentNode(node));}/*
  given a DOM element, return the list of all scroll parents, up the list of ancesors
  until we get to the top window object. This list is what we attach scroll listeners
  to, because if any of these parent elements scroll, we'll need to re-calculate the
  reference element's position.
  */function listScrollParents(element,list){var _element$ownerDocumen;if(list===void 0){list=[];}var scrollParent=getScrollParent(element);var isBody=scrollParent===((_element$ownerDocumen=element.ownerDocument)==null?void 0:_element$ownerDocumen.body);var win=getWindow(scrollParent);var target=isBody?[win].concat(win.visualViewport||[],isScrollParent(scrollParent)?scrollParent:[]):scrollParent;var updatedList=list.concat(target);return isBody?updatedList:// $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
updatedList.concat(listScrollParents(getParentNode(target)));}function rectToClientRect(rect){return Object.assign({},rect,{left:rect.x,top:rect.y,right:rect.x+rect.width,bottom:rect.y+rect.height});}function getInnerBoundingClientRect(element){var rect=getBoundingClientRect(element);rect.top=rect.top+element.clientTop;rect.left=rect.left+element.clientLeft;rect.bottom=rect.top+element.clientHeight;rect.right=rect.left+element.clientWidth;rect.width=element.clientWidth;rect.height=element.clientHeight;rect.x=rect.left;rect.y=rect.top;return rect;}function getClientRectFromMixedType(element,clippingParent){return clippingParent===viewport?rectToClientRect(getViewportRect(element)):isHTMLElement(clippingParent)?getInnerBoundingClientRect(clippingParent):rectToClientRect(getDocumentRect(getDocumentElement(element)));}// A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element){var clippingParents=listScrollParents(getParentNode(element));var canEscapeClipping=['absolute','fixed'].indexOf(getComputedStyle$1(element).position)>=0;var clipperElement=canEscapeClipping&&isHTMLElement(element)?getOffsetParent(element):element;if(!isElement(clipperElement)){return[];}// $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
return clippingParents.filter(function(clippingParent){return isElement(clippingParent)&&contains(clippingParent,clipperElement)&&getNodeName(clippingParent)!=='body';});}// Gets the maximum area that the element is visible in due to any number of
// clipping parents
function getClippingRect(element,boundary,rootBoundary){var mainClippingParents=boundary==='clippingParents'?getClippingParents(element):[].concat(boundary);var clippingParents=[].concat(mainClippingParents,[rootBoundary]);var firstClippingParent=clippingParents[0];var clippingRect=clippingParents.reduce(function(accRect,clippingParent){var rect=getClientRectFromMixedType(element,clippingParent);accRect.top=max(rect.top,accRect.top);accRect.right=min(rect.right,accRect.right);accRect.bottom=min(rect.bottom,accRect.bottom);accRect.left=max(rect.left,accRect.left);return accRect;},getClientRectFromMixedType(element,firstClippingParent));clippingRect.width=clippingRect.right-clippingRect.left;clippingRect.height=clippingRect.bottom-clippingRect.top;clippingRect.x=clippingRect.left;clippingRect.y=clippingRect.top;return clippingRect;}function computeOffsets(_ref){var reference=_ref.reference,element=_ref.element,placement=_ref.placement;var basePlacement=placement?getBasePlacement(placement):null;var variation=placement?getVariation(placement):null;var commonX=reference.x+reference.width/2-element.width/2;var commonY=reference.y+reference.height/2-element.height/2;var offsets;switch(basePlacement){case top:offsets={x:commonX,y:reference.y-element.height};break;case bottom:offsets={x:commonX,y:reference.y+reference.height};break;case right:offsets={x:reference.x+reference.width,y:commonY};break;case left:offsets={x:reference.x-element.width,y:commonY};break;default:offsets={x:reference.x,y:reference.y};}var mainAxis=basePlacement?getMainAxisFromPlacement(basePlacement):null;if(mainAxis!=null){var len=mainAxis==='y'?'height':'width';switch(variation){case start:offsets[mainAxis]=offsets[mainAxis]-(reference[len]/2-element[len]/2);break;case end:offsets[mainAxis]=offsets[mainAxis]+(reference[len]/2-element[len]/2);break;}}return offsets;}function detectOverflow(state,options){if(options===void 0){options={};}var _options=options,_options$placement=_options.placement,placement=_options$placement===void 0?state.placement:_options$placement,_options$boundary=_options.boundary,boundary=_options$boundary===void 0?clippingParents:_options$boundary,_options$rootBoundary=_options.rootBoundary,rootBoundary=_options$rootBoundary===void 0?viewport:_options$rootBoundary,_options$elementConte=_options.elementContext,elementContext=_options$elementConte===void 0?popper:_options$elementConte,_options$altBoundary=_options.altBoundary,altBoundary=_options$altBoundary===void 0?false:_options$altBoundary,_options$padding=_options.padding,padding=_options$padding===void 0?0:_options$padding;var paddingObject=mergePaddingObject(typeof padding!=='number'?padding:expandToHashMap(padding,basePlacements));var altContext=elementContext===popper?reference:popper;var popperRect=state.rects.popper;var element=state.elements[altBoundary?altContext:elementContext];var clippingClientRect=getClippingRect(isElement(element)?element:element.contextElement||getDocumentElement(state.elements.popper),boundary,rootBoundary);var referenceClientRect=getBoundingClientRect(state.elements.reference);var popperOffsets=computeOffsets({reference:referenceClientRect,element:popperRect,strategy:'absolute',placement:placement});var popperClientRect=rectToClientRect(Object.assign({},popperRect,popperOffsets));var elementClientRect=elementContext===popper?popperClientRect:referenceClientRect;// positive = overflowing the clipping rect
// 0 or negative = within the clipping rect
var overflowOffsets={top:clippingClientRect.top-elementClientRect.top+paddingObject.top,bottom:elementClientRect.bottom-clippingClientRect.bottom+paddingObject.bottom,left:clippingClientRect.left-elementClientRect.left+paddingObject.left,right:elementClientRect.right-clippingClientRect.right+paddingObject.right};var offsetData=state.modifiersData.offset;// Offsets can be applied only to the popper element
if(elementContext===popper&&offsetData){var offset=offsetData[placement];Object.keys(overflowOffsets).forEach(function(key){var multiply=[right,bottom].indexOf(key)>=0?1:-1;var axis=[top,bottom].indexOf(key)>=0?'y':'x';overflowOffsets[key]+=offset[axis]*multiply;});}return overflowOffsets;}function computeAutoPlacement(state,options){if(options===void 0){options={};}var _options=options,placement=_options.placement,boundary=_options.boundary,rootBoundary=_options.rootBoundary,padding=_options.padding,flipVariations=_options.flipVariations,_options$allowedAutoP=_options.allowedAutoPlacements,allowedAutoPlacements=_options$allowedAutoP===void 0?placements:_options$allowedAutoP;var variation=getVariation(placement);var placements$1=variation?flipVariations?variationPlacements:variationPlacements.filter(function(placement){return getVariation(placement)===variation;}):basePlacements;var allowedPlacements=placements$1.filter(function(placement){return allowedAutoPlacements.indexOf(placement)>=0;});if(allowedPlacements.length===0){allowedPlacements=placements$1;}// $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
var overflows=allowedPlacements.reduce(function(acc,placement){acc[placement]=detectOverflow(state,{placement:placement,boundary:boundary,rootBoundary:rootBoundary,padding:padding})[getBasePlacement(placement)];return acc;},{});return Object.keys(overflows).sort(function(a,b){return overflows[a]-overflows[b];});}function getExpandedFallbackPlacements(placement){if(getBasePlacement(placement)===auto){return[];}var oppositePlacement=getOppositePlacement(placement);return[getOppositeVariationPlacement(placement),oppositePlacement,getOppositeVariationPlacement(oppositePlacement)];}function flip(_ref){var state=_ref.state,options=_ref.options,name=_ref.name;if(state.modifiersData[name]._skip){return;}var _options$mainAxis=options.mainAxis,checkMainAxis=_options$mainAxis===void 0?true:_options$mainAxis,_options$altAxis=options.altAxis,checkAltAxis=_options$altAxis===void 0?true:_options$altAxis,specifiedFallbackPlacements=options.fallbackPlacements,padding=options.padding,boundary=options.boundary,rootBoundary=options.rootBoundary,altBoundary=options.altBoundary,_options$flipVariatio=options.flipVariations,flipVariations=_options$flipVariatio===void 0?true:_options$flipVariatio,allowedAutoPlacements=options.allowedAutoPlacements;var preferredPlacement=state.options.placement;var basePlacement=getBasePlacement(preferredPlacement);var isBasePlacement=basePlacement===preferredPlacement;var fallbackPlacements=specifiedFallbackPlacements||(isBasePlacement||!flipVariations?[getOppositePlacement(preferredPlacement)]:getExpandedFallbackPlacements(preferredPlacement));var placements=[preferredPlacement].concat(fallbackPlacements).reduce(function(acc,placement){return acc.concat(getBasePlacement(placement)===auto?computeAutoPlacement(state,{placement:placement,boundary:boundary,rootBoundary:rootBoundary,padding:padding,flipVariations:flipVariations,allowedAutoPlacements:allowedAutoPlacements}):placement);},[]);var referenceRect=state.rects.reference;var popperRect=state.rects.popper;var checksMap=new Map();var makeFallbackChecks=true;var firstFittingPlacement=placements[0];for(var i=0;i<placements.length;i++){var placement=placements[i];var _basePlacement=getBasePlacement(placement);var isStartVariation=getVariation(placement)===start;var isVertical=[top,bottom].indexOf(_basePlacement)>=0;var len=isVertical?'width':'height';var overflow=detectOverflow(state,{placement:placement,boundary:boundary,rootBoundary:rootBoundary,altBoundary:altBoundary,padding:padding});var mainVariationSide=isVertical?isStartVariation?right:left:isStartVariation?bottom:top;if(referenceRect[len]>popperRect[len]){mainVariationSide=getOppositePlacement(mainVariationSide);}var altVariationSide=getOppositePlacement(mainVariationSide);var checks=[];if(checkMainAxis){checks.push(overflow[_basePlacement]<=0);}if(checkAltAxis){checks.push(overflow[mainVariationSide]<=0,overflow[altVariationSide]<=0);}if(checks.every(function(check){return check;})){firstFittingPlacement=placement;makeFallbackChecks=false;break;}checksMap.set(placement,checks);}if(makeFallbackChecks){// `2` may be desired in some cases – research later
var numberOfChecks=flipVariations?3:1;var _loop=function _loop(_i){var fittingPlacement=placements.find(function(placement){var checks=checksMap.get(placement);if(checks){return checks.slice(0,_i).every(function(check){return check;});}});if(fittingPlacement){firstFittingPlacement=fittingPlacement;return"break";}};for(var _i=numberOfChecks;_i>0;_i--){var _ret=_loop(_i);if(_ret==="break")break;}}if(state.placement!==firstFittingPlacement){state.modifiersData[name]._skip=true;state.placement=firstFittingPlacement;state.reset=true;}}// eslint-disable-next-line import/no-unused-modules
var flip$1={name:'flip',enabled:true,phase:'main',fn:flip,requiresIfExists:['offset'],data:{_skip:false}};function getSideOffsets(overflow,rect,preventedOffsets){if(preventedOffsets===void 0){preventedOffsets={x:0,y:0};}return{top:overflow.top-rect.height-preventedOffsets.y,right:overflow.right-rect.width+preventedOffsets.x,bottom:overflow.bottom-rect.height+preventedOffsets.y,left:overflow.left-rect.width-preventedOffsets.x};}function isAnySideFullyClipped(overflow){return[top,right,bottom,left].some(function(side){return overflow[side]>=0;});}function hide(_ref){var state=_ref.state,name=_ref.name;var referenceRect=state.rects.reference;var popperRect=state.rects.popper;var preventedOffsets=state.modifiersData.preventOverflow;var referenceOverflow=detectOverflow(state,{elementContext:'reference'});var popperAltOverflow=detectOverflow(state,{altBoundary:true});var referenceClippingOffsets=getSideOffsets(referenceOverflow,referenceRect);var popperEscapeOffsets=getSideOffsets(popperAltOverflow,popperRect,preventedOffsets);var isReferenceHidden=isAnySideFullyClipped(referenceClippingOffsets);var hasPopperEscaped=isAnySideFullyClipped(popperEscapeOffsets);state.modifiersData[name]={referenceClippingOffsets:referenceClippingOffsets,popperEscapeOffsets:popperEscapeOffsets,isReferenceHidden:isReferenceHidden,hasPopperEscaped:hasPopperEscaped};state.attributes.popper=Object.assign({},state.attributes.popper,{'data-popper-reference-hidden':isReferenceHidden,'data-popper-escaped':hasPopperEscaped});}// eslint-disable-next-line import/no-unused-modules
var hide$1={name:'hide',enabled:true,phase:'main',requiresIfExists:['preventOverflow'],fn:hide};function distanceAndSkiddingToXY(placement,rects,offset){var basePlacement=getBasePlacement(placement);var invertDistance=[left,top].indexOf(basePlacement)>=0?-1:1;var _ref=typeof offset==='function'?offset(Object.assign({},rects,{placement:placement})):offset,skidding=_ref[0],distance=_ref[1];skidding=skidding||0;distance=(distance||0)*invertDistance;return[left,right].indexOf(basePlacement)>=0?{x:distance,y:skidding}:{x:skidding,y:distance};}function offset(_ref2){var state=_ref2.state,options=_ref2.options,name=_ref2.name;var _options$offset=options.offset,offset=_options$offset===void 0?[0,0]:_options$offset;var data=placements.reduce(function(acc,placement){acc[placement]=distanceAndSkiddingToXY(placement,state.rects,offset);return acc;},{});var _data$state$placement=data[state.placement],x=_data$state$placement.x,y=_data$state$placement.y;if(state.modifiersData.popperOffsets!=null){state.modifiersData.popperOffsets.x+=x;state.modifiersData.popperOffsets.y+=y;}state.modifiersData[name]=data;}// eslint-disable-next-line import/no-unused-modules
var offset$1={name:'offset',enabled:true,phase:'main',requires:['popperOffsets'],fn:offset};function popperOffsets(_ref){var state=_ref.state,name=_ref.name;// Offsets are the actual position the popper needs to have to be
// properly positioned near its reference element
// This is the most basic placement, and will be adjusted by
// the modifiers in the next step
state.modifiersData[name]=computeOffsets({reference:state.rects.reference,element:state.rects.popper,strategy:'absolute',placement:state.placement});}// eslint-disable-next-line import/no-unused-modules
var popperOffsets$1={name:'popperOffsets',enabled:true,phase:'read',fn:popperOffsets,data:{}};function getAltAxis(axis){return axis==='x'?'y':'x';}function preventOverflow(_ref){var state=_ref.state,options=_ref.options,name=_ref.name;var _options$mainAxis=options.mainAxis,checkMainAxis=_options$mainAxis===void 0?true:_options$mainAxis,_options$altAxis=options.altAxis,checkAltAxis=_options$altAxis===void 0?false:_options$altAxis,boundary=options.boundary,rootBoundary=options.rootBoundary,altBoundary=options.altBoundary,padding=options.padding,_options$tether=options.tether,tether=_options$tether===void 0?true:_options$tether,_options$tetherOffset=options.tetherOffset,tetherOffset=_options$tetherOffset===void 0?0:_options$tetherOffset;var overflow=detectOverflow(state,{boundary:boundary,rootBoundary:rootBoundary,padding:padding,altBoundary:altBoundary});var basePlacement=getBasePlacement(state.placement);var variation=getVariation(state.placement);var isBasePlacement=!variation;var mainAxis=getMainAxisFromPlacement(basePlacement);var altAxis=getAltAxis(mainAxis);var popperOffsets=state.modifiersData.popperOffsets;var referenceRect=state.rects.reference;var popperRect=state.rects.popper;var tetherOffsetValue=typeof tetherOffset==='function'?tetherOffset(Object.assign({},state.rects,{placement:state.placement})):tetherOffset;var data={x:0,y:0};if(!popperOffsets){return;}if(checkMainAxis||checkAltAxis){var mainSide=mainAxis==='y'?top:left;var altSide=mainAxis==='y'?bottom:right;var len=mainAxis==='y'?'height':'width';var offset=popperOffsets[mainAxis];var min$1=popperOffsets[mainAxis]+overflow[mainSide];var max$1=popperOffsets[mainAxis]-overflow[altSide];var additive=tether?-popperRect[len]/2:0;var minLen=variation===start?referenceRect[len]:popperRect[len];var maxLen=variation===start?-popperRect[len]:-referenceRect[len];// We need to include the arrow in the calculation so the arrow doesn't go
// outside the reference bounds
var arrowElement=state.elements.arrow;var arrowRect=tether&&arrowElement?getLayoutRect(arrowElement):{width:0,height:0};var arrowPaddingObject=state.modifiersData['arrow#persistent']?state.modifiersData['arrow#persistent'].padding:getFreshSideObject();var arrowPaddingMin=arrowPaddingObject[mainSide];var arrowPaddingMax=arrowPaddingObject[altSide];// If the reference length is smaller than the arrow length, we don't want
// to include its full size in the calculation. If the reference is small
// and near the edge of a boundary, the popper can overflow even if the
// reference is not overflowing as well (e.g. virtual elements with no
// width or height)
var arrowLen=within(0,referenceRect[len],arrowRect[len]);var minOffset=isBasePlacement?referenceRect[len]/2-additive-arrowLen-arrowPaddingMin-tetherOffsetValue:minLen-arrowLen-arrowPaddingMin-tetherOffsetValue;var maxOffset=isBasePlacement?-referenceRect[len]/2+additive+arrowLen+arrowPaddingMax+tetherOffsetValue:maxLen+arrowLen+arrowPaddingMax+tetherOffsetValue;var arrowOffsetParent=state.elements.arrow&&getOffsetParent(state.elements.arrow);var clientOffset=arrowOffsetParent?mainAxis==='y'?arrowOffsetParent.clientTop||0:arrowOffsetParent.clientLeft||0:0;var offsetModifierValue=state.modifiersData.offset?state.modifiersData.offset[state.placement][mainAxis]:0;var tetherMin=popperOffsets[mainAxis]+minOffset-offsetModifierValue-clientOffset;var tetherMax=popperOffsets[mainAxis]+maxOffset-offsetModifierValue;if(checkMainAxis){var preventedOffset=within(tether?min(min$1,tetherMin):min$1,offset,tether?max(max$1,tetherMax):max$1);popperOffsets[mainAxis]=preventedOffset;data[mainAxis]=preventedOffset-offset;}if(checkAltAxis){var _mainSide=mainAxis==='x'?top:left;var _altSide=mainAxis==='x'?bottom:right;var _offset=popperOffsets[altAxis];var _min=_offset+overflow[_mainSide];var _max=_offset-overflow[_altSide];var _preventedOffset=within(tether?min(_min,tetherMin):_min,_offset,tether?max(_max,tetherMax):_max);popperOffsets[altAxis]=_preventedOffset;data[altAxis]=_preventedOffset-_offset;}}state.modifiersData[name]=data;}// eslint-disable-next-line import/no-unused-modules
var preventOverflow$1={name:'preventOverflow',enabled:true,phase:'main',fn:preventOverflow,requiresIfExists:['offset']};function getHTMLElementScroll(element){return{scrollLeft:element.scrollLeft,scrollTop:element.scrollTop};}function getNodeScroll(node){if(node===getWindow(node)||!isHTMLElement(node)){return getWindowScroll(node);}else{return getHTMLElementScroll(node);}}function isElementScaled(element){var rect=element.getBoundingClientRect();var scaleX=rect.width/element.offsetWidth||1;var scaleY=rect.height/element.offsetHeight||1;return scaleX!==1||scaleY!==1;}// Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.
function getCompositeRect(elementOrVirtualElement,offsetParent,isFixed){if(isFixed===void 0){isFixed=false;}var isOffsetParentAnElement=isHTMLElement(offsetParent);isHTMLElement(offsetParent)&&isElementScaled(offsetParent);var documentElement=getDocumentElement(offsetParent);var rect=getBoundingClientRect(elementOrVirtualElement);var scroll={scrollLeft:0,scrollTop:0};var offsets={x:0,y:0};if(isOffsetParentAnElement||!isOffsetParentAnElement&&!isFixed){if(getNodeName(offsetParent)!=='body'||// https://github.com/popperjs/popper-core/issues/1078
isScrollParent(documentElement)){scroll=getNodeScroll(offsetParent);}if(isHTMLElement(offsetParent)){offsets=getBoundingClientRect(offsetParent);offsets.x+=offsetParent.clientLeft;offsets.y+=offsetParent.clientTop;}else if(documentElement){offsets.x=getWindowScrollBarX(documentElement);}}return{x:rect.left+scroll.scrollLeft-offsets.x,y:rect.top+scroll.scrollTop-offsets.y,width:rect.width,height:rect.height};}function order(modifiers){var map=new Map();var visited=new Set();var result=[];modifiers.forEach(function(modifier){map.set(modifier.name,modifier);});// On visiting object, check for its dependencies and visit them recursively
function sort(modifier){visited.add(modifier.name);var requires=[].concat(modifier.requires||[],modifier.requiresIfExists||[]);requires.forEach(function(dep){if(!visited.has(dep)){var depModifier=map.get(dep);if(depModifier){sort(depModifier);}}});result.push(modifier);}modifiers.forEach(function(modifier){if(!visited.has(modifier.name)){// check for visited object
sort(modifier);}});return result;}function orderModifiers(modifiers){// order based on dependencies
var orderedModifiers=order(modifiers);// order based on phase
return modifierPhases.reduce(function(acc,phase){return acc.concat(orderedModifiers.filter(function(modifier){return modifier.phase===phase;}));},[]);}function debounce(fn){var pending;return function(){if(!pending){pending=new Promise(function(resolve){Promise.resolve().then(function(){pending=undefined;resolve(fn());});});}return pending;};}function mergeByName(modifiers){var merged=modifiers.reduce(function(merged,current){var existing=merged[current.name];merged[current.name]=existing?Object.assign({},existing,current,{options:Object.assign({},existing.options,current.options),data:Object.assign({},existing.data,current.data)}):current;return merged;},{});// IE11 does not support Object.values
return Object.keys(merged).map(function(key){return merged[key];});}var DEFAULT_OPTIONS={placement:'bottom',modifiers:[],strategy:'absolute'};function areValidElements(){for(var _len=arguments.length,args=new Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return!args.some(function(element){return!(element&&typeof element.getBoundingClientRect==='function');});}function popperGenerator(generatorOptions){if(generatorOptions===void 0){generatorOptions={};}var _generatorOptions=generatorOptions,_generatorOptions$def=_generatorOptions.defaultModifiers,defaultModifiers=_generatorOptions$def===void 0?[]:_generatorOptions$def,_generatorOptions$def2=_generatorOptions.defaultOptions,defaultOptions=_generatorOptions$def2===void 0?DEFAULT_OPTIONS:_generatorOptions$def2;return function createPopper(reference,popper,options){if(options===void 0){options=defaultOptions;}var state={placement:'bottom',orderedModifiers:[],options:Object.assign({},DEFAULT_OPTIONS,defaultOptions),modifiersData:{},elements:{reference:reference,popper:popper},attributes:{},styles:{}};var effectCleanupFns=[];var isDestroyed=false;var instance={state:state,setOptions:function setOptions(setOptionsAction){var options=typeof setOptionsAction==='function'?setOptionsAction(state.options):setOptionsAction;cleanupModifierEffects();state.options=Object.assign({},defaultOptions,state.options,options);state.scrollParents={reference:isElement(reference)?listScrollParents(reference):reference.contextElement?listScrollParents(reference.contextElement):[],popper:listScrollParents(popper)};// Orders the modifiers based on their dependencies and `phase`
// properties
var orderedModifiers=orderModifiers(mergeByName([].concat(defaultModifiers,state.options.modifiers)));// Strip out disabled modifiers
state.orderedModifiers=orderedModifiers.filter(function(m){return m.enabled;});// Validate the provided modifiers so that the consumer will get warned
runModifierEffects();return instance.update();},// Sync update – it will always be executed, even if not necessary. This
// is useful for low frequency updates where sync behavior simplifies the
// logic.
// For high frequency updates (e.g. `resize` and `scroll` events), always
// prefer the async Popper#update method
forceUpdate:function forceUpdate(){if(isDestroyed){return;}var _state$elements=state.elements,reference=_state$elements.reference,popper=_state$elements.popper;// Don't proceed if `reference` or `popper` are not valid elements
// anymore
if(!areValidElements(reference,popper)){return;}// Store the reference and popper rects to be read by modifiers
state.rects={reference:getCompositeRect(reference,getOffsetParent(popper),state.options.strategy==='fixed'),popper:getLayoutRect(popper)};// Modifiers have the ability to reset the current update cycle. The
// most common use case for this is the `flip` modifier changing the
// placement, which then needs to re-run all the modifiers, because the
// logic was previously ran for the previous placement and is therefore
// stale/incorrect
state.reset=false;state.placement=state.options.placement;// On each update cycle, the `modifiersData` property for each modifier
// is filled with the initial data specified by the modifier. This means
// it doesn't persist and is fresh on each update.
// To ensure persistent data, use `${name}#persistent`
state.orderedModifiers.forEach(function(modifier){return state.modifiersData[modifier.name]=Object.assign({},modifier.data);});for(var index=0;index<state.orderedModifiers.length;index++){if(state.reset===true){state.reset=false;index=-1;continue;}var _state$orderedModifie=state.orderedModifiers[index],fn=_state$orderedModifie.fn,_state$orderedModifie2=_state$orderedModifie.options,_options=_state$orderedModifie2===void 0?{}:_state$orderedModifie2,name=_state$orderedModifie.name;if(typeof fn==='function'){state=fn({state:state,options:_options,name:name,instance:instance})||state;}}},// Async and optimistically optimized update – it will not be executed if
// not necessary (debounced to run at most once-per-tick)
update:debounce(function(){return new Promise(function(resolve){instance.forceUpdate();resolve(state);});}),destroy:function destroy(){cleanupModifierEffects();isDestroyed=true;}};if(!areValidElements(reference,popper)){return instance;}instance.setOptions(options).then(function(state){if(!isDestroyed&&options.onFirstUpdate){options.onFirstUpdate(state);}});// Modifiers have the ability to execute arbitrary code before the first
// update cycle runs. They will be executed in the same order as the update
// cycle. This is useful when a modifier adds some persistent data that
// other modifiers need to use, but the modifier is run after the dependent
// one.
function runModifierEffects(){state.orderedModifiers.forEach(function(_ref3){var name=_ref3.name,_ref3$options=_ref3.options,options=_ref3$options===void 0?{}:_ref3$options,effect=_ref3.effect;if(typeof effect==='function'){var cleanupFn=effect({state:state,name:name,instance:instance,options:options});var noopFn=function noopFn(){};effectCleanupFns.push(cleanupFn||noopFn);}});}function cleanupModifierEffects(){effectCleanupFns.forEach(function(fn){return fn();});effectCleanupFns=[];}return instance;};}var createPopper$2=/*#__PURE__*/popperGenerator();// eslint-disable-next-line import/no-unused-modules
var defaultModifiers$1=[eventListeners,popperOffsets$1,computeStyles$1,applyStyles$1];var createPopper$1=/*#__PURE__*/popperGenerator({defaultModifiers:defaultModifiers$1});// eslint-disable-next-line import/no-unused-modules
var defaultModifiers=[eventListeners,popperOffsets$1,computeStyles$1,applyStyles$1,offset$1,flip$1,preventOverflow$1,arrow$1,hide$1];var createPopper=/*#__PURE__*/popperGenerator({defaultModifiers:defaultModifiers});// eslint-disable-next-line import/no-unused-modules
var Popper=/*#__PURE__*/Object.freeze({__proto__:null,popperGenerator:popperGenerator,detectOverflow:detectOverflow,createPopperBase:createPopper$2,createPopper:createPopper,createPopperLite:createPopper$1,top:top,bottom:bottom,right:right,left:left,auto:auto,basePlacements:basePlacements,start:start,end:end,clippingParents:clippingParents,viewport:viewport,popper:popper,reference:reference,variationPlacements:variationPlacements,placements:placements,beforeRead:beforeRead,read:read,afterRead:afterRead,beforeMain:beforeMain,main:main,afterMain:afterMain,beforeWrite:beforeWrite,write:write,afterWrite:afterWrite,modifierPhases:modifierPhases,applyStyles:applyStyles$1,arrow:arrow$1,computeStyles:computeStyles$1,eventListeners:eventListeners,flip:flip$1,hide:hide$1,offset:offset$1,popperOffsets:popperOffsets$1,preventOverflow:preventOverflow$1});/**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/scrollBar.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */var SELECTOR_FIXED_CONTENT='.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';var SELECTOR_STICKY_CONTENT='.sticky-top';var ScrollBarHelper=/*#__PURE__*/function(){function ScrollBarHelper(){(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this,ScrollBarHelper);this._element=document.body;}(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ScrollBarHelper,[{key:"getWidth",value:function getWidth(){// https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
var documentWidth=document.documentElement.clientWidth;return Math.abs(window.innerWidth-documentWidth);}},{key:"hide",value:function hide(){var width=this.getWidth();this._disableOverFlow();// give padding to element to balance the hidden scrollbar width
this._setElementAttributes(this._element,'paddingRight',function(calculatedValue){return calculatedValue+width;});// trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
this._setElementAttributes(SELECTOR_FIXED_CONTENT,'paddingRight',function(calculatedValue){return calculatedValue+width;});this._setElementAttributes(SELECTOR_STICKY_CONTENT,'marginRight',function(calculatedValue){return calculatedValue-width;});}},{key:"_disableOverFlow",value:function _disableOverFlow(){this._saveInitialAttribute(this._element,'overflow');this._element.style.overflow='hidden';}},{key:"_setElementAttributes",value:function _setElementAttributes(selector,styleProp,callback){var _this11=this;var scrollbarWidth=this.getWidth();var manipulationCallBack=function manipulationCallBack(element){if(element!==_this11._element&&window.innerWidth>element.clientWidth+scrollbarWidth){return;}_this11._saveInitialAttribute(element,styleProp);var calculatedValue=window.getComputedStyle(element)[styleProp];element.style[styleProp]="".concat(callback(Number.parseFloat(calculatedValue)),"px");};this._applyManipulationCallback(selector,manipulationCallBack);}},{key:"reset",value:function reset(){this._resetElementAttributes(this._element,'overflow');this._resetElementAttributes(this._element,'paddingRight');this._resetElementAttributes(SELECTOR_FIXED_CONTENT,'paddingRight');this._resetElementAttributes(SELECTOR_STICKY_CONTENT,'marginRight');}},{key:"_saveInitialAttribute",value:function _saveInitialAttribute(element,styleProp){var actualValue=element.style[styleProp];if(actualValue){Manipulator.setDataAttribute(element,styleProp,actualValue);}}},{key:"_resetElementAttributes",value:function _resetElementAttributes(selector,styleProp){var manipulationCallBack=function manipulationCallBack(element){var value=Manipulator.getDataAttribute(element,styleProp);if(typeof value==='undefined'){element.style.removeProperty(styleProp);}else{Manipulator.removeDataAttribute(element,styleProp);element.style[styleProp]=value;}};this._applyManipulationCallback(selector,manipulationCallBack);}},{key:"_applyManipulationCallback",value:function _applyManipulationCallback(selector,callBack){if(isElement$1(selector)){callBack(selector);}else{SelectorEngine.find(selector,this._element).forEach(callBack);}}},{key:"isOverflowing",value:function isOverflowing(){return this.getWidth()>0;}}]);return ScrollBarHelper;}();/**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/backdrop.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */var Default$7={className:'modal-backdrop',isVisible:true,// if false, we use the backdrop helper without adding any element to the dom
isAnimated:false,rootElement:'body',// give the choice to place backdrop under different elements
clickCallback:null};var DefaultType$7={className:'string',isVisible:'boolean',isAnimated:'boolean',rootElement:'(element|string)',clickCallback:'(function|null)'};var NAME$8='backdrop';var CLASS_NAME_FADE$4='fade';var CLASS_NAME_SHOW$5='show';var EVENT_MOUSEDOWN="mousedown.bs.".concat(NAME$8);var Backdrop=/*#__PURE__*/function(){function Backdrop(config){(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this,Backdrop);this._config=this._getConfig(config);this._isAppended=false;this._element=null;}(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Backdrop,[{key:"show",value:function show(callback){if(!this._config.isVisible){execute(callback);return;}this._append();if(this._config.isAnimated){reflow(this._getElement());}this._getElement().classList.add(CLASS_NAME_SHOW$5);this._emulateAnimation(function(){execute(callback);});}},{key:"hide",value:function hide(callback){var _this12=this;if(!this._config.isVisible){execute(callback);return;}this._getElement().classList.remove(CLASS_NAME_SHOW$5);this._emulateAnimation(function(){_this12.dispose();execute(callback);});}// Private
},{key:"_getElement",value:function _getElement(){if(!this._element){var backdrop=document.createElement('div');backdrop.className=this._config.className;if(this._config.isAnimated){backdrop.classList.add(CLASS_NAME_FADE$4);}this._element=backdrop;}return this._element;}},{key:"_getConfig",value:function _getConfig(config){config=(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({},Default$7),typeof config==='object'?config:{});// use getElement() with the default "body" to get a fresh Element on each instantiation
config.rootElement=getElement(config.rootElement);typeCheckConfig(NAME$8,config,DefaultType$7);return config;}},{key:"_append",value:function _append(){var _this13=this;if(this._isAppended){return;}this._config.rootElement.append(this._getElement());EventHandler.on(this._getElement(),EVENT_MOUSEDOWN,function(){execute(_this13._config.clickCallback);});this._isAppended=true;}},{key:"dispose",value:function dispose(){if(!this._isAppended){return;}EventHandler.off(this._element,EVENT_MOUSEDOWN);this._element.remove();this._isAppended=false;}},{key:"_emulateAnimation",value:function _emulateAnimation(callback){executeAfterTransition(callback,this._getElement(),this._config.isAnimated);}}]);return Backdrop;}();/**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/focustrap.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */var Default$6={trapElement:null,// The element to trap focus inside of
autofocus:true};var DefaultType$6={trapElement:'element',autofocus:'boolean'};var NAME$7='focustrap';var DATA_KEY$7='bs.focustrap';var EVENT_KEY$7=".".concat(DATA_KEY$7);var EVENT_FOCUSIN$1="focusin".concat(EVENT_KEY$7);var EVENT_KEYDOWN_TAB="keydown.tab".concat(EVENT_KEY$7);var TAB_KEY='Tab';var TAB_NAV_FORWARD='forward';var TAB_NAV_BACKWARD='backward';var FocusTrap=/*#__PURE__*/function(){function FocusTrap(config){(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this,FocusTrap);this._config=this._getConfig(config);this._isActive=false;this._lastTabNavDirection=null;}(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(FocusTrap,[{key:"activate",value:function activate(){var _this14=this;var _this$_config=this._config,trapElement=_this$_config.trapElement,autofocus=_this$_config.autofocus;if(this._isActive){return;}if(autofocus){trapElement.focus();}EventHandler.off(document,EVENT_KEY$7);// guard against infinite focus loop
EventHandler.on(document,EVENT_FOCUSIN$1,function(event){return _this14._handleFocusin(event);});EventHandler.on(document,EVENT_KEYDOWN_TAB,function(event){return _this14._handleKeydown(event);});this._isActive=true;}},{key:"deactivate",value:function deactivate(){if(!this._isActive){return;}this._isActive=false;EventHandler.off(document,EVENT_KEY$7);}// Private
},{key:"_handleFocusin",value:function _handleFocusin(event){var target=event.target;var trapElement=this._config.trapElement;if(target===document||target===trapElement||trapElement.contains(target)){return;}var elements=SelectorEngine.focusableChildren(trapElement);if(elements.length===0){trapElement.focus();}else if(this._lastTabNavDirection===TAB_NAV_BACKWARD){elements[elements.length-1].focus();}else{elements[0].focus();}}},{key:"_handleKeydown",value:function _handleKeydown(event){if(event.key!==TAB_KEY){return;}this._lastTabNavDirection=event.shiftKey?TAB_NAV_BACKWARD:TAB_NAV_FORWARD;}},{key:"_getConfig",value:function _getConfig(config){config=(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_objectSpread2_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({},Default$6),typeof config==='object'?config:{});typeCheckConfig(NAME$7,config,DefaultType$6);return config;}}]);return FocusTrap;}();/**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): util/sanitizer.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */var uriAttributes=new Set(['background','cite','href','itemtype','longdesc','poster','src','xlink:href']);var ARIA_ATTRIBUTE_PATTERN=/^aria-[\w-]*$/i;/**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
   */var SAFE_URL_PATTERN=/^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i;/**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
   */var DATA_URL_PATTERN=/^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;var allowedAttribute=function allowedAttribute(attribute,allowedAttributeList){var attributeName=attribute.nodeName.toLowerCase();if(allowedAttributeList.includes(attributeName)){if(uriAttributes.has(attributeName)){return Boolean(SAFE_URL_PATTERN.test(attribute.nodeValue)||DATA_URL_PATTERN.test(attribute.nodeValue));}return true;}var regExp=allowedAttributeList.filter(function(attributeRegex){return attributeRegex instanceof RegExp;});// Check if a regular expression validates the attribute.
for(var i=0,len=regExp.length;i<len;i++){if(regExp[i].test(attributeName)){return true;}}return false;};var DefaultAllowlist={// Global attributes allowed on any supplied element below.
'*':['class','dir','id','lang','role',ARIA_ATTRIBUTE_PATTERN],a:['target','href','title','rel'],area:[],b:[],br:[],col:[],code:[],div:[],em:[],hr:[],h1:[],h2:[],h3:[],h4:[],h5:[],h6:[],i:[],img:['src','srcset','alt','title','width','height'],li:[],ol:[],p:[],pre:[],s:[],small:[],span:[],sub:[],sup:[],strong:[],u:[],ul:[]};function sanitizeHtml(unsafeHtml,allowList,sanitizeFn){var _ref8;if(!unsafeHtml.length){return unsafeHtml;}if(sanitizeFn&&typeof sanitizeFn==='function'){return sanitizeFn(unsafeHtml);}var domParser=new window.DOMParser();var createdDocument=domParser.parseFromString(unsafeHtml,'text/html');var elements=(_ref8=[]).concat.apply(_ref8,(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(createdDocument.body.querySelectorAll('*')));var _loop2=function _loop2(i,len){var _ref9;var element=elements[i];var elementName=element.nodeName.toLowerCase();if(!Object.keys(allowList).includes(elementName)){element.remove();return"continue";}var attributeList=(_ref9=[]).concat.apply(_ref9,(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(element.attributes));var allowedAttributes=[].concat(allowList['*']||[],allowList[elementName]||[]);attributeList.forEach(function(attribute){if(!allowedAttribute(attribute,allowedAttributes)){element.removeAttribute(attribute.nodeName);}});};for(var i=0,len=elements.length;i<len;i++){var _ret2=_loop2(i,len);if(_ret2==="continue")continue;}return createdDocument.body.innerHTML;}/**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): tab.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */var NAME$1='tab';var DATA_KEY$1='bs.tab';var EVENT_KEY$1=".".concat(DATA_KEY$1);var DATA_API_KEY='.data-api';var EVENT_HIDE$1="hide".concat(EVENT_KEY$1);var EVENT_HIDDEN$1="hidden".concat(EVENT_KEY$1);var EVENT_SHOW$1="show".concat(EVENT_KEY$1);var EVENT_SHOWN$1="shown".concat(EVENT_KEY$1);var EVENT_CLICK_DATA_API="click".concat(EVENT_KEY$1).concat(DATA_API_KEY);var CLASS_NAME_DROPDOWN_MENU='dropdown-menu';var CLASS_NAME_ACTIVE='active';var CLASS_NAME_FADE$1='fade';var CLASS_NAME_SHOW$1='show';var SELECTOR_DROPDOWN='.dropdown';var SELECTOR_NAV_LIST_GROUP='.nav, .list-group';var SELECTOR_ACTIVE='.active';var SELECTOR_ACTIVE_UL=':scope > li > .active';var SELECTOR_DATA_TOGGLE='[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]';var SELECTOR_DROPDOWN_TOGGLE='.dropdown-toggle';var SELECTOR_DROPDOWN_ACTIVE_CHILD=':scope > .dropdown-menu .active';/**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */var Tab=/*#__PURE__*/function(_BaseComponent3){(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(Tab,_BaseComponent3);var _super3=(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_createSuper_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(Tab);function Tab(){(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this,Tab);return _super3.apply(this,arguments);}(0,_Volumes_Data_supernovabrands_sandandsky_lp_react_node_modules_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Tab,[{key:"show",value:// Public
function show(){var _this15=this;if(this._element.parentNode&&this._element.parentNode.nodeType===Node.ELEMENT_NODE&&this._element.classList.contains(CLASS_NAME_ACTIVE)){return;}var previous;var target=getElementFromSelector(this._element);var listElement=this._element.closest(SELECTOR_NAV_LIST_GROUP);if(listElement){var itemSelector=listElement.nodeName==='UL'||listElement.nodeName==='OL'?SELECTOR_ACTIVE_UL:SELECTOR_ACTIVE;previous=SelectorEngine.find(itemSelector,listElement);previous=previous[previous.length-1];}var hideEvent=previous?EventHandler.trigger(previous,EVENT_HIDE$1,{relatedTarget:this._element}):null;var showEvent=EventHandler.trigger(this._element,EVENT_SHOW$1,{relatedTarget:previous});if(showEvent.defaultPrevented||hideEvent!==null&&hideEvent.defaultPrevented){return;}this._activate(this._element,listElement);var complete=function complete(){EventHandler.trigger(previous,EVENT_HIDDEN$1,{relatedTarget:_this15._element});EventHandler.trigger(_this15._element,EVENT_SHOWN$1,{relatedTarget:previous});};if(target){this._activate(target,target.parentNode,complete);}else{complete();}}// Private
},{key:"_activate",value:function _activate(element,container,callback){var _this16=this;var activeElements=container&&(container.nodeName==='UL'||container.nodeName==='OL')?SelectorEngine.find(SELECTOR_ACTIVE_UL,container):SelectorEngine.children(container,SELECTOR_ACTIVE);var active=activeElements[0];var isTransitioning=callback&&active&&active.classList.contains(CLASS_NAME_FADE$1);var complete=function complete(){return _this16._transitionComplete(element,active,callback);};if(active&&isTransitioning){active.classList.remove(CLASS_NAME_SHOW$1);this._queueCallback(complete,element,true);}else{complete();}}},{key:"_transitionComplete",value:function _transitionComplete(element,active,callback){if(active){active.classList.remove(CLASS_NAME_ACTIVE);var dropdownChild=SelectorEngine.findOne(SELECTOR_DROPDOWN_ACTIVE_CHILD,active.parentNode);if(dropdownChild){dropdownChild.classList.remove(CLASS_NAME_ACTIVE);}if(active.getAttribute('role')==='tab'){active.setAttribute('aria-selected',false);}}element.classList.add(CLASS_NAME_ACTIVE);if(element.getAttribute('role')==='tab'){element.setAttribute('aria-selected',true);}reflow(element);if(element.classList.contains(CLASS_NAME_FADE$1)){element.classList.add(CLASS_NAME_SHOW$1);}var parent=element.parentNode;if(parent&&parent.nodeName==='LI'){parent=parent.parentNode;}if(parent&&parent.classList.contains(CLASS_NAME_DROPDOWN_MENU)){var dropdownElement=element.closest(SELECTOR_DROPDOWN);if(dropdownElement){SelectorEngine.find(SELECTOR_DROPDOWN_TOGGLE,dropdownElement).forEach(function(dropdown){return dropdown.classList.add(CLASS_NAME_ACTIVE);});}element.setAttribute('aria-expanded',true);}if(callback){callback();}}// Static
}],[{key:"NAME",get:// Getters
function get(){return NAME$1;}},{key:"jQueryInterface",value:function jQueryInterface(config){return this.each(function(){var data=Tab.getOrCreateInstance(this);if(typeof config==='string'){if(typeof data[config]==='undefined'){throw new TypeError("No method named \"".concat(config,"\""));}data[config]();}});}}]);return Tab;}(BaseComponent);/**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */EventHandler.on(document,EVENT_CLICK_DATA_API,SELECTOR_DATA_TOGGLE,function(event){if(['A','AREA'].includes(this.tagName)){event.preventDefault();}if(isDisabled(this)){return;}var data=Tab.getOrCreateInstance(this);data.show();});/**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   * add .Tab to jQuery only if jQuery is present
   */defineJQueryPlugin(Tab);/**
   * --------------------------------------------------------------------------
   * Bootstrap (v5.1.3): index.umd.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */var index_umd={// Button,
Carousel:Carousel,Collapse:Collapse,Tab:Tab};return index_umd;});

/***/ }),

/***/ 651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Alert": function() { return /* binding */ Alert; },
  "Button": function() { return /* binding */ Button; },
  "Carousel": function() { return /* binding */ Carousel; },
  "Collapse": function() { return /* binding */ Collapse; },
  "Dropdown": function() { return /* binding */ Dropdown; },
  "Modal": function() { return /* binding */ Modal; },
  "Offcanvas": function() { return /* binding */ Offcanvas; },
  "Popover": function() { return /* binding */ Popover; },
  "ScrollSpy": function() { return /* binding */ ScrollSpy; },
  "Tab": function() { return /* binding */ Tab; },
  "Toast": function() { return /* binding */ Toast; },
  "Tooltip": function() { return /* binding */ Tooltip; }
});

// NAMESPACE OBJECT: ./node_modules/@popperjs/core/lib/index.js
var lib_namespaceObject = {};
__webpack_require__.r(lib_namespaceObject);
__webpack_require__.d(lib_namespaceObject, {
  "afterMain": function() { return afterMain; },
  "afterRead": function() { return afterRead; },
  "afterWrite": function() { return afterWrite; },
  "applyStyles": function() { return modifiers_applyStyles; },
  "arrow": function() { return modifiers_arrow; },
  "auto": function() { return auto; },
  "basePlacements": function() { return basePlacements; },
  "beforeMain": function() { return beforeMain; },
  "beforeRead": function() { return beforeRead; },
  "beforeWrite": function() { return beforeWrite; },
  "bottom": function() { return bottom; },
  "clippingParents": function() { return clippingParents; },
  "computeStyles": function() { return modifiers_computeStyles; },
  "createPopper": function() { return popper_createPopper; },
  "createPopperBase": function() { return createPopper; },
  "createPopperLite": function() { return popper_lite_createPopper; },
  "detectOverflow": function() { return detectOverflow; },
  "end": function() { return end; },
  "eventListeners": function() { return eventListeners; },
  "flip": function() { return modifiers_flip; },
  "hide": function() { return modifiers_hide; },
  "left": function() { return left; },
  "main": function() { return main; },
  "modifierPhases": function() { return modifierPhases; },
  "offset": function() { return modifiers_offset; },
  "placements": function() { return enums_placements; },
  "popper": function() { return popper; },
  "popperGenerator": function() { return popperGenerator; },
  "popperOffsets": function() { return modifiers_popperOffsets; },
  "preventOverflow": function() { return modifiers_preventOverflow; },
  "read": function() { return read; },
  "reference": function() { return reference; },
  "right": function() { return right; },
  "start": function() { return start; },
  "top": function() { return enums_top; },
  "variationPlacements": function() { return variationPlacements; },
  "viewport": function() { return viewport; },
  "write": function() { return write; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(120);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/superPropBase.js

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = (0,getPrototypeOf/* default */.Z)(object);
    if (object === null) break;
  }

  return object;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/get.js

function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }

      return desc.value;
    };
  }

  return _get.apply(this, arguments);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(413);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(942);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(982);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__(340);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js + 4 modules
var createSuper = __webpack_require__(876);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(885);
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/enums.js
var enums_top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [enums_top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var enums_placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeName.js
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindow.js
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/instanceOf.js


function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/applyStyles.js

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_applyStyles = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect,
  requires: ['computeStyles']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getBasePlacement.js

function getBasePlacement(placement) {
  return placement.split('-')[0];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/math.js
var math_max = Math.max;
var math_min = Math.min;
var round = Math.round;
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getBoundingClientRect.js


function getBoundingClientRect(element, includeScale) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  var rect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (isHTMLElement(element) && includeScale) {
    var offsetHeight = element.offsetHeight;
    var offsetWidth = element.offsetWidth; // Do not attempt to divide by 0, otherwise we get `Infinity` as scale
    // Fallback to 1 in case both values are `0`

    if (offsetWidth > 0) {
      scaleX = round(rect.width) / offsetWidth || 1;
    }

    if (offsetHeight > 0) {
      scaleY = round(rect.height) / offsetHeight || 1;
    }
  }

  return {
    width: rect.width / scaleX,
    height: rect.height / scaleY,
    top: rect.top / scaleY,
    right: rect.right / scaleX,
    bottom: rect.bottom / scaleY,
    left: rect.left / scaleX,
    x: rect.left / scaleX,
    y: rect.top / scaleY
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getLayoutRect.js
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/contains.js

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
    var next = child;

    do {
      if (next && parent.isSameNode(next)) {
        return true;
      } // $FlowFixMe[prop-missing]: need a better way to handle this...


      next = next.parentNode || next.host;
    } while (next);
  } // Give up, the result is false


  return false;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getComputedStyle.js

function getComputedStyle_getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isTableElement.js

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentElement.js

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getParentNode.js



function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getOffsetParent.js







function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle_getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle_getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle_getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle_getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle_getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/within.js

function within(min, value, max) {
  return math_max(min, math_min(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getFreshSideObject.js
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergePaddingObject.js

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/arrow.js









 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? enums_top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function arrow_effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (false) {}

  if (!contains(state.elements.popper, arrowElement)) {
    if (false) {}

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_arrow = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: arrow_effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getVariation.js
function getVariation(placement) {
  return placement.split('-')[1];
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/computeStyles.js







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = enums_top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle_getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === enums_top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === enums_top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (false) { var transitionProperty; }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_computeStyles = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/eventListeners.js
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function eventListeners_effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var eventListeners = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: eventListeners_effect,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositePlacement.js
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getOppositeVariationPlacement.js
var getOppositeVariationPlacement_hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return getOppositeVariationPlacement_hash[matched];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScroll.js

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getWindowScrollBarX.js



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getViewportRect.js



function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getDocumentRect.js




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = math_max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = math_max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle_getComputedStyle(body || html).direction === 'rtl') {
    x += math_max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/isScrollParent.js

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle_getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getScrollParent.js




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/listScrollParents.js




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/rectToClientRect.js
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getClippingRect.js















function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle_getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = math_max(rect.top, accRect.top);
    accRect.right = math_min(rect.right, accRect.right);
    accRect.bottom = math_min(rect.bottom, accRect.bottom);
    accRect.left = math_max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeOffsets.js




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case enums_top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/detectOverflow.js








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [enums_top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/computeAutoPlacement.js




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? enums_placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;

    if (false) {}
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/flip.js






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [enums_top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : enums_top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_flip = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/hide.js



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [enums_top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_hide = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/offset.js

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, enums_top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = enums_placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_offset = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/popperOffsets.js


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name; // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step

  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_popperOffsets = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/getAltAxis.js
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/preventOverflow.js












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? enums_top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? math_min(min, tetherMin) : min, offset, tether ? math_max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? enums_top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [enums_top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ var modifiers_preventOverflow = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/modifiers/index.js









;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getHTMLElementScroll.js
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getNodeScroll.js




function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/dom-utils/getCompositeRect.js









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/orderModifiers.js
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/debounce.js
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/utils/mergeByName.js
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}
;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/createPopper.js














var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (false) { var _getComputedStyle, marginTop, marginRight, marginBottom, marginLeft, flipModifier, modifiers; }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (false) {}

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (false) {}

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (false) {}

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/popperGenerator(); // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper.js










var defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles, modifiers_offset, modifiers_flip, modifiers_preventOverflow, modifiers_arrow, modifiers_hide];
var popper_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/popper-lite.js





var popper_lite_defaultModifiers = [eventListeners, modifiers_popperOffsets, modifiers_computeStyles, modifiers_applyStyles];
var popper_lite_createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: popper_lite_defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/@popperjs/core/lib/index.js

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules


;// CONCATENATED MODULE: ./node_modules/bootstrap/dist/js/bootstrap.esm.js











var _KEY_TO_DIRECTION;

/*!
  * Bootstrap v5.1.3 (https://getbootstrap.com/)
  * Copyright 2011-2021 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

var MAX_UID = 1000000;
var MILLISECONDS_MULTIPLIER = 1000;
var TRANSITION_END = 'transitionend'; // Shoutout AngusCroll (https://goo.gl/pxwQGp)

var toType = function toType(obj) {
  if (obj === null || obj === undefined) {
    return "".concat(obj);
  }

  return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * --------------------------------------------------------------------------
 * Public Util Api
 * --------------------------------------------------------------------------
 */


var getUID = function getUID(prefix) {
  do {
    prefix += Math.floor(Math.random() * MAX_UID);
  } while (document.getElementById(prefix));

  return prefix;
};

var getSelector = function getSelector(element) {
  var selector = element.getAttribute('data-bs-target');

  if (!selector || selector === '#') {
    var hrefAttr = element.getAttribute('href'); // The only valid content that could double as a selector are IDs or classes,
    // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
    // `document.querySelector` will rightfully complain it is invalid.
    // See https://github.com/twbs/bootstrap/issues/32273

    if (!hrefAttr || !hrefAttr.includes('#') && !hrefAttr.startsWith('.')) {
      return null;
    } // Just in case some CMS puts out a full URL with the anchor appended


    if (hrefAttr.includes('#') && !hrefAttr.startsWith('#')) {
      hrefAttr = "#".concat(hrefAttr.split('#')[1]);
    }

    selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : null;
  }

  return selector;
};

var getSelectorFromElement = function getSelectorFromElement(element) {
  var selector = getSelector(element);

  if (selector) {
    return document.querySelector(selector) ? selector : null;
  }

  return null;
};

var getElementFromSelector = function getElementFromSelector(element) {
  var selector = getSelector(element);
  return selector ? document.querySelector(selector) : null;
};

var getTransitionDurationFromElement = function getTransitionDurationFromElement(element) {
  if (!element) {
    return 0;
  } // Get transition-duration of the element


  var _window$getComputedSt = window.getComputedStyle(element),
      transitionDuration = _window$getComputedSt.transitionDuration,
      transitionDelay = _window$getComputedSt.transitionDelay;

  var floatTransitionDuration = Number.parseFloat(transitionDuration);
  var floatTransitionDelay = Number.parseFloat(transitionDelay); // Return 0 if element or transition duration is not found

  if (!floatTransitionDuration && !floatTransitionDelay) {
    return 0;
  } // If multiple durations are defined, take the first


  transitionDuration = transitionDuration.split(',')[0];
  transitionDelay = transitionDelay.split(',')[0];
  return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
};

var triggerTransitionEnd = function triggerTransitionEnd(element) {
  element.dispatchEvent(new Event(TRANSITION_END));
};

var bootstrap_esm_isElement = function isElement(obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }

  if (typeof obj.jquery !== 'undefined') {
    obj = obj[0];
  }

  return typeof obj.nodeType !== 'undefined';
};

var getElement = function getElement(obj) {
  if (bootstrap_esm_isElement(obj)) {
    // it's a jQuery object or a node element
    return obj.jquery ? obj[0] : obj;
  }

  if (typeof obj === 'string' && obj.length > 0) {
    return document.querySelector(obj);
  }

  return null;
};

var typeCheckConfig = function typeCheckConfig(componentName, config, configTypes) {
  Object.keys(configTypes).forEach(function (property) {
    var expectedTypes = configTypes[property];
    var value = config[property];
    var valueType = value && bootstrap_esm_isElement(value) ? 'element' : toType(value);

    if (!new RegExp(expectedTypes).test(valueType)) {
      throw new TypeError("".concat(componentName.toUpperCase(), ": Option \"").concat(property, "\" provided type \"").concat(valueType, "\" but expected type \"").concat(expectedTypes, "\"."));
    }
  });
};

var isVisible = function isVisible(element) {
  if (!bootstrap_esm_isElement(element) || element.getClientRects().length === 0) {
    return false;
  }

  return getComputedStyle(element).getPropertyValue('visibility') === 'visible';
};

var isDisabled = function isDisabled(element) {
  if (!element || element.nodeType !== Node.ELEMENT_NODE) {
    return true;
  }

  if (element.classList.contains('disabled')) {
    return true;
  }

  if (typeof element.disabled !== 'undefined') {
    return element.disabled;
  }

  return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};

var findShadowRoot = function findShadowRoot(element) {
  if (!document.documentElement.attachShadow) {
    return null;
  } // Can find the shadow root otherwise it'll return the document


  if (typeof element.getRootNode === 'function') {
    var root = element.getRootNode();
    return root instanceof ShadowRoot ? root : null;
  }

  if (element instanceof ShadowRoot) {
    return element;
  } // when we don't find a shadow root


  if (!element.parentNode) {
    return null;
  }

  return findShadowRoot(element.parentNode);
};

var noop = function noop() {};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */


var reflow = function reflow(element) {
  // eslint-disable-next-line no-unused-expressions
  element.offsetHeight;
};

var getjQuery = function getjQuery() {
  var _window = window,
      jQuery = _window.jQuery;

  if (jQuery && !document.body.hasAttribute('data-bs-no-jquery')) {
    return jQuery;
  }

  return null;
};

var DOMContentLoadedCallbacks = [];

var onDOMContentLoaded = function onDOMContentLoaded(callback) {
  if (document.readyState === 'loading') {
    // add listener on the first call when the document is in loading state
    if (!DOMContentLoadedCallbacks.length) {
      document.addEventListener('DOMContentLoaded', function () {
        DOMContentLoadedCallbacks.forEach(function (callback) {
          return callback();
        });
      });
    }

    DOMContentLoadedCallbacks.push(callback);
  } else {
    callback();
  }
};

var isRTL = function isRTL() {
  return document.documentElement.dir === 'rtl';
};

var defineJQueryPlugin = function defineJQueryPlugin(plugin) {
  onDOMContentLoaded(function () {
    var $ = getjQuery();
    /* istanbul ignore if */

    if ($) {
      var name = plugin.NAME;
      var JQUERY_NO_CONFLICT = $.fn[name];
      $.fn[name] = plugin.jQueryInterface;
      $.fn[name].Constructor = plugin;

      $.fn[name].noConflict = function () {
        $.fn[name] = JQUERY_NO_CONFLICT;
        return plugin.jQueryInterface;
      };
    }
  });
};

var execute = function execute(callback) {
  if (typeof callback === 'function') {
    callback();
  }
};

var executeAfterTransition = function executeAfterTransition(callback, transitionElement) {
  var waitForTransition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!waitForTransition) {
    execute(callback);
    return;
  }

  var durationPadding = 5;
  var emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
  var called = false;

  var handler = function handler(_ref) {
    var target = _ref.target;

    if (target !== transitionElement) {
      return;
    }

    called = true;
    transitionElement.removeEventListener(TRANSITION_END, handler);
    execute(callback);
  };

  transitionElement.addEventListener(TRANSITION_END, handler);
  setTimeout(function () {
    if (!called) {
      triggerTransitionEnd(transitionElement);
    }
  }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */


var getNextActiveElement = function getNextActiveElement(list, activeElement, shouldGetNext, isCycleAllowed) {
  var index = list.indexOf(activeElement); // if the element does not exist in the list return an element depending on the direction and if cycle is allowed

  if (index === -1) {
    return list[!shouldGetNext && isCycleAllowed ? list.length - 1 : 0];
  }

  var listLength = list.length;
  index += shouldGetNext ? 1 : -1;

  if (isCycleAllowed) {
    index = (index + listLength) % listLength;
  }

  return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */


var namespaceRegex = /[^.]*(?=\..*)\.|.*/;
var stripNameRegex = /\..*/;
var stripUidRegex = /::\d+$/;
var eventRegistry = {}; // Events storage

var uidEvent = 1;
var customEvents = {
  mouseenter: 'mouseover',
  mouseleave: 'mouseout'
};
var customEventsRegex = /^(mouseenter|mouseleave)/i;
var nativeEvents = new Set(['click', 'dblclick', 'mouseup', 'mousedown', 'contextmenu', 'mousewheel', 'DOMMouseScroll', 'mouseover', 'mouseout', 'mousemove', 'selectstart', 'selectend', 'keydown', 'keypress', 'keyup', 'orientationchange', 'touchstart', 'touchmove', 'touchend', 'touchcancel', 'pointerdown', 'pointermove', 'pointerup', 'pointerleave', 'pointercancel', 'gesturestart', 'gesturechange', 'gestureend', 'focus', 'blur', 'change', 'reset', 'select', 'submit', 'focusin', 'focusout', 'load', 'unload', 'beforeunload', 'resize', 'move', 'DOMContentLoaded', 'readystatechange', 'error', 'abort', 'scroll']);
/**
 * ------------------------------------------------------------------------
 * Private methods
 * ------------------------------------------------------------------------
 */

function getUidEvent(element, uid) {
  return uid && "".concat(uid, "::").concat(uidEvent++) || element.uidEvent || uidEvent++;
}

function getEvent(element) {
  var uid = getUidEvent(element);
  element.uidEvent = uid;
  eventRegistry[uid] = eventRegistry[uid] || {};
  return eventRegistry[uid];
}

function bootstrapHandler(element, fn) {
  return function handler(event) {
    event.delegateTarget = element;

    if (handler.oneOff) {
      EventHandler.off(element, event.type, fn);
    }

    return fn.apply(element, [event]);
  };
}

function bootstrapDelegationHandler(element, selector, fn) {
  return function handler(event) {
    var domElements = element.querySelectorAll(selector);

    for (var target = event.target; target && target !== this; target = target.parentNode) {
      for (var i = domElements.length; i--;) {
        if (domElements[i] === target) {
          event.delegateTarget = target;

          if (handler.oneOff) {
            EventHandler.off(element, event.type, selector, fn);
          }

          return fn.apply(target, [event]);
        }
      }
    } // To please ESLint


    return null;
  };
}

function findHandler(events, handler) {
  var delegationSelector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var uidEventList = Object.keys(events);

  for (var i = 0, len = uidEventList.length; i < len; i++) {
    var event = events[uidEventList[i]];

    if (event.originalHandler === handler && event.delegationSelector === delegationSelector) {
      return event;
    }
  }

  return null;
}

function normalizeParams(originalTypeEvent, handler, delegationFn) {
  var delegation = typeof handler === 'string';
  var originalHandler = delegation ? delegationFn : handler;
  var typeEvent = getTypeEvent(originalTypeEvent);
  var isNative = nativeEvents.has(typeEvent);

  if (!isNative) {
    typeEvent = originalTypeEvent;
  }

  return [delegation, originalHandler, typeEvent];
}

function addHandler(element, originalTypeEvent, handler, delegationFn, oneOff) {
  if (typeof originalTypeEvent !== 'string' || !element) {
    return;
  }

  if (!handler) {
    handler = delegationFn;
    delegationFn = null;
  } // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
  // this prevents the handler from being dispatched the same way as mouseover or mouseout does


  if (customEventsRegex.test(originalTypeEvent)) {
    var wrapFn = function wrapFn(fn) {
      return function (event) {
        if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) {
          return fn.call(this, event);
        }
      };
    };

    if (delegationFn) {
      delegationFn = wrapFn(delegationFn);
    } else {
      handler = wrapFn(handler);
    }
  }

  var _normalizeParams = normalizeParams(originalTypeEvent, handler, delegationFn),
      _normalizeParams2 = (0,slicedToArray/* default */.Z)(_normalizeParams, 3),
      delegation = _normalizeParams2[0],
      originalHandler = _normalizeParams2[1],
      typeEvent = _normalizeParams2[2];

  var events = getEvent(element);
  var handlers = events[typeEvent] || (events[typeEvent] = {});
  var previousFn = findHandler(handlers, originalHandler, delegation ? handler : null);

  if (previousFn) {
    previousFn.oneOff = previousFn.oneOff && oneOff;
    return;
  }

  var uid = getUidEvent(originalHandler, originalTypeEvent.replace(namespaceRegex, ''));
  var fn = delegation ? bootstrapDelegationHandler(element, handler, delegationFn) : bootstrapHandler(element, handler);
  fn.delegationSelector = delegation ? handler : null;
  fn.originalHandler = originalHandler;
  fn.oneOff = oneOff;
  fn.uidEvent = uid;
  handlers[uid] = fn;
  element.addEventListener(typeEvent, fn, delegation);
}

function removeHandler(element, events, typeEvent, handler, delegationSelector) {
  var fn = findHandler(events[typeEvent], handler, delegationSelector);

  if (!fn) {
    return;
  }

  element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
  delete events[typeEvent][fn.uidEvent];
}

function removeNamespacedHandlers(element, events, typeEvent, namespace) {
  var storeElementEvent = events[typeEvent] || {};
  Object.keys(storeElementEvent).forEach(function (handlerKey) {
    if (handlerKey.includes(namespace)) {
      var event = storeElementEvent[handlerKey];
      removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
    }
  });
}

function getTypeEvent(event) {
  // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
  event = event.replace(stripNameRegex, '');
  return customEvents[event] || event;
}

var EventHandler = {
  on: function on(element, event, handler, delegationFn) {
    addHandler(element, event, handler, delegationFn, false);
  },
  one: function one(element, event, handler, delegationFn) {
    addHandler(element, event, handler, delegationFn, true);
  },
  off: function off(element, originalTypeEvent, handler, delegationFn) {
    if (typeof originalTypeEvent !== 'string' || !element) {
      return;
    }

    var _normalizeParams3 = normalizeParams(originalTypeEvent, handler, delegationFn),
        _normalizeParams4 = (0,slicedToArray/* default */.Z)(_normalizeParams3, 3),
        delegation = _normalizeParams4[0],
        originalHandler = _normalizeParams4[1],
        typeEvent = _normalizeParams4[2];

    var inNamespace = typeEvent !== originalTypeEvent;
    var events = getEvent(element);
    var isNamespace = originalTypeEvent.startsWith('.');

    if (typeof originalHandler !== 'undefined') {
      // Simplest case: handler is passed, remove that listener ONLY.
      if (!events || !events[typeEvent]) {
        return;
      }

      removeHandler(element, events, typeEvent, originalHandler, delegation ? handler : null);
      return;
    }

    if (isNamespace) {
      Object.keys(events).forEach(function (elementEvent) {
        removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
      });
    }

    var storeElementEvent = events[typeEvent] || {};
    Object.keys(storeElementEvent).forEach(function (keyHandlers) {
      var handlerKey = keyHandlers.replace(stripUidRegex, '');

      if (!inNamespace || originalTypeEvent.includes(handlerKey)) {
        var event = storeElementEvent[keyHandlers];
        removeHandler(element, events, typeEvent, event.originalHandler, event.delegationSelector);
      }
    });
  },
  trigger: function trigger(element, event, args) {
    if (typeof event !== 'string' || !element) {
      return null;
    }

    var $ = getjQuery();
    var typeEvent = getTypeEvent(event);
    var inNamespace = event !== typeEvent;
    var isNative = nativeEvents.has(typeEvent);
    var jQueryEvent;
    var bubbles = true;
    var nativeDispatch = true;
    var defaultPrevented = false;
    var evt = null;

    if (inNamespace && $) {
      jQueryEvent = $.Event(event, args);
      $(element).trigger(jQueryEvent);
      bubbles = !jQueryEvent.isPropagationStopped();
      nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
      defaultPrevented = jQueryEvent.isDefaultPrevented();
    }

    if (isNative) {
      evt = document.createEvent('HTMLEvents');
      evt.initEvent(typeEvent, bubbles, true);
    } else {
      evt = new CustomEvent(event, {
        bubbles: bubbles,
        cancelable: true
      });
    } // merge custom information in our event


    if (typeof args !== 'undefined') {
      Object.keys(args).forEach(function (key) {
        Object.defineProperty(evt, key, {
          get: function get() {
            return args[key];
          }
        });
      });
    }

    if (defaultPrevented) {
      evt.preventDefault();
    }

    if (nativeDispatch) {
      element.dispatchEvent(evt);
    }

    if (evt.defaultPrevented && typeof jQueryEvent !== 'undefined') {
      jQueryEvent.preventDefault();
    }

    return evt;
  }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

var elementMap = new Map();
var Data = {
  set: function set(element, key, instance) {
    if (!elementMap.has(element)) {
      elementMap.set(element, new Map());
    }

    var instanceMap = elementMap.get(element); // make it clear we only want one instance per element
    // can be removed later when multiple key/instances are fine to be used

    if (!instanceMap.has(key) && instanceMap.size !== 0) {
      // eslint-disable-next-line no-console
      console.error("Bootstrap doesn't allow more than one instance per element. Bound instance: ".concat(Array.from(instanceMap.keys())[0], "."));
      return;
    }

    instanceMap.set(key, instance);
  },
  get: function get(element, key) {
    if (elementMap.has(element)) {
      return elementMap.get(element).get(key) || null;
    }

    return null;
  },
  remove: function remove(element, key) {
    if (!elementMap.has(element)) {
      return;
    }

    var instanceMap = elementMap.get(element);
    instanceMap.delete(key); // free up element references if there are no instances left for an element

    if (instanceMap.size === 0) {
      elementMap.delete(element);
    }
  }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

var VERSION = '5.1.3';

var BaseComponent = /*#__PURE__*/function () {
  function BaseComponent(element) {
    (0,classCallCheck/* default */.Z)(this, BaseComponent);

    element = getElement(element);

    if (!element) {
      return;
    }

    this._element = element;
    Data.set(this._element, this.constructor.DATA_KEY, this);
  }

  (0,createClass/* default */.Z)(BaseComponent, [{
    key: "dispose",
    value: function dispose() {
      var _this = this;

      Data.remove(this._element, this.constructor.DATA_KEY);
      EventHandler.off(this._element, this.constructor.EVENT_KEY);
      Object.getOwnPropertyNames(this).forEach(function (propertyName) {
        _this[propertyName] = null;
      });
    }
  }, {
    key: "_queueCallback",
    value: function _queueCallback(callback, element) {
      var isAnimated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      executeAfterTransition(callback, element, isAnimated);
    }
    /** Static */

  }], [{
    key: "getInstance",
    value: function getInstance(element) {
      return Data.get(getElement(element), this.DATA_KEY);
    }
  }, {
    key: "getOrCreateInstance",
    value: function getOrCreateInstance(element) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
  }, {
    key: "VERSION",
    get: function get() {
      return VERSION;
    }
  }, {
    key: "NAME",
    get: function get() {
      throw new Error('You have to implement the static method "NAME", for each component!');
    }
  }, {
    key: "DATA_KEY",
    get: function get() {
      return "bs.".concat(this.NAME);
    }
  }, {
    key: "EVENT_KEY",
    get: function get() {
      return ".".concat(this.DATA_KEY);
    }
  }]);

  return BaseComponent;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */


var enableDismissTrigger = function enableDismissTrigger(component) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'hide';
  var clickEvent = "click.dismiss".concat(component.EVENT_KEY);
  var name = component.NAME;
  EventHandler.on(document, clickEvent, "[data-bs-dismiss=\"".concat(name, "\"]"), function (event) {
    if (['A', 'AREA'].includes(this.tagName)) {
      event.preventDefault();
    }

    if (isDisabled(this)) {
      return;
    }

    var target = getElementFromSelector(this) || this.closest(".".concat(name));
    var instance = component.getOrCreateInstance(target); // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method

    instance[method]();
  });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */


var NAME$d = 'alert';
var DATA_KEY$c = 'bs.alert';
var EVENT_KEY$c = ".".concat(DATA_KEY$c);
var EVENT_CLOSE = "close".concat(EVENT_KEY$c);
var EVENT_CLOSED = "closed".concat(EVENT_KEY$c);
var CLASS_NAME_FADE$5 = 'fade';
var CLASS_NAME_SHOW$8 = 'show';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

var Alert = /*#__PURE__*/function (_BaseComponent) {
  (0,inherits/* default */.Z)(Alert, _BaseComponent);

  var _super = (0,createSuper/* default */.Z)(Alert);

  function Alert() {
    (0,classCallCheck/* default */.Z)(this, Alert);

    return _super.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(Alert, [{
    key: "close",
    value: // Public
    function close() {
      var _this2 = this;

      var closeEvent = EventHandler.trigger(this._element, EVENT_CLOSE);

      if (closeEvent.defaultPrevented) {
        return;
      }

      this._element.classList.remove(CLASS_NAME_SHOW$8);

      var isAnimated = this._element.classList.contains(CLASS_NAME_FADE$5);

      this._queueCallback(function () {
        return _this2._destroyElement();
      }, this._element, isAnimated);
    } // Private

  }, {
    key: "_destroyElement",
    value: function _destroyElement() {
      this._element.remove();

      EventHandler.trigger(this._element, EVENT_CLOSED);
      this.dispose();
    } // Static

  }], [{
    key: "NAME",
    get: // Getters
    function get() {
      return NAME$d;
    }
  }, {
    key: "jQueryInterface",
    value: function jQueryInterface(config) {
      return this.each(function () {
        var data = Alert.getOrCreateInstance(this);

        if (typeof config !== 'string') {
          return;
        }

        if (data[config] === undefined || config.startsWith('_') || config === 'constructor') {
          throw new TypeError("No method named \"".concat(config, "\""));
        }

        data[config](this);
      });
    }
  }]);

  return Alert;
}(BaseComponent);
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


enableDismissTrigger(Alert, 'close');
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Alert to jQuery only if jQuery is present
 */

defineJQueryPlugin(Alert);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

var NAME$c = 'button';
var DATA_KEY$b = 'bs.button';
var EVENT_KEY$b = ".".concat(DATA_KEY$b);
var DATA_API_KEY$7 = '.data-api';
var CLASS_NAME_ACTIVE$3 = 'active';
var SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
var EVENT_CLICK_DATA_API$6 = "click".concat(EVENT_KEY$b).concat(DATA_API_KEY$7);
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

var Button = /*#__PURE__*/function (_BaseComponent2) {
  (0,inherits/* default */.Z)(Button, _BaseComponent2);

  var _super2 = (0,createSuper/* default */.Z)(Button);

  function Button() {
    (0,classCallCheck/* default */.Z)(this, Button);

    return _super2.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(Button, [{
    key: "toggle",
    value: // Public
    function toggle() {
      // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
      this._element.setAttribute('aria-pressed', this._element.classList.toggle(CLASS_NAME_ACTIVE$3));
    } // Static

  }], [{
    key: "NAME",
    get: // Getters
    function get() {
      return NAME$c;
    }
  }, {
    key: "jQueryInterface",
    value: function jQueryInterface(config) {
      return this.each(function () {
        var data = Button.getOrCreateInstance(this);

        if (config === 'toggle') {
          data[config]();
        }
      });
    }
  }]);

  return Button;
}(BaseComponent);
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(document, EVENT_CLICK_DATA_API$6, SELECTOR_DATA_TOGGLE$5, function (event) {
  event.preventDefault();
  var button = event.target.closest(SELECTOR_DATA_TOGGLE$5);
  var data = Button.getOrCreateInstance(button);
  data.toggle();
});
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Button to jQuery only if jQuery is present
 */

defineJQueryPlugin(Button);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

function normalizeData(val) {
  if (val === 'true') {
    return true;
  }

  if (val === 'false') {
    return false;
  }

  if (val === Number(val).toString()) {
    return Number(val);
  }

  if (val === '' || val === 'null') {
    return null;
  }

  return val;
}

function normalizeDataKey(key) {
  return key.replace(/[A-Z]/g, function (chr) {
    return "-".concat(chr.toLowerCase());
  });
}

var Manipulator = {
  setDataAttribute: function setDataAttribute(element, key, value) {
    element.setAttribute("data-bs-".concat(normalizeDataKey(key)), value);
  },
  removeDataAttribute: function removeDataAttribute(element, key) {
    element.removeAttribute("data-bs-".concat(normalizeDataKey(key)));
  },
  getDataAttributes: function getDataAttributes(element) {
    if (!element) {
      return {};
    }

    var attributes = {};
    Object.keys(element.dataset).filter(function (key) {
      return key.startsWith('bs');
    }).forEach(function (key) {
      var pureKey = key.replace(/^bs/, '');
      pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
      attributes[pureKey] = normalizeData(element.dataset[key]);
    });
    return attributes;
  },
  getDataAttribute: function getDataAttribute(element, key) {
    return normalizeData(element.getAttribute("data-bs-".concat(normalizeDataKey(key))));
  },
  offset: function offset(element) {
    var rect = element.getBoundingClientRect();
    return {
      top: rect.top + window.pageYOffset,
      left: rect.left + window.pageXOffset
    };
  },
  position: function position(element) {
    return {
      top: element.offsetTop,
      left: element.offsetLeft
    };
  }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

var NODE_TEXT = 3;
var SelectorEngine = {
  find: function find(selector) {
    var _ref2;

    var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.documentElement;
    return (_ref2 = []).concat.apply(_ref2, (0,toConsumableArray/* default */.Z)(Element.prototype.querySelectorAll.call(element, selector)));
  },
  findOne: function findOne(selector) {
    var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.documentElement;
    return Element.prototype.querySelector.call(element, selector);
  },
  children: function children(element, selector) {
    var _ref3;

    return (_ref3 = []).concat.apply(_ref3, (0,toConsumableArray/* default */.Z)(element.children)).filter(function (child) {
      return child.matches(selector);
    });
  },
  parents: function parents(element, selector) {
    var parents = [];
    var ancestor = element.parentNode;

    while (ancestor && ancestor.nodeType === Node.ELEMENT_NODE && ancestor.nodeType !== NODE_TEXT) {
      if (ancestor.matches(selector)) {
        parents.push(ancestor);
      }

      ancestor = ancestor.parentNode;
    }

    return parents;
  },
  prev: function prev(element, selector) {
    var previous = element.previousElementSibling;

    while (previous) {
      if (previous.matches(selector)) {
        return [previous];
      }

      previous = previous.previousElementSibling;
    }

    return [];
  },
  next: function next(element, selector) {
    var next = element.nextElementSibling;

    while (next) {
      if (next.matches(selector)) {
        return [next];
      }

      next = next.nextElementSibling;
    }

    return [];
  },
  focusableChildren: function focusableChildren(element) {
    var focusables = ['a', 'button', 'input', 'textarea', 'select', 'details', '[tabindex]', '[contenteditable="true"]'].map(function (selector) {
      return "".concat(selector, ":not([tabindex^=\"-\"])");
    }).join(', ');
    return this.find(focusables, element).filter(function (el) {
      return !isDisabled(el) && isVisible(el);
    });
  }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

var NAME$b = 'carousel';
var DATA_KEY$a = 'bs.carousel';
var EVENT_KEY$a = ".".concat(DATA_KEY$a);
var DATA_API_KEY$6 = '.data-api';
var ARROW_LEFT_KEY = 'ArrowLeft';
var ARROW_RIGHT_KEY = 'ArrowRight';
var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch

var SWIPE_THRESHOLD = 40;
var Default$a = {
  interval: 5000,
  keyboard: true,
  slide: false,
  pause: 'hover',
  wrap: true,
  touch: true
};
var DefaultType$a = {
  interval: '(number|boolean)',
  keyboard: 'boolean',
  slide: '(boolean|string)',
  pause: '(string|boolean)',
  wrap: 'boolean',
  touch: 'boolean'
};
var ORDER_NEXT = 'next';
var ORDER_PREV = 'prev';
var DIRECTION_LEFT = 'left';
var DIRECTION_RIGHT = 'right';
var KEY_TO_DIRECTION = (_KEY_TO_DIRECTION = {}, (0,defineProperty/* default */.Z)(_KEY_TO_DIRECTION, ARROW_LEFT_KEY, DIRECTION_RIGHT), (0,defineProperty/* default */.Z)(_KEY_TO_DIRECTION, ARROW_RIGHT_KEY, DIRECTION_LEFT), _KEY_TO_DIRECTION);
var EVENT_SLIDE = "slide".concat(EVENT_KEY$a);
var EVENT_SLID = "slid".concat(EVENT_KEY$a);
var EVENT_KEYDOWN = "keydown".concat(EVENT_KEY$a);
var EVENT_MOUSEENTER = "mouseenter".concat(EVENT_KEY$a);
var EVENT_MOUSELEAVE = "mouseleave".concat(EVENT_KEY$a);
var EVENT_TOUCHSTART = "touchstart".concat(EVENT_KEY$a);
var EVENT_TOUCHMOVE = "touchmove".concat(EVENT_KEY$a);
var EVENT_TOUCHEND = "touchend".concat(EVENT_KEY$a);
var EVENT_POINTERDOWN = "pointerdown".concat(EVENT_KEY$a);
var EVENT_POINTERUP = "pointerup".concat(EVENT_KEY$a);
var EVENT_DRAG_START = "dragstart".concat(EVENT_KEY$a);
var EVENT_LOAD_DATA_API$2 = "load".concat(EVENT_KEY$a).concat(DATA_API_KEY$6);
var EVENT_CLICK_DATA_API$5 = "click".concat(EVENT_KEY$a).concat(DATA_API_KEY$6);
var CLASS_NAME_CAROUSEL = 'carousel';
var CLASS_NAME_ACTIVE$2 = 'active';
var CLASS_NAME_SLIDE = 'slide';
var CLASS_NAME_END = 'carousel-item-end';
var CLASS_NAME_START = 'carousel-item-start';
var CLASS_NAME_NEXT = 'carousel-item-next';
var CLASS_NAME_PREV = 'carousel-item-prev';
var CLASS_NAME_POINTER_EVENT = 'pointer-event';
var SELECTOR_ACTIVE$1 = '.active';
var SELECTOR_ACTIVE_ITEM = '.active.carousel-item';
var SELECTOR_ITEM = '.carousel-item';
var SELECTOR_ITEM_IMG = '.carousel-item img';
var SELECTOR_NEXT_PREV = '.carousel-item-next, .carousel-item-prev';
var SELECTOR_INDICATORS = '.carousel-indicators';
var SELECTOR_INDICATOR = '[data-bs-target]';
var SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
var SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
var POINTER_TYPE_TOUCH = 'touch';
var POINTER_TYPE_PEN = 'pen';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

var Carousel = /*#__PURE__*/function (_BaseComponent3) {
  (0,inherits/* default */.Z)(Carousel, _BaseComponent3);

  var _super3 = (0,createSuper/* default */.Z)(Carousel);

  function Carousel(element, config) {
    var _this3;

    (0,classCallCheck/* default */.Z)(this, Carousel);

    _this3 = _super3.call(this, element);
    _this3._items = null;
    _this3._interval = null;
    _this3._activeElement = null;
    _this3._isPaused = false;
    _this3._isSliding = false;
    _this3.touchTimeout = null;
    _this3.touchStartX = 0;
    _this3.touchDeltaX = 0;
    _this3._config = _this3._getConfig(config);
    _this3._indicatorsElement = SelectorEngine.findOne(SELECTOR_INDICATORS, _this3._element);
    _this3._touchSupported = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    _this3._pointerEvent = Boolean(window.PointerEvent);

    _this3._addEventListeners();

    return _this3;
  } // Getters


  (0,createClass/* default */.Z)(Carousel, [{
    key: "next",
    value: // Public
    function next() {
      this._slide(ORDER_NEXT);
    }
  }, {
    key: "nextWhenVisible",
    value: function nextWhenVisible() {
      // Don't call next when the page isn't visible
      // or the carousel or its parent isn't visible
      if (!document.hidden && isVisible(this._element)) {
        this.next();
      }
    }
  }, {
    key: "prev",
    value: function prev() {
      this._slide(ORDER_PREV);
    }
  }, {
    key: "pause",
    value: function pause(event) {
      if (!event) {
        this._isPaused = true;
      }

      if (SelectorEngine.findOne(SELECTOR_NEXT_PREV, this._element)) {
        triggerTransitionEnd(this._element);
        this.cycle(true);
      }

      clearInterval(this._interval);
      this._interval = null;
    }
  }, {
    key: "cycle",
    value: function cycle(event) {
      if (!event) {
        this._isPaused = false;
      }

      if (this._interval) {
        clearInterval(this._interval);
        this._interval = null;
      }

      if (this._config && this._config.interval && !this._isPaused) {
        this._updateInterval();

        this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
      }
    }
  }, {
    key: "to",
    value: function to(index) {
      var _this4 = this;

      this._activeElement = SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);

      var activeIndex = this._getItemIndex(this._activeElement);

      if (index > this._items.length - 1 || index < 0) {
        return;
      }

      if (this._isSliding) {
        EventHandler.one(this._element, EVENT_SLID, function () {
          return _this4.to(index);
        });
        return;
      }

      if (activeIndex === index) {
        this.pause();
        this.cycle();
        return;
      }

      var order = index > activeIndex ? ORDER_NEXT : ORDER_PREV;

      this._slide(order, this._items[index]);
    } // Private

  }, {
    key: "_getConfig",
    value: function _getConfig(config) {
      config = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, Default$a), Manipulator.getDataAttributes(this._element)), typeof config === 'object' ? config : {});
      typeCheckConfig(NAME$b, config, DefaultType$a);
      return config;
    }
  }, {
    key: "_handleSwipe",
    value: function _handleSwipe() {
      var absDeltax = Math.abs(this.touchDeltaX);

      if (absDeltax <= SWIPE_THRESHOLD) {
        return;
      }

      var direction = absDeltax / this.touchDeltaX;
      this.touchDeltaX = 0;

      if (!direction) {
        return;
      }

      this._slide(direction > 0 ? DIRECTION_RIGHT : DIRECTION_LEFT);
    }
  }, {
    key: "_addEventListeners",
    value: function _addEventListeners() {
      var _this5 = this;

      if (this._config.keyboard) {
        EventHandler.on(this._element, EVENT_KEYDOWN, function (event) {
          return _this5._keydown(event);
        });
      }

      if (this._config.pause === 'hover') {
        EventHandler.on(this._element, EVENT_MOUSEENTER, function (event) {
          return _this5.pause(event);
        });
        EventHandler.on(this._element, EVENT_MOUSELEAVE, function (event) {
          return _this5.cycle(event);
        });
      }

      if (this._config.touch && this._touchSupported) {
        this._addTouchEventListeners();
      }
    }
  }, {
    key: "_addTouchEventListeners",
    value: function _addTouchEventListeners() {
      var _this6 = this;

      var hasPointerPenTouch = function hasPointerPenTouch(event) {
        return _this6._pointerEvent && (event.pointerType === POINTER_TYPE_PEN || event.pointerType === POINTER_TYPE_TOUCH);
      };

      var start = function start(event) {
        if (hasPointerPenTouch(event)) {
          _this6.touchStartX = event.clientX;
        } else if (!_this6._pointerEvent) {
          _this6.touchStartX = event.touches[0].clientX;
        }
      };

      var move = function move(event) {
        // ensure swiping with one touch and not pinching
        _this6.touchDeltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - _this6.touchStartX;
      };

      var end = function end(event) {
        if (hasPointerPenTouch(event)) {
          _this6.touchDeltaX = event.clientX - _this6.touchStartX;
        }

        _this6._handleSwipe();

        if (_this6._config.pause === 'hover') {
          // If it's a touch-enabled device, mouseenter/leave are fired as
          // part of the mouse compatibility events on first tap - the carousel
          // would stop cycling until user tapped out of it;
          // here, we listen for touchend, explicitly pause the carousel
          // (as if it's the second time we tap on it, mouseenter compat event
          // is NOT fired) and after a timeout (to allow for mouse compatibility
          // events to fire) we explicitly restart cycling
          _this6.pause();

          if (_this6.touchTimeout) {
            clearTimeout(_this6.touchTimeout);
          }

          _this6.touchTimeout = setTimeout(function (event) {
            return _this6.cycle(event);
          }, TOUCHEVENT_COMPAT_WAIT + _this6._config.interval);
        }
      };

      SelectorEngine.find(SELECTOR_ITEM_IMG, this._element).forEach(function (itemImg) {
        EventHandler.on(itemImg, EVENT_DRAG_START, function (event) {
          return event.preventDefault();
        });
      });

      if (this._pointerEvent) {
        EventHandler.on(this._element, EVENT_POINTERDOWN, function (event) {
          return start(event);
        });
        EventHandler.on(this._element, EVENT_POINTERUP, function (event) {
          return end(event);
        });

        this._element.classList.add(CLASS_NAME_POINTER_EVENT);
      } else {
        EventHandler.on(this._element, EVENT_TOUCHSTART, function (event) {
          return start(event);
        });
        EventHandler.on(this._element, EVENT_TOUCHMOVE, function (event) {
          return move(event);
        });
        EventHandler.on(this._element, EVENT_TOUCHEND, function (event) {
          return end(event);
        });
      }
    }
  }, {
    key: "_keydown",
    value: function _keydown(event) {
      if (/input|textarea/i.test(event.target.tagName)) {
        return;
      }

      var direction = KEY_TO_DIRECTION[event.key];

      if (direction) {
        event.preventDefault();

        this._slide(direction);
      }
    }
  }, {
    key: "_getItemIndex",
    value: function _getItemIndex(element) {
      this._items = element && element.parentNode ? SelectorEngine.find(SELECTOR_ITEM, element.parentNode) : [];
      return this._items.indexOf(element);
    }
  }, {
    key: "_getItemByOrder",
    value: function _getItemByOrder(order, activeElement) {
      var isNext = order === ORDER_NEXT;
      return getNextActiveElement(this._items, activeElement, isNext, this._config.wrap);
    }
  }, {
    key: "_triggerSlideEvent",
    value: function _triggerSlideEvent(relatedTarget, eventDirectionName) {
      var targetIndex = this._getItemIndex(relatedTarget);

      var fromIndex = this._getItemIndex(SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element));

      return EventHandler.trigger(this._element, EVENT_SLIDE, {
        relatedTarget: relatedTarget,
        direction: eventDirectionName,
        from: fromIndex,
        to: targetIndex
      });
    }
  }, {
    key: "_setActiveIndicatorElement",
    value: function _setActiveIndicatorElement(element) {
      if (this._indicatorsElement) {
        var activeIndicator = SelectorEngine.findOne(SELECTOR_ACTIVE$1, this._indicatorsElement);
        activeIndicator.classList.remove(CLASS_NAME_ACTIVE$2);
        activeIndicator.removeAttribute('aria-current');
        var indicators = SelectorEngine.find(SELECTOR_INDICATOR, this._indicatorsElement);

        for (var i = 0; i < indicators.length; i++) {
          if (Number.parseInt(indicators[i].getAttribute('data-bs-slide-to'), 10) === this._getItemIndex(element)) {
            indicators[i].classList.add(CLASS_NAME_ACTIVE$2);
            indicators[i].setAttribute('aria-current', 'true');
            break;
          }
        }
      }
    }
  }, {
    key: "_updateInterval",
    value: function _updateInterval() {
      var element = this._activeElement || SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);

      if (!element) {
        return;
      }

      var elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);

      if (elementInterval) {
        this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
        this._config.interval = elementInterval;
      } else {
        this._config.interval = this._config.defaultInterval || this._config.interval;
      }
    }
  }, {
    key: "_slide",
    value: function _slide(directionOrOrder, element) {
      var _this7 = this;

      var order = this._directionToOrder(directionOrOrder);

      var activeElement = SelectorEngine.findOne(SELECTOR_ACTIVE_ITEM, this._element);

      var activeElementIndex = this._getItemIndex(activeElement);

      var nextElement = element || this._getItemByOrder(order, activeElement);

      var nextElementIndex = this._getItemIndex(nextElement);

      var isCycling = Boolean(this._interval);
      var isNext = order === ORDER_NEXT;
      var directionalClassName = isNext ? CLASS_NAME_START : CLASS_NAME_END;
      var orderClassName = isNext ? CLASS_NAME_NEXT : CLASS_NAME_PREV;

      var eventDirectionName = this._orderToDirection(order);

      if (nextElement && nextElement.classList.contains(CLASS_NAME_ACTIVE$2)) {
        this._isSliding = false;
        return;
      }

      if (this._isSliding) {
        return;
      }

      var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);

      if (slideEvent.defaultPrevented) {
        return;
      }

      if (!activeElement || !nextElement) {
        // Some weirdness is happening, so we bail
        return;
      }

      this._isSliding = true;

      if (isCycling) {
        this.pause();
      }

      this._setActiveIndicatorElement(nextElement);

      this._activeElement = nextElement;

      var triggerSlidEvent = function triggerSlidEvent() {
        EventHandler.trigger(_this7._element, EVENT_SLID, {
          relatedTarget: nextElement,
          direction: eventDirectionName,
          from: activeElementIndex,
          to: nextElementIndex
        });
      };

      if (this._element.classList.contains(CLASS_NAME_SLIDE)) {
        nextElement.classList.add(orderClassName);
        reflow(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);

        var completeCallBack = function completeCallBack() {
          nextElement.classList.remove(directionalClassName, orderClassName);
          nextElement.classList.add(CLASS_NAME_ACTIVE$2);
          activeElement.classList.remove(CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
          _this7._isSliding = false;
          setTimeout(triggerSlidEvent, 0);
        };

        this._queueCallback(completeCallBack, activeElement, true);
      } else {
        activeElement.classList.remove(CLASS_NAME_ACTIVE$2);
        nextElement.classList.add(CLASS_NAME_ACTIVE$2);
        this._isSliding = false;
        triggerSlidEvent();
      }

      if (isCycling) {
        this.cycle();
      }
    }
  }, {
    key: "_directionToOrder",
    value: function _directionToOrder(direction) {
      if (![DIRECTION_RIGHT, DIRECTION_LEFT].includes(direction)) {
        return direction;
      }

      if (isRTL()) {
        return direction === DIRECTION_LEFT ? ORDER_PREV : ORDER_NEXT;
      }

      return direction === DIRECTION_LEFT ? ORDER_NEXT : ORDER_PREV;
    }
  }, {
    key: "_orderToDirection",
    value: function _orderToDirection(order) {
      if (![ORDER_NEXT, ORDER_PREV].includes(order)) {
        return order;
      }

      if (isRTL()) {
        return order === ORDER_PREV ? DIRECTION_LEFT : DIRECTION_RIGHT;
      }

      return order === ORDER_PREV ? DIRECTION_RIGHT : DIRECTION_LEFT;
    } // Static

  }], [{
    key: "Default",
    get: function get() {
      return Default$a;
    }
  }, {
    key: "NAME",
    get: function get() {
      return NAME$b;
    }
  }, {
    key: "carouselInterface",
    value: function carouselInterface(element, config) {
      var data = Carousel.getOrCreateInstance(element, config);
      var _config = data._config;

      if (typeof config === 'object') {
        _config = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, _config), config);
      }

      var action = typeof config === 'string' ? config : _config.slide;

      if (typeof config === 'number') {
        data.to(config);
      } else if (typeof action === 'string') {
        if (typeof data[action] === 'undefined') {
          throw new TypeError("No method named \"".concat(action, "\""));
        }

        data[action]();
      } else if (_config.interval && _config.ride) {
        data.pause();
        data.cycle();
      }
    }
  }, {
    key: "jQueryInterface",
    value: function jQueryInterface(config) {
      return this.each(function () {
        Carousel.carouselInterface(this, config);
      });
    }
  }, {
    key: "dataApiClickHandler",
    value: function dataApiClickHandler(event) {
      var target = getElementFromSelector(this);

      if (!target || !target.classList.contains(CLASS_NAME_CAROUSEL)) {
        return;
      }

      var config = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, Manipulator.getDataAttributes(target)), Manipulator.getDataAttributes(this));

      var slideIndex = this.getAttribute('data-bs-slide-to');

      if (slideIndex) {
        config.interval = false;
      }

      Carousel.carouselInterface(target, config);

      if (slideIndex) {
        Carousel.getInstance(target).to(slideIndex);
      }

      event.preventDefault();
    }
  }]);

  return Carousel;
}(BaseComponent);
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(document, EVENT_CLICK_DATA_API$5, SELECTOR_DATA_SLIDE, Carousel.dataApiClickHandler);
EventHandler.on(window, EVENT_LOAD_DATA_API$2, function () {
  var carousels = SelectorEngine.find(SELECTOR_DATA_RIDE);

  for (var i = 0, len = carousels.length; i < len; i++) {
    Carousel.carouselInterface(carousels[i], Carousel.getInstance(carousels[i]));
  }
});
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Carousel to jQuery only if jQuery is present
 */

defineJQueryPlugin(Carousel);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

var NAME$a = 'collapse';
var DATA_KEY$9 = 'bs.collapse';
var EVENT_KEY$9 = ".".concat(DATA_KEY$9);
var DATA_API_KEY$5 = '.data-api';
var Default$9 = {
  toggle: true,
  parent: null
};
var DefaultType$9 = {
  toggle: 'boolean',
  parent: '(null|element)'
};
var EVENT_SHOW$5 = "show".concat(EVENT_KEY$9);
var EVENT_SHOWN$5 = "shown".concat(EVENT_KEY$9);
var EVENT_HIDE$5 = "hide".concat(EVENT_KEY$9);
var EVENT_HIDDEN$5 = "hidden".concat(EVENT_KEY$9);
var EVENT_CLICK_DATA_API$4 = "click".concat(EVENT_KEY$9).concat(DATA_API_KEY$5);
var CLASS_NAME_SHOW$7 = 'show';
var CLASS_NAME_COLLAPSE = 'collapse';
var CLASS_NAME_COLLAPSING = 'collapsing';
var CLASS_NAME_COLLAPSED = 'collapsed';
var CLASS_NAME_DEEPER_CHILDREN = ":scope .".concat(CLASS_NAME_COLLAPSE, " .").concat(CLASS_NAME_COLLAPSE);
var CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
var WIDTH = 'width';
var HEIGHT = 'height';
var SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
var SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

var Collapse = /*#__PURE__*/function (_BaseComponent4) {
  (0,inherits/* default */.Z)(Collapse, _BaseComponent4);

  var _super4 = (0,createSuper/* default */.Z)(Collapse);

  function Collapse(element, config) {
    var _this8;

    (0,classCallCheck/* default */.Z)(this, Collapse);

    _this8 = _super4.call(this, element);
    _this8._isTransitioning = false;
    _this8._config = _this8._getConfig(config);
    _this8._triggerArray = [];
    var toggleList = SelectorEngine.find(SELECTOR_DATA_TOGGLE$4);

    for (var i = 0, len = toggleList.length; i < len; i++) {
      var elem = toggleList[i];
      var selector = getSelectorFromElement(elem);
      var filterElement = SelectorEngine.find(selector).filter(function (foundElem) {
        return foundElem === _this8._element;
      });

      if (selector !== null && filterElement.length) {
        _this8._selector = selector;

        _this8._triggerArray.push(elem);
      }
    }

    _this8._initializeChildren();

    if (!_this8._config.parent) {
      _this8._addAriaAndCollapsedClass(_this8._triggerArray, _this8._isShown());
    }

    if (_this8._config.toggle) {
      _this8.toggle();
    }

    return _this8;
  } // Getters


  (0,createClass/* default */.Z)(Collapse, [{
    key: "toggle",
    value: // Public
    function toggle() {
      if (this._isShown()) {
        this.hide();
      } else {
        this.show();
      }
    }
  }, {
    key: "show",
    value: function show() {
      var _this9 = this;

      if (this._isTransitioning || this._isShown()) {
        return;
      }

      var actives = [];
      var activesData;

      if (this._config.parent) {
        var children = SelectorEngine.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        actives = SelectorEngine.find(SELECTOR_ACTIVES, this._config.parent).filter(function (elem) {
          return !children.includes(elem);
        }); // remove children if greater depth
      }

      var container = SelectorEngine.findOne(this._selector);

      if (actives.length) {
        var tempActiveData = actives.find(function (elem) {
          return container !== elem;
        });
        activesData = tempActiveData ? Collapse.getInstance(tempActiveData) : null;

        if (activesData && activesData._isTransitioning) {
          return;
        }
      }

      var startEvent = EventHandler.trigger(this._element, EVENT_SHOW$5);

      if (startEvent.defaultPrevented) {
        return;
      }

      actives.forEach(function (elemActive) {
        if (container !== elemActive) {
          Collapse.getOrCreateInstance(elemActive, {
            toggle: false
          }).hide();
        }

        if (!activesData) {
          Data.set(elemActive, DATA_KEY$9, null);
        }
      });

      var dimension = this._getDimension();

      this._element.classList.remove(CLASS_NAME_COLLAPSE);

      this._element.classList.add(CLASS_NAME_COLLAPSING);

      this._element.style[dimension] = 0;

      this._addAriaAndCollapsedClass(this._triggerArray, true);

      this._isTransitioning = true;

      var complete = function complete() {
        _this9._isTransitioning = false;

        _this9._element.classList.remove(CLASS_NAME_COLLAPSING);

        _this9._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);

        _this9._element.style[dimension] = '';
        EventHandler.trigger(_this9._element, EVENT_SHOWN$5);
      };

      var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
      var scrollSize = "scroll".concat(capitalizedDimension);

      this._queueCallback(complete, this._element, true);

      this._element.style[dimension] = "".concat(this._element[scrollSize], "px");
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this10 = this;

      if (this._isTransitioning || !this._isShown()) {
        return;
      }

      var startEvent = EventHandler.trigger(this._element, EVENT_HIDE$5);

      if (startEvent.defaultPrevented) {
        return;
      }

      var dimension = this._getDimension();

      this._element.style[dimension] = "".concat(this._element.getBoundingClientRect()[dimension], "px");
      reflow(this._element);

      this._element.classList.add(CLASS_NAME_COLLAPSING);

      this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW$7);

      var triggerArrayLength = this._triggerArray.length;

      for (var i = 0; i < triggerArrayLength; i++) {
        var trigger = this._triggerArray[i];
        var elem = getElementFromSelector(trigger);

        if (elem && !this._isShown(elem)) {
          this._addAriaAndCollapsedClass([trigger], false);
        }
      }

      this._isTransitioning = true;

      var complete = function complete() {
        _this10._isTransitioning = false;

        _this10._element.classList.remove(CLASS_NAME_COLLAPSING);

        _this10._element.classList.add(CLASS_NAME_COLLAPSE);

        EventHandler.trigger(_this10._element, EVENT_HIDDEN$5);
      };

      this._element.style[dimension] = '';

      this._queueCallback(complete, this._element, true);
    }
  }, {
    key: "_isShown",
    value: function _isShown() {
      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._element;
      return element.classList.contains(CLASS_NAME_SHOW$7);
    } // Private

  }, {
    key: "_getConfig",
    value: function _getConfig(config) {
      config = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, Default$9), Manipulator.getDataAttributes(this._element)), config);
      config.toggle = Boolean(config.toggle); // Coerce string values

      config.parent = getElement(config.parent);
      typeCheckConfig(NAME$a, config, DefaultType$9);
      return config;
    }
  }, {
    key: "_getDimension",
    value: function _getDimension() {
      return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
    }
  }, {
    key: "_initializeChildren",
    value: function _initializeChildren() {
      var _this11 = this;

      if (!this._config.parent) {
        return;
      }

      var children = SelectorEngine.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
      SelectorEngine.find(SELECTOR_DATA_TOGGLE$4, this._config.parent).filter(function (elem) {
        return !children.includes(elem);
      }).forEach(function (element) {
        var selected = getElementFromSelector(element);

        if (selected) {
          _this11._addAriaAndCollapsedClass([element], _this11._isShown(selected));
        }
      });
    }
  }, {
    key: "_addAriaAndCollapsedClass",
    value: function _addAriaAndCollapsedClass(triggerArray, isOpen) {
      if (!triggerArray.length) {
        return;
      }

      triggerArray.forEach(function (elem) {
        if (isOpen) {
          elem.classList.remove(CLASS_NAME_COLLAPSED);
        } else {
          elem.classList.add(CLASS_NAME_COLLAPSED);
        }

        elem.setAttribute('aria-expanded', isOpen);
      });
    } // Static

  }], [{
    key: "Default",
    get: function get() {
      return Default$9;
    }
  }, {
    key: "NAME",
    get: function get() {
      return NAME$a;
    }
  }, {
    key: "jQueryInterface",
    value: function jQueryInterface(config) {
      return this.each(function () {
        var _config = {};

        if (typeof config === 'string' && /show|hide/.test(config)) {
          _config.toggle = false;
        }

        var data = Collapse.getOrCreateInstance(this, _config);

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"".concat(config, "\""));
          }

          data[config]();
        }
      });
    }
  }]);

  return Collapse;
}(BaseComponent);
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(document, EVENT_CLICK_DATA_API$4, SELECTOR_DATA_TOGGLE$4, function (event) {
  // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
  if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') {
    event.preventDefault();
  }

  var selector = getSelectorFromElement(this);
  var selectorElements = SelectorEngine.find(selector);
  selectorElements.forEach(function (element) {
    Collapse.getOrCreateInstance(element, {
      toggle: false
    }).toggle();
  });
});
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Collapse to jQuery only if jQuery is present
 */

defineJQueryPlugin(Collapse);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

var NAME$9 = 'dropdown';
var DATA_KEY$8 = 'bs.dropdown';
var EVENT_KEY$8 = ".".concat(DATA_KEY$8);
var DATA_API_KEY$4 = '.data-api';
var ESCAPE_KEY$2 = 'Escape';
var SPACE_KEY = 'Space';
var TAB_KEY$1 = 'Tab';
var ARROW_UP_KEY = 'ArrowUp';
var ARROW_DOWN_KEY = 'ArrowDown';
var RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button

var REGEXP_KEYDOWN = new RegExp("".concat(ARROW_UP_KEY, "|").concat(ARROW_DOWN_KEY, "|").concat(ESCAPE_KEY$2));
var EVENT_HIDE$4 = "hide".concat(EVENT_KEY$8);
var EVENT_HIDDEN$4 = "hidden".concat(EVENT_KEY$8);
var EVENT_SHOW$4 = "show".concat(EVENT_KEY$8);
var EVENT_SHOWN$4 = "shown".concat(EVENT_KEY$8);
var EVENT_CLICK_DATA_API$3 = "click".concat(EVENT_KEY$8).concat(DATA_API_KEY$4);
var EVENT_KEYDOWN_DATA_API = "keydown".concat(EVENT_KEY$8).concat(DATA_API_KEY$4);
var EVENT_KEYUP_DATA_API = "keyup".concat(EVENT_KEY$8).concat(DATA_API_KEY$4);
var CLASS_NAME_SHOW$6 = 'show';
var CLASS_NAME_DROPUP = 'dropup';
var CLASS_NAME_DROPEND = 'dropend';
var CLASS_NAME_DROPSTART = 'dropstart';
var CLASS_NAME_NAVBAR = 'navbar';
var SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]';
var SELECTOR_MENU = '.dropdown-menu';
var SELECTOR_NAVBAR_NAV = '.navbar-nav';
var SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
var PLACEMENT_TOP = isRTL() ? 'top-end' : 'top-start';
var PLACEMENT_TOPEND = isRTL() ? 'top-start' : 'top-end';
var PLACEMENT_BOTTOM = isRTL() ? 'bottom-end' : 'bottom-start';
var PLACEMENT_BOTTOMEND = isRTL() ? 'bottom-start' : 'bottom-end';
var PLACEMENT_RIGHT = isRTL() ? 'left-start' : 'right-start';
var PLACEMENT_LEFT = isRTL() ? 'right-start' : 'left-start';
var Default$8 = {
  offset: [0, 2],
  boundary: 'clippingParents',
  reference: 'toggle',
  display: 'dynamic',
  popperConfig: null,
  autoClose: true
};
var DefaultType$8 = {
  offset: '(array|string|function)',
  boundary: '(string|element)',
  reference: '(string|element|object)',
  display: 'string',
  popperConfig: '(null|object|function)',
  autoClose: '(boolean|string)'
};
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

var Dropdown = /*#__PURE__*/function (_BaseComponent5) {
  (0,inherits/* default */.Z)(Dropdown, _BaseComponent5);

  var _super5 = (0,createSuper/* default */.Z)(Dropdown);

  function Dropdown(element, config) {
    var _this12;

    (0,classCallCheck/* default */.Z)(this, Dropdown);

    _this12 = _super5.call(this, element);
    _this12._popper = null;
    _this12._config = _this12._getConfig(config);
    _this12._menu = _this12._getMenuElement();
    _this12._inNavbar = _this12._detectNavbar();
    return _this12;
  } // Getters


  (0,createClass/* default */.Z)(Dropdown, [{
    key: "toggle",
    value: // Public
    function toggle() {
      return this._isShown() ? this.hide() : this.show();
    }
  }, {
    key: "show",
    value: function show() {
      if (isDisabled(this._element) || this._isShown(this._menu)) {
        return;
      }

      var relatedTarget = {
        relatedTarget: this._element
      };
      var showEvent = EventHandler.trigger(this._element, EVENT_SHOW$4, relatedTarget);

      if (showEvent.defaultPrevented) {
        return;
      }

      var parent = Dropdown.getParentFromElement(this._element); // Totally disable Popper for Dropdowns in Navbar

      if (this._inNavbar) {
        Manipulator.setDataAttribute(this._menu, 'popper', 'none');
      } else {
        this._createPopper(parent);
      } // If this is a touch-enabled device we add extra
      // empty mouseover listeners to the body's immediate children;
      // only needed because of broken event delegation on iOS
      // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html


      if ('ontouchstart' in document.documentElement && !parent.closest(SELECTOR_NAVBAR_NAV)) {
        var _ref4;

        (_ref4 = []).concat.apply(_ref4, (0,toConsumableArray/* default */.Z)(document.body.children)).forEach(function (elem) {
          return EventHandler.on(elem, 'mouseover', noop);
        });
      }

      this._element.focus();

      this._element.setAttribute('aria-expanded', true);

      this._menu.classList.add(CLASS_NAME_SHOW$6);

      this._element.classList.add(CLASS_NAME_SHOW$6);

      EventHandler.trigger(this._element, EVENT_SHOWN$4, relatedTarget);
    }
  }, {
    key: "hide",
    value: function hide() {
      if (isDisabled(this._element) || !this._isShown(this._menu)) {
        return;
      }

      var relatedTarget = {
        relatedTarget: this._element
      };

      this._completeHide(relatedTarget);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this._popper) {
        this._popper.destroy();
      }

      _get((0,getPrototypeOf/* default */.Z)(Dropdown.prototype), "dispose", this).call(this);
    }
  }, {
    key: "update",
    value: function update() {
      this._inNavbar = this._detectNavbar();

      if (this._popper) {
        this._popper.update();
      }
    } // Private

  }, {
    key: "_completeHide",
    value: function _completeHide(relatedTarget) {
      var hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$4, relatedTarget);

      if (hideEvent.defaultPrevented) {
        return;
      } // If this is a touch-enabled device we remove the extra
      // empty mouseover listeners we added for iOS support


      if ('ontouchstart' in document.documentElement) {
        var _ref5;

        (_ref5 = []).concat.apply(_ref5, (0,toConsumableArray/* default */.Z)(document.body.children)).forEach(function (elem) {
          return EventHandler.off(elem, 'mouseover', noop);
        });
      }

      if (this._popper) {
        this._popper.destroy();
      }

      this._menu.classList.remove(CLASS_NAME_SHOW$6);

      this._element.classList.remove(CLASS_NAME_SHOW$6);

      this._element.setAttribute('aria-expanded', 'false');

      Manipulator.removeDataAttribute(this._menu, 'popper');
      EventHandler.trigger(this._element, EVENT_HIDDEN$4, relatedTarget);
    }
  }, {
    key: "_getConfig",
    value: function _getConfig(config) {
      config = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, this.constructor.Default), Manipulator.getDataAttributes(this._element)), config);
      typeCheckConfig(NAME$9, config, this.constructor.DefaultType);

      if (typeof config.reference === 'object' && !bootstrap_esm_isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') {
        // Popper virtual elements require a getBoundingClientRect method
        throw new TypeError("".concat(NAME$9.toUpperCase(), ": Option \"reference\" provided type \"object\" without a required \"getBoundingClientRect\" method."));
      }

      return config;
    }
  }, {
    key: "_createPopper",
    value: function _createPopper(parent) {
      if (typeof lib_namespaceObject === 'undefined') {
        throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
      }

      var referenceElement = this._element;

      if (this._config.reference === 'parent') {
        referenceElement = parent;
      } else if (bootstrap_esm_isElement(this._config.reference)) {
        referenceElement = getElement(this._config.reference);
      } else if (typeof this._config.reference === 'object') {
        referenceElement = this._config.reference;
      }

      var popperConfig = this._getPopperConfig();

      var isDisplayStatic = popperConfig.modifiers.find(function (modifier) {
        return modifier.name === 'applyStyles' && modifier.enabled === false;
      });
      this._popper = popper_createPopper(referenceElement, this._menu, popperConfig);

      if (isDisplayStatic) {
        Manipulator.setDataAttribute(this._menu, 'popper', 'static');
      }
    }
  }, {
    key: "_isShown",
    value: function _isShown() {
      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._element;
      return element.classList.contains(CLASS_NAME_SHOW$6);
    }
  }, {
    key: "_getMenuElement",
    value: function _getMenuElement() {
      return SelectorEngine.next(this._element, SELECTOR_MENU)[0];
    }
  }, {
    key: "_getPlacement",
    value: function _getPlacement() {
      var parentDropdown = this._element.parentNode;

      if (parentDropdown.classList.contains(CLASS_NAME_DROPEND)) {
        return PLACEMENT_RIGHT;
      }

      if (parentDropdown.classList.contains(CLASS_NAME_DROPSTART)) {
        return PLACEMENT_LEFT;
      } // We need to trim the value because custom properties can also include spaces


      var isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';

      if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) {
        return isEnd ? PLACEMENT_TOPEND : PLACEMENT_TOP;
      }

      return isEnd ? PLACEMENT_BOTTOMEND : PLACEMENT_BOTTOM;
    }
  }, {
    key: "_detectNavbar",
    value: function _detectNavbar() {
      return this._element.closest(".".concat(CLASS_NAME_NAVBAR)) !== null;
    }
  }, {
    key: "_getOffset",
    value: function _getOffset() {
      var _this13 = this;

      var offset = this._config.offset;

      if (typeof offset === 'string') {
        return offset.split(',').map(function (val) {
          return Number.parseInt(val, 10);
        });
      }

      if (typeof offset === 'function') {
        return function (popperData) {
          return offset(popperData, _this13._element);
        };
      }

      return offset;
    }
  }, {
    key: "_getPopperConfig",
    value: function _getPopperConfig() {
      var defaultBsPopperConfig = {
        placement: this._getPlacement(),
        modifiers: [{
          name: 'preventOverflow',
          options: {
            boundary: this._config.boundary
          }
        }, {
          name: 'offset',
          options: {
            offset: this._getOffset()
          }
        }]
      }; // Disable Popper if we have a static display

      if (this._config.display === 'static') {
        defaultBsPopperConfig.modifiers = [{
          name: 'applyStyles',
          enabled: false
        }];
      }

      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, defaultBsPopperConfig), typeof this._config.popperConfig === 'function' ? this._config.popperConfig(defaultBsPopperConfig) : this._config.popperConfig);
    }
  }, {
    key: "_selectMenuItem",
    value: function _selectMenuItem(_ref6) {
      var key = _ref6.key,
          target = _ref6.target;
      var items = SelectorEngine.find(SELECTOR_VISIBLE_ITEMS, this._menu).filter(isVisible);

      if (!items.length) {
        return;
      } // if target isn't included in items (e.g. when expanding the dropdown)
      // allow cycling to get the last item in case key equals ARROW_UP_KEY


      getNextActiveElement(items, target, key === ARROW_DOWN_KEY, !items.includes(target)).focus();
    } // Static

  }], [{
    key: "Default",
    get: function get() {
      return Default$8;
    }
  }, {
    key: "DefaultType",
    get: function get() {
      return DefaultType$8;
    }
  }, {
    key: "NAME",
    get: function get() {
      return NAME$9;
    }
  }, {
    key: "jQueryInterface",
    value: function jQueryInterface(config) {
      return this.each(function () {
        var data = Dropdown.getOrCreateInstance(this, config);

        if (typeof config !== 'string') {
          return;
        }

        if (typeof data[config] === 'undefined') {
          throw new TypeError("No method named \"".concat(config, "\""));
        }

        data[config]();
      });
    }
  }, {
    key: "clearMenus",
    value: function clearMenus(event) {
      if (event && (event.button === RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== TAB_KEY$1)) {
        return;
      }

      var toggles = SelectorEngine.find(SELECTOR_DATA_TOGGLE$3);

      for (var i = 0, len = toggles.length; i < len; i++) {
        var context = Dropdown.getInstance(toggles[i]);

        if (!context || context._config.autoClose === false) {
          continue;
        }

        if (!context._isShown()) {
          continue;
        }

        var relatedTarget = {
          relatedTarget: context._element
        };

        if (event) {
          var composedPath = event.composedPath();
          var isMenuTarget = composedPath.includes(context._menu);

          if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) {
            continue;
          } // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu


          if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) {
            continue;
          }

          if (event.type === 'click') {
            relatedTarget.clickEvent = event;
          }
        }

        context._completeHide(relatedTarget);
      }
    }
  }, {
    key: "getParentFromElement",
    value: function getParentFromElement(element) {
      return getElementFromSelector(element) || element.parentNode;
    }
  }, {
    key: "dataApiKeydownHandler",
    value: function dataApiKeydownHandler(event) {
      // If not input/textarea:
      //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
      // If input/textarea:
      //  - If space key => not a dropdown command
      //  - If key is other than escape
      //    - If key is not up or down => not a dropdown command
      //    - If trigger inside the menu => not a dropdown command
      if (/input|textarea/i.test(event.target.tagName) ? event.key === SPACE_KEY || event.key !== ESCAPE_KEY$2 && (event.key !== ARROW_DOWN_KEY && event.key !== ARROW_UP_KEY || event.target.closest(SELECTOR_MENU)) : !REGEXP_KEYDOWN.test(event.key)) {
        return;
      }

      var isActive = this.classList.contains(CLASS_NAME_SHOW$6);

      if (!isActive && event.key === ESCAPE_KEY$2) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      if (isDisabled(this)) {
        return;
      }

      var getToggleButton = this.matches(SELECTOR_DATA_TOGGLE$3) ? this : SelectorEngine.prev(this, SELECTOR_DATA_TOGGLE$3)[0];
      var instance = Dropdown.getOrCreateInstance(getToggleButton);

      if (event.key === ESCAPE_KEY$2) {
        instance.hide();
        return;
      }

      if (event.key === ARROW_UP_KEY || event.key === ARROW_DOWN_KEY) {
        if (!isActive) {
          instance.show();
        }

        instance._selectMenuItem(event);

        return;
      }

      if (!isActive || event.key === SPACE_KEY) {
        Dropdown.clearMenus();
      }
    }
  }]);

  return Dropdown;
}(BaseComponent);
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE$3, Dropdown.dataApiKeydownHandler);
EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
EventHandler.on(document, EVENT_CLICK_DATA_API$3, Dropdown.clearMenus);
EventHandler.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
EventHandler.on(document, EVENT_CLICK_DATA_API$3, SELECTOR_DATA_TOGGLE$3, function (event) {
  event.preventDefault();
  Dropdown.getOrCreateInstance(this).toggle();
});
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Dropdown to jQuery only if jQuery is present
 */

defineJQueryPlugin(Dropdown);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

var SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
var SELECTOR_STICKY_CONTENT = '.sticky-top';

var ScrollBarHelper = /*#__PURE__*/function () {
  function ScrollBarHelper() {
    (0,classCallCheck/* default */.Z)(this, ScrollBarHelper);

    this._element = document.body;
  }

  (0,createClass/* default */.Z)(ScrollBarHelper, [{
    key: "getWidth",
    value: function getWidth() {
      // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
      var documentWidth = document.documentElement.clientWidth;
      return Math.abs(window.innerWidth - documentWidth);
    }
  }, {
    key: "hide",
    value: function hide() {
      var width = this.getWidth();

      this._disableOverFlow(); // give padding to element to balance the hidden scrollbar width


      this._setElementAttributes(this._element, 'paddingRight', function (calculatedValue) {
        return calculatedValue + width;
      }); // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth


      this._setElementAttributes(SELECTOR_FIXED_CONTENT, 'paddingRight', function (calculatedValue) {
        return calculatedValue + width;
      });

      this._setElementAttributes(SELECTOR_STICKY_CONTENT, 'marginRight', function (calculatedValue) {
        return calculatedValue - width;
      });
    }
  }, {
    key: "_disableOverFlow",
    value: function _disableOverFlow() {
      this._saveInitialAttribute(this._element, 'overflow');

      this._element.style.overflow = 'hidden';
    }
  }, {
    key: "_setElementAttributes",
    value: function _setElementAttributes(selector, styleProp, callback) {
      var _this14 = this;

      var scrollbarWidth = this.getWidth();

      var manipulationCallBack = function manipulationCallBack(element) {
        if (element !== _this14._element && window.innerWidth > element.clientWidth + scrollbarWidth) {
          return;
        }

        _this14._saveInitialAttribute(element, styleProp);

        var calculatedValue = window.getComputedStyle(element)[styleProp];
        element.style[styleProp] = "".concat(callback(Number.parseFloat(calculatedValue)), "px");
      };

      this._applyManipulationCallback(selector, manipulationCallBack);
    }
  }, {
    key: "reset",
    value: function reset() {
      this._resetElementAttributes(this._element, 'overflow');

      this._resetElementAttributes(this._element, 'paddingRight');

      this._resetElementAttributes(SELECTOR_FIXED_CONTENT, 'paddingRight');

      this._resetElementAttributes(SELECTOR_STICKY_CONTENT, 'marginRight');
    }
  }, {
    key: "_saveInitialAttribute",
    value: function _saveInitialAttribute(element, styleProp) {
      var actualValue = element.style[styleProp];

      if (actualValue) {
        Manipulator.setDataAttribute(element, styleProp, actualValue);
      }
    }
  }, {
    key: "_resetElementAttributes",
    value: function _resetElementAttributes(selector, styleProp) {
      var manipulationCallBack = function manipulationCallBack(element) {
        var value = Manipulator.getDataAttribute(element, styleProp);

        if (typeof value === 'undefined') {
          element.style.removeProperty(styleProp);
        } else {
          Manipulator.removeDataAttribute(element, styleProp);
          element.style[styleProp] = value;
        }
      };

      this._applyManipulationCallback(selector, manipulationCallBack);
    }
  }, {
    key: "_applyManipulationCallback",
    value: function _applyManipulationCallback(selector, callBack) {
      if (bootstrap_esm_isElement(selector)) {
        callBack(selector);
      } else {
        SelectorEngine.find(selector, this._element).forEach(callBack);
      }
    }
  }, {
    key: "isOverflowing",
    value: function isOverflowing() {
      return this.getWidth() > 0;
    }
  }]);

  return ScrollBarHelper;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */


var Default$7 = {
  className: 'modal-backdrop',
  isVisible: true,
  // if false, we use the backdrop helper without adding any element to the dom
  isAnimated: false,
  rootElement: 'body',
  // give the choice to place backdrop under different elements
  clickCallback: null
};
var DefaultType$7 = {
  className: 'string',
  isVisible: 'boolean',
  isAnimated: 'boolean',
  rootElement: '(element|string)',
  clickCallback: '(function|null)'
};
var NAME$8 = 'backdrop';
var CLASS_NAME_FADE$4 = 'fade';
var CLASS_NAME_SHOW$5 = 'show';
var EVENT_MOUSEDOWN = "mousedown.bs.".concat(NAME$8);

var Backdrop = /*#__PURE__*/function () {
  function Backdrop(config) {
    (0,classCallCheck/* default */.Z)(this, Backdrop);

    this._config = this._getConfig(config);
    this._isAppended = false;
    this._element = null;
  }

  (0,createClass/* default */.Z)(Backdrop, [{
    key: "show",
    value: function show(callback) {
      if (!this._config.isVisible) {
        execute(callback);
        return;
      }

      this._append();

      if (this._config.isAnimated) {
        reflow(this._getElement());
      }

      this._getElement().classList.add(CLASS_NAME_SHOW$5);

      this._emulateAnimation(function () {
        execute(callback);
      });
    }
  }, {
    key: "hide",
    value: function hide(callback) {
      var _this15 = this;

      if (!this._config.isVisible) {
        execute(callback);
        return;
      }

      this._getElement().classList.remove(CLASS_NAME_SHOW$5);

      this._emulateAnimation(function () {
        _this15.dispose();

        execute(callback);
      });
    } // Private

  }, {
    key: "_getElement",
    value: function _getElement() {
      if (!this._element) {
        var backdrop = document.createElement('div');
        backdrop.className = this._config.className;

        if (this._config.isAnimated) {
          backdrop.classList.add(CLASS_NAME_FADE$4);
        }

        this._element = backdrop;
      }

      return this._element;
    }
  }, {
    key: "_getConfig",
    value: function _getConfig(config) {
      config = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, Default$7), typeof config === 'object' ? config : {}); // use getElement() with the default "body" to get a fresh Element on each instantiation

      config.rootElement = getElement(config.rootElement);
      typeCheckConfig(NAME$8, config, DefaultType$7);
      return config;
    }
  }, {
    key: "_append",
    value: function _append() {
      var _this16 = this;

      if (this._isAppended) {
        return;
      }

      this._config.rootElement.append(this._getElement());

      EventHandler.on(this._getElement(), EVENT_MOUSEDOWN, function () {
        execute(_this16._config.clickCallback);
      });
      this._isAppended = true;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (!this._isAppended) {
        return;
      }

      EventHandler.off(this._element, EVENT_MOUSEDOWN);

      this._element.remove();

      this._isAppended = false;
    }
  }, {
    key: "_emulateAnimation",
    value: function _emulateAnimation(callback) {
      executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
    }
  }]);

  return Backdrop;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */


var Default$6 = {
  trapElement: null,
  // The element to trap focus inside of
  autofocus: true
};
var DefaultType$6 = {
  trapElement: 'element',
  autofocus: 'boolean'
};
var NAME$7 = 'focustrap';
var DATA_KEY$7 = 'bs.focustrap';
var EVENT_KEY$7 = ".".concat(DATA_KEY$7);
var EVENT_FOCUSIN$1 = "focusin".concat(EVENT_KEY$7);
var EVENT_KEYDOWN_TAB = "keydown.tab".concat(EVENT_KEY$7);
var TAB_KEY = 'Tab';
var TAB_NAV_FORWARD = 'forward';
var TAB_NAV_BACKWARD = 'backward';

var FocusTrap = /*#__PURE__*/function () {
  function FocusTrap(config) {
    (0,classCallCheck/* default */.Z)(this, FocusTrap);

    this._config = this._getConfig(config);
    this._isActive = false;
    this._lastTabNavDirection = null;
  }

  (0,createClass/* default */.Z)(FocusTrap, [{
    key: "activate",
    value: function activate() {
      var _this17 = this;

      var _this$_config = this._config,
          trapElement = _this$_config.trapElement,
          autofocus = _this$_config.autofocus;

      if (this._isActive) {
        return;
      }

      if (autofocus) {
        trapElement.focus();
      }

      EventHandler.off(document, EVENT_KEY$7); // guard against infinite focus loop

      EventHandler.on(document, EVENT_FOCUSIN$1, function (event) {
        return _this17._handleFocusin(event);
      });
      EventHandler.on(document, EVENT_KEYDOWN_TAB, function (event) {
        return _this17._handleKeydown(event);
      });
      this._isActive = true;
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      if (!this._isActive) {
        return;
      }

      this._isActive = false;
      EventHandler.off(document, EVENT_KEY$7);
    } // Private

  }, {
    key: "_handleFocusin",
    value: function _handleFocusin(event) {
      var target = event.target;
      var trapElement = this._config.trapElement;

      if (target === document || target === trapElement || trapElement.contains(target)) {
        return;
      }

      var elements = SelectorEngine.focusableChildren(trapElement);

      if (elements.length === 0) {
        trapElement.focus();
      } else if (this._lastTabNavDirection === TAB_NAV_BACKWARD) {
        elements[elements.length - 1].focus();
      } else {
        elements[0].focus();
      }
    }
  }, {
    key: "_handleKeydown",
    value: function _handleKeydown(event) {
      if (event.key !== TAB_KEY) {
        return;
      }

      this._lastTabNavDirection = event.shiftKey ? TAB_NAV_BACKWARD : TAB_NAV_FORWARD;
    }
  }, {
    key: "_getConfig",
    value: function _getConfig(config) {
      config = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, Default$6), typeof config === 'object' ? config : {});
      typeCheckConfig(NAME$7, config, DefaultType$6);
      return config;
    }
  }]);

  return FocusTrap;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */


var NAME$6 = 'modal';
var DATA_KEY$6 = 'bs.modal';
var EVENT_KEY$6 = ".".concat(DATA_KEY$6);
var DATA_API_KEY$3 = '.data-api';
var ESCAPE_KEY$1 = 'Escape';
var Default$5 = {
  backdrop: true,
  keyboard: true,
  focus: true
};
var DefaultType$5 = {
  backdrop: '(boolean|string)',
  keyboard: 'boolean',
  focus: 'boolean'
};
var EVENT_HIDE$3 = "hide".concat(EVENT_KEY$6);
var EVENT_HIDE_PREVENTED = "hidePrevented".concat(EVENT_KEY$6);
var EVENT_HIDDEN$3 = "hidden".concat(EVENT_KEY$6);
var EVENT_SHOW$3 = "show".concat(EVENT_KEY$6);
var EVENT_SHOWN$3 = "shown".concat(EVENT_KEY$6);
var EVENT_RESIZE = "resize".concat(EVENT_KEY$6);
var EVENT_CLICK_DISMISS = "click.dismiss".concat(EVENT_KEY$6);
var EVENT_KEYDOWN_DISMISS$1 = "keydown.dismiss".concat(EVENT_KEY$6);
var EVENT_MOUSEUP_DISMISS = "mouseup.dismiss".concat(EVENT_KEY$6);
var EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss".concat(EVENT_KEY$6);
var EVENT_CLICK_DATA_API$2 = "click".concat(EVENT_KEY$6).concat(DATA_API_KEY$3);
var CLASS_NAME_OPEN = 'modal-open';
var CLASS_NAME_FADE$3 = 'fade';
var CLASS_NAME_SHOW$4 = 'show';
var CLASS_NAME_STATIC = 'modal-static';
var OPEN_SELECTOR$1 = '.modal.show';
var SELECTOR_DIALOG = '.modal-dialog';
var SELECTOR_MODAL_BODY = '.modal-body';
var SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

var Modal = /*#__PURE__*/function (_BaseComponent6) {
  (0,inherits/* default */.Z)(Modal, _BaseComponent6);

  var _super6 = (0,createSuper/* default */.Z)(Modal);

  function Modal(element, config) {
    var _this18;

    (0,classCallCheck/* default */.Z)(this, Modal);

    _this18 = _super6.call(this, element);
    _this18._config = _this18._getConfig(config);
    _this18._dialog = SelectorEngine.findOne(SELECTOR_DIALOG, _this18._element);
    _this18._backdrop = _this18._initializeBackDrop();
    _this18._focustrap = _this18._initializeFocusTrap();
    _this18._isShown = false;
    _this18._ignoreBackdropClick = false;
    _this18._isTransitioning = false;
    _this18._scrollBar = new ScrollBarHelper();
    return _this18;
  } // Getters


  (0,createClass/* default */.Z)(Modal, [{
    key: "toggle",
    value: // Public
    function toggle(relatedTarget) {
      return this._isShown ? this.hide() : this.show(relatedTarget);
    }
  }, {
    key: "show",
    value: function show(relatedTarget) {
      var _this19 = this;

      if (this._isShown || this._isTransitioning) {
        return;
      }

      var showEvent = EventHandler.trigger(this._element, EVENT_SHOW$3, {
        relatedTarget: relatedTarget
      });

      if (showEvent.defaultPrevented) {
        return;
      }

      this._isShown = true;

      if (this._isAnimated()) {
        this._isTransitioning = true;
      }

      this._scrollBar.hide();

      document.body.classList.add(CLASS_NAME_OPEN);

      this._adjustDialog();

      this._setEscapeEvent();

      this._setResizeEvent();

      EventHandler.on(this._dialog, EVENT_MOUSEDOWN_DISMISS, function () {
        EventHandler.one(_this19._element, EVENT_MOUSEUP_DISMISS, function (event) {
          if (event.target === _this19._element) {
            _this19._ignoreBackdropClick = true;
          }
        });
      });

      this._showBackdrop(function () {
        return _this19._showElement(relatedTarget);
      });
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this20 = this;

      if (!this._isShown || this._isTransitioning) {
        return;
      }

      var hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$3);

      if (hideEvent.defaultPrevented) {
        return;
      }

      this._isShown = false;

      var isAnimated = this._isAnimated();

      if (isAnimated) {
        this._isTransitioning = true;
      }

      this._setEscapeEvent();

      this._setResizeEvent();

      this._focustrap.deactivate();

      this._element.classList.remove(CLASS_NAME_SHOW$4);

      EventHandler.off(this._element, EVENT_CLICK_DISMISS);
      EventHandler.off(this._dialog, EVENT_MOUSEDOWN_DISMISS);

      this._queueCallback(function () {
        return _this20._hideModal();
      }, this._element, isAnimated);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      [window, this._dialog].forEach(function (htmlElement) {
        return EventHandler.off(htmlElement, EVENT_KEY$6);
      });

      this._backdrop.dispose();

      this._focustrap.deactivate();

      _get((0,getPrototypeOf/* default */.Z)(Modal.prototype), "dispose", this).call(this);
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate() {
      this._adjustDialog();
    } // Private

  }, {
    key: "_initializeBackDrop",
    value: function _initializeBackDrop() {
      return new Backdrop({
        isVisible: Boolean(this._config.backdrop),
        // 'static' option will be translated to true, and booleans will keep their value
        isAnimated: this._isAnimated()
      });
    }
  }, {
    key: "_initializeFocusTrap",
    value: function _initializeFocusTrap() {
      return new FocusTrap({
        trapElement: this._element
      });
    }
  }, {
    key: "_getConfig",
    value: function _getConfig(config) {
      config = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, Default$5), Manipulator.getDataAttributes(this._element)), typeof config === 'object' ? config : {});
      typeCheckConfig(NAME$6, config, DefaultType$5);
      return config;
    }
  }, {
    key: "_showElement",
    value: function _showElement(relatedTarget) {
      var _this21 = this;

      var isAnimated = this._isAnimated();

      var modalBody = SelectorEngine.findOne(SELECTOR_MODAL_BODY, this._dialog);

      if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
        // Don't move modal's DOM position
        document.body.append(this._element);
      }

      this._element.style.display = 'block';

      this._element.removeAttribute('aria-hidden');

      this._element.setAttribute('aria-modal', true);

      this._element.setAttribute('role', 'dialog');

      this._element.scrollTop = 0;

      if (modalBody) {
        modalBody.scrollTop = 0;
      }

      if (isAnimated) {
        reflow(this._element);
      }

      this._element.classList.add(CLASS_NAME_SHOW$4);

      var transitionComplete = function transitionComplete() {
        if (_this21._config.focus) {
          _this21._focustrap.activate();
        }

        _this21._isTransitioning = false;
        EventHandler.trigger(_this21._element, EVENT_SHOWN$3, {
          relatedTarget: relatedTarget
        });
      };

      this._queueCallback(transitionComplete, this._dialog, isAnimated);
    }
  }, {
    key: "_setEscapeEvent",
    value: function _setEscapeEvent() {
      var _this22 = this;

      if (this._isShown) {
        EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS$1, function (event) {
          if (_this22._config.keyboard && event.key === ESCAPE_KEY$1) {
            event.preventDefault();

            _this22.hide();
          } else if (!_this22._config.keyboard && event.key === ESCAPE_KEY$1) {
            _this22._triggerBackdropTransition();
          }
        });
      } else {
        EventHandler.off(this._element, EVENT_KEYDOWN_DISMISS$1);
      }
    }
  }, {
    key: "_setResizeEvent",
    value: function _setResizeEvent() {
      var _this23 = this;

      if (this._isShown) {
        EventHandler.on(window, EVENT_RESIZE, function () {
          return _this23._adjustDialog();
        });
      } else {
        EventHandler.off(window, EVENT_RESIZE);
      }
    }
  }, {
    key: "_hideModal",
    value: function _hideModal() {
      var _this24 = this;

      this._element.style.display = 'none';

      this._element.setAttribute('aria-hidden', true);

      this._element.removeAttribute('aria-modal');

      this._element.removeAttribute('role');

      this._isTransitioning = false;

      this._backdrop.hide(function () {
        document.body.classList.remove(CLASS_NAME_OPEN);

        _this24._resetAdjustments();

        _this24._scrollBar.reset();

        EventHandler.trigger(_this24._element, EVENT_HIDDEN$3);
      });
    }
  }, {
    key: "_showBackdrop",
    value: function _showBackdrop(callback) {
      var _this25 = this;

      EventHandler.on(this._element, EVENT_CLICK_DISMISS, function (event) {
        if (_this25._ignoreBackdropClick) {
          _this25._ignoreBackdropClick = false;
          return;
        }

        if (event.target !== event.currentTarget) {
          return;
        }

        if (_this25._config.backdrop === true) {
          _this25.hide();
        } else if (_this25._config.backdrop === 'static') {
          _this25._triggerBackdropTransition();
        }
      });

      this._backdrop.show(callback);
    }
  }, {
    key: "_isAnimated",
    value: function _isAnimated() {
      return this._element.classList.contains(CLASS_NAME_FADE$3);
    }
  }, {
    key: "_triggerBackdropTransition",
    value: function _triggerBackdropTransition() {
      var _this26 = this;

      var hideEvent = EventHandler.trigger(this._element, EVENT_HIDE_PREVENTED);

      if (hideEvent.defaultPrevented) {
        return;
      }

      var _this$_element = this._element,
          classList = _this$_element.classList,
          scrollHeight = _this$_element.scrollHeight,
          style = _this$_element.style;
      var isModalOverflowing = scrollHeight > document.documentElement.clientHeight; // return if the following background transition hasn't yet completed

      if (!isModalOverflowing && style.overflowY === 'hidden' || classList.contains(CLASS_NAME_STATIC)) {
        return;
      }

      if (!isModalOverflowing) {
        style.overflowY = 'hidden';
      }

      classList.add(CLASS_NAME_STATIC);

      this._queueCallback(function () {
        classList.remove(CLASS_NAME_STATIC);

        if (!isModalOverflowing) {
          _this26._queueCallback(function () {
            style.overflowY = '';
          }, _this26._dialog);
        }
      }, this._dialog);

      this._element.focus();
    } // ----------------------------------------------------------------------
    // the following methods are used to handle overflowing modals
    // ----------------------------------------------------------------------

  }, {
    key: "_adjustDialog",
    value: function _adjustDialog() {
      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

      var scrollbarWidth = this._scrollBar.getWidth();

      var isBodyOverflowing = scrollbarWidth > 0;

      if (!isBodyOverflowing && isModalOverflowing && !isRTL() || isBodyOverflowing && !isModalOverflowing && isRTL()) {
        this._element.style.paddingLeft = "".concat(scrollbarWidth, "px");
      }

      if (isBodyOverflowing && !isModalOverflowing && !isRTL() || !isBodyOverflowing && isModalOverflowing && isRTL()) {
        this._element.style.paddingRight = "".concat(scrollbarWidth, "px");
      }
    }
  }, {
    key: "_resetAdjustments",
    value: function _resetAdjustments() {
      this._element.style.paddingLeft = '';
      this._element.style.paddingRight = '';
    } // Static

  }], [{
    key: "Default",
    get: function get() {
      return Default$5;
    }
  }, {
    key: "NAME",
    get: function get() {
      return NAME$6;
    }
  }, {
    key: "jQueryInterface",
    value: function jQueryInterface(config, relatedTarget) {
      return this.each(function () {
        var data = Modal.getOrCreateInstance(this, config);

        if (typeof config !== 'string') {
          return;
        }

        if (typeof data[config] === 'undefined') {
          throw new TypeError("No method named \"".concat(config, "\""));
        }

        data[config](relatedTarget);
      });
    }
  }]);

  return Modal;
}(BaseComponent);
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(document, EVENT_CLICK_DATA_API$2, SELECTOR_DATA_TOGGLE$2, function (event) {
  var _this27 = this;

  var target = getElementFromSelector(this);

  if (['A', 'AREA'].includes(this.tagName)) {
    event.preventDefault();
  }

  EventHandler.one(target, EVENT_SHOW$3, function (showEvent) {
    if (showEvent.defaultPrevented) {
      // only register focus restorer if modal will actually get shown
      return;
    }

    EventHandler.one(target, EVENT_HIDDEN$3, function () {
      if (isVisible(_this27)) {
        _this27.focus();
      }
    });
  }); // avoid conflict when clicking moddal toggler while another one is open

  var allReadyOpen = SelectorEngine.findOne(OPEN_SELECTOR$1);

  if (allReadyOpen) {
    Modal.getInstance(allReadyOpen).hide();
  }

  var data = Modal.getOrCreateInstance(target);
  data.toggle(this);
});
enableDismissTrigger(Modal);
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Modal to jQuery only if jQuery is present
 */

defineJQueryPlugin(Modal);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

var NAME$5 = 'offcanvas';
var DATA_KEY$5 = 'bs.offcanvas';
var EVENT_KEY$5 = ".".concat(DATA_KEY$5);
var DATA_API_KEY$2 = '.data-api';
var EVENT_LOAD_DATA_API$1 = "load".concat(EVENT_KEY$5).concat(DATA_API_KEY$2);
var ESCAPE_KEY = 'Escape';
var Default$4 = {
  backdrop: true,
  keyboard: true,
  scroll: false
};
var DefaultType$4 = {
  backdrop: 'boolean',
  keyboard: 'boolean',
  scroll: 'boolean'
};
var CLASS_NAME_SHOW$3 = 'show';
var CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
var OPEN_SELECTOR = '.offcanvas.show';
var EVENT_SHOW$2 = "show".concat(EVENT_KEY$5);
var EVENT_SHOWN$2 = "shown".concat(EVENT_KEY$5);
var EVENT_HIDE$2 = "hide".concat(EVENT_KEY$5);
var EVENT_HIDDEN$2 = "hidden".concat(EVENT_KEY$5);
var EVENT_CLICK_DATA_API$1 = "click".concat(EVENT_KEY$5).concat(DATA_API_KEY$2);
var EVENT_KEYDOWN_DISMISS = "keydown.dismiss".concat(EVENT_KEY$5);
var SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

var Offcanvas = /*#__PURE__*/function (_BaseComponent7) {
  (0,inherits/* default */.Z)(Offcanvas, _BaseComponent7);

  var _super7 = (0,createSuper/* default */.Z)(Offcanvas);

  function Offcanvas(element, config) {
    var _this28;

    (0,classCallCheck/* default */.Z)(this, Offcanvas);

    _this28 = _super7.call(this, element);
    _this28._config = _this28._getConfig(config);
    _this28._isShown = false;
    _this28._backdrop = _this28._initializeBackDrop();
    _this28._focustrap = _this28._initializeFocusTrap();

    _this28._addEventListeners();

    return _this28;
  } // Getters


  (0,createClass/* default */.Z)(Offcanvas, [{
    key: "toggle",
    value: // Public
    function toggle(relatedTarget) {
      return this._isShown ? this.hide() : this.show(relatedTarget);
    }
  }, {
    key: "show",
    value: function show(relatedTarget) {
      var _this29 = this;

      if (this._isShown) {
        return;
      }

      var showEvent = EventHandler.trigger(this._element, EVENT_SHOW$2, {
        relatedTarget: relatedTarget
      });

      if (showEvent.defaultPrevented) {
        return;
      }

      this._isShown = true;
      this._element.style.visibility = 'visible';

      this._backdrop.show();

      if (!this._config.scroll) {
        new ScrollBarHelper().hide();
      }

      this._element.removeAttribute('aria-hidden');

      this._element.setAttribute('aria-modal', true);

      this._element.setAttribute('role', 'dialog');

      this._element.classList.add(CLASS_NAME_SHOW$3);

      var completeCallBack = function completeCallBack() {
        if (!_this29._config.scroll) {
          _this29._focustrap.activate();
        }

        EventHandler.trigger(_this29._element, EVENT_SHOWN$2, {
          relatedTarget: relatedTarget
        });
      };

      this._queueCallback(completeCallBack, this._element, true);
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this30 = this;

      if (!this._isShown) {
        return;
      }

      var hideEvent = EventHandler.trigger(this._element, EVENT_HIDE$2);

      if (hideEvent.defaultPrevented) {
        return;
      }

      this._focustrap.deactivate();

      this._element.blur();

      this._isShown = false;

      this._element.classList.remove(CLASS_NAME_SHOW$3);

      this._backdrop.hide();

      var completeCallback = function completeCallback() {
        _this30._element.setAttribute('aria-hidden', true);

        _this30._element.removeAttribute('aria-modal');

        _this30._element.removeAttribute('role');

        _this30._element.style.visibility = 'hidden';

        if (!_this30._config.scroll) {
          new ScrollBarHelper().reset();
        }

        EventHandler.trigger(_this30._element, EVENT_HIDDEN$2);
      };

      this._queueCallback(completeCallback, this._element, true);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._backdrop.dispose();

      this._focustrap.deactivate();

      _get((0,getPrototypeOf/* default */.Z)(Offcanvas.prototype), "dispose", this).call(this);
    } // Private

  }, {
    key: "_getConfig",
    value: function _getConfig(config) {
      config = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, Default$4), Manipulator.getDataAttributes(this._element)), typeof config === 'object' ? config : {});
      typeCheckConfig(NAME$5, config, DefaultType$4);
      return config;
    }
  }, {
    key: "_initializeBackDrop",
    value: function _initializeBackDrop() {
      var _this31 = this;

      return new Backdrop({
        className: CLASS_NAME_BACKDROP,
        isVisible: this._config.backdrop,
        isAnimated: true,
        rootElement: this._element.parentNode,
        clickCallback: function clickCallback() {
          return _this31.hide();
        }
      });
    }
  }, {
    key: "_initializeFocusTrap",
    value: function _initializeFocusTrap() {
      return new FocusTrap({
        trapElement: this._element
      });
    }
  }, {
    key: "_addEventListeners",
    value: function _addEventListeners() {
      var _this32 = this;

      EventHandler.on(this._element, EVENT_KEYDOWN_DISMISS, function (event) {
        if (_this32._config.keyboard && event.key === ESCAPE_KEY) {
          _this32.hide();
        }
      });
    } // Static

  }], [{
    key: "NAME",
    get: function get() {
      return NAME$5;
    }
  }, {
    key: "Default",
    get: function get() {
      return Default$4;
    }
  }, {
    key: "jQueryInterface",
    value: function jQueryInterface(config) {
      return this.each(function () {
        var data = Offcanvas.getOrCreateInstance(this, config);

        if (typeof config !== 'string') {
          return;
        }

        if (data[config] === undefined || config.startsWith('_') || config === 'constructor') {
          throw new TypeError("No method named \"".concat(config, "\""));
        }

        data[config](this);
      });
    }
  }]);

  return Offcanvas;
}(BaseComponent);
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(document, EVENT_CLICK_DATA_API$1, SELECTOR_DATA_TOGGLE$1, function (event) {
  var _this33 = this;

  var target = getElementFromSelector(this);

  if (['A', 'AREA'].includes(this.tagName)) {
    event.preventDefault();
  }

  if (isDisabled(this)) {
    return;
  }

  EventHandler.one(target, EVENT_HIDDEN$2, function () {
    // focus on trigger when it is closed
    if (isVisible(_this33)) {
      _this33.focus();
    }
  }); // avoid conflict when clicking a toggler of an offcanvas, while another is open

  var allReadyOpen = SelectorEngine.findOne(OPEN_SELECTOR);

  if (allReadyOpen && allReadyOpen !== target) {
    Offcanvas.getInstance(allReadyOpen).hide();
  }

  var data = Offcanvas.getOrCreateInstance(target);
  data.toggle(this);
});
EventHandler.on(window, EVENT_LOAD_DATA_API$1, function () {
  return SelectorEngine.find(OPEN_SELECTOR).forEach(function (el) {
    return Offcanvas.getOrCreateInstance(el).show();
  });
});
enableDismissTrigger(Offcanvas);
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

defineJQueryPlugin(Offcanvas);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

var uriAttributes = new Set(['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href']);
var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
/**
 * A pattern that recognizes a commonly useful subset of URLs that are safe.
 *
 * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
 */

var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file|sms):|[^#&/:?]*(?:[#/?]|$))/i;
/**
 * A pattern that matches safe data URLs. Only matches image, video and audio types.
 *
 * Shoutout to Angular https://github.com/angular/angular/blob/12.2.x/packages/core/src/sanitization/url_sanitizer.ts
 */

var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i;

var allowedAttribute = function allowedAttribute(attribute, allowedAttributeList) {
  var attributeName = attribute.nodeName.toLowerCase();

  if (allowedAttributeList.includes(attributeName)) {
    if (uriAttributes.has(attributeName)) {
      return Boolean(SAFE_URL_PATTERN.test(attribute.nodeValue) || DATA_URL_PATTERN.test(attribute.nodeValue));
    }

    return true;
  }

  var regExp = allowedAttributeList.filter(function (attributeRegex) {
    return attributeRegex instanceof RegExp;
  }); // Check if a regular expression validates the attribute.

  for (var i = 0, len = regExp.length; i < len; i++) {
    if (regExp[i].test(attributeName)) {
      return true;
    }
  }

  return false;
};

var DefaultAllowlist = {
  // Global attributes allowed on any supplied element below.
  '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
  a: ['target', 'href', 'title', 'rel'],
  area: [],
  b: [],
  br: [],
  col: [],
  code: [],
  div: [],
  em: [],
  hr: [],
  h1: [],
  h2: [],
  h3: [],
  h4: [],
  h5: [],
  h6: [],
  i: [],
  img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
  li: [],
  ol: [],
  p: [],
  pre: [],
  s: [],
  small: [],
  span: [],
  sub: [],
  sup: [],
  strong: [],
  u: [],
  ul: []
};

function sanitizeHtml(unsafeHtml, allowList, sanitizeFn) {
  var _ref7;

  if (!unsafeHtml.length) {
    return unsafeHtml;
  }

  if (sanitizeFn && typeof sanitizeFn === 'function') {
    return sanitizeFn(unsafeHtml);
  }

  var domParser = new window.DOMParser();
  var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');

  var elements = (_ref7 = []).concat.apply(_ref7, (0,toConsumableArray/* default */.Z)(createdDocument.body.querySelectorAll('*')));

  var _loop = function _loop(i, len) {
    var _ref8;

    var element = elements[i];
    var elementName = element.nodeName.toLowerCase();

    if (!Object.keys(allowList).includes(elementName)) {
      element.remove();
      return "continue";
    }

    var attributeList = (_ref8 = []).concat.apply(_ref8, (0,toConsumableArray/* default */.Z)(element.attributes));

    var allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
    attributeList.forEach(function (attribute) {
      if (!allowedAttribute(attribute, allowedAttributes)) {
        element.removeAttribute(attribute.nodeName);
      }
    });
  };

  for (var i = 0, len = elements.length; i < len; i++) {
    var _ret = _loop(i, len);

    if (_ret === "continue") continue;
  }

  return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */


var NAME$4 = 'tooltip';
var DATA_KEY$4 = 'bs.tooltip';
var EVENT_KEY$4 = ".".concat(DATA_KEY$4);
var CLASS_PREFIX$1 = 'bs-tooltip';
var DISALLOWED_ATTRIBUTES = new Set(['sanitize', 'allowList', 'sanitizeFn']);
var DefaultType$3 = {
  animation: 'boolean',
  template: 'string',
  title: '(string|element|function)',
  trigger: 'string',
  delay: '(number|object)',
  html: 'boolean',
  selector: '(string|boolean)',
  placement: '(string|function)',
  offset: '(array|string|function)',
  container: '(string|element|boolean)',
  fallbackPlacements: 'array',
  boundary: '(string|element)',
  customClass: '(string|function)',
  sanitize: 'boolean',
  sanitizeFn: '(null|function)',
  allowList: 'object',
  popperConfig: '(null|object|function)'
};
var AttachmentMap = {
  AUTO: 'auto',
  TOP: 'top',
  RIGHT: isRTL() ? 'left' : 'right',
  BOTTOM: 'bottom',
  LEFT: isRTL() ? 'right' : 'left'
};
var Default$3 = {
  animation: true,
  template: '<div class="tooltip" role="tooltip">' + '<div class="tooltip-arrow"></div>' + '<div class="tooltip-inner"></div>' + '</div>',
  trigger: 'hover focus',
  title: '',
  delay: 0,
  html: false,
  selector: false,
  placement: 'top',
  offset: [0, 0],
  container: false,
  fallbackPlacements: ['top', 'right', 'bottom', 'left'],
  boundary: 'clippingParents',
  customClass: '',
  sanitize: true,
  sanitizeFn: null,
  allowList: DefaultAllowlist,
  popperConfig: null
};
var Event$2 = {
  HIDE: "hide".concat(EVENT_KEY$4),
  HIDDEN: "hidden".concat(EVENT_KEY$4),
  SHOW: "show".concat(EVENT_KEY$4),
  SHOWN: "shown".concat(EVENT_KEY$4),
  INSERTED: "inserted".concat(EVENT_KEY$4),
  CLICK: "click".concat(EVENT_KEY$4),
  FOCUSIN: "focusin".concat(EVENT_KEY$4),
  FOCUSOUT: "focusout".concat(EVENT_KEY$4),
  MOUSEENTER: "mouseenter".concat(EVENT_KEY$4),
  MOUSELEAVE: "mouseleave".concat(EVENT_KEY$4)
};
var CLASS_NAME_FADE$2 = 'fade';
var CLASS_NAME_MODAL = 'modal';
var CLASS_NAME_SHOW$2 = 'show';
var HOVER_STATE_SHOW = 'show';
var HOVER_STATE_OUT = 'out';
var SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
var SELECTOR_MODAL = ".".concat(CLASS_NAME_MODAL);
var EVENT_MODAL_HIDE = 'hide.bs.modal';
var TRIGGER_HOVER = 'hover';
var TRIGGER_FOCUS = 'focus';
var TRIGGER_CLICK = 'click';
var TRIGGER_MANUAL = 'manual';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

var Tooltip = /*#__PURE__*/function (_BaseComponent8) {
  (0,inherits/* default */.Z)(Tooltip, _BaseComponent8);

  var _super8 = (0,createSuper/* default */.Z)(Tooltip);

  function Tooltip(element, config) {
    var _this34;

    (0,classCallCheck/* default */.Z)(this, Tooltip);

    if (typeof lib_namespaceObject === 'undefined') {
      throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
    }

    _this34 = _super8.call(this, element); // private

    _this34._isEnabled = true;
    _this34._timeout = 0;
    _this34._hoverState = '';
    _this34._activeTrigger = {};
    _this34._popper = null; // Protected

    _this34._config = _this34._getConfig(config);
    _this34.tip = null;

    _this34._setListeners();

    return _this34;
  } // Getters


  (0,createClass/* default */.Z)(Tooltip, [{
    key: "enable",
    value: // Public
    function enable() {
      this._isEnabled = true;
    }
  }, {
    key: "disable",
    value: function disable() {
      this._isEnabled = false;
    }
  }, {
    key: "toggleEnabled",
    value: function toggleEnabled() {
      this._isEnabled = !this._isEnabled;
    }
  }, {
    key: "toggle",
    value: function toggle(event) {
      if (!this._isEnabled) {
        return;
      }

      if (event) {
        var context = this._initializeOnDelegatedTarget(event);

        context._activeTrigger.click = !context._activeTrigger.click;

        if (context._isWithActiveTrigger()) {
          context._enter(null, context);
        } else {
          context._leave(null, context);
        }
      } else {
        if (this.getTipElement().classList.contains(CLASS_NAME_SHOW$2)) {
          this._leave(null, this);

          return;
        }

        this._enter(null, this);
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      clearTimeout(this._timeout);
      EventHandler.off(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);

      if (this.tip) {
        this.tip.remove();
      }

      this._disposePopper();

      _get((0,getPrototypeOf/* default */.Z)(Tooltip.prototype), "dispose", this).call(this);
    }
  }, {
    key: "show",
    value: function show() {
      var _this35 = this;

      if (this._element.style.display === 'none') {
        throw new Error('Please use show on visible elements');
      }

      if (!(this.isWithContent() && this._isEnabled)) {
        return;
      }

      var showEvent = EventHandler.trigger(this._element, this.constructor.Event.SHOW);
      var shadowRoot = findShadowRoot(this._element);
      var isInTheDom = shadowRoot === null ? this._element.ownerDocument.documentElement.contains(this._element) : shadowRoot.contains(this._element);

      if (showEvent.defaultPrevented || !isInTheDom) {
        return;
      } // A trick to recreate a tooltip in case a new title is given by using the NOT documented `data-bs-original-title`
      // This will be removed later in favor of a `setContent` method


      if (this.constructor.NAME === 'tooltip' && this.tip && this.getTitle() !== this.tip.querySelector(SELECTOR_TOOLTIP_INNER).innerHTML) {
        this._disposePopper();

        this.tip.remove();
        this.tip = null;
      }

      var tip = this.getTipElement();
      var tipId = getUID(this.constructor.NAME);
      tip.setAttribute('id', tipId);

      this._element.setAttribute('aria-describedby', tipId);

      if (this._config.animation) {
        tip.classList.add(CLASS_NAME_FADE$2);
      }

      var placement = typeof this._config.placement === 'function' ? this._config.placement.call(this, tip, this._element) : this._config.placement;

      var attachment = this._getAttachment(placement);

      this._addAttachmentClass(attachment);

      var container = this._config.container;
      Data.set(tip, this.constructor.DATA_KEY, this);

      if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
        container.append(tip);
        EventHandler.trigger(this._element, this.constructor.Event.INSERTED);
      }

      if (this._popper) {
        this._popper.update();
      } else {
        this._popper = popper_createPopper(this._element, tip, this._getPopperConfig(attachment));
      }

      tip.classList.add(CLASS_NAME_SHOW$2);

      var customClass = this._resolvePossibleFunction(this._config.customClass);

      if (customClass) {
        var _tip$classList;

        (_tip$classList = tip.classList).add.apply(_tip$classList, (0,toConsumableArray/* default */.Z)(customClass.split(' ')));
      } // If this is a touch-enabled device we add extra
      // empty mouseover listeners to the body's immediate children;
      // only needed because of broken event delegation on iOS
      // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html


      if ('ontouchstart' in document.documentElement) {
        var _ref9;

        (_ref9 = []).concat.apply(_ref9, (0,toConsumableArray/* default */.Z)(document.body.children)).forEach(function (element) {
          EventHandler.on(element, 'mouseover', noop);
        });
      }

      var complete = function complete() {
        var prevHoverState = _this35._hoverState;
        _this35._hoverState = null;
        EventHandler.trigger(_this35._element, _this35.constructor.Event.SHOWN);

        if (prevHoverState === HOVER_STATE_OUT) {
          _this35._leave(null, _this35);
        }
      };

      var isAnimated = this.tip.classList.contains(CLASS_NAME_FADE$2);

      this._queueCallback(complete, this.tip, isAnimated);
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this36 = this;

      if (!this._popper) {
        return;
      }

      var tip = this.getTipElement();

      var complete = function complete() {
        if (_this36._isWithActiveTrigger()) {
          return;
        }

        if (_this36._hoverState !== HOVER_STATE_SHOW) {
          tip.remove();
        }

        _this36._cleanTipClass();

        _this36._element.removeAttribute('aria-describedby');

        EventHandler.trigger(_this36._element, _this36.constructor.Event.HIDDEN);

        _this36._disposePopper();
      };

      var hideEvent = EventHandler.trigger(this._element, this.constructor.Event.HIDE);

      if (hideEvent.defaultPrevented) {
        return;
      }

      tip.classList.remove(CLASS_NAME_SHOW$2); // If this is a touch-enabled device we remove the extra
      // empty mouseover listeners we added for iOS support

      if ('ontouchstart' in document.documentElement) {
        var _ref10;

        (_ref10 = []).concat.apply(_ref10, (0,toConsumableArray/* default */.Z)(document.body.children)).forEach(function (element) {
          return EventHandler.off(element, 'mouseover', noop);
        });
      }

      this._activeTrigger[TRIGGER_CLICK] = false;
      this._activeTrigger[TRIGGER_FOCUS] = false;
      this._activeTrigger[TRIGGER_HOVER] = false;
      var isAnimated = this.tip.classList.contains(CLASS_NAME_FADE$2);

      this._queueCallback(complete, this.tip, isAnimated);

      this._hoverState = '';
    }
  }, {
    key: "update",
    value: function update() {
      if (this._popper !== null) {
        this._popper.update();
      }
    } // Protected

  }, {
    key: "isWithContent",
    value: function isWithContent() {
      return Boolean(this.getTitle());
    }
  }, {
    key: "getTipElement",
    value: function getTipElement() {
      if (this.tip) {
        return this.tip;
      }

      var element = document.createElement('div');
      element.innerHTML = this._config.template;
      var tip = element.children[0];
      this.setContent(tip);
      tip.classList.remove(CLASS_NAME_FADE$2, CLASS_NAME_SHOW$2);
      this.tip = tip;
      return this.tip;
    }
  }, {
    key: "setContent",
    value: function setContent(tip) {
      this._sanitizeAndSetContent(tip, this.getTitle(), SELECTOR_TOOLTIP_INNER);
    }
  }, {
    key: "_sanitizeAndSetContent",
    value: function _sanitizeAndSetContent(template, content, selector) {
      var templateElement = SelectorEngine.findOne(selector, template);

      if (!content && templateElement) {
        templateElement.remove();
        return;
      } // we use append for html objects to maintain js events


      this.setElementContent(templateElement, content);
    }
  }, {
    key: "setElementContent",
    value: function setElementContent(element, content) {
      if (element === null) {
        return;
      }

      if (bootstrap_esm_isElement(content)) {
        content = getElement(content); // content is a DOM node or a jQuery

        if (this._config.html) {
          if (content.parentNode !== element) {
            element.innerHTML = '';
            element.append(content);
          }
        } else {
          element.textContent = content.textContent;
        }

        return;
      }

      if (this._config.html) {
        if (this._config.sanitize) {
          content = sanitizeHtml(content, this._config.allowList, this._config.sanitizeFn);
        }

        element.innerHTML = content;
      } else {
        element.textContent = content;
      }
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      var title = this._element.getAttribute('data-bs-original-title') || this._config.title;

      return this._resolvePossibleFunction(title);
    }
  }, {
    key: "updateAttachment",
    value: function updateAttachment(attachment) {
      if (attachment === 'right') {
        return 'end';
      }

      if (attachment === 'left') {
        return 'start';
      }

      return attachment;
    } // Private

  }, {
    key: "_initializeOnDelegatedTarget",
    value: function _initializeOnDelegatedTarget(event, context) {
      return context || this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
    }
  }, {
    key: "_getOffset",
    value: function _getOffset() {
      var _this37 = this;

      var offset = this._config.offset;

      if (typeof offset === 'string') {
        return offset.split(',').map(function (val) {
          return Number.parseInt(val, 10);
        });
      }

      if (typeof offset === 'function') {
        return function (popperData) {
          return offset(popperData, _this37._element);
        };
      }

      return offset;
    }
  }, {
    key: "_resolvePossibleFunction",
    value: function _resolvePossibleFunction(content) {
      return typeof content === 'function' ? content.call(this._element) : content;
    }
  }, {
    key: "_getPopperConfig",
    value: function _getPopperConfig(attachment) {
      var _this38 = this;

      var defaultBsPopperConfig = {
        placement: attachment,
        modifiers: [{
          name: 'flip',
          options: {
            fallbackPlacements: this._config.fallbackPlacements
          }
        }, {
          name: 'offset',
          options: {
            offset: this._getOffset()
          }
        }, {
          name: 'preventOverflow',
          options: {
            boundary: this._config.boundary
          }
        }, {
          name: 'arrow',
          options: {
            element: ".".concat(this.constructor.NAME, "-arrow")
          }
        }, {
          name: 'onChange',
          enabled: true,
          phase: 'afterWrite',
          fn: function fn(data) {
            return _this38._handlePopperPlacementChange(data);
          }
        }],
        onFirstUpdate: function onFirstUpdate(data) {
          if (data.options.placement !== data.placement) {
            _this38._handlePopperPlacementChange(data);
          }
        }
      };
      return (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, defaultBsPopperConfig), typeof this._config.popperConfig === 'function' ? this._config.popperConfig(defaultBsPopperConfig) : this._config.popperConfig);
    }
  }, {
    key: "_addAttachmentClass",
    value: function _addAttachmentClass(attachment) {
      this.getTipElement().classList.add("".concat(this._getBasicClassPrefix(), "-").concat(this.updateAttachment(attachment)));
    }
  }, {
    key: "_getAttachment",
    value: function _getAttachment(placement) {
      return AttachmentMap[placement.toUpperCase()];
    }
  }, {
    key: "_setListeners",
    value: function _setListeners() {
      var _this39 = this;

      var triggers = this._config.trigger.split(' ');

      triggers.forEach(function (trigger) {
        if (trigger === 'click') {
          EventHandler.on(_this39._element, _this39.constructor.Event.CLICK, _this39._config.selector, function (event) {
            return _this39.toggle(event);
          });
        } else if (trigger !== TRIGGER_MANUAL) {
          var eventIn = trigger === TRIGGER_HOVER ? _this39.constructor.Event.MOUSEENTER : _this39.constructor.Event.FOCUSIN;
          var eventOut = trigger === TRIGGER_HOVER ? _this39.constructor.Event.MOUSELEAVE : _this39.constructor.Event.FOCUSOUT;
          EventHandler.on(_this39._element, eventIn, _this39._config.selector, function (event) {
            return _this39._enter(event);
          });
          EventHandler.on(_this39._element, eventOut, _this39._config.selector, function (event) {
            return _this39._leave(event);
          });
        }
      });

      this._hideModalHandler = function () {
        if (_this39._element) {
          _this39.hide();
        }
      };

      EventHandler.on(this._element.closest(SELECTOR_MODAL), EVENT_MODAL_HIDE, this._hideModalHandler);

      if (this._config.selector) {
        this._config = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, this._config), {}, {
          trigger: 'manual',
          selector: ''
        });
      } else {
        this._fixTitle();
      }
    }
  }, {
    key: "_fixTitle",
    value: function _fixTitle() {
      var title = this._element.getAttribute('title');

      var originalTitleType = typeof this._element.getAttribute('data-bs-original-title');

      if (title || originalTitleType !== 'string') {
        this._element.setAttribute('data-bs-original-title', title || '');

        if (title && !this._element.getAttribute('aria-label') && !this._element.textContent) {
          this._element.setAttribute('aria-label', title);
        }

        this._element.setAttribute('title', '');
      }
    }
  }, {
    key: "_enter",
    value: function _enter(event, context) {
      context = this._initializeOnDelegatedTarget(event, context);

      if (event) {
        context._activeTrigger[event.type === 'focusin' ? TRIGGER_FOCUS : TRIGGER_HOVER] = true;
      }

      if (context.getTipElement().classList.contains(CLASS_NAME_SHOW$2) || context._hoverState === HOVER_STATE_SHOW) {
        context._hoverState = HOVER_STATE_SHOW;
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HOVER_STATE_SHOW;

      if (!context._config.delay || !context._config.delay.show) {
        context.show();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HOVER_STATE_SHOW) {
          context.show();
        }
      }, context._config.delay.show);
    }
  }, {
    key: "_leave",
    value: function _leave(event, context) {
      context = this._initializeOnDelegatedTarget(event, context);

      if (event) {
        context._activeTrigger[event.type === 'focusout' ? TRIGGER_FOCUS : TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
      }

      if (context._isWithActiveTrigger()) {
        return;
      }

      clearTimeout(context._timeout);
      context._hoverState = HOVER_STATE_OUT;

      if (!context._config.delay || !context._config.delay.hide) {
        context.hide();
        return;
      }

      context._timeout = setTimeout(function () {
        if (context._hoverState === HOVER_STATE_OUT) {
          context.hide();
        }
      }, context._config.delay.hide);
    }
  }, {
    key: "_isWithActiveTrigger",
    value: function _isWithActiveTrigger() {
      for (var trigger in this._activeTrigger) {
        if (this._activeTrigger[trigger]) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "_getConfig",
    value: function _getConfig(config) {
      var dataAttributes = Manipulator.getDataAttributes(this._element);
      Object.keys(dataAttributes).forEach(function (dataAttr) {
        if (DISALLOWED_ATTRIBUTES.has(dataAttr)) {
          delete dataAttributes[dataAttr];
        }
      });
      config = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, this.constructor.Default), dataAttributes), typeof config === 'object' && config ? config : {});
      config.container = config.container === false ? document.body : getElement(config.container);

      if (typeof config.delay === 'number') {
        config.delay = {
          show: config.delay,
          hide: config.delay
        };
      }

      if (typeof config.title === 'number') {
        config.title = config.title.toString();
      }

      if (typeof config.content === 'number') {
        config.content = config.content.toString();
      }

      typeCheckConfig(NAME$4, config, this.constructor.DefaultType);

      if (config.sanitize) {
        config.template = sanitizeHtml(config.template, config.allowList, config.sanitizeFn);
      }

      return config;
    }
  }, {
    key: "_getDelegateConfig",
    value: function _getDelegateConfig() {
      var config = {};

      for (var key in this._config) {
        if (this.constructor.Default[key] !== this._config[key]) {
          config[key] = this._config[key];
        }
      } // In the future can be replaced with:
      // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
      // `Object.fromEntries(keysWithDifferentValues)`


      return config;
    }
  }, {
    key: "_cleanTipClass",
    value: function _cleanTipClass() {
      var tip = this.getTipElement();
      var basicClassPrefixRegex = new RegExp("(^|\\s)".concat(this._getBasicClassPrefix(), "\\S+"), 'g');
      var tabClass = tip.getAttribute('class').match(basicClassPrefixRegex);

      if (tabClass !== null && tabClass.length > 0) {
        tabClass.map(function (token) {
          return token.trim();
        }).forEach(function (tClass) {
          return tip.classList.remove(tClass);
        });
      }
    }
  }, {
    key: "_getBasicClassPrefix",
    value: function _getBasicClassPrefix() {
      return CLASS_PREFIX$1;
    }
  }, {
    key: "_handlePopperPlacementChange",
    value: function _handlePopperPlacementChange(popperData) {
      var state = popperData.state;

      if (!state) {
        return;
      }

      this.tip = state.elements.popper;

      this._cleanTipClass();

      this._addAttachmentClass(this._getAttachment(state.placement));
    }
  }, {
    key: "_disposePopper",
    value: function _disposePopper() {
      if (this._popper) {
        this._popper.destroy();

        this._popper = null;
      }
    } // Static

  }], [{
    key: "Default",
    get: function get() {
      return Default$3;
    }
  }, {
    key: "NAME",
    get: function get() {
      return NAME$4;
    }
  }, {
    key: "Event",
    get: function get() {
      return Event$2;
    }
  }, {
    key: "DefaultType",
    get: function get() {
      return DefaultType$3;
    }
  }, {
    key: "jQueryInterface",
    value: function jQueryInterface(config) {
      return this.each(function () {
        var data = Tooltip.getOrCreateInstance(this, config);

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"".concat(config, "\""));
          }

          data[config]();
        }
      });
    }
  }]);

  return Tooltip;
}(BaseComponent);
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Tooltip to jQuery only if jQuery is present
 */


defineJQueryPlugin(Tooltip);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

var NAME$3 = 'popover';
var DATA_KEY$3 = 'bs.popover';
var EVENT_KEY$3 = ".".concat(DATA_KEY$3);
var CLASS_PREFIX = 'bs-popover';

var Default$2 = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, Tooltip.Default), {}, {
  placement: 'right',
  offset: [0, 8],
  trigger: 'click',
  content: '',
  template: '<div class="popover" role="tooltip">' + '<div class="popover-arrow"></div>' + '<h3 class="popover-header"></h3>' + '<div class="popover-body"></div>' + '</div>'
});

var DefaultType$2 = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, Tooltip.DefaultType), {}, {
  content: '(string|element|function)'
});

var Event$1 = {
  HIDE: "hide".concat(EVENT_KEY$3),
  HIDDEN: "hidden".concat(EVENT_KEY$3),
  SHOW: "show".concat(EVENT_KEY$3),
  SHOWN: "shown".concat(EVENT_KEY$3),
  INSERTED: "inserted".concat(EVENT_KEY$3),
  CLICK: "click".concat(EVENT_KEY$3),
  FOCUSIN: "focusin".concat(EVENT_KEY$3),
  FOCUSOUT: "focusout".concat(EVENT_KEY$3),
  MOUSEENTER: "mouseenter".concat(EVENT_KEY$3),
  MOUSELEAVE: "mouseleave".concat(EVENT_KEY$3)
};
var SELECTOR_TITLE = '.popover-header';
var SELECTOR_CONTENT = '.popover-body';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

var Popover = /*#__PURE__*/function (_Tooltip) {
  (0,inherits/* default */.Z)(Popover, _Tooltip);

  var _super9 = (0,createSuper/* default */.Z)(Popover);

  function Popover() {
    (0,classCallCheck/* default */.Z)(this, Popover);

    return _super9.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(Popover, [{
    key: "isWithContent",
    value: // Overrides
    function isWithContent() {
      return this.getTitle() || this._getContent();
    }
  }, {
    key: "setContent",
    value: function setContent(tip) {
      this._sanitizeAndSetContent(tip, this.getTitle(), SELECTOR_TITLE);

      this._sanitizeAndSetContent(tip, this._getContent(), SELECTOR_CONTENT);
    } // Private

  }, {
    key: "_getContent",
    value: function _getContent() {
      return this._resolvePossibleFunction(this._config.content);
    }
  }, {
    key: "_getBasicClassPrefix",
    value: function _getBasicClassPrefix() {
      return CLASS_PREFIX;
    } // Static

  }], [{
    key: "Default",
    get: // Getters
    function get() {
      return Default$2;
    }
  }, {
    key: "NAME",
    get: function get() {
      return NAME$3;
    }
  }, {
    key: "Event",
    get: function get() {
      return Event$1;
    }
  }, {
    key: "DefaultType",
    get: function get() {
      return DefaultType$2;
    }
  }, {
    key: "jQueryInterface",
    value: function jQueryInterface(config) {
      return this.each(function () {
        var data = Popover.getOrCreateInstance(this, config);

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"".concat(config, "\""));
          }

          data[config]();
        }
      });
    }
  }]);

  return Popover;
}(Tooltip);
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Popover to jQuery only if jQuery is present
 */


defineJQueryPlugin(Popover);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

var NAME$2 = 'scrollspy';
var DATA_KEY$2 = 'bs.scrollspy';
var EVENT_KEY$2 = ".".concat(DATA_KEY$2);
var DATA_API_KEY$1 = '.data-api';
var Default$1 = {
  offset: 10,
  method: 'auto',
  target: ''
};
var DefaultType$1 = {
  offset: 'number',
  method: 'string',
  target: '(string|element)'
};
var EVENT_ACTIVATE = "activate".concat(EVENT_KEY$2);
var EVENT_SCROLL = "scroll".concat(EVENT_KEY$2);
var EVENT_LOAD_DATA_API = "load".concat(EVENT_KEY$2).concat(DATA_API_KEY$1);
var CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
var CLASS_NAME_ACTIVE$1 = 'active';
var SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
var SELECTOR_NAV_LIST_GROUP$1 = '.nav, .list-group';
var SELECTOR_NAV_LINKS = '.nav-link';
var SELECTOR_NAV_ITEMS = '.nav-item';
var SELECTOR_LIST_ITEMS = '.list-group-item';
var SELECTOR_LINK_ITEMS = "".concat(SELECTOR_NAV_LINKS, ", ").concat(SELECTOR_LIST_ITEMS, ", .").concat(CLASS_NAME_DROPDOWN_ITEM);
var SELECTOR_DROPDOWN$1 = '.dropdown';
var SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
var METHOD_OFFSET = 'offset';
var METHOD_POSITION = 'position';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

var ScrollSpy = /*#__PURE__*/function (_BaseComponent9) {
  (0,inherits/* default */.Z)(ScrollSpy, _BaseComponent9);

  var _super10 = (0,createSuper/* default */.Z)(ScrollSpy);

  function ScrollSpy(element, config) {
    var _this40;

    (0,classCallCheck/* default */.Z)(this, ScrollSpy);

    _this40 = _super10.call(this, element);
    _this40._scrollElement = _this40._element.tagName === 'BODY' ? window : _this40._element;
    _this40._config = _this40._getConfig(config);
    _this40._offsets = [];
    _this40._targets = [];
    _this40._activeTarget = null;
    _this40._scrollHeight = 0;
    EventHandler.on(_this40._scrollElement, EVENT_SCROLL, function () {
      return _this40._process();
    });

    _this40.refresh();

    _this40._process();

    return _this40;
  } // Getters


  (0,createClass/* default */.Z)(ScrollSpy, [{
    key: "refresh",
    value: // Public
    function refresh() {
      var _this41 = this;

      var autoMethod = this._scrollElement === this._scrollElement.window ? METHOD_OFFSET : METHOD_POSITION;
      var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;
      var offsetBase = offsetMethod === METHOD_POSITION ? this._getScrollTop() : 0;
      this._offsets = [];
      this._targets = [];
      this._scrollHeight = this._getScrollHeight();
      var targets = SelectorEngine.find(SELECTOR_LINK_ITEMS, this._config.target);
      targets.map(function (element) {
        var targetSelector = getSelectorFromElement(element);
        var target = targetSelector ? SelectorEngine.findOne(targetSelector) : null;

        if (target) {
          var targetBCR = target.getBoundingClientRect();

          if (targetBCR.width || targetBCR.height) {
            return [Manipulator[offsetMethod](target).top + offsetBase, targetSelector];
          }
        }

        return null;
      }).filter(function (item) {
        return item;
      }).sort(function (a, b) {
        return a[0] - b[0];
      }).forEach(function (item) {
        _this41._offsets.push(item[0]);

        _this41._targets.push(item[1]);
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {
      EventHandler.off(this._scrollElement, EVENT_KEY$2);

      _get((0,getPrototypeOf/* default */.Z)(ScrollSpy.prototype), "dispose", this).call(this);
    } // Private

  }, {
    key: "_getConfig",
    value: function _getConfig(config) {
      config = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, Default$1), Manipulator.getDataAttributes(this._element)), typeof config === 'object' && config ? config : {});
      config.target = getElement(config.target) || document.documentElement;
      typeCheckConfig(NAME$2, config, DefaultType$1);
      return config;
    }
  }, {
    key: "_getScrollTop",
    value: function _getScrollTop() {
      return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
    }
  }, {
    key: "_getScrollHeight",
    value: function _getScrollHeight() {
      return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    }
  }, {
    key: "_getOffsetHeight",
    value: function _getOffsetHeight() {
      return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
    }
  }, {
    key: "_process",
    value: function _process() {
      var scrollTop = this._getScrollTop() + this._config.offset;

      var scrollHeight = this._getScrollHeight();

      var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

      if (this._scrollHeight !== scrollHeight) {
        this.refresh();
      }

      if (scrollTop >= maxScroll) {
        var target = this._targets[this._targets.length - 1];

        if (this._activeTarget !== target) {
          this._activate(target);
        }

        return;
      }

      if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
        this._activeTarget = null;

        this._clear();

        return;
      }

      for (var i = this._offsets.length; i--;) {
        var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);

        if (isActiveTarget) {
          this._activate(this._targets[i]);
        }
      }
    }
  }, {
    key: "_activate",
    value: function _activate(target) {
      this._activeTarget = target;

      this._clear();

      var queries = SELECTOR_LINK_ITEMS.split(',').map(function (selector) {
        return "".concat(selector, "[data-bs-target=\"").concat(target, "\"],").concat(selector, "[href=\"").concat(target, "\"]");
      });
      var link = SelectorEngine.findOne(queries.join(','), this._config.target);
      link.classList.add(CLASS_NAME_ACTIVE$1);

      if (link.classList.contains(CLASS_NAME_DROPDOWN_ITEM)) {
        SelectorEngine.findOne(SELECTOR_DROPDOWN_TOGGLE$1, link.closest(SELECTOR_DROPDOWN$1)).classList.add(CLASS_NAME_ACTIVE$1);
      } else {
        SelectorEngine.parents(link, SELECTOR_NAV_LIST_GROUP$1).forEach(function (listGroup) {
          // Set triggered links parents as active
          // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
          SelectorEngine.prev(listGroup, "".concat(SELECTOR_NAV_LINKS, ", ").concat(SELECTOR_LIST_ITEMS)).forEach(function (item) {
            return item.classList.add(CLASS_NAME_ACTIVE$1);
          }); // Handle special case when .nav-link is inside .nav-item

          SelectorEngine.prev(listGroup, SELECTOR_NAV_ITEMS).forEach(function (navItem) {
            SelectorEngine.children(navItem, SELECTOR_NAV_LINKS).forEach(function (item) {
              return item.classList.add(CLASS_NAME_ACTIVE$1);
            });
          });
        });
      }

      EventHandler.trigger(this._scrollElement, EVENT_ACTIVATE, {
        relatedTarget: target
      });
    }
  }, {
    key: "_clear",
    value: function _clear() {
      SelectorEngine.find(SELECTOR_LINK_ITEMS, this._config.target).filter(function (node) {
        return node.classList.contains(CLASS_NAME_ACTIVE$1);
      }).forEach(function (node) {
        return node.classList.remove(CLASS_NAME_ACTIVE$1);
      });
    } // Static

  }], [{
    key: "Default",
    get: function get() {
      return Default$1;
    }
  }, {
    key: "NAME",
    get: function get() {
      return NAME$2;
    }
  }, {
    key: "jQueryInterface",
    value: function jQueryInterface(config) {
      return this.each(function () {
        var data = ScrollSpy.getOrCreateInstance(this, config);

        if (typeof config !== 'string') {
          return;
        }

        if (typeof data[config] === 'undefined') {
          throw new TypeError("No method named \"".concat(config, "\""));
        }

        data[config]();
      });
    }
  }]);

  return ScrollSpy;
}(BaseComponent);
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(window, EVENT_LOAD_DATA_API, function () {
  SelectorEngine.find(SELECTOR_DATA_SPY).forEach(function (spy) {
    return new ScrollSpy(spy);
  });
});
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .ScrollSpy to jQuery only if jQuery is present
 */

defineJQueryPlugin(ScrollSpy);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

var NAME$1 = 'tab';
var DATA_KEY$1 = 'bs.tab';
var EVENT_KEY$1 = ".".concat(DATA_KEY$1);
var DATA_API_KEY = '.data-api';
var EVENT_HIDE$1 = "hide".concat(EVENT_KEY$1);
var EVENT_HIDDEN$1 = "hidden".concat(EVENT_KEY$1);
var EVENT_SHOW$1 = "show".concat(EVENT_KEY$1);
var EVENT_SHOWN$1 = "shown".concat(EVENT_KEY$1);
var EVENT_CLICK_DATA_API = "click".concat(EVENT_KEY$1).concat(DATA_API_KEY);
var CLASS_NAME_DROPDOWN_MENU = 'dropdown-menu';
var CLASS_NAME_ACTIVE = 'active';
var CLASS_NAME_FADE$1 = 'fade';
var CLASS_NAME_SHOW$1 = 'show';
var SELECTOR_DROPDOWN = '.dropdown';
var SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
var SELECTOR_ACTIVE = '.active';
var SELECTOR_ACTIVE_UL = ':scope > li > .active';
var SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]';
var SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
var SELECTOR_DROPDOWN_ACTIVE_CHILD = ':scope > .dropdown-menu .active';
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

var Tab = /*#__PURE__*/function (_BaseComponent10) {
  (0,inherits/* default */.Z)(Tab, _BaseComponent10);

  var _super11 = (0,createSuper/* default */.Z)(Tab);

  function Tab() {
    (0,classCallCheck/* default */.Z)(this, Tab);

    return _super11.apply(this, arguments);
  }

  (0,createClass/* default */.Z)(Tab, [{
    key: "show",
    value: // Public
    function show() {
      var _this42 = this;

      if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && this._element.classList.contains(CLASS_NAME_ACTIVE)) {
        return;
      }

      var previous;
      var target = getElementFromSelector(this._element);

      var listElement = this._element.closest(SELECTOR_NAV_LIST_GROUP);

      if (listElement) {
        var itemSelector = listElement.nodeName === 'UL' || listElement.nodeName === 'OL' ? SELECTOR_ACTIVE_UL : SELECTOR_ACTIVE;
        previous = SelectorEngine.find(itemSelector, listElement);
        previous = previous[previous.length - 1];
      }

      var hideEvent = previous ? EventHandler.trigger(previous, EVENT_HIDE$1, {
        relatedTarget: this._element
      }) : null;
      var showEvent = EventHandler.trigger(this._element, EVENT_SHOW$1, {
        relatedTarget: previous
      });

      if (showEvent.defaultPrevented || hideEvent !== null && hideEvent.defaultPrevented) {
        return;
      }

      this._activate(this._element, listElement);

      var complete = function complete() {
        EventHandler.trigger(previous, EVENT_HIDDEN$1, {
          relatedTarget: _this42._element
        });
        EventHandler.trigger(_this42._element, EVENT_SHOWN$1, {
          relatedTarget: previous
        });
      };

      if (target) {
        this._activate(target, target.parentNode, complete);
      } else {
        complete();
      }
    } // Private

  }, {
    key: "_activate",
    value: function _activate(element, container, callback) {
      var _this43 = this;

      var activeElements = container && (container.nodeName === 'UL' || container.nodeName === 'OL') ? SelectorEngine.find(SELECTOR_ACTIVE_UL, container) : SelectorEngine.children(container, SELECTOR_ACTIVE);
      var active = activeElements[0];
      var isTransitioning = callback && active && active.classList.contains(CLASS_NAME_FADE$1);

      var complete = function complete() {
        return _this43._transitionComplete(element, active, callback);
      };

      if (active && isTransitioning) {
        active.classList.remove(CLASS_NAME_SHOW$1);

        this._queueCallback(complete, element, true);
      } else {
        complete();
      }
    }
  }, {
    key: "_transitionComplete",
    value: function _transitionComplete(element, active, callback) {
      if (active) {
        active.classList.remove(CLASS_NAME_ACTIVE);
        var dropdownChild = SelectorEngine.findOne(SELECTOR_DROPDOWN_ACTIVE_CHILD, active.parentNode);

        if (dropdownChild) {
          dropdownChild.classList.remove(CLASS_NAME_ACTIVE);
        }

        if (active.getAttribute('role') === 'tab') {
          active.setAttribute('aria-selected', false);
        }
      }

      element.classList.add(CLASS_NAME_ACTIVE);

      if (element.getAttribute('role') === 'tab') {
        element.setAttribute('aria-selected', true);
      }

      reflow(element);

      if (element.classList.contains(CLASS_NAME_FADE$1)) {
        element.classList.add(CLASS_NAME_SHOW$1);
      }

      var parent = element.parentNode;

      if (parent && parent.nodeName === 'LI') {
        parent = parent.parentNode;
      }

      if (parent && parent.classList.contains(CLASS_NAME_DROPDOWN_MENU)) {
        var dropdownElement = element.closest(SELECTOR_DROPDOWN);

        if (dropdownElement) {
          SelectorEngine.find(SELECTOR_DROPDOWN_TOGGLE, dropdownElement).forEach(function (dropdown) {
            return dropdown.classList.add(CLASS_NAME_ACTIVE);
          });
        }

        element.setAttribute('aria-expanded', true);
      }

      if (callback) {
        callback();
      }
    } // Static

  }], [{
    key: "NAME",
    get: // Getters
    function get() {
      return NAME$1;
    }
  }, {
    key: "jQueryInterface",
    value: function jQueryInterface(config) {
      return this.each(function () {
        var data = Tab.getOrCreateInstance(this);

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"".concat(config, "\""));
          }

          data[config]();
        }
      });
    }
  }]);

  return Tab;
}(BaseComponent);
/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */


EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function (event) {
  if (['A', 'AREA'].includes(this.tagName)) {
    event.preventDefault();
  }

  if (isDisabled(this)) {
    return;
  }

  var data = Tab.getOrCreateInstance(this);
  data.show();
});
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Tab to jQuery only if jQuery is present
 */

defineJQueryPlugin(Tab);
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.1.3): toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

var NAME = 'toast';
var DATA_KEY = 'bs.toast';
var EVENT_KEY = ".".concat(DATA_KEY);
var EVENT_MOUSEOVER = "mouseover".concat(EVENT_KEY);
var EVENT_MOUSEOUT = "mouseout".concat(EVENT_KEY);
var EVENT_FOCUSIN = "focusin".concat(EVENT_KEY);
var EVENT_FOCUSOUT = "focusout".concat(EVENT_KEY);
var EVENT_HIDE = "hide".concat(EVENT_KEY);
var EVENT_HIDDEN = "hidden".concat(EVENT_KEY);
var EVENT_SHOW = "show".concat(EVENT_KEY);
var EVENT_SHOWN = "shown".concat(EVENT_KEY);
var CLASS_NAME_FADE = 'fade';
var CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility

var CLASS_NAME_SHOW = 'show';
var CLASS_NAME_SHOWING = 'showing';
var DefaultType = {
  animation: 'boolean',
  autohide: 'boolean',
  delay: 'number'
};
var Default = {
  animation: true,
  autohide: true,
  delay: 5000
};
/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

var Toast = /*#__PURE__*/function (_BaseComponent11) {
  (0,inherits/* default */.Z)(Toast, _BaseComponent11);

  var _super12 = (0,createSuper/* default */.Z)(Toast);

  function Toast(element, config) {
    var _this44;

    (0,classCallCheck/* default */.Z)(this, Toast);

    _this44 = _super12.call(this, element);
    _this44._config = _this44._getConfig(config);
    _this44._timeout = null;
    _this44._hasMouseInteraction = false;
    _this44._hasKeyboardInteraction = false;

    _this44._setListeners();

    return _this44;
  } // Getters


  (0,createClass/* default */.Z)(Toast, [{
    key: "show",
    value: // Public
    function show() {
      var _this45 = this;

      var showEvent = EventHandler.trigger(this._element, EVENT_SHOW);

      if (showEvent.defaultPrevented) {
        return;
      }

      this._clearTimeout();

      if (this._config.animation) {
        this._element.classList.add(CLASS_NAME_FADE);
      }

      var complete = function complete() {
        _this45._element.classList.remove(CLASS_NAME_SHOWING);

        EventHandler.trigger(_this45._element, EVENT_SHOWN);

        _this45._maybeScheduleHide();
      };

      this._element.classList.remove(CLASS_NAME_HIDE); // @deprecated


      reflow(this._element);

      this._element.classList.add(CLASS_NAME_SHOW);

      this._element.classList.add(CLASS_NAME_SHOWING);

      this._queueCallback(complete, this._element, this._config.animation);
    }
  }, {
    key: "hide",
    value: function hide() {
      var _this46 = this;

      if (!this._element.classList.contains(CLASS_NAME_SHOW)) {
        return;
      }

      var hideEvent = EventHandler.trigger(this._element, EVENT_HIDE);

      if (hideEvent.defaultPrevented) {
        return;
      }

      var complete = function complete() {
        _this46._element.classList.add(CLASS_NAME_HIDE); // @deprecated


        _this46._element.classList.remove(CLASS_NAME_SHOWING);

        _this46._element.classList.remove(CLASS_NAME_SHOW);

        EventHandler.trigger(_this46._element, EVENT_HIDDEN);
      };

      this._element.classList.add(CLASS_NAME_SHOWING);

      this._queueCallback(complete, this._element, this._config.animation);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._clearTimeout();

      if (this._element.classList.contains(CLASS_NAME_SHOW)) {
        this._element.classList.remove(CLASS_NAME_SHOW);
      }

      _get((0,getPrototypeOf/* default */.Z)(Toast.prototype), "dispose", this).call(this);
    } // Private

  }, {
    key: "_getConfig",
    value: function _getConfig(config) {
      config = (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, Default), Manipulator.getDataAttributes(this._element)), typeof config === 'object' && config ? config : {});
      typeCheckConfig(NAME, config, this.constructor.DefaultType);
      return config;
    }
  }, {
    key: "_maybeScheduleHide",
    value: function _maybeScheduleHide() {
      var _this47 = this;

      if (!this._config.autohide) {
        return;
      }

      if (this._hasMouseInteraction || this._hasKeyboardInteraction) {
        return;
      }

      this._timeout = setTimeout(function () {
        _this47.hide();
      }, this._config.delay);
    }
  }, {
    key: "_onInteraction",
    value: function _onInteraction(event, isInteracting) {
      switch (event.type) {
        case 'mouseover':
        case 'mouseout':
          this._hasMouseInteraction = isInteracting;
          break;

        case 'focusin':
        case 'focusout':
          this._hasKeyboardInteraction = isInteracting;
          break;
      }

      if (isInteracting) {
        this._clearTimeout();

        return;
      }

      var nextElement = event.relatedTarget;

      if (this._element === nextElement || this._element.contains(nextElement)) {
        return;
      }

      this._maybeScheduleHide();
    }
  }, {
    key: "_setListeners",
    value: function _setListeners() {
      var _this48 = this;

      EventHandler.on(this._element, EVENT_MOUSEOVER, function (event) {
        return _this48._onInteraction(event, true);
      });
      EventHandler.on(this._element, EVENT_MOUSEOUT, function (event) {
        return _this48._onInteraction(event, false);
      });
      EventHandler.on(this._element, EVENT_FOCUSIN, function (event) {
        return _this48._onInteraction(event, true);
      });
      EventHandler.on(this._element, EVENT_FOCUSOUT, function (event) {
        return _this48._onInteraction(event, false);
      });
    }
  }, {
    key: "_clearTimeout",
    value: function _clearTimeout() {
      clearTimeout(this._timeout);
      this._timeout = null;
    } // Static

  }], [{
    key: "DefaultType",
    get: function get() {
      return DefaultType;
    }
  }, {
    key: "Default",
    get: function get() {
      return Default;
    }
  }, {
    key: "NAME",
    get: function get() {
      return NAME;
    }
  }, {
    key: "jQueryInterface",
    value: function jQueryInterface(config) {
      return this.each(function () {
        var data = Toast.getOrCreateInstance(this, config);

        if (typeof config === 'string') {
          if (typeof data[config] === 'undefined') {
            throw new TypeError("No method named \"".concat(config, "\""));
          }

          data[config](this);
        }
      });
    }
  }]);

  return Toast;
}(BaseComponent);

enableDismissTrigger(Toast);
/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .Toast to jQuery only if jQuery is present
 */

defineJQueryPlugin(Toast);


/***/ }),

/***/ 725:
/***/ (function(module) {

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/***/ }),

/***/ 463:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/


var aa = __webpack_require__(791),
    m = __webpack_require__(725),
    r = __webpack_require__(296);

function y(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) {
    b += "&args[]=" + encodeURIComponent(arguments[c]);
  }

  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}

if (!aa) throw Error(y(227));
var ba = new Set(),
    ca = {};

function da(a, b) {
  ea(a, b);
  ea(a + "Capture", b);
}

function ea(a, b) {
  ca[a] = b;

  for (a = 0; a < b.length; a++) {
    ba.add(b[a]);
  }
}

var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement),
    ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    ia = Object.prototype.hasOwnProperty,
    ja = {},
    ka = {};

function la(a) {
  if (ia.call(ka, a)) return !0;
  if (ia.call(ja, a)) return !1;
  if (ha.test(a)) return ka[a] = !0;
  ja[a] = !0;
  return !1;
}

function ma(a, b, c, d) {
  if (null !== c && 0 === c.type) return !1;

  switch (typeof b) {
    case "function":
    case "symbol":
      return !0;

    case "boolean":
      if (d) return !1;
      if (null !== c) return !c.acceptsBooleans;
      a = a.toLowerCase().slice(0, 5);
      return "data-" !== a && "aria-" !== a;

    default:
      return !1;
  }
}

function na(a, b, c, d) {
  if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
  if (d) return !1;
  if (null !== c) switch (c.type) {
    case 3:
      return !b;

    case 4:
      return !1 === b;

    case 5:
      return isNaN(b);

    case 6:
      return isNaN(b) || 1 > b;
  }
  return !1;
}

function B(a, b, c, d, e, f, g) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
  this.attributeName = d;
  this.attributeNamespace = e;
  this.mustUseProperty = c;
  this.propertyName = a;
  this.type = b;
  this.sanitizeURL = f;
  this.removeEmptyString = g;
}

var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
  D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
  var b = a[0];
  D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
  D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (a) {
  D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
  D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
["checked", "multiple", "muted", "selected"].forEach(function (a) {
  D[a] = new B(a, 3, !0, a, null, !1, !1);
});
["capture", "download"].forEach(function (a) {
  D[a] = new B(a, 4, !1, a, null, !1, !1);
});
["cols", "rows", "size", "span"].forEach(function (a) {
  D[a] = new B(a, 6, !1, a, null, !1, !1);
});
["rowSpan", "start"].forEach(function (a) {
  D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;

function pa(a) {
  return a[1].toUpperCase();
}

"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
  var b = a.replace(oa, pa);
  D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
  var b = a.replace(oa, pa);
  D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
  var b = a.replace(oa, pa);
  D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
["tabIndex", "crossOrigin"].forEach(function (a) {
  D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
["src", "href", "action", "formAction"].forEach(function (a) {
  D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});

function qa(a, b, c, d) {
  var e = D.hasOwnProperty(b) ? D[b] : null;
  var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
  f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}

var ra = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    sa = 60103,
    ta = 60106,
    ua = 60107,
    wa = 60108,
    xa = 60114,
    ya = 60109,
    za = 60110,
    Aa = 60112,
    Ba = 60113,
    Ca = 60120,
    Da = 60115,
    Ea = 60116,
    Fa = 60121,
    Ga = 60128,
    Ha = 60129,
    Ia = 60130,
    Ja = 60131;

if ("function" === typeof Symbol && Symbol.for) {
  var E = Symbol.for;
  sa = E("react.element");
  ta = E("react.portal");
  ua = E("react.fragment");
  wa = E("react.strict_mode");
  xa = E("react.profiler");
  ya = E("react.provider");
  za = E("react.context");
  Aa = E("react.forward_ref");
  Ba = E("react.suspense");
  Ca = E("react.suspense_list");
  Da = E("react.memo");
  Ea = E("react.lazy");
  Fa = E("react.block");
  E("react.scope");
  Ga = E("react.opaque.id");
  Ha = E("react.debug_trace_mode");
  Ia = E("react.offscreen");
  Ja = E("react.legacy_hidden");
}

var Ka = "function" === typeof Symbol && Symbol.iterator;

function La(a) {
  if (null === a || "object" !== typeof a) return null;
  a = Ka && a[Ka] || a["@@iterator"];
  return "function" === typeof a ? a : null;
}

var Ma;

function Na(a) {
  if (void 0 === Ma) try {
    throw Error();
  } catch (c) {
    var b = c.stack.trim().match(/\n( *(at )?)/);
    Ma = b && b[1] || "";
  }
  return "\n" + Ma + a;
}

var Oa = !1;

function Pa(a, b) {
  if (!a || Oa) return "";
  Oa = !0;
  var c = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;

  try {
    if (b) {
      if (b = function b() {
        throw Error();
      }, Object.defineProperty(b.prototype, "props", {
        set: function set() {
          throw Error();
        }
      }), "object" === typeof Reflect && Reflect.construct) {
        try {
          Reflect.construct(b, []);
        } catch (k) {
          var d = k;
        }

        Reflect.construct(a, [], b);
      } else {
        try {
          b.call();
        } catch (k) {
          d = k;
        }

        a.call(b.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (k) {
        d = k;
      }

      a();
    }
  } catch (k) {
    if (k && d && "string" === typeof k.stack) {
      for (var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];) {
        h--;
      }

      for (; 1 <= g && 0 <= h; g--, h--) {
        if (e[g] !== f[h]) {
          if (1 !== g || 1 !== h) {
            do {
              if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
            } while (1 <= g && 0 <= h);
          }

          break;
        }
      }
    }
  } finally {
    Oa = !1, Error.prepareStackTrace = c;
  }

  return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}

function Qa(a) {
  switch (a.tag) {
    case 5:
      return Na(a.type);

    case 16:
      return Na("Lazy");

    case 13:
      return Na("Suspense");

    case 19:
      return Na("SuspenseList");

    case 0:
    case 2:
    case 15:
      return a = Pa(a.type, !1), a;

    case 11:
      return a = Pa(a.type.render, !1), a;

    case 22:
      return a = Pa(a.type._render, !1), a;

    case 1:
      return a = Pa(a.type, !0), a;

    default:
      return "";
  }
}

function Ra(a) {
  if (null == a) return null;
  if ("function" === typeof a) return a.displayName || a.name || null;
  if ("string" === typeof a) return a;

  switch (a) {
    case ua:
      return "Fragment";

    case ta:
      return "Portal";

    case xa:
      return "Profiler";

    case wa:
      return "StrictMode";

    case Ba:
      return "Suspense";

    case Ca:
      return "SuspenseList";
  }

  if ("object" === typeof a) switch (a.$$typeof) {
    case za:
      return (a.displayName || "Context") + ".Consumer";

    case ya:
      return (a._context.displayName || "Context") + ".Provider";

    case Aa:
      var b = a.render;
      b = b.displayName || b.name || "";
      return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");

    case Da:
      return Ra(a.type);

    case Fa:
      return Ra(a._render);

    case Ea:
      b = a._payload;
      a = a._init;

      try {
        return Ra(a(b));
      } catch (c) {}

  }
  return null;
}

function Sa(a) {
  switch (typeof a) {
    case "boolean":
    case "number":
    case "object":
    case "string":
    case "undefined":
      return a;

    default:
      return "";
  }
}

function Ta(a) {
  var b = a.type;
  return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}

function Ua(a) {
  var b = Ta(a) ? "checked" : "value",
      c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
      d = "" + a[b];

  if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
    var e = c.get,
        f = c.set;
    Object.defineProperty(a, b, {
      configurable: !0,
      get: function get() {
        return e.call(this);
      },
      set: function set(a) {
        d = "" + a;
        f.call(this, a);
      }
    });
    Object.defineProperty(a, b, {
      enumerable: c.enumerable
    });
    return {
      getValue: function getValue() {
        return d;
      },
      setValue: function setValue(a) {
        d = "" + a;
      },
      stopTracking: function stopTracking() {
        a._valueTracker = null;
        delete a[b];
      }
    };
  }
}

function Va(a) {
  a._valueTracker || (a._valueTracker = Ua(a));
}

function Wa(a) {
  if (!a) return !1;
  var b = a._valueTracker;
  if (!b) return !0;
  var c = b.getValue();
  var d = "";
  a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
  a = d;
  return a !== c ? (b.setValue(a), !0) : !1;
}

function Xa(a) {
  a = a || ("undefined" !== typeof document ? document : void 0);
  if ("undefined" === typeof a) return null;

  try {
    return a.activeElement || a.body;
  } catch (b) {
    return a.body;
  }
}

function Ya(a, b) {
  var c = b.checked;
  return m({}, b, {
    defaultChecked: void 0,
    defaultValue: void 0,
    value: void 0,
    checked: null != c ? c : a._wrapperState.initialChecked
  });
}

function Za(a, b) {
  var c = null == b.defaultValue ? "" : b.defaultValue,
      d = null != b.checked ? b.checked : b.defaultChecked;
  c = Sa(null != b.value ? b.value : c);
  a._wrapperState = {
    initialChecked: d,
    initialValue: c,
    controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
  };
}

function $a(a, b) {
  b = b.checked;
  null != b && qa(a, "checked", b, !1);
}

function ab(a, b) {
  $a(a, b);
  var c = Sa(b.value),
      d = b.type;
  if (null != c) {
    if ("number" === d) {
      if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
    } else a.value !== "" + c && (a.value = "" + c);
  } else if ("submit" === d || "reset" === d) {
    a.removeAttribute("value");
    return;
  }
  b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
  null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}

function cb(a, b, c) {
  if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
    var d = b.type;
    if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
    b = "" + a._wrapperState.initialValue;
    c || b === a.value || (a.value = b);
    a.defaultValue = b;
  }

  c = a.name;
  "" !== c && (a.name = "");
  a.defaultChecked = !!a._wrapperState.initialChecked;
  "" !== c && (a.name = c);
}

function bb(a, b, c) {
  if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}

function db(a) {
  var b = "";
  aa.Children.forEach(a, function (a) {
    null != a && (b += a);
  });
  return b;
}

function eb(a, b) {
  a = m({
    children: void 0
  }, b);
  if (b = db(b.children)) a.children = b;
  return a;
}

function fb(a, b, c, d) {
  a = a.options;

  if (b) {
    b = {};

    for (var e = 0; e < c.length; e++) {
      b["$" + c[e]] = !0;
    }

    for (c = 0; c < a.length; c++) {
      e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    }
  } else {
    c = "" + Sa(c);
    b = null;

    for (e = 0; e < a.length; e++) {
      if (a[e].value === c) {
        a[e].selected = !0;
        d && (a[e].defaultSelected = !0);
        return;
      }

      null !== b || a[e].disabled || (b = a[e]);
    }

    null !== b && (b.selected = !0);
  }
}

function gb(a, b) {
  if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
  return m({}, b, {
    value: void 0,
    defaultValue: void 0,
    children: "" + a._wrapperState.initialValue
  });
}

function hb(a, b) {
  var c = b.value;

  if (null == c) {
    c = b.children;
    b = b.defaultValue;

    if (null != c) {
      if (null != b) throw Error(y(92));

      if (Array.isArray(c)) {
        if (!(1 >= c.length)) throw Error(y(93));
        c = c[0];
      }

      b = c;
    }

    null == b && (b = "");
    c = b;
  }

  a._wrapperState = {
    initialValue: Sa(c)
  };
}

function ib(a, b) {
  var c = Sa(b.value),
      d = Sa(b.defaultValue);
  null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
  null != d && (a.defaultValue = "" + d);
}

function jb(a) {
  var b = a.textContent;
  b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}

var kb = {
  html: "http://www.w3.org/1999/xhtml",
  mathml: "http://www.w3.org/1998/Math/MathML",
  svg: "http://www.w3.org/2000/svg"
};

function lb(a) {
  switch (a) {
    case "svg":
      return "http://www.w3.org/2000/svg";

    case "math":
      return "http://www.w3.org/1998/Math/MathML";

    default:
      return "http://www.w3.org/1999/xhtml";
  }
}

function mb(a, b) {
  return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}

var nb,
    ob = function (a) {
  return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
    MSApp.execUnsafeLocalFunction(function () {
      return a(b, c, d, e);
    });
  } : a;
}(function (a, b) {
  if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;else {
    nb = nb || document.createElement("div");
    nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";

    for (b = nb.firstChild; a.firstChild;) {
      a.removeChild(a.firstChild);
    }

    for (; b.firstChild;) {
      a.appendChild(b.firstChild);
    }
  }
});

function pb(a, b) {
  if (b) {
    var c = a.firstChild;

    if (c && c === a.lastChild && 3 === c.nodeType) {
      c.nodeValue = b;
      return;
    }
  }

  a.textContent = b;
}

var qb = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridArea: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
},
    rb = ["Webkit", "ms", "Moz", "O"];
Object.keys(qb).forEach(function (a) {
  rb.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);
    qb[b] = qb[a];
  });
});

function sb(a, b, c) {
  return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}

function tb(a, b) {
  a = a.style;

  for (var c in b) {
    if (b.hasOwnProperty(c)) {
      var d = 0 === c.indexOf("--"),
          e = sb(c, b[c], d);
      "float" === c && (c = "cssFloat");
      d ? a.setProperty(c, e) : a[c] = e;
    }
  }
}

var ub = m({
  menuitem: !0
}, {
  area: !0,
  base: !0,
  br: !0,
  col: !0,
  embed: !0,
  hr: !0,
  img: !0,
  input: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
});

function vb(a, b) {
  if (b) {
    if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));

    if (null != b.dangerouslySetInnerHTML) {
      if (null != b.children) throw Error(y(60));
      if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
    }

    if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
  }
}

function wb(a, b) {
  if (-1 === a.indexOf("-")) return "string" === typeof b.is;

  switch (a) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return !1;

    default:
      return !0;
  }
}

function xb(a) {
  a = a.target || a.srcElement || window;
  a.correspondingUseElement && (a = a.correspondingUseElement);
  return 3 === a.nodeType ? a.parentNode : a;
}

var yb = null,
    zb = null,
    Ab = null;

function Bb(a) {
  if (a = Cb(a)) {
    if ("function" !== typeof yb) throw Error(y(280));
    var b = a.stateNode;
    b && (b = Db(b), yb(a.stateNode, a.type, b));
  }
}

function Eb(a) {
  zb ? Ab ? Ab.push(a) : Ab = [a] : zb = a;
}

function Fb() {
  if (zb) {
    var a = zb,
        b = Ab;
    Ab = zb = null;
    Bb(a);
    if (b) for (a = 0; a < b.length; a++) {
      Bb(b[a]);
    }
  }
}

function Gb(a, b) {
  return a(b);
}

function Hb(a, b, c, d, e) {
  return a(b, c, d, e);
}

function Ib() {}

var Jb = Gb,
    Kb = !1,
    Lb = !1;

function Mb() {
  if (null !== zb || null !== Ab) Ib(), Fb();
}

function Nb(a, b, c) {
  if (Lb) return a(b, c);
  Lb = !0;

  try {
    return Jb(a, b, c);
  } finally {
    Lb = !1, Mb();
  }
}

function Ob(a, b) {
  var c = a.stateNode;
  if (null === c) return null;
  var d = Db(c);
  if (null === d) return null;
  c = d[b];

  a: switch (b) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
      a = !d;
      break a;

    default:
      a = !1;
  }

  if (a) return null;
  if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
  return c;
}

var Pb = !1;
if (fa) try {
  var Qb = {};
  Object.defineProperty(Qb, "passive", {
    get: function get() {
      Pb = !0;
    }
  });
  window.addEventListener("test", Qb, Qb);
  window.removeEventListener("test", Qb, Qb);
} catch (a) {
  Pb = !1;
}

function Rb(a, b, c, d, e, f, g, h, k) {
  var l = Array.prototype.slice.call(arguments, 3);

  try {
    b.apply(c, l);
  } catch (n) {
    this.onError(n);
  }
}

var Sb = !1,
    Tb = null,
    Ub = !1,
    Vb = null,
    Wb = {
  onError: function onError(a) {
    Sb = !0;
    Tb = a;
  }
};

function Xb(a, b, c, d, e, f, g, h, k) {
  Sb = !1;
  Tb = null;
  Rb.apply(Wb, arguments);
}

function Yb(a, b, c, d, e, f, g, h, k) {
  Xb.apply(this, arguments);

  if (Sb) {
    if (Sb) {
      var l = Tb;
      Sb = !1;
      Tb = null;
    } else throw Error(y(198));

    Ub || (Ub = !0, Vb = l);
  }
}

function Zb(a) {
  var b = a,
      c = a;
  if (a.alternate) for (; b.return;) {
    b = b.return;
  } else {
    a = b;

    do {
      b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
    } while (a);
  }
  return 3 === b.tag ? c : null;
}

function $b(a) {
  if (13 === a.tag) {
    var b = a.memoizedState;
    null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
    if (null !== b) return b.dehydrated;
  }

  return null;
}

function ac(a) {
  if (Zb(a) !== a) throw Error(y(188));
}

function bc(a) {
  var b = a.alternate;

  if (!b) {
    b = Zb(a);
    if (null === b) throw Error(y(188));
    return b !== a ? null : a;
  }

  for (var c = a, d = b;;) {
    var e = c.return;
    if (null === e) break;
    var f = e.alternate;

    if (null === f) {
      d = e.return;

      if (null !== d) {
        c = d;
        continue;
      }

      break;
    }

    if (e.child === f.child) {
      for (f = e.child; f;) {
        if (f === c) return ac(e), a;
        if (f === d) return ac(e), b;
        f = f.sibling;
      }

      throw Error(y(188));
    }

    if (c.return !== d.return) c = e, d = f;else {
      for (var g = !1, h = e.child; h;) {
        if (h === c) {
          g = !0;
          c = e;
          d = f;
          break;
        }

        if (h === d) {
          g = !0;
          d = e;
          c = f;
          break;
        }

        h = h.sibling;
      }

      if (!g) {
        for (h = f.child; h;) {
          if (h === c) {
            g = !0;
            c = f;
            d = e;
            break;
          }

          if (h === d) {
            g = !0;
            d = f;
            c = e;
            break;
          }

          h = h.sibling;
        }

        if (!g) throw Error(y(189));
      }
    }
    if (c.alternate !== d) throw Error(y(190));
  }

  if (3 !== c.tag) throw Error(y(188));
  return c.stateNode.current === c ? a : b;
}

function cc(a) {
  a = bc(a);
  if (!a) return null;

  for (var b = a;;) {
    if (5 === b.tag || 6 === b.tag) return b;
    if (b.child) b.child.return = b, b = b.child;else {
      if (b === a) break;

      for (; !b.sibling;) {
        if (!b.return || b.return === a) return null;
        b = b.return;
      }

      b.sibling.return = b.return;
      b = b.sibling;
    }
  }

  return null;
}

function dc(a, b) {
  for (var c = a.alternate; null !== b;) {
    if (b === a || b === c) return !0;
    b = b.return;
  }

  return !1;
}

var ec,
    fc,
    gc,
    hc,
    ic = !1,
    jc = [],
    kc = null,
    lc = null,
    mc = null,
    nc = new Map(),
    oc = new Map(),
    pc = [],
    qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");

function rc(a, b, c, d, e) {
  return {
    blockedOn: a,
    domEventName: b,
    eventSystemFlags: c | 16,
    nativeEvent: e,
    targetContainers: [d]
  };
}

function sc(a, b) {
  switch (a) {
    case "focusin":
    case "focusout":
      kc = null;
      break;

    case "dragenter":
    case "dragleave":
      lc = null;
      break;

    case "mouseover":
    case "mouseout":
      mc = null;
      break;

    case "pointerover":
    case "pointerout":
      nc.delete(b.pointerId);
      break;

    case "gotpointercapture":
    case "lostpointercapture":
      oc.delete(b.pointerId);
  }
}

function tc(a, b, c, d, e, f) {
  if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
  a.eventSystemFlags |= d;
  b = a.targetContainers;
  null !== e && -1 === b.indexOf(e) && b.push(e);
  return a;
}

function uc(a, b, c, d, e) {
  switch (b) {
    case "focusin":
      return kc = tc(kc, a, b, c, d, e), !0;

    case "dragenter":
      return lc = tc(lc, a, b, c, d, e), !0;

    case "mouseover":
      return mc = tc(mc, a, b, c, d, e), !0;

    case "pointerover":
      var f = e.pointerId;
      nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
      return !0;

    case "gotpointercapture":
      return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
  }

  return !1;
}

function vc(a) {
  var b = wc(a.target);

  if (null !== b) {
    var c = Zb(b);
    if (null !== c) if (b = c.tag, 13 === b) {
      if (b = $b(c), null !== b) {
        a.blockedOn = b;
        hc(a.lanePriority, function () {
          r.unstable_runWithPriority(a.priority, function () {
            gc(c);
          });
        });
        return;
      }
    } else if (3 === b && c.stateNode.hydrate) {
      a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
      return;
    }
  }

  a.blockedOn = null;
}

function xc(a) {
  if (null !== a.blockedOn) return !1;

  for (var b = a.targetContainers; 0 < b.length;) {
    var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
    if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
    b.shift();
  }

  return !0;
}

function zc(a, b, c) {
  xc(a) && c.delete(b);
}

function Ac() {
  for (ic = !1; 0 < jc.length;) {
    var a = jc[0];

    if (null !== a.blockedOn) {
      a = Cb(a.blockedOn);
      null !== a && ec(a);
      break;
    }

    for (var b = a.targetContainers; 0 < b.length;) {
      var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);

      if (null !== c) {
        a.blockedOn = c;
        break;
      }

      b.shift();
    }

    null === a.blockedOn && jc.shift();
  }

  null !== kc && xc(kc) && (kc = null);
  null !== lc && xc(lc) && (lc = null);
  null !== mc && xc(mc) && (mc = null);
  nc.forEach(zc);
  oc.forEach(zc);
}

function Bc(a, b) {
  a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, Ac)));
}

function Cc(a) {
  function b(b) {
    return Bc(b, a);
  }

  if (0 < jc.length) {
    Bc(jc[0], a);

    for (var c = 1; c < jc.length; c++) {
      var d = jc[c];
      d.blockedOn === a && (d.blockedOn = null);
    }
  }

  null !== kc && Bc(kc, a);
  null !== lc && Bc(lc, a);
  null !== mc && Bc(mc, a);
  nc.forEach(b);
  oc.forEach(b);

  for (c = 0; c < pc.length; c++) {
    d = pc[c], d.blockedOn === a && (d.blockedOn = null);
  }

  for (; 0 < pc.length && (c = pc[0], null === c.blockedOn);) {
    vc(c), null === c.blockedOn && pc.shift();
  }
}

function Dc(a, b) {
  var c = {};
  c[a.toLowerCase()] = b.toLowerCase();
  c["Webkit" + a] = "webkit" + b;
  c["Moz" + a] = "moz" + b;
  return c;
}

var Ec = {
  animationend: Dc("Animation", "AnimationEnd"),
  animationiteration: Dc("Animation", "AnimationIteration"),
  animationstart: Dc("Animation", "AnimationStart"),
  transitionend: Dc("Transition", "TransitionEnd")
},
    Fc = {},
    Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);

function Hc(a) {
  if (Fc[a]) return Fc[a];
  if (!Ec[a]) return a;
  var b = Ec[a],
      c;

  for (c in b) {
    if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
  }

  return a;
}

var Ic = Hc("animationend"),
    Jc = Hc("animationiteration"),
    Kc = Hc("animationstart"),
    Lc = Hc("transitionend"),
    Mc = new Map(),
    Nc = new Map(),
    Oc = ["abort", "abort", Ic, "animationEnd", Jc, "animationIteration", Kc, "animationStart", "canplay", "canPlay", "canplaythrough", "canPlayThrough", "durationchange", "durationChange", "emptied", "emptied", "encrypted", "encrypted", "ended", "ended", "error", "error", "gotpointercapture", "gotPointerCapture", "load", "load", "loadeddata", "loadedData", "loadedmetadata", "loadedMetadata", "loadstart", "loadStart", "lostpointercapture", "lostPointerCapture", "playing", "playing", "progress", "progress", "seeking", "seeking", "stalled", "stalled", "suspend", "suspend", "timeupdate", "timeUpdate", Lc, "transitionEnd", "waiting", "waiting"];

function Pc(a, b) {
  for (var c = 0; c < a.length; c += 2) {
    var d = a[c],
        e = a[c + 1];
    e = "on" + (e[0].toUpperCase() + e.slice(1));
    Nc.set(d, b);
    Mc.set(d, e);
    da(e, [d]);
  }
}

var Qc = r.unstable_now;
Qc();
var F = 8;

function Rc(a) {
  if (0 !== (1 & a)) return F = 15, 1;
  if (0 !== (2 & a)) return F = 14, 2;
  if (0 !== (4 & a)) return F = 13, 4;
  var b = 24 & a;
  if (0 !== b) return F = 12, b;
  if (0 !== (a & 32)) return F = 11, 32;
  b = 192 & a;
  if (0 !== b) return F = 10, b;
  if (0 !== (a & 256)) return F = 9, 256;
  b = 3584 & a;
  if (0 !== b) return F = 8, b;
  if (0 !== (a & 4096)) return F = 7, 4096;
  b = 4186112 & a;
  if (0 !== b) return F = 6, b;
  b = 62914560 & a;
  if (0 !== b) return F = 5, b;
  if (a & 67108864) return F = 4, 67108864;
  if (0 !== (a & 134217728)) return F = 3, 134217728;
  b = 805306368 & a;
  if (0 !== b) return F = 2, b;
  if (0 !== (1073741824 & a)) return F = 1, 1073741824;
  F = 8;
  return a;
}

function Sc(a) {
  switch (a) {
    case 99:
      return 15;

    case 98:
      return 10;

    case 97:
    case 96:
      return 8;

    case 95:
      return 2;

    default:
      return 0;
  }
}

function Tc(a) {
  switch (a) {
    case 15:
    case 14:
      return 99;

    case 13:
    case 12:
    case 11:
    case 10:
      return 98;

    case 9:
    case 8:
    case 7:
    case 6:
    case 4:
    case 5:
      return 97;

    case 3:
    case 2:
    case 1:
      return 95;

    case 0:
      return 90;

    default:
      throw Error(y(358, a));
  }
}

function Uc(a, b) {
  var c = a.pendingLanes;
  if (0 === c) return F = 0;
  var d = 0,
      e = 0,
      f = a.expiredLanes,
      g = a.suspendedLanes,
      h = a.pingedLanes;
  if (0 !== f) d = f, e = F = 15;else if (f = c & 134217727, 0 !== f) {
    var k = f & ~g;
    0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
  } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
  if (0 === d) return 0;
  d = 31 - Vc(d);
  d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;

  if (0 !== b && b !== d && 0 === (b & g)) {
    Rc(b);
    if (e <= F) return b;
    F = e;
  }

  b = a.entangledLanes;
  if (0 !== b) for (a = a.entanglements, b &= d; 0 < b;) {
    c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
  }
  return d;
}

function Wc(a) {
  a = a.pendingLanes & -1073741825;
  return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}

function Xc(a, b) {
  switch (a) {
    case 15:
      return 1;

    case 14:
      return 2;

    case 12:
      return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;

    case 10:
      return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;

    case 8:
      return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;

    case 2:
      return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
  }

  throw Error(y(358, a));
}

function Yc(a) {
  return a & -a;
}

function Zc(a) {
  for (var b = [], c = 0; 31 > c; c++) {
    b.push(a);
  }

  return b;
}

function $c(a, b, c) {
  a.pendingLanes |= b;
  var d = b - 1;
  a.suspendedLanes &= d;
  a.pingedLanes &= d;
  a = a.eventTimes;
  b = 31 - Vc(b);
  a[b] = c;
}

var Vc = Math.clz32 ? Math.clz32 : ad,
    bd = Math.log,
    cd = Math.LN2;

function ad(a) {
  return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}

var dd = r.unstable_UserBlockingPriority,
    ed = r.unstable_runWithPriority,
    fd = !0;

function gd(a, b, c, d) {
  Kb || Ib();
  var e = hd,
      f = Kb;
  Kb = !0;

  try {
    Hb(e, a, b, c, d);
  } finally {
    (Kb = f) || Mb();
  }
}

function id(a, b, c, d) {
  ed(dd, hd.bind(null, a, b, c, d));
}

function hd(a, b, c, d) {
  if (fd) {
    var e;
    if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);else {
      var f = yc(a, b, c, d);
      if (null === f) e && sc(a, d);else {
        if (e) {
          if (-1 < qc.indexOf(a)) {
            a = rc(f, a, b, c, d);
            jc.push(a);
            return;
          }

          if (uc(f, a, b, c, d)) return;
          sc(a, d);
        }

        jd(a, b, d, null, c);
      }
    }
  }
}

function yc(a, b, c, d) {
  var e = xb(d);
  e = wc(e);

  if (null !== e) {
    var f = Zb(e);
    if (null === f) e = null;else {
      var g = f.tag;

      if (13 === g) {
        e = $b(f);
        if (null !== e) return e;
        e = null;
      } else if (3 === g) {
        if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
        e = null;
      } else f !== e && (e = null);
    }
  }

  jd(a, b, d, e, c);
  return null;
}

var kd = null,
    ld = null,
    md = null;

function nd() {
  if (md) return md;
  var a,
      b = ld,
      c = b.length,
      d,
      e = "value" in kd ? kd.value : kd.textContent,
      f = e.length;

  for (a = 0; a < c && b[a] === e[a]; a++) {
    ;
  }

  var g = c - a;

  for (d = 1; d <= g && b[c - d] === e[f - d]; d++) {
    ;
  }

  return md = e.slice(a, 1 < d ? 1 - d : void 0);
}

function od(a) {
  var b = a.keyCode;
  "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
  10 === a && (a = 13);
  return 32 <= a || 13 === a ? a : 0;
}

function pd() {
  return !0;
}

function qd() {
  return !1;
}

function rd(a) {
  function b(b, d, e, f, g) {
    this._reactName = b;
    this._targetInst = e;
    this.type = d;
    this.nativeEvent = f;
    this.target = g;
    this.currentTarget = null;

    for (var c in a) {
      a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
    }

    this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
    this.isPropagationStopped = qd;
    return this;
  }

  m(b.prototype, {
    preventDefault: function preventDefault() {
      this.defaultPrevented = !0;
      var a = this.nativeEvent;
      a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
    },
    stopPropagation: function stopPropagation() {
      var a = this.nativeEvent;
      a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
    },
    persist: function persist() {},
    isPersistent: pd
  });
  return b;
}

var sd = {
  eventPhase: 0,
  bubbles: 0,
  cancelable: 0,
  timeStamp: function timeStamp(a) {
    return a.timeStamp || Date.now();
  },
  defaultPrevented: 0,
  isTrusted: 0
},
    td = rd(sd),
    ud = m({}, sd, {
  view: 0,
  detail: 0
}),
    vd = rd(ud),
    wd,
    xd,
    yd,
    Ad = m({}, ud, {
  screenX: 0,
  screenY: 0,
  clientX: 0,
  clientY: 0,
  pageX: 0,
  pageY: 0,
  ctrlKey: 0,
  shiftKey: 0,
  altKey: 0,
  metaKey: 0,
  getModifierState: zd,
  button: 0,
  buttons: 0,
  relatedTarget: function relatedTarget(a) {
    return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
  },
  movementX: function movementX(a) {
    if ("movementX" in a) return a.movementX;
    a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
    return wd;
  },
  movementY: function movementY(a) {
    return "movementY" in a ? a.movementY : xd;
  }
}),
    Bd = rd(Ad),
    Cd = m({}, Ad, {
  dataTransfer: 0
}),
    Dd = rd(Cd),
    Ed = m({}, ud, {
  relatedTarget: 0
}),
    Fd = rd(Ed),
    Gd = m({}, sd, {
  animationName: 0,
  elapsedTime: 0,
  pseudoElement: 0
}),
    Hd = rd(Gd),
    Id = m({}, sd, {
  clipboardData: function clipboardData(a) {
    return "clipboardData" in a ? a.clipboardData : window.clipboardData;
  }
}),
    Jd = rd(Id),
    Kd = m({}, sd, {
  data: 0
}),
    Ld = rd(Kd),
    Md = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
},
    Nd = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
},
    Od = {
  Alt: "altKey",
  Control: "ctrlKey",
  Meta: "metaKey",
  Shift: "shiftKey"
};

function Pd(a) {
  var b = this.nativeEvent;
  return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}

function zd() {
  return Pd;
}

var Qd = m({}, ud, {
  key: function key(a) {
    if (a.key) {
      var b = Md[a.key] || a.key;
      if ("Unidentified" !== b) return b;
    }

    return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
  },
  code: 0,
  location: 0,
  ctrlKey: 0,
  shiftKey: 0,
  altKey: 0,
  metaKey: 0,
  repeat: 0,
  locale: 0,
  getModifierState: zd,
  charCode: function charCode(a) {
    return "keypress" === a.type ? od(a) : 0;
  },
  keyCode: function keyCode(a) {
    return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  },
  which: function which(a) {
    return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  }
}),
    Rd = rd(Qd),
    Sd = m({}, Ad, {
  pointerId: 0,
  width: 0,
  height: 0,
  pressure: 0,
  tangentialPressure: 0,
  tiltX: 0,
  tiltY: 0,
  twist: 0,
  pointerType: 0,
  isPrimary: 0
}),
    Td = rd(Sd),
    Ud = m({}, ud, {
  touches: 0,
  targetTouches: 0,
  changedTouches: 0,
  altKey: 0,
  metaKey: 0,
  ctrlKey: 0,
  shiftKey: 0,
  getModifierState: zd
}),
    Vd = rd(Ud),
    Wd = m({}, sd, {
  propertyName: 0,
  elapsedTime: 0,
  pseudoElement: 0
}),
    Xd = rd(Wd),
    Yd = m({}, Ad, {
  deltaX: function deltaX(a) {
    return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
  },
  deltaY: function deltaY(a) {
    return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
}),
    Zd = rd(Yd),
    $d = [9, 13, 27, 32],
    ae = fa && "CompositionEvent" in window,
    be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be,
    de = fa && (!ae || be && 8 < be && 11 >= be),
    ee = String.fromCharCode(32),
    fe = !1;

function ge(a, b) {
  switch (a) {
    case "keyup":
      return -1 !== $d.indexOf(b.keyCode);

    case "keydown":
      return 229 !== b.keyCode;

    case "keypress":
    case "mousedown":
    case "focusout":
      return !0;

    default:
      return !1;
  }
}

function he(a) {
  a = a.detail;
  return "object" === typeof a && "data" in a ? a.data : null;
}

var ie = !1;

function je(a, b) {
  switch (a) {
    case "compositionend":
      return he(b);

    case "keypress":
      if (32 !== b.which) return null;
      fe = !0;
      return ee;

    case "textInput":
      return a = b.data, a === ee && fe ? null : a;

    default:
      return null;
  }
}

function ke(a, b) {
  if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;

  switch (a) {
    case "paste":
      return null;

    case "keypress":
      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
        if (b.char && 1 < b.char.length) return b.char;
        if (b.which) return String.fromCharCode(b.which);
      }

      return null;

    case "compositionend":
      return de && "ko" !== b.locale ? null : b.data;

    default:
      return null;
  }
}

var le = {
  color: !0,
  date: !0,
  datetime: !0,
  "datetime-local": !0,
  email: !0,
  month: !0,
  number: !0,
  password: !0,
  range: !0,
  search: !0,
  tel: !0,
  text: !0,
  time: !0,
  url: !0,
  week: !0
};

function me(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}

function ne(a, b, c, d) {
  Eb(d);
  b = oe(b, "onChange");
  0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
    event: c,
    listeners: b
  }));
}

var pe = null,
    qe = null;

function re(a) {
  se(a, 0);
}

function te(a) {
  var b = ue(a);
  if (Wa(b)) return a;
}

function ve(a, b) {
  if ("change" === a) return b;
}

var we = !1;

if (fa) {
  var xe;

  if (fa) {
    var ye = ("oninput" in document);

    if (!ye) {
      var ze = document.createElement("div");
      ze.setAttribute("oninput", "return;");
      ye = "function" === typeof ze.oninput;
    }

    xe = ye;
  } else xe = !1;

  we = xe && (!document.documentMode || 9 < document.documentMode);
}

function Ae() {
  pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}

function Be(a) {
  if ("value" === a.propertyName && te(qe)) {
    var b = [];
    ne(b, qe, a, xb(a));
    a = re;
    if (Kb) a(b);else {
      Kb = !0;

      try {
        Gb(a, b);
      } finally {
        Kb = !1, Mb();
      }
    }
  }
}

function Ce(a, b, c) {
  "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}

function De(a) {
  if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}

function Ee(a, b) {
  if ("click" === a) return te(b);
}

function Fe(a, b) {
  if ("input" === a || "change" === a) return te(b);
}

function Ge(a, b) {
  return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}

var He = "function" === typeof Object.is ? Object.is : Ge,
    Ie = Object.prototype.hasOwnProperty;

function Je(a, b) {
  if (He(a, b)) return !0;
  if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
  var c = Object.keys(a),
      d = Object.keys(b);
  if (c.length !== d.length) return !1;

  for (d = 0; d < c.length; d++) {
    if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
  }

  return !0;
}

function Ke(a) {
  for (; a && a.firstChild;) {
    a = a.firstChild;
  }

  return a;
}

function Le(a, b) {
  var c = Ke(a);
  a = 0;

  for (var d; c;) {
    if (3 === c.nodeType) {
      d = a + c.textContent.length;
      if (a <= b && d >= b) return {
        node: c,
        offset: b - a
      };
      a = d;
    }

    a: {
      for (; c;) {
        if (c.nextSibling) {
          c = c.nextSibling;
          break a;
        }

        c = c.parentNode;
      }

      c = void 0;
    }

    c = Ke(c);
  }
}

function Me(a, b) {
  return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}

function Ne() {
  for (var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;) {
    try {
      var c = "string" === typeof b.contentWindow.location.href;
    } catch (d) {
      c = !1;
    }

    if (c) a = b.contentWindow;else break;
    b = Xa(a.document);
  }

  return b;
}

function Oe(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}

var Pe = fa && "documentMode" in document && 11 >= document.documentMode,
    Qe = null,
    Re = null,
    Se = null,
    Te = !1;

function Ue(a, b, c) {
  var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
  Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
    start: d.selectionStart,
    end: d.selectionEnd
  } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
    anchorNode: d.anchorNode,
    anchorOffset: d.anchorOffset,
    focusNode: d.focusNode,
    focusOffset: d.focusOffset
  }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
    event: b,
    listeners: d
  }), b.target = Qe)));
}

Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);

for (var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++) {
  Nc.set(Ve[We], 0);
}

ea("onMouseEnter", ["mouseout", "mouseover"]);
ea("onMouseLeave", ["mouseout", "mouseover"]);
ea("onPointerEnter", ["pointerout", "pointerover"]);
ea("onPointerLeave", ["pointerout", "pointerover"]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),
    Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));

function Ze(a, b, c) {
  var d = a.type || "unknown-event";
  a.currentTarget = c;
  Yb(d, b, void 0, a);
  a.currentTarget = null;
}

function se(a, b) {
  b = 0 !== (b & 4);

  for (var c = 0; c < a.length; c++) {
    var d = a[c],
        e = d.event;
    d = d.listeners;

    a: {
      var f = void 0;
      if (b) for (var g = d.length - 1; 0 <= g; g--) {
        var h = d[g],
            k = h.instance,
            l = h.currentTarget;
        h = h.listener;
        if (k !== f && e.isPropagationStopped()) break a;
        Ze(e, h, l);
        f = k;
      } else for (g = 0; g < d.length; g++) {
        h = d[g];
        k = h.instance;
        l = h.currentTarget;
        h = h.listener;
        if (k !== f && e.isPropagationStopped()) break a;
        Ze(e, h, l);
        f = k;
      }
    }
  }

  if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}

function G(a, b) {
  var c = $e(b),
      d = a + "__bubble";
  c.has(d) || (af(b, a, 2, !1), c.add(d));
}

var bf = "_reactListening" + Math.random().toString(36).slice(2);

function cf(a) {
  a[bf] || (a[bf] = !0, ba.forEach(function (b) {
    Ye.has(b) || df(b, !1, a, null);
    df(b, !0, a, null);
  }));
}

function df(a, b, c, d) {
  var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0,
      f = c;
  "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);

  if (null !== d && !b && Ye.has(a)) {
    if ("scroll" !== a) return;
    e |= 2;
    f = d;
  }

  var g = $e(f),
      h = a + "__" + (b ? "capture" : "bubble");
  g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}

function af(a, b, c, d) {
  var e = Nc.get(b);

  switch (void 0 === e ? 2 : e) {
    case 0:
      e = gd;
      break;

    case 1:
      e = id;
      break;

    default:
      e = hd;
  }

  c = e.bind(null, b, c, a);
  e = void 0;
  !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
  d ? void 0 !== e ? a.addEventListener(b, c, {
    capture: !0,
    passive: e
  }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
    passive: e
  }) : a.addEventListener(b, c, !1);
}

function jd(a, b, c, d, e) {
  var f = d;
  if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for (;;) {
    if (null === d) return;
    var g = d.tag;

    if (3 === g || 4 === g) {
      var h = d.stateNode.containerInfo;
      if (h === e || 8 === h.nodeType && h.parentNode === e) break;
      if (4 === g) for (g = d.return; null !== g;) {
        var k = g.tag;
        if (3 === k || 4 === k) if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
        g = g.return;
      }

      for (; null !== h;) {
        g = wc(h);
        if (null === g) return;
        k = g.tag;

        if (5 === k || 6 === k) {
          d = f = g;
          continue a;
        }

        h = h.parentNode;
      }
    }

    d = d.return;
  }
  Nb(function () {
    var d = f,
        e = xb(c),
        g = [];

    a: {
      var h = Mc.get(a);

      if (void 0 !== h) {
        var k = td,
            x = a;

        switch (a) {
          case "keypress":
            if (0 === od(c)) break a;

          case "keydown":
          case "keyup":
            k = Rd;
            break;

          case "focusin":
            x = "focus";
            k = Fd;
            break;

          case "focusout":
            x = "blur";
            k = Fd;
            break;

          case "beforeblur":
          case "afterblur":
            k = Fd;
            break;

          case "click":
            if (2 === c.button) break a;

          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            k = Bd;
            break;

          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            k = Dd;
            break;

          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            k = Vd;
            break;

          case Ic:
          case Jc:
          case Kc:
            k = Hd;
            break;

          case Lc:
            k = Xd;
            break;

          case "scroll":
            k = vd;
            break;

          case "wheel":
            k = Zd;
            break;

          case "copy":
          case "cut":
          case "paste":
            k = Jd;
            break;

          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            k = Td;
        }

        var w = 0 !== (b & 4),
            z = !w && "scroll" === a,
            u = w ? null !== h ? h + "Capture" : null : h;
        w = [];

        for (var t = d, q; null !== t;) {
          q = t;
          var v = q.stateNode;
          5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
          if (z) break;
          t = t.return;
        }

        0 < w.length && (h = new k(h, x, null, c, e), g.push({
          event: h,
          listeners: w
        }));
      }
    }

    if (0 === (b & 7)) {
      a: {
        h = "mouseover" === a || "pointerover" === a;
        k = "mouseout" === a || "pointerout" === a;
        if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;

        if (k || h) {
          h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;

          if (k) {
            if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
          } else k = null, x = d;

          if (k !== x) {
            w = Bd;
            v = "onMouseLeave";
            u = "onMouseEnter";
            t = "mouse";
            if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
            z = null == k ? h : ue(k);
            q = null == x ? h : ue(x);
            h = new w(v, t + "leave", k, c, e);
            h.target = z;
            h.relatedTarget = q;
            v = null;
            wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
            z = v;
            if (k && x) b: {
              w = k;
              u = x;
              t = 0;

              for (q = w; q; q = gf(q)) {
                t++;
              }

              q = 0;

              for (v = u; v; v = gf(v)) {
                q++;
              }

              for (; 0 < t - q;) {
                w = gf(w), t--;
              }

              for (; 0 < q - t;) {
                u = gf(u), q--;
              }

              for (; t--;) {
                if (w === u || null !== u && w === u.alternate) break b;
                w = gf(w);
                u = gf(u);
              }

              w = null;
            } else w = null;
            null !== k && hf(g, h, k, w, !1);
            null !== x && null !== z && hf(g, z, x, w, !0);
          }
        }
      }

      a: {
        h = d ? ue(d) : window;
        k = h.nodeName && h.nodeName.toLowerCase();
        if ("select" === k || "input" === k && "file" === h.type) var J = ve;else if (me(h)) {
          if (we) J = Fe;else {
            J = De;
            var K = Ce;
          }
        } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);

        if (J && (J = J(a, d))) {
          ne(g, J, c, e);
          break a;
        }

        K && K(a, h, d);
        "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
      }

      K = d ? ue(d) : window;

      switch (a) {
        case "focusin":
          if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
          break;

        case "focusout":
          Se = Re = Qe = null;
          break;

        case "mousedown":
          Te = !0;
          break;

        case "contextmenu":
        case "mouseup":
        case "dragend":
          Te = !1;
          Ue(g, c, e);
          break;

        case "selectionchange":
          if (Pe) break;

        case "keydown":
        case "keyup":
          Ue(g, c, e);
      }

      var Q;
      if (ae) b: {
        switch (a) {
          case "compositionstart":
            var L = "onCompositionStart";
            break b;

          case "compositionend":
            L = "onCompositionEnd";
            break b;

          case "compositionupdate":
            L = "onCompositionUpdate";
            break b;
        }

        L = void 0;
      } else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
      L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
        event: L,
        listeners: K
      }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
      if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
        event: e,
        listeners: d
      }), e.data = Q);
    }

    se(g, b);
  });
}

function ef(a, b, c) {
  return {
    instance: a,
    listener: b,
    currentTarget: c
  };
}

function oe(a, b) {
  for (var c = b + "Capture", d = []; null !== a;) {
    var e = a,
        f = e.stateNode;
    5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
    a = a.return;
  }

  return d;
}

function gf(a) {
  if (null === a) return null;

  do {
    a = a.return;
  } while (a && 5 !== a.tag);

  return a ? a : null;
}

function hf(a, b, c, d, e) {
  for (var f = b._reactName, g = []; null !== c && c !== d;) {
    var h = c,
        k = h.alternate,
        l = h.stateNode;
    if (null !== k && k === d) break;
    5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
    c = c.return;
  }

  0 !== g.length && a.push({
    event: b,
    listeners: g
  });
}

function jf() {}

var kf = null,
    lf = null;

function mf(a, b) {
  switch (a) {
    case "button":
    case "input":
    case "select":
    case "textarea":
      return !!b.autoFocus;
  }

  return !1;
}

function nf(a, b) {
  return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}

var of = "function" === typeof setTimeout ? setTimeout : void 0,
    pf = "function" === typeof clearTimeout ? clearTimeout : void 0;

function qf(a) {
  1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}

function rf(a) {
  for (; null != a; a = a.nextSibling) {
    var b = a.nodeType;
    if (1 === b || 3 === b) break;
  }

  return a;
}

function sf(a) {
  a = a.previousSibling;

  for (var b = 0; a;) {
    if (8 === a.nodeType) {
      var c = a.data;

      if ("$" === c || "$!" === c || "$?" === c) {
        if (0 === b) return a;
        b--;
      } else "/$" === c && b++;
    }

    a = a.previousSibling;
  }

  return null;
}

var tf = 0;

function uf(a) {
  return {
    $$typeof: Ga,
    toString: a,
    valueOf: a
  };
}

var vf = Math.random().toString(36).slice(2),
    wf = "__reactFiber$" + vf,
    xf = "__reactProps$" + vf,
    ff = "__reactContainer$" + vf,
    yf = "__reactEvents$" + vf;

function wc(a) {
  var b = a[wf];
  if (b) return b;

  for (var c = a.parentNode; c;) {
    if (b = c[ff] || c[wf]) {
      c = b.alternate;
      if (null !== b.child || null !== c && null !== c.child) for (a = sf(a); null !== a;) {
        if (c = a[wf]) return c;
        a = sf(a);
      }
      return b;
    }

    a = c;
    c = a.parentNode;
  }

  return null;
}

function Cb(a) {
  a = a[wf] || a[ff];
  return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}

function ue(a) {
  if (5 === a.tag || 6 === a.tag) return a.stateNode;
  throw Error(y(33));
}

function Db(a) {
  return a[xf] || null;
}

function $e(a) {
  var b = a[yf];
  void 0 === b && (b = a[yf] = new Set());
  return b;
}

var zf = [],
    Af = -1;

function Bf(a) {
  return {
    current: a
  };
}

function H(a) {
  0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}

function I(a, b) {
  Af++;
  zf[Af] = a.current;
  a.current = b;
}

var Cf = {},
    M = Bf(Cf),
    N = Bf(!1),
    Df = Cf;

function Ef(a, b) {
  var c = a.type.contextTypes;
  if (!c) return Cf;
  var d = a.stateNode;
  if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
  var e = {},
      f;

  for (f in c) {
    e[f] = b[f];
  }

  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
  return e;
}

function Ff(a) {
  a = a.childContextTypes;
  return null !== a && void 0 !== a;
}

function Gf() {
  H(N);
  H(M);
}

function Hf(a, b, c) {
  if (M.current !== Cf) throw Error(y(168));
  I(M, b);
  I(N, c);
}

function If(a, b, c) {
  var d = a.stateNode;
  a = b.childContextTypes;
  if ("function" !== typeof d.getChildContext) return c;
  d = d.getChildContext();

  for (var e in d) {
    if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
  }

  return m({}, c, d);
}

function Jf(a) {
  a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
  Df = M.current;
  I(M, a);
  I(N, N.current);
  return !0;
}

function Kf(a, b, c) {
  var d = a.stateNode;
  if (!d) throw Error(y(169));
  c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
  I(N, c);
}

var Lf = null,
    Mf = null,
    Nf = r.unstable_runWithPriority,
    Of = r.unstable_scheduleCallback,
    Pf = r.unstable_cancelCallback,
    Qf = r.unstable_shouldYield,
    Rf = r.unstable_requestPaint,
    Sf = r.unstable_now,
    Tf = r.unstable_getCurrentPriorityLevel,
    Uf = r.unstable_ImmediatePriority,
    Vf = r.unstable_UserBlockingPriority,
    Wf = r.unstable_NormalPriority,
    Xf = r.unstable_LowPriority,
    Yf = r.unstable_IdlePriority,
    Zf = {},
    $f = void 0 !== Rf ? Rf : function () {},
    ag = null,
    bg = null,
    cg = !1,
    dg = Sf(),
    O = 1E4 > dg ? Sf : function () {
  return Sf() - dg;
};

function eg() {
  switch (Tf()) {
    case Uf:
      return 99;

    case Vf:
      return 98;

    case Wf:
      return 97;

    case Xf:
      return 96;

    case Yf:
      return 95;

    default:
      throw Error(y(332));
  }
}

function fg(a) {
  switch (a) {
    case 99:
      return Uf;

    case 98:
      return Vf;

    case 97:
      return Wf;

    case 96:
      return Xf;

    case 95:
      return Yf;

    default:
      throw Error(y(332));
  }
}

function gg(a, b) {
  a = fg(a);
  return Nf(a, b);
}

function hg(a, b, c) {
  a = fg(a);
  return Of(a, b, c);
}

function ig() {
  if (null !== bg) {
    var a = bg;
    bg = null;
    Pf(a);
  }

  jg();
}

function jg() {
  if (!cg && null !== ag) {
    cg = !0;
    var a = 0;

    try {
      var b = ag;
      gg(99, function () {
        for (; a < b.length; a++) {
          var c = b[a];

          do {
            c = c(!0);
          } while (null !== c);
        }
      });
      ag = null;
    } catch (c) {
      throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
    } finally {
      cg = !1;
    }
  }
}

var kg = ra.ReactCurrentBatchConfig;

function lg(a, b) {
  if (a && a.defaultProps) {
    b = m({}, b);
    a = a.defaultProps;

    for (var c in a) {
      void 0 === b[c] && (b[c] = a[c]);
    }

    return b;
  }

  return b;
}

var mg = Bf(null),
    ng = null,
    og = null,
    pg = null;

function qg() {
  pg = og = ng = null;
}

function rg(a) {
  var b = mg.current;
  H(mg);
  a.type._context._currentValue = b;
}

function sg(a, b) {
  for (; null !== a;) {
    var c = a.alternate;
    if ((a.childLanes & b) === b) {
      if (null === c || (c.childLanes & b) === b) break;else c.childLanes |= b;
    } else a.childLanes |= b, null !== c && (c.childLanes |= b);
    a = a.return;
  }
}

function tg(a, b) {
  ng = a;
  pg = og = null;
  a = a.dependencies;
  null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}

function vg(a, b) {
  if (pg !== a && !1 !== b && 0 !== b) {
    if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
    b = {
      context: a,
      observedBits: b,
      next: null
    };

    if (null === og) {
      if (null === ng) throw Error(y(308));
      og = b;
      ng.dependencies = {
        lanes: 0,
        firstContext: b,
        responders: null
      };
    } else og = og.next = b;
  }

  return a._currentValue;
}

var wg = !1;

function xg(a) {
  a.updateQueue = {
    baseState: a.memoizedState,
    firstBaseUpdate: null,
    lastBaseUpdate: null,
    shared: {
      pending: null
    },
    effects: null
  };
}

function yg(a, b) {
  a = a.updateQueue;
  b.updateQueue === a && (b.updateQueue = {
    baseState: a.baseState,
    firstBaseUpdate: a.firstBaseUpdate,
    lastBaseUpdate: a.lastBaseUpdate,
    shared: a.shared,
    effects: a.effects
  });
}

function zg(a, b) {
  return {
    eventTime: a,
    lane: b,
    tag: 0,
    payload: null,
    callback: null,
    next: null
  };
}

function Ag(a, b) {
  a = a.updateQueue;

  if (null !== a) {
    a = a.shared;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
  }
}

function Bg(a, b) {
  var c = a.updateQueue,
      d = a.alternate;

  if (null !== d && (d = d.updateQueue, c === d)) {
    var e = null,
        f = null;
    c = c.firstBaseUpdate;

    if (null !== c) {
      do {
        var g = {
          eventTime: c.eventTime,
          lane: c.lane,
          tag: c.tag,
          payload: c.payload,
          callback: c.callback,
          next: null
        };
        null === f ? e = f = g : f = f.next = g;
        c = c.next;
      } while (null !== c);

      null === f ? e = f = b : f = f.next = b;
    } else e = f = b;

    c = {
      baseState: d.baseState,
      firstBaseUpdate: e,
      lastBaseUpdate: f,
      shared: d.shared,
      effects: d.effects
    };
    a.updateQueue = c;
    return;
  }

  a = c.lastBaseUpdate;
  null === a ? c.firstBaseUpdate = b : a.next = b;
  c.lastBaseUpdate = b;
}

function Cg(a, b, c, d) {
  var e = a.updateQueue;
  wg = !1;
  var f = e.firstBaseUpdate,
      g = e.lastBaseUpdate,
      h = e.shared.pending;

  if (null !== h) {
    e.shared.pending = null;
    var k = h,
        l = k.next;
    k.next = null;
    null === g ? f = l : g.next = l;
    g = k;
    var n = a.alternate;

    if (null !== n) {
      n = n.updateQueue;
      var A = n.lastBaseUpdate;
      A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
    }
  }

  if (null !== f) {
    A = e.baseState;
    g = 0;
    n = l = k = null;

    do {
      h = f.lane;
      var p = f.eventTime;

      if ((d & h) === h) {
        null !== n && (n = n.next = {
          eventTime: p,
          lane: 0,
          tag: f.tag,
          payload: f.payload,
          callback: f.callback,
          next: null
        });

        a: {
          var C = a,
              x = f;
          h = b;
          p = c;

          switch (x.tag) {
            case 1:
              C = x.payload;

              if ("function" === typeof C) {
                A = C.call(p, A, h);
                break a;
              }

              A = C;
              break a;

            case 3:
              C.flags = C.flags & -4097 | 64;

            case 0:
              C = x.payload;
              h = "function" === typeof C ? C.call(p, A, h) : C;
              if (null === h || void 0 === h) break a;
              A = m({}, A, h);
              break a;

            case 2:
              wg = !0;
          }
        }

        null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [f] : h.push(f));
      } else p = {
        eventTime: p,
        lane: h,
        tag: f.tag,
        payload: f.payload,
        callback: f.callback,
        next: null
      }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;

      f = f.next;
      if (null === f) if (h = e.shared.pending, null === h) break;else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
    } while (1);

    null === n && (k = A);
    e.baseState = k;
    e.firstBaseUpdate = l;
    e.lastBaseUpdate = n;
    Dg |= g;
    a.lanes = g;
    a.memoizedState = A;
  }
}

function Eg(a, b, c) {
  a = b.effects;
  b.effects = null;
  if (null !== a) for (b = 0; b < a.length; b++) {
    var d = a[b],
        e = d.callback;

    if (null !== e) {
      d.callback = null;
      d = c;
      if ("function" !== typeof e) throw Error(y(191, e));
      e.call(d);
    }
  }
}

var Fg = new aa.Component().refs;

function Gg(a, b, c, d) {
  b = a.memoizedState;
  c = c(d, b);
  c = null === c || void 0 === c ? b : m({}, b, c);
  a.memoizedState = c;
  0 === a.lanes && (a.updateQueue.baseState = c);
}

var Kg = {
  isMounted: function isMounted(a) {
    return (a = a._reactInternals) ? Zb(a) === a : !1;
  },
  enqueueSetState: function enqueueSetState(a, b, c) {
    a = a._reactInternals;
    var d = Hg(),
        e = Ig(a),
        f = zg(d, e);
    f.payload = b;
    void 0 !== c && null !== c && (f.callback = c);
    Ag(a, f);
    Jg(a, e, d);
  },
  enqueueReplaceState: function enqueueReplaceState(a, b, c) {
    a = a._reactInternals;
    var d = Hg(),
        e = Ig(a),
        f = zg(d, e);
    f.tag = 1;
    f.payload = b;
    void 0 !== c && null !== c && (f.callback = c);
    Ag(a, f);
    Jg(a, e, d);
  },
  enqueueForceUpdate: function enqueueForceUpdate(a, b) {
    a = a._reactInternals;
    var c = Hg(),
        d = Ig(a),
        e = zg(c, d);
    e.tag = 2;
    void 0 !== b && null !== b && (e.callback = b);
    Ag(a, e);
    Jg(a, d, c);
  }
};

function Lg(a, b, c, d, e, f, g) {
  a = a.stateNode;
  return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}

function Mg(a, b, c) {
  var d = !1,
      e = Cf;
  var f = b.contextType;
  "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
  b = new b(c, f);
  a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
  b.updater = Kg;
  a.stateNode = b;
  b._reactInternals = a;
  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
  return b;
}

function Ng(a, b, c, d) {
  a = b.state;
  "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
  "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
  b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}

function Og(a, b, c, d) {
  var e = a.stateNode;
  e.props = c;
  e.state = a.memoizedState;
  e.refs = Fg;
  xg(a);
  var f = b.contextType;
  "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
  Cg(a, c, e, d);
  e.state = a.memoizedState;
  f = b.getDerivedStateFromProps;
  "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
  "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
  "function" === typeof e.componentDidMount && (a.flags |= 4);
}

var Pg = Array.isArray;

function Qg(a, b, c) {
  a = c.ref;

  if (null !== a && "function" !== typeof a && "object" !== typeof a) {
    if (c._owner) {
      c = c._owner;

      if (c) {
        if (1 !== c.tag) throw Error(y(309));
        var d = c.stateNode;
      }

      if (!d) throw Error(y(147, a));
      var e = "" + a;
      if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;

      b = function b(a) {
        var b = d.refs;
        b === Fg && (b = d.refs = {});
        null === a ? delete b[e] : b[e] = a;
      };

      b._stringRef = e;
      return b;
    }

    if ("string" !== typeof a) throw Error(y(284));
    if (!c._owner) throw Error(y(290, a));
  }

  return a;
}

function Rg(a, b) {
  if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}

function Sg(a) {
  function b(b, c) {
    if (a) {
      var d = b.lastEffect;
      null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
      c.nextEffect = null;
      c.flags = 8;
    }
  }

  function c(c, d) {
    if (!a) return null;

    for (; null !== d;) {
      b(c, d), d = d.sibling;
    }

    return null;
  }

  function d(a, b) {
    for (a = new Map(); null !== b;) {
      null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
    }

    return a;
  }

  function e(a, b) {
    a = Tg(a, b);
    a.index = 0;
    a.sibling = null;
    return a;
  }

  function f(b, c, d) {
    b.index = d;
    if (!a) return c;
    d = b.alternate;
    if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
    b.flags = 2;
    return c;
  }

  function g(b) {
    a && null === b.alternate && (b.flags = 2);
    return b;
  }

  function h(a, b, c, d) {
    if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
    b = e(b, c);
    b.return = a;
    return b;
  }

  function k(a, b, c, d) {
    if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
    d = Vg(c.type, c.key, c.props, null, a.mode, d);
    d.ref = Qg(a, b, c);
    d.return = a;
    return d;
  }

  function l(a, b, c, d) {
    if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
    b = e(b, c.children || []);
    b.return = a;
    return b;
  }

  function n(a, b, c, d, f) {
    if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
    b = e(b, c);
    b.return = a;
    return b;
  }

  function A(a, b, c) {
    if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;

    if ("object" === typeof b && null !== b) {
      switch (b.$$typeof) {
        case sa:
          return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;

        case ta:
          return b = Wg(b, a.mode, c), b.return = a, b;
      }

      if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
      Rg(a, b);
    }

    return null;
  }

  function p(a, b, c, d) {
    var e = null !== b ? b.key : null;
    if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);

    if ("object" === typeof c && null !== c) {
      switch (c.$$typeof) {
        case sa:
          return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;

        case ta:
          return c.key === e ? l(a, b, c, d) : null;
      }

      if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
      Rg(a, c);
    }

    return null;
  }

  function C(a, b, c, d, e) {
    if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);

    if ("object" === typeof d && null !== d) {
      switch (d.$$typeof) {
        case sa:
          return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);

        case ta:
          return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
      }

      if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
      Rg(b, d);
    }

    return null;
  }

  function x(e, g, h, k) {
    for (var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++) {
      u.index > z ? (q = u, u = null) : q = u.sibling;
      var n = p(e, u, h[z], k);

      if (null === n) {
        null === u && (u = q);
        break;
      }

      a && u && null === n.alternate && b(e, u);
      g = f(n, g, z);
      null === t ? l = n : t.sibling = n;
      t = n;
      u = q;
    }

    if (z === h.length) return c(e, u), l;

    if (null === u) {
      for (; z < h.length; z++) {
        u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
      }

      return l;
    }

    for (u = d(e, u); z < h.length; z++) {
      q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
    }

    a && u.forEach(function (a) {
      return b(e, a);
    });
    return l;
  }

  function w(e, g, h, k) {
    var l = La(h);
    if ("function" !== typeof l) throw Error(y(150));
    h = l.call(h);
    if (null == h) throw Error(y(151));

    for (var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()) {
      u.index > z ? (q = u, u = null) : q = u.sibling;
      var w = p(e, u, n.value, k);

      if (null === w) {
        null === u && (u = q);
        break;
      }

      a && u && null === w.alternate && b(e, u);
      g = f(w, g, z);
      null === t ? l = w : t.sibling = w;
      t = w;
      u = q;
    }

    if (n.done) return c(e, u), l;

    if (null === u) {
      for (; !n.done; z++, n = h.next()) {
        n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
      }

      return l;
    }

    for (u = d(e, u); !n.done; z++, n = h.next()) {
      n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
    }

    a && u.forEach(function (a) {
      return b(e, a);
    });
    return l;
  }

  return function (a, d, f, h) {
    var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
    k && (f = f.props.children);
    var l = "object" === typeof f && null !== f;
    if (l) switch (f.$$typeof) {
      case sa:
        a: {
          l = f.key;

          for (k = d; null !== k;) {
            if (k.key === l) {
              switch (k.tag) {
                case 7:
                  if (f.type === ua) {
                    c(a, k.sibling);
                    d = e(k, f.props.children);
                    d.return = a;
                    a = d;
                    break a;
                  }

                  break;

                default:
                  if (k.elementType === f.type) {
                    c(a, k.sibling);
                    d = e(k, f.props);
                    d.ref = Qg(a, k, f);
                    d.return = a;
                    a = d;
                    break a;
                  }

              }

              c(a, k);
              break;
            } else b(a, k);

            k = k.sibling;
          }

          f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
        }

        return g(a);

      case ta:
        a: {
          for (k = f.key; null !== d;) {
            if (d.key === k) {
              if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                c(a, d.sibling);
                d = e(d, f.children || []);
                d.return = a;
                a = d;
                break a;
              } else {
                c(a, d);
                break;
              }
            } else b(a, d);
            d = d.sibling;
          }

          d = Wg(f, a.mode, h);
          d.return = a;
          a = d;
        }

        return g(a);
    }
    if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
    if (Pg(f)) return x(a, d, f, h);
    if (La(f)) return w(a, d, f, h);
    l && Rg(a, f);
    if ("undefined" === typeof f && !k) switch (a.tag) {
      case 1:
      case 22:
      case 0:
      case 11:
      case 15:
        throw Error(y(152, Ra(a.type) || "Component"));
    }
    return c(a, d);
  };
}

var Yg = Sg(!0),
    Zg = Sg(!1),
    $g = {},
    ah = Bf($g),
    bh = Bf($g),
    ch = Bf($g);

function dh(a) {
  if (a === $g) throw Error(y(174));
  return a;
}

function eh(a, b) {
  I(ch, b);
  I(bh, a);
  I(ah, $g);
  a = b.nodeType;

  switch (a) {
    case 9:
    case 11:
      b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
      break;

    default:
      a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
  }

  H(ah);
  I(ah, b);
}

function fh() {
  H(ah);
  H(bh);
  H(ch);
}

function gh(a) {
  dh(ch.current);
  var b = dh(ah.current);
  var c = mb(b, a.type);
  b !== c && (I(bh, a), I(ah, c));
}

function hh(a) {
  bh.current === a && (H(ah), H(bh));
}

var P = Bf(0);

function ih(a) {
  for (var b = a; null !== b;) {
    if (13 === b.tag) {
      var c = b.memoizedState;
      if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
    } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
      if (0 !== (b.flags & 64)) return b;
    } else if (null !== b.child) {
      b.child.return = b;
      b = b.child;
      continue;
    }

    if (b === a) break;

    for (; null === b.sibling;) {
      if (null === b.return || b.return === a) return null;
      b = b.return;
    }

    b.sibling.return = b.return;
    b = b.sibling;
  }

  return null;
}

var jh = null,
    kh = null,
    lh = !1;

function mh(a, b) {
  var c = nh(5, null, null, 0);
  c.elementType = "DELETED";
  c.type = "DELETED";
  c.stateNode = b;
  c.return = a;
  c.flags = 8;
  null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}

function oh(a, b) {
  switch (a.tag) {
    case 5:
      var c = a.type;
      b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
      return null !== b ? (a.stateNode = b, !0) : !1;

    case 6:
      return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;

    case 13:
      return !1;

    default:
      return !1;
  }
}

function ph(a) {
  if (lh) {
    var b = kh;

    if (b) {
      var c = b;

      if (!oh(a, b)) {
        b = rf(c.nextSibling);

        if (!b || !oh(a, b)) {
          a.flags = a.flags & -1025 | 2;
          lh = !1;
          jh = a;
          return;
        }

        mh(jh, c);
      }

      jh = a;
      kh = rf(b.firstChild);
    } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
  }
}

function qh(a) {
  for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;) {
    a = a.return;
  }

  jh = a;
}

function rh(a) {
  if (a !== jh) return !1;
  if (!lh) return qh(a), lh = !0, !1;
  var b = a.type;
  if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for (b = kh; b;) {
    mh(a, b), b = rf(b.nextSibling);
  }
  qh(a);

  if (13 === a.tag) {
    a = a.memoizedState;
    a = null !== a ? a.dehydrated : null;
    if (!a) throw Error(y(317));

    a: {
      a = a.nextSibling;

      for (b = 0; a;) {
        if (8 === a.nodeType) {
          var c = a.data;

          if ("/$" === c) {
            if (0 === b) {
              kh = rf(a.nextSibling);
              break a;
            }

            b--;
          } else "$" !== c && "$!" !== c && "$?" !== c || b++;
        }

        a = a.nextSibling;
      }

      kh = null;
    }
  } else kh = jh ? rf(a.stateNode.nextSibling) : null;

  return !0;
}

function sh() {
  kh = jh = null;
  lh = !1;
}

var th = [];

function uh() {
  for (var a = 0; a < th.length; a++) {
    th[a]._workInProgressVersionPrimary = null;
  }

  th.length = 0;
}

var vh = ra.ReactCurrentDispatcher,
    wh = ra.ReactCurrentBatchConfig,
    xh = 0,
    R = null,
    S = null,
    T = null,
    yh = !1,
    zh = !1;

function Ah() {
  throw Error(y(321));
}

function Bh(a, b) {
  if (null === b) return !1;

  for (var c = 0; c < b.length && c < a.length; c++) {
    if (!He(a[c], b[c])) return !1;
  }

  return !0;
}

function Ch(a, b, c, d, e, f) {
  xh = f;
  R = b;
  b.memoizedState = null;
  b.updateQueue = null;
  b.lanes = 0;
  vh.current = null === a || null === a.memoizedState ? Dh : Eh;
  a = c(d, e);

  if (zh) {
    f = 0;

    do {
      zh = !1;
      if (!(25 > f)) throw Error(y(301));
      f += 1;
      T = S = null;
      b.updateQueue = null;
      vh.current = Fh;
      a = c(d, e);
    } while (zh);
  }

  vh.current = Gh;
  b = null !== S && null !== S.next;
  xh = 0;
  T = S = R = null;
  yh = !1;
  if (b) throw Error(y(300));
  return a;
}

function Hh() {
  var a = {
    memoizedState: null,
    baseState: null,
    baseQueue: null,
    queue: null,
    next: null
  };
  null === T ? R.memoizedState = T = a : T = T.next = a;
  return T;
}

function Ih() {
  if (null === S) {
    var a = R.alternate;
    a = null !== a ? a.memoizedState : null;
  } else a = S.next;

  var b = null === T ? R.memoizedState : T.next;
  if (null !== b) T = b, S = a;else {
    if (null === a) throw Error(y(310));
    S = a;
    a = {
      memoizedState: S.memoizedState,
      baseState: S.baseState,
      baseQueue: S.baseQueue,
      queue: S.queue,
      next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
  }
  return T;
}

function Jh(a, b) {
  return "function" === typeof b ? b(a) : b;
}

function Kh(a) {
  var b = Ih(),
      c = b.queue;
  if (null === c) throw Error(y(311));
  c.lastRenderedReducer = a;
  var d = S,
      e = d.baseQueue,
      f = c.pending;

  if (null !== f) {
    if (null !== e) {
      var g = e.next;
      e.next = f.next;
      f.next = g;
    }

    d.baseQueue = e = f;
    c.pending = null;
  }

  if (null !== e) {
    e = e.next;
    d = d.baseState;
    var h = g = f = null,
        k = e;

    do {
      var l = k.lane;
      if ((xh & l) === l) null !== h && (h = h.next = {
        lane: 0,
        action: k.action,
        eagerReducer: k.eagerReducer,
        eagerState: k.eagerState,
        next: null
      }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);else {
        var n = {
          lane: l,
          action: k.action,
          eagerReducer: k.eagerReducer,
          eagerState: k.eagerState,
          next: null
        };
        null === h ? (g = h = n, f = d) : h = h.next = n;
        R.lanes |= l;
        Dg |= l;
      }
      k = k.next;
    } while (null !== k && k !== e);

    null === h ? f = d : h.next = g;
    He(d, b.memoizedState) || (ug = !0);
    b.memoizedState = d;
    b.baseState = f;
    b.baseQueue = h;
    c.lastRenderedState = d;
  }

  return [b.memoizedState, c.dispatch];
}

function Lh(a) {
  var b = Ih(),
      c = b.queue;
  if (null === c) throw Error(y(311));
  c.lastRenderedReducer = a;
  var d = c.dispatch,
      e = c.pending,
      f = b.memoizedState;

  if (null !== e) {
    c.pending = null;
    var g = e = e.next;

    do {
      f = a(f, g.action), g = g.next;
    } while (g !== e);

    He(f, b.memoizedState) || (ug = !0);
    b.memoizedState = f;
    null === b.baseQueue && (b.baseState = f);
    c.lastRenderedState = f;
  }

  return [f, d];
}

function Mh(a, b, c) {
  var d = b._getVersion;
  d = d(b._source);
  var e = b._workInProgressVersionPrimary;
  if (null !== e) a = e === d;else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
  if (a) return c(b._source);
  th.push(b);
  throw Error(y(350));
}

function Nh(a, b, c, d) {
  var e = U;
  if (null === e) throw Error(y(349));
  var f = b._getVersion,
      g = f(b._source),
      h = vh.current,
      k = h.useState(function () {
    return Mh(e, b, c);
  }),
      l = k[1],
      n = k[0];
  k = T;
  var A = a.memoizedState,
      p = A.refs,
      C = p.getSnapshot,
      x = A.source;
  A = A.subscribe;
  var w = R;
  a.memoizedState = {
    refs: p,
    source: b,
    subscribe: d
  };
  h.useEffect(function () {
    p.getSnapshot = c;
    p.setSnapshot = l;
    var a = f(b._source);

    if (!He(g, a)) {
      a = c(b._source);
      He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
      a = e.mutableReadLanes;
      e.entangledLanes |= a;

      for (var d = e.entanglements, h = a; 0 < h;) {
        var k = 31 - Vc(h),
            v = 1 << k;
        d[k] |= a;
        h &= ~v;
      }
    }
  }, [c, b, d]);
  h.useEffect(function () {
    return d(b._source, function () {
      var a = p.getSnapshot,
          c = p.setSnapshot;

      try {
        c(a(b._source));
        var d = Ig(w);
        e.mutableReadLanes |= d & e.pendingLanes;
      } catch (q) {
        c(function () {
          throw q;
        });
      }
    });
  }, [b, d]);
  He(C, c) && He(x, b) && He(A, d) || (a = {
    pending: null,
    dispatch: null,
    lastRenderedReducer: Jh,
    lastRenderedState: n
  }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
  return n;
}

function Ph(a, b, c) {
  var d = Ih();
  return Nh(d, a, b, c);
}

function Qh(a) {
  var b = Hh();
  "function" === typeof a && (a = a());
  b.memoizedState = b.baseState = a;
  a = b.queue = {
    pending: null,
    dispatch: null,
    lastRenderedReducer: Jh,
    lastRenderedState: a
  };
  a = a.dispatch = Oh.bind(null, R, a);
  return [b.memoizedState, a];
}

function Rh(a, b, c, d) {
  a = {
    tag: a,
    create: b,
    destroy: c,
    deps: d,
    next: null
  };
  b = R.updateQueue;
  null === b ? (b = {
    lastEffect: null
  }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
  return a;
}

function Sh(a) {
  var b = Hh();
  a = {
    current: a
  };
  return b.memoizedState = a;
}

function Th() {
  return Ih().memoizedState;
}

function Uh(a, b, c, d) {
  var e = Hh();
  R.flags |= a;
  e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}

function Vh(a, b, c, d) {
  var e = Ih();
  d = void 0 === d ? null : d;
  var f = void 0;

  if (null !== S) {
    var g = S.memoizedState;
    f = g.destroy;

    if (null !== d && Bh(d, g.deps)) {
      Rh(b, c, f, d);
      return;
    }
  }

  R.flags |= a;
  e.memoizedState = Rh(1 | b, c, f, d);
}

function Wh(a, b) {
  return Uh(516, 4, a, b);
}

function Xh(a, b) {
  return Vh(516, 4, a, b);
}

function Yh(a, b) {
  return Vh(4, 2, a, b);
}

function Zh(a, b) {
  if ("function" === typeof b) return a = a(), b(a), function () {
    b(null);
  };
  if (null !== b && void 0 !== b) return a = a(), b.current = a, function () {
    b.current = null;
  };
}

function $h(a, b, c) {
  c = null !== c && void 0 !== c ? c.concat([a]) : null;
  return Vh(4, 2, Zh.bind(null, b, a), c);
}

function ai() {}

function bi(a, b) {
  var c = Ih();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && Bh(b, d[1])) return d[0];
  c.memoizedState = [a, b];
  return a;
}

function ci(a, b) {
  var c = Ih();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && Bh(b, d[1])) return d[0];
  a = a();
  c.memoizedState = [a, b];
  return a;
}

function di(a, b) {
  var c = eg();
  gg(98 > c ? 98 : c, function () {
    a(!0);
  });
  gg(97 < c ? 97 : c, function () {
    var c = wh.transition;
    wh.transition = 1;

    try {
      a(!1), b();
    } finally {
      wh.transition = c;
    }
  });
}

function Oh(a, b, c) {
  var d = Hg(),
      e = Ig(a),
      f = {
    lane: e,
    action: c,
    eagerReducer: null,
    eagerState: null,
    next: null
  },
      g = b.pending;
  null === g ? f.next = f : (f.next = g.next, g.next = f);
  b.pending = f;
  g = a.alternate;
  if (a === R || null !== g && g === R) zh = yh = !0;else {
    if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
      var h = b.lastRenderedState,
          k = g(h, c);
      f.eagerReducer = g;
      f.eagerState = k;
      if (He(k, h)) return;
    } catch (l) {} finally {}
    Jg(a, e, d);
  }
}

var Gh = {
  readContext: vg,
  useCallback: Ah,
  useContext: Ah,
  useEffect: Ah,
  useImperativeHandle: Ah,
  useLayoutEffect: Ah,
  useMemo: Ah,
  useReducer: Ah,
  useRef: Ah,
  useState: Ah,
  useDebugValue: Ah,
  useDeferredValue: Ah,
  useTransition: Ah,
  useMutableSource: Ah,
  useOpaqueIdentifier: Ah,
  unstable_isNewReconciler: !1
},
    Dh = {
  readContext: vg,
  useCallback: function useCallback(a, b) {
    Hh().memoizedState = [a, void 0 === b ? null : b];
    return a;
  },
  useContext: vg,
  useEffect: Wh,
  useImperativeHandle: function useImperativeHandle(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([a]) : null;
    return Uh(4, 2, Zh.bind(null, b, a), c);
  },
  useLayoutEffect: function useLayoutEffect(a, b) {
    return Uh(4, 2, a, b);
  },
  useMemo: function useMemo(a, b) {
    var c = Hh();
    b = void 0 === b ? null : b;
    a = a();
    c.memoizedState = [a, b];
    return a;
  },
  useReducer: function useReducer(a, b, c) {
    var d = Hh();
    b = void 0 !== c ? c(b) : b;
    d.memoizedState = d.baseState = b;
    a = d.queue = {
      pending: null,
      dispatch: null,
      lastRenderedReducer: a,
      lastRenderedState: b
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [d.memoizedState, a];
  },
  useRef: Sh,
  useState: Qh,
  useDebugValue: ai,
  useDeferredValue: function useDeferredValue(a) {
    var b = Qh(a),
        c = b[0],
        d = b[1];
    Wh(function () {
      var b = wh.transition;
      wh.transition = 1;

      try {
        d(a);
      } finally {
        wh.transition = b;
      }
    }, [a]);
    return c;
  },
  useTransition: function useTransition() {
    var a = Qh(!1),
        b = a[0];
    a = di.bind(null, a[1]);
    Sh(a);
    return [a, b];
  },
  useMutableSource: function useMutableSource(a, b, c) {
    var d = Hh();
    d.memoizedState = {
      refs: {
        getSnapshot: b,
        setSnapshot: null
      },
      source: a,
      subscribe: c
    };
    return Nh(d, a, b, c);
  },
  useOpaqueIdentifier: function useOpaqueIdentifier() {
    if (lh) {
      var a = !1,
          b = uf(function () {
        a || (a = !0, c("r:" + (tf++).toString(36)));
        throw Error(y(355));
      }),
          c = Qh(b)[1];
      0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function () {
        c("r:" + (tf++).toString(36));
      }, void 0, null));
      return b;
    }

    b = "r:" + (tf++).toString(36);
    Qh(b);
    return b;
  },
  unstable_isNewReconciler: !1
},
    Eh = {
  readContext: vg,
  useCallback: bi,
  useContext: vg,
  useEffect: Xh,
  useImperativeHandle: $h,
  useLayoutEffect: Yh,
  useMemo: ci,
  useReducer: Kh,
  useRef: Th,
  useState: function useState() {
    return Kh(Jh);
  },
  useDebugValue: ai,
  useDeferredValue: function useDeferredValue(a) {
    var b = Kh(Jh),
        c = b[0],
        d = b[1];
    Xh(function () {
      var b = wh.transition;
      wh.transition = 1;

      try {
        d(a);
      } finally {
        wh.transition = b;
      }
    }, [a]);
    return c;
  },
  useTransition: function useTransition() {
    var a = Kh(Jh)[0];
    return [Th().current, a];
  },
  useMutableSource: Ph,
  useOpaqueIdentifier: function useOpaqueIdentifier() {
    return Kh(Jh)[0];
  },
  unstable_isNewReconciler: !1
},
    Fh = {
  readContext: vg,
  useCallback: bi,
  useContext: vg,
  useEffect: Xh,
  useImperativeHandle: $h,
  useLayoutEffect: Yh,
  useMemo: ci,
  useReducer: Lh,
  useRef: Th,
  useState: function useState() {
    return Lh(Jh);
  },
  useDebugValue: ai,
  useDeferredValue: function useDeferredValue(a) {
    var b = Lh(Jh),
        c = b[0],
        d = b[1];
    Xh(function () {
      var b = wh.transition;
      wh.transition = 1;

      try {
        d(a);
      } finally {
        wh.transition = b;
      }
    }, [a]);
    return c;
  },
  useTransition: function useTransition() {
    var a = Lh(Jh)[0];
    return [Th().current, a];
  },
  useMutableSource: Ph,
  useOpaqueIdentifier: function useOpaqueIdentifier() {
    return Lh(Jh)[0];
  },
  unstable_isNewReconciler: !1
},
    ei = ra.ReactCurrentOwner,
    ug = !1;

function fi(a, b, c, d) {
  b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}

function gi(a, b, c, d, e) {
  c = c.render;
  var f = b.ref;
  tg(b, e);
  d = Ch(a, b, c, d, f, e);
  if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
  b.flags |= 1;
  fi(a, b, d, e);
  return b.child;
}

function ii(a, b, c, d, e, f) {
  if (null === a) {
    var g = c.type;
    if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
    a = Vg(c.type, null, d, b, b.mode, f);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
  }

  g = a.child;
  if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
  b.flags |= 1;
  a = Tg(g, d);
  a.ref = b.ref;
  a.return = b;
  return b.child = a;
}

function ki(a, b, c, d, e, f) {
  if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);else return b.lanes = a.lanes, hi(a, b, f);
  return li(a, b, c, d, f);
}

function mi(a, b, c) {
  var d = b.pendingProps,
      e = d.children,
      f = null !== a ? a.memoizedState : null;
  if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
    if (0 === (b.mode & 4)) b.memoizedState = {
      baseLanes: 0
    }, ni(b, c);else if (0 !== (c & 1073741824)) b.memoizedState = {
      baseLanes: 0
    }, ni(b, null !== f ? f.baseLanes : c);else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
      baseLanes: a
    }, ni(b, a), null;
  } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
  fi(a, b, e, c);
  return b.child;
}

function oi(a, b) {
  var c = b.ref;
  if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}

function li(a, b, c, d, e) {
  var f = Ff(c) ? Df : M.current;
  f = Ef(b, f);
  tg(b, e);
  c = Ch(a, b, c, d, f, e);
  if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
  b.flags |= 1;
  fi(a, b, c, e);
  return b.child;
}

function pi(a, b, c, d, e) {
  if (Ff(c)) {
    var f = !0;
    Jf(b);
  } else f = !1;

  tg(b, e);
  if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;else if (null === a) {
    var g = b.stateNode,
        h = b.memoizedProps;
    g.props = h;
    var k = g.context,
        l = c.contextType;
    "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
    var n = c.getDerivedStateFromProps,
        A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
    A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
    wg = !1;
    var p = b.memoizedState;
    g.state = p;
    Cg(b, d, g, e);
    k = b.memoizedState;
    h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
  } else {
    g = b.stateNode;
    yg(a, b);
    h = b.memoizedProps;
    l = b.type === b.elementType ? h : lg(b.type, h);
    g.props = l;
    A = b.pendingProps;
    p = g.context;
    k = c.contextType;
    "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
    var C = c.getDerivedStateFromProps;
    (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
    wg = !1;
    p = b.memoizedState;
    g.state = p;
    Cg(b, d, g, e);
    var x = b.memoizedState;
    h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
  }
  return qi(a, b, c, d, f, e);
}

function qi(a, b, c, d, e, f) {
  oi(a, b);
  var g = 0 !== (b.flags & 64);
  if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
  d = b.stateNode;
  ei.current = b;
  var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
  b.flags |= 1;
  null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
  b.memoizedState = d.state;
  e && Kf(b, c, !0);
  return b.child;
}

function ri(a) {
  var b = a.stateNode;
  b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
  eh(a, b.containerInfo);
}

var si = {
  dehydrated: null,
  retryLane: 0
};

function ti(a, b, c) {
  var d = b.pendingProps,
      e = P.current,
      f = !1,
      g;
  (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
  g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
  I(P, e & 1);

  if (null === a) {
    void 0 !== d.fallback && ph(b);
    a = d.children;
    e = d.fallback;
    if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
      baseLanes: c
    }, b.memoizedState = si, a;
    if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
      baseLanes: c
    }, b.memoizedState = si, b.lanes = 33554432, a;
    c = vi({
      mode: "visible",
      children: a
    }, b.mode, c, null);
    c.return = b;
    return b.child = c;
  }

  if (null !== a.memoizedState) {
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
      baseLanes: c
    } : {
      baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
  }

  if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
    baseLanes: c
  } : {
    baseLanes: e.baseLanes | c
  }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
  c = xi(a, b, d.children, c);
  b.memoizedState = null;
  return c;
}

function ui(a, b, c, d) {
  var e = a.mode,
      f = a.child;
  b = {
    mode: "hidden",
    children: b
  };
  0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
  c = Xg(c, e, d, null);
  f.return = a;
  c.return = a;
  f.sibling = c;
  a.child = f;
  return c;
}

function xi(a, b, c, d) {
  var e = a.child;
  a = e.sibling;
  c = Tg(e, {
    mode: "visible",
    children: c
  });
  0 === (b.mode & 2) && (c.lanes = d);
  c.return = b;
  c.sibling = null;
  null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
  return b.child = c;
}

function wi(a, b, c, d, e) {
  var f = b.mode,
      g = a.child;
  a = g.sibling;
  var h = {
    mode: "hidden",
    children: c
  };
  0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
  null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
  d.return = b;
  c.return = b;
  c.sibling = d;
  b.child = c;
  return d;
}

function yi(a, b) {
  a.lanes |= b;
  var c = a.alternate;
  null !== c && (c.lanes |= b);
  sg(a.return, b);
}

function zi(a, b, c, d, e, f) {
  var g = a.memoizedState;
  null === g ? a.memoizedState = {
    isBackwards: b,
    rendering: null,
    renderingStartTime: 0,
    last: d,
    tail: c,
    tailMode: e,
    lastEffect: f
  } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}

function Ai(a, b, c) {
  var d = b.pendingProps,
      e = d.revealOrder,
      f = d.tail;
  fi(a, b, d.children, c);
  d = P.current;
  if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;else {
    if (null !== a && 0 !== (a.flags & 64)) a: for (a = b.child; null !== a;) {
      if (13 === a.tag) null !== a.memoizedState && yi(a, c);else if (19 === a.tag) yi(a, c);else if (null !== a.child) {
        a.child.return = a;
        a = a.child;
        continue;
      }
      if (a === b) break a;

      for (; null === a.sibling;) {
        if (null === a.return || a.return === b) break a;
        a = a.return;
      }

      a.sibling.return = a.return;
      a = a.sibling;
    }
    d &= 1;
  }
  I(P, d);
  if (0 === (b.mode & 2)) b.memoizedState = null;else switch (e) {
    case "forwards":
      c = b.child;

      for (e = null; null !== c;) {
        a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
      }

      c = e;
      null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
      zi(b, !1, e, c, f, b.lastEffect);
      break;

    case "backwards":
      c = null;
      e = b.child;

      for (b.child = null; null !== e;) {
        a = e.alternate;

        if (null !== a && null === ih(a)) {
          b.child = e;
          break;
        }

        a = e.sibling;
        e.sibling = c;
        c = e;
        e = a;
      }

      zi(b, !0, c, null, f, b.lastEffect);
      break;

    case "together":
      zi(b, !1, null, null, void 0, b.lastEffect);
      break;

    default:
      b.memoizedState = null;
  }
  return b.child;
}

function hi(a, b, c) {
  null !== a && (b.dependencies = a.dependencies);
  Dg |= b.lanes;

  if (0 !== (c & b.childLanes)) {
    if (null !== a && b.child !== a.child) throw Error(y(153));

    if (null !== b.child) {
      a = b.child;
      c = Tg(a, a.pendingProps);
      b.child = c;

      for (c.return = b; null !== a.sibling;) {
        a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
      }

      c.sibling = null;
    }

    return b.child;
  }

  return null;
}

var Bi, Ci, Di, Ei;

Bi = function Bi(a, b) {
  for (var c = b.child; null !== c;) {
    if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);else if (4 !== c.tag && null !== c.child) {
      c.child.return = c;
      c = c.child;
      continue;
    }
    if (c === b) break;

    for (; null === c.sibling;) {
      if (null === c.return || c.return === b) return;
      c = c.return;
    }

    c.sibling.return = c.return;
    c = c.sibling;
  }
};

Ci = function Ci() {};

Di = function Di(a, b, c, d) {
  var e = a.memoizedProps;

  if (e !== d) {
    a = b.stateNode;
    dh(ah.current);
    var f = null;

    switch (c) {
      case "input":
        e = Ya(a, e);
        d = Ya(a, d);
        f = [];
        break;

      case "option":
        e = eb(a, e);
        d = eb(a, d);
        f = [];
        break;

      case "select":
        e = m({}, e, {
          value: void 0
        });
        d = m({}, d, {
          value: void 0
        });
        f = [];
        break;

      case "textarea":
        e = gb(a, e);
        d = gb(a, d);
        f = [];
        break;

      default:
        "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
    }

    vb(c, d);
    var g;
    c = null;

    for (l in e) {
      if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) if ("style" === l) {
        var h = e[l];

        for (g in h) {
          h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
        }
      } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
    }

    for (l in d) {
      var k = d[l];
      h = null != e ? e[l] : void 0;
      if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) if ("style" === l) {
        if (h) {
          for (g in h) {
            !h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
          }

          for (g in k) {
            k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
          }
        } else c || (f || (f = []), f.push(l, c)), c = k;
      } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
    }

    c && (f = f || []).push("style", c);
    var l = f;
    if (b.updateQueue = l) b.flags |= 4;
  }
};

Ei = function Ei(a, b, c, d) {
  c !== d && (b.flags |= 4);
};

function Fi(a, b) {
  if (!lh) switch (a.tailMode) {
    case "hidden":
      b = a.tail;

      for (var c = null; null !== b;) {
        null !== b.alternate && (c = b), b = b.sibling;
      }

      null === c ? a.tail = null : c.sibling = null;
      break;

    case "collapsed":
      c = a.tail;

      for (var d = null; null !== c;) {
        null !== c.alternate && (d = c), c = c.sibling;
      }

      null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
  }
}

function Gi(a, b, c) {
  var d = b.pendingProps;

  switch (b.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return null;

    case 1:
      return Ff(b.type) && Gf(), null;

    case 3:
      fh();
      H(N);
      H(M);
      uh();
      d = b.stateNode;
      d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
      if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
      Ci(b);
      return null;

    case 5:
      hh(b);
      var e = dh(ch.current);
      c = b.type;
      if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);else {
        if (!d) {
          if (null === b.stateNode) throw Error(y(166));
          return null;
        }

        a = dh(ah.current);

        if (rh(b)) {
          d = b.stateNode;
          c = b.type;
          var f = b.memoizedProps;
          d[wf] = b;
          d[xf] = f;

          switch (c) {
            case "dialog":
              G("cancel", d);
              G("close", d);
              break;

            case "iframe":
            case "object":
            case "embed":
              G("load", d);
              break;

            case "video":
            case "audio":
              for (a = 0; a < Xe.length; a++) {
                G(Xe[a], d);
              }

              break;

            case "source":
              G("error", d);
              break;

            case "img":
            case "image":
            case "link":
              G("error", d);
              G("load", d);
              break;

            case "details":
              G("toggle", d);
              break;

            case "input":
              Za(d, f);
              G("invalid", d);
              break;

            case "select":
              d._wrapperState = {
                wasMultiple: !!f.multiple
              };
              G("invalid", d);
              break;

            case "textarea":
              hb(d, f), G("invalid", d);
          }

          vb(c, f);
          a = null;

          for (var g in f) {
            f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = ["children", e]) : "number" === typeof e && d.textContent !== "" + e && (a = ["children", "" + e]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
          }

          switch (c) {
            case "input":
              Va(d);
              cb(d, f, !0);
              break;

            case "textarea":
              Va(d);
              jb(d);
              break;

            case "select":
            case "option":
              break;

            default:
              "function" === typeof f.onClick && (d.onclick = jf);
          }

          d = a;
          b.updateQueue = d;
          null !== d && (b.flags |= 4);
        } else {
          g = 9 === e.nodeType ? e : e.ownerDocument;
          a === kb.html && (a = lb(c));
          a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
            is: d.is
          }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
          a[wf] = b;
          a[xf] = d;
          Bi(a, b, !1, !1);
          b.stateNode = a;
          g = wb(c, d);

          switch (c) {
            case "dialog":
              G("cancel", a);
              G("close", a);
              e = d;
              break;

            case "iframe":
            case "object":
            case "embed":
              G("load", a);
              e = d;
              break;

            case "video":
            case "audio":
              for (e = 0; e < Xe.length; e++) {
                G(Xe[e], a);
              }

              e = d;
              break;

            case "source":
              G("error", a);
              e = d;
              break;

            case "img":
            case "image":
            case "link":
              G("error", a);
              G("load", a);
              e = d;
              break;

            case "details":
              G("toggle", a);
              e = d;
              break;

            case "input":
              Za(a, d);
              e = Ya(a, d);
              G("invalid", a);
              break;

            case "option":
              e = eb(a, d);
              break;

            case "select":
              a._wrapperState = {
                wasMultiple: !!d.multiple
              };
              e = m({}, d, {
                value: void 0
              });
              G("invalid", a);
              break;

            case "textarea":
              hb(a, d);
              e = gb(a, d);
              G("invalid", a);
              break;

            default:
              e = d;
          }

          vb(c, e);
          var h = e;

          for (f in h) {
            if (h.hasOwnProperty(f)) {
              var k = h[f];
              "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
            }
          }

          switch (c) {
            case "input":
              Va(a);
              cb(a, d, !1);
              break;

            case "textarea":
              Va(a);
              jb(a);
              break;

            case "option":
              null != d.value && a.setAttribute("value", "" + Sa(d.value));
              break;

            case "select":
              a.multiple = !!d.multiple;
              f = d.value;
              null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
              break;

            default:
              "function" === typeof e.onClick && (a.onclick = jf);
          }

          mf(c, d) && (b.flags |= 4);
        }

        null !== b.ref && (b.flags |= 128);
      }
      return null;

    case 6:
      if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);else {
        if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
        c = dh(ch.current);
        dh(ah.current);
        rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
      }
      return null;

    case 13:
      H(P);
      d = b.memoizedState;
      if (0 !== (b.flags & 64)) return b.lanes = c, b;
      d = null !== d;
      c = !1;
      null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
      if (d && !c && 0 !== (b.mode & 2)) if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);else {
        if (0 === V || 3 === V) V = 4;
        null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
      }
      if (d || c) b.flags |= 4;
      return null;

    case 4:
      return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;

    case 10:
      return rg(b), null;

    case 17:
      return Ff(b.type) && Gf(), null;

    case 19:
      H(P);
      d = b.memoizedState;
      if (null === d) return null;
      f = 0 !== (b.flags & 64);
      g = d.rendering;
      if (null === g) {
        if (f) Fi(d, !1);else {
          if (0 !== V || null !== a && 0 !== (a.flags & 64)) for (a = b.child; null !== a;) {
            g = ih(a);

            if (null !== g) {
              b.flags |= 64;
              Fi(d, !1);
              f = g.updateQueue;
              null !== f && (b.updateQueue = f, b.flags |= 4);
              null === d.lastEffect && (b.firstEffect = null);
              b.lastEffect = d.lastEffect;
              d = c;

              for (c = b.child; null !== c;) {
                f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                  lanes: a.lanes,
                  firstContext: a.firstContext
                }), c = c.sibling;
              }

              I(P, P.current & 1 | 2);
              return b.child;
            }

            a = a.sibling;
          }
          null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
        }
      } else {
        if (!f) if (a = ih(g), null !== a) {
          if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
        } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
        d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
      }
      return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;

    case 23:
    case 24:
      return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
  }

  throw Error(y(156, b.tag));
}

function Li(a) {
  switch (a.tag) {
    case 1:
      Ff(a.type) && Gf();
      var b = a.flags;
      return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;

    case 3:
      fh();
      H(N);
      H(M);
      uh();
      b = a.flags;
      if (0 !== (b & 64)) throw Error(y(285));
      a.flags = b & -4097 | 64;
      return a;

    case 5:
      return hh(a), null;

    case 13:
      return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;

    case 19:
      return H(P), null;

    case 4:
      return fh(), null;

    case 10:
      return rg(a), null;

    case 23:
    case 24:
      return Ki(), null;

    default:
      return null;
  }
}

function Mi(a, b) {
  try {
    var c = "",
        d = b;

    do {
      c += Qa(d), d = d.return;
    } while (d);

    var e = c;
  } catch (f) {
    e = "\nError generating stack: " + f.message + "\n" + f.stack;
  }

  return {
    value: a,
    source: b,
    stack: e
  };
}

function Ni(a, b) {
  try {
    console.error(b.value);
  } catch (c) {
    setTimeout(function () {
      throw c;
    });
  }
}

var Oi = "function" === typeof WeakMap ? WeakMap : Map;

function Pi(a, b, c) {
  c = zg(-1, c);
  c.tag = 3;
  c.payload = {
    element: null
  };
  var d = b.value;

  c.callback = function () {
    Qi || (Qi = !0, Ri = d);
    Ni(a, b);
  };

  return c;
}

function Si(a, b, c) {
  c = zg(-1, c);
  c.tag = 3;
  var d = a.type.getDerivedStateFromError;

  if ("function" === typeof d) {
    var e = b.value;

    c.payload = function () {
      Ni(a, b);
      return d(e);
    };
  }

  var f = a.stateNode;
  null !== f && "function" === typeof f.componentDidCatch && (c.callback = function () {
    "function" !== typeof d && (null === Ti ? Ti = new Set([this]) : Ti.add(this), Ni(a, b));
    var c = b.stack;
    this.componentDidCatch(b.value, {
      componentStack: null !== c ? c : ""
    });
  });
  return c;
}

var Ui = "function" === typeof WeakSet ? WeakSet : Set;

function Vi(a) {
  var b = a.ref;
  if (null !== b) if ("function" === typeof b) try {
    b(null);
  } catch (c) {
    Wi(a, c);
  } else b.current = null;
}

function Xi(a, b) {
  switch (b.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      return;

    case 1:
      if (b.flags & 256 && null !== a) {
        var c = a.memoizedProps,
            d = a.memoizedState;
        a = b.stateNode;
        b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
        a.__reactInternalSnapshotBeforeUpdate = b;
      }

      return;

    case 3:
      b.flags & 256 && qf(b.stateNode.containerInfo);
      return;

    case 5:
    case 6:
    case 4:
    case 17:
      return;
  }

  throw Error(y(163));
}

function Yi(a, b, c) {
  switch (c.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      b = c.updateQueue;
      b = null !== b ? b.lastEffect : null;

      if (null !== b) {
        a = b = b.next;

        do {
          if (3 === (a.tag & 3)) {
            var d = a.create;
            a.destroy = d();
          }

          a = a.next;
        } while (a !== b);
      }

      b = c.updateQueue;
      b = null !== b ? b.lastEffect : null;

      if (null !== b) {
        a = b = b.next;

        do {
          var e = a;
          d = e.next;
          e = e.tag;
          0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
          a = d;
        } while (a !== b);
      }

      return;

    case 1:
      a = c.stateNode;
      c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
      b = c.updateQueue;
      null !== b && Eg(c, b, a);
      return;

    case 3:
      b = c.updateQueue;

      if (null !== b) {
        a = null;
        if (null !== c.child) switch (c.child.tag) {
          case 5:
            a = c.child.stateNode;
            break;

          case 1:
            a = c.child.stateNode;
        }
        Eg(c, b, a);
      }

      return;

    case 5:
      a = c.stateNode;
      null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
      return;

    case 6:
      return;

    case 4:
      return;

    case 12:
      return;

    case 13:
      null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
      return;

    case 19:
    case 17:
    case 20:
    case 21:
    case 23:
    case 24:
      return;
  }

  throw Error(y(163));
}

function aj(a, b) {
  for (var c = a;;) {
    if (5 === c.tag) {
      var d = c.stateNode;
      if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";else {
        d = c.stateNode;
        var e = c.memoizedProps.style;
        e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
        d.style.display = sb("display", e);
      }
    } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
      c.child.return = c;
      c = c.child;
      continue;
    }

    if (c === a) break;

    for (; null === c.sibling;) {
      if (null === c.return || c.return === a) return;
      c = c.return;
    }

    c.sibling.return = c.return;
    c = c.sibling;
  }
}

function bj(a, b) {
  if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
    Mf.onCommitFiberUnmount(Lf, b);
  } catch (f) {}

  switch (b.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      a = b.updateQueue;

      if (null !== a && (a = a.lastEffect, null !== a)) {
        var c = a = a.next;

        do {
          var d = c,
              e = d.destroy;
          d = d.tag;
          if (void 0 !== e) if (0 !== (d & 4)) Zi(b, c);else {
            d = b;

            try {
              e();
            } catch (f) {
              Wi(d, f);
            }
          }
          c = c.next;
        } while (c !== a);
      }

      break;

    case 1:
      Vi(b);
      a = b.stateNode;
      if ("function" === typeof a.componentWillUnmount) try {
        a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
      } catch (f) {
        Wi(b, f);
      }
      break;

    case 5:
      Vi(b);
      break;

    case 4:
      cj(a, b);
  }
}

function dj(a) {
  a.alternate = null;
  a.child = null;
  a.dependencies = null;
  a.firstEffect = null;
  a.lastEffect = null;
  a.memoizedProps = null;
  a.memoizedState = null;
  a.pendingProps = null;
  a.return = null;
  a.updateQueue = null;
}

function ej(a) {
  return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}

function fj(a) {
  a: {
    for (var b = a.return; null !== b;) {
      if (ej(b)) break a;
      b = b.return;
    }

    throw Error(y(160));
  }

  var c = b;
  b = c.stateNode;

  switch (c.tag) {
    case 5:
      var d = !1;
      break;

    case 3:
      b = b.containerInfo;
      d = !0;
      break;

    case 4:
      b = b.containerInfo;
      d = !0;
      break;

    default:
      throw Error(y(161));
  }

  c.flags & 16 && (pb(b, ""), c.flags &= -17);

  a: b: for (c = a;;) {
    for (; null === c.sibling;) {
      if (null === c.return || ej(c.return)) {
        c = null;
        break a;
      }

      c = c.return;
    }

    c.sibling.return = c.return;

    for (c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;) {
      if (c.flags & 2) continue b;
      if (null === c.child || 4 === c.tag) continue b;else c.child.return = c, c = c.child;
    }

    if (!(c.flags & 2)) {
      c = c.stateNode;
      break a;
    }
  }

  d ? gj(a, c, b) : hj(a, c, b);
}

function gj(a, b, c) {
  var d = a.tag,
      e = 5 === d || 6 === d;
  if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));else if (4 !== d && (a = a.child, null !== a)) for (gj(a, b, c), a = a.sibling; null !== a;) {
    gj(a, b, c), a = a.sibling;
  }
}

function hj(a, b, c) {
  var d = a.tag,
      e = 5 === d || 6 === d;
  if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);else if (4 !== d && (a = a.child, null !== a)) for (hj(a, b, c), a = a.sibling; null !== a;) {
    hj(a, b, c), a = a.sibling;
  }
}

function cj(a, b) {
  for (var c = b, d = !1, e, f;;) {
    if (!d) {
      d = c.return;

      a: for (;;) {
        if (null === d) throw Error(y(160));
        e = d.stateNode;

        switch (d.tag) {
          case 5:
            f = !1;
            break a;

          case 3:
            e = e.containerInfo;
            f = !0;
            break a;

          case 4:
            e = e.containerInfo;
            f = !0;
            break a;
        }

        d = d.return;
      }

      d = !0;
    }

    if (5 === c.tag || 6 === c.tag) {
      a: for (var g = a, h = c, k = h;;) {
        if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;else {
          if (k === h) break a;

          for (; null === k.sibling;) {
            if (null === k.return || k.return === h) break a;
            k = k.return;
          }

          k.sibling.return = k.return;
          k = k.sibling;
        }
      }

      f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
    } else if (4 === c.tag) {
      if (null !== c.child) {
        e = c.stateNode.containerInfo;
        f = !0;
        c.child.return = c;
        c = c.child;
        continue;
      }
    } else if (bj(a, c), null !== c.child) {
      c.child.return = c;
      c = c.child;
      continue;
    }

    if (c === b) break;

    for (; null === c.sibling;) {
      if (null === c.return || c.return === b) return;
      c = c.return;
      4 === c.tag && (d = !1);
    }

    c.sibling.return = c.return;
    c = c.sibling;
  }
}

function ij(a, b) {
  switch (b.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      var c = b.updateQueue;
      c = null !== c ? c.lastEffect : null;

      if (null !== c) {
        var d = c = c.next;

        do {
          3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
        } while (d !== c);
      }

      return;

    case 1:
      return;

    case 5:
      c = b.stateNode;

      if (null != c) {
        d = b.memoizedProps;
        var e = null !== a ? a.memoizedProps : d;
        a = b.type;
        var f = b.updateQueue;
        b.updateQueue = null;

        if (null !== f) {
          c[xf] = d;
          "input" === a && "radio" === d.type && null != d.name && $a(c, d);
          wb(a, e);
          b = wb(a, d);

          for (e = 0; e < f.length; e += 2) {
            var g = f[e],
                h = f[e + 1];
            "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
          }

          switch (a) {
            case "input":
              ab(c, d);
              break;

            case "textarea":
              ib(c, d);
              break;

            case "select":
              a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
          }
        }
      }

      return;

    case 6:
      if (null === b.stateNode) throw Error(y(162));
      b.stateNode.nodeValue = b.memoizedProps;
      return;

    case 3:
      c = b.stateNode;
      c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
      return;

    case 12:
      return;

    case 13:
      null !== b.memoizedState && (jj = O(), aj(b.child, !0));
      kj(b);
      return;

    case 19:
      kj(b);
      return;

    case 17:
      return;

    case 23:
    case 24:
      aj(b, null !== b.memoizedState);
      return;
  }

  throw Error(y(163));
}

function kj(a) {
  var b = a.updateQueue;

  if (null !== b) {
    a.updateQueue = null;
    var c = a.stateNode;
    null === c && (c = a.stateNode = new Ui());
    b.forEach(function (b) {
      var d = lj.bind(null, a, b);
      c.has(b) || (c.add(b), b.then(d, d));
    });
  }
}

function mj(a, b) {
  return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}

var nj = Math.ceil,
    oj = ra.ReactCurrentDispatcher,
    pj = ra.ReactCurrentOwner,
    X = 0,
    U = null,
    Y = null,
    W = 0,
    qj = 0,
    rj = Bf(0),
    V = 0,
    sj = null,
    tj = 0,
    Dg = 0,
    Hi = 0,
    uj = 0,
    vj = null,
    jj = 0,
    Ji = Infinity;

function wj() {
  Ji = O() + 500;
}

var Z = null,
    Qi = !1,
    Ri = null,
    Ti = null,
    xj = !1,
    yj = null,
    zj = 90,
    Aj = [],
    Bj = [],
    Cj = null,
    Dj = 0,
    Ej = null,
    Fj = -1,
    Gj = 0,
    Hj = 0,
    Ij = null,
    Jj = !1;

function Hg() {
  return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}

function Ig(a) {
  a = a.mode;
  if (0 === (a & 2)) return 1;
  if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
  0 === Gj && (Gj = tj);

  if (0 !== kg.transition) {
    0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
    a = Gj;
    var b = 4186112 & ~Hj;
    b &= -b;
    0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
    return b;
  }

  a = eg();
  0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
  return a;
}

function Jg(a, b, c) {
  if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
  a = Kj(a, b);
  if (null === a) return null;
  $c(a, b, c);
  a === U && (Hi |= b, 4 === V && Ii(a, W));
  var d = eg();
  1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([a]) : Cj.add(a)), Mj(a, c));
  vj = a;
}

function Kj(a, b) {
  a.lanes |= b;
  var c = a.alternate;
  null !== c && (c.lanes |= b);
  c = a;

  for (a = a.return; null !== a;) {
    a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
  }

  return 3 === c.tag ? c.stateNode : null;
}

function Mj(a, b) {
  for (var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;) {
    var h = 31 - Vc(g),
        k = 1 << h,
        l = f[h];

    if (-1 === l) {
      if (0 === (k & d) || 0 !== (k & e)) {
        l = b;
        Rc(k);
        var n = F;
        f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
      }
    } else l <= b && (a.expiredLanes |= k);

    g &= ~k;
  }

  d = Uc(a, a === U ? W : 0);
  b = F;
  if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);else {
    if (null !== c) {
      if (a.callbackPriority === b) return;
      c !== Zf && Pf(c);
    }

    15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [c], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
    a.callbackPriority = b;
    a.callbackNode = c;
  }
}

function Nj(a) {
  Fj = -1;
  Hj = Gj = 0;
  if (0 !== (X & 48)) throw Error(y(327));
  var b = a.callbackNode;
  if (Oj() && a.callbackNode !== b) return null;
  var c = Uc(a, a === U ? W : 0);
  if (0 === c) return null;
  var d = c;
  var e = X;
  X |= 16;
  var f = Pj();
  if (U !== a || W !== d) wj(), Qj(a, d);

  do {
    try {
      Rj();
      break;
    } catch (h) {
      Sj(a, h);
    }
  } while (1);

  qg();
  oj.current = f;
  X = e;
  null !== Y ? d = 0 : (U = null, W = 0, d = V);
  if (0 !== (tj & Hi)) Qj(a, 0);else if (0 !== d) {
    2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
    if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = c;

    switch (d) {
      case 0:
      case 1:
        throw Error(y(345));

      case 2:
        Uj(a);
        break;

      case 3:
        Ii(a, c);

        if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
          if (0 !== Uc(a, 0)) break;
          e = a.suspendedLanes;

          if ((e & c) !== c) {
            Hg();
            a.pingedLanes |= a.suspendedLanes & e;
            break;
          }

          a.timeoutHandle = of(Uj.bind(null, a), d);
          break;
        }

        Uj(a);
        break;

      case 4:
        Ii(a, c);
        if ((c & 4186112) === c) break;
        d = a.eventTimes;

        for (e = -1; 0 < c;) {
          var g = 31 - Vc(c);
          f = 1 << g;
          g = d[g];
          g > e && (e = g);
          c &= ~f;
        }

        c = e;
        c = O() - c;
        c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;

        if (10 < c) {
          a.timeoutHandle = of(Uj.bind(null, a), c);
          break;
        }

        Uj(a);
        break;

      case 5:
        Uj(a);
        break;

      default:
        throw Error(y(329));
    }
  }
  Mj(a, O());
  return a.callbackNode === b ? Nj.bind(null, a) : null;
}

function Ii(a, b) {
  b &= ~uj;
  b &= ~Hi;
  a.suspendedLanes |= b;
  a.pingedLanes &= ~b;

  for (a = a.expirationTimes; 0 < b;) {
    var c = 31 - Vc(b),
        d = 1 << c;
    a[c] = -1;
    b &= ~d;
  }
}

function Lj(a) {
  if (0 !== (X & 48)) throw Error(y(327));
  Oj();

  if (a === U && 0 !== (a.expiredLanes & W)) {
    var b = W;
    var c = Tj(a, b);
    0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
  } else b = Uc(a, 0), c = Tj(a, b);

  0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
  if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
  a.finishedWork = a.current.alternate;
  a.finishedLanes = b;
  Uj(a);
  Mj(a, O());
  return null;
}

function Vj() {
  if (null !== Cj) {
    var a = Cj;
    Cj = null;
    a.forEach(function (a) {
      a.expiredLanes |= 24 & a.pendingLanes;
      Mj(a, O());
    });
  }

  ig();
}

function Wj(a, b) {
  var c = X;
  X |= 1;

  try {
    return a(b);
  } finally {
    X = c, 0 === X && (wj(), ig());
  }
}

function Xj(a, b) {
  var c = X;
  X &= -2;
  X |= 8;

  try {
    return a(b);
  } finally {
    X = c, 0 === X && (wj(), ig());
  }
}

function ni(a, b) {
  I(rj, qj);
  qj |= b;
  tj |= b;
}

function Ki() {
  qj = rj.current;
  H(rj);
}

function Qj(a, b) {
  a.finishedWork = null;
  a.finishedLanes = 0;
  var c = a.timeoutHandle;
  -1 !== c && (a.timeoutHandle = -1, pf(c));
  if (null !== Y) for (c = Y.return; null !== c;) {
    var d = c;

    switch (d.tag) {
      case 1:
        d = d.type.childContextTypes;
        null !== d && void 0 !== d && Gf();
        break;

      case 3:
        fh();
        H(N);
        H(M);
        uh();
        break;

      case 5:
        hh(d);
        break;

      case 4:
        fh();
        break;

      case 13:
        H(P);
        break;

      case 19:
        H(P);
        break;

      case 10:
        rg(d);
        break;

      case 23:
      case 24:
        Ki();
    }

    c = c.return;
  }
  U = a;
  Y = Tg(a.current, null);
  W = qj = tj = b;
  V = 0;
  sj = null;
  uj = Hi = Dg = 0;
}

function Sj(a, b) {
  do {
    var c = Y;

    try {
      qg();
      vh.current = Gh;

      if (yh) {
        for (var d = R.memoizedState; null !== d;) {
          var e = d.queue;
          null !== e && (e.pending = null);
          d = d.next;
        }

        yh = !1;
      }

      xh = 0;
      T = S = R = null;
      zh = !1;
      pj.current = null;

      if (null === c || null === c.return) {
        V = 1;
        sj = b;
        Y = null;
        break;
      }

      a: {
        var f = a,
            g = c.return,
            h = c,
            k = b;
        b = W;
        h.flags |= 2048;
        h.firstEffect = h.lastEffect = null;

        if (null !== k && "object" === typeof k && "function" === typeof k.then) {
          var l = k;

          if (0 === (h.mode & 2)) {
            var n = h.alternate;
            n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
          }

          var A = 0 !== (P.current & 1),
              p = g;

          do {
            var C;

            if (C = 13 === p.tag) {
              var x = p.memoizedState;
              if (null !== x) C = null !== x.dehydrated ? !0 : !1;else {
                var w = p.memoizedProps;
                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
              }
            }

            if (C) {
              var z = p.updateQueue;

              if (null === z) {
                var u = new Set();
                u.add(l);
                p.updateQueue = u;
              } else z.add(l);

              if (0 === (p.mode & 2)) {
                p.flags |= 64;
                h.flags |= 16384;
                h.flags &= -2981;
                if (1 === h.tag) if (null === h.alternate) h.tag = 17;else {
                  var t = zg(-1, 1);
                  t.tag = 2;
                  Ag(h, t);
                }
                h.lanes |= 1;
                break a;
              }

              k = void 0;
              h = b;
              var q = f.pingCache;
              null === q ? (q = f.pingCache = new Oi(), k = new Set(), q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set(), q.set(l, k)));

              if (!k.has(h)) {
                k.add(h);
                var v = Yj.bind(null, f, l, h);
                l.then(v, v);
              }

              p.flags |= 4096;
              p.lanes = b;
              break a;
            }

            p = p.return;
          } while (null !== p);

          k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
        }

        5 !== V && (V = 2);
        k = Mi(k, h);
        p = g;

        do {
          switch (p.tag) {
            case 3:
              f = k;
              p.flags |= 4096;
              b &= -b;
              p.lanes |= b;
              var J = Pi(p, f, b);
              Bg(p, J);
              break a;

            case 1:
              f = k;
              var K = p.type,
                  Q = p.stateNode;

              if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                p.flags |= 4096;
                b &= -b;
                p.lanes |= b;
                var L = Si(p, f, b);
                Bg(p, L);
                break a;
              }

          }

          p = p.return;
        } while (null !== p);
      }

      Zj(c);
    } catch (va) {
      b = va;
      Y === c && null !== c && (Y = c = c.return);
      continue;
    }

    break;
  } while (1);
}

function Pj() {
  var a = oj.current;
  oj.current = Gh;
  return null === a ? Gh : a;
}

function Tj(a, b) {
  var c = X;
  X |= 16;
  var d = Pj();
  U === a && W === b || Qj(a, b);

  do {
    try {
      ak();
      break;
    } catch (e) {
      Sj(a, e);
    }
  } while (1);

  qg();
  X = c;
  oj.current = d;
  if (null !== Y) throw Error(y(261));
  U = null;
  W = 0;
  return V;
}

function ak() {
  for (; null !== Y;) {
    bk(Y);
  }
}

function Rj() {
  for (; null !== Y && !Qf();) {
    bk(Y);
  }
}

function bk(a) {
  var b = ck(a.alternate, a, qj);
  a.memoizedProps = a.pendingProps;
  null === b ? Zj(a) : Y = b;
  pj.current = null;
}

function Zj(a) {
  var b = a;

  do {
    var c = b.alternate;
    a = b.return;

    if (0 === (b.flags & 2048)) {
      c = Gi(c, b, qj);

      if (null !== c) {
        Y = c;
        return;
      }

      c = b;

      if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
        for (var d = 0, e = c.child; null !== e;) {
          d |= e.lanes | e.childLanes, e = e.sibling;
        }

        c.childLanes = d;
      }

      null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
    } else {
      c = Li(b);

      if (null !== c) {
        c.flags &= 2047;
        Y = c;
        return;
      }

      null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
    }

    b = b.sibling;

    if (null !== b) {
      Y = b;
      return;
    }

    Y = b = a;
  } while (null !== b);

  0 === V && (V = 5);
}

function Uj(a) {
  var b = eg();
  gg(99, dk.bind(null, a, b));
  return null;
}

function dk(a, b) {
  do {
    Oj();
  } while (null !== yj);

  if (0 !== (X & 48)) throw Error(y(327));
  var c = a.finishedWork;
  if (null === c) return null;
  a.finishedWork = null;
  a.finishedLanes = 0;
  if (c === a.current) throw Error(y(177));
  a.callbackNode = null;
  var d = c.lanes | c.childLanes,
      e = d,
      f = a.pendingLanes & ~e;
  a.pendingLanes = e;
  a.suspendedLanes = 0;
  a.pingedLanes = 0;
  a.expiredLanes &= e;
  a.mutableReadLanes &= e;
  a.entangledLanes &= e;
  e = a.entanglements;

  for (var g = a.eventTimes, h = a.expirationTimes; 0 < f;) {
    var k = 31 - Vc(f),
        l = 1 << k;
    e[k] = 0;
    g[k] = -1;
    h[k] = -1;
    f &= ~l;
  }

  null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
  a === U && (Y = U = null, W = 0);
  1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;

  if (null !== d) {
    e = X;
    X |= 32;
    pj.current = null;
    kf = fd;
    g = Ne();

    if (Oe(g)) {
      if ("selectionStart" in g) h = {
        start: g.selectionStart,
        end: g.selectionEnd
      };else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
        h = l.anchorNode;
        f = l.anchorOffset;
        k = l.focusNode;
        l = l.focusOffset;

        try {
          h.nodeType, k.nodeType;
        } catch (va) {
          h = null;
          break a;
        }

        var n = 0,
            A = -1,
            p = -1,
            C = 0,
            x = 0,
            w = g,
            z = null;

        b: for (;;) {
          for (var u;;) {
            w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
            w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
            3 === w.nodeType && (n += w.nodeValue.length);
            if (null === (u = w.firstChild)) break;
            z = w;
            w = u;
          }

          for (;;) {
            if (w === g) break b;
            z === h && ++C === f && (A = n);
            z === k && ++x === l && (p = n);
            if (null !== (u = w.nextSibling)) break;
            w = z;
            z = w.parentNode;
          }

          w = u;
        }

        h = -1 === A || -1 === p ? null : {
          start: A,
          end: p
        };
      } else h = null;
      h = h || {
        start: 0,
        end: 0
      };
    } else h = null;

    lf = {
      focusedElem: g,
      selectionRange: h
    };
    fd = !1;
    Ij = null;
    Jj = !1;
    Z = d;

    do {
      try {
        ek();
      } catch (va) {
        if (null === Z) throw Error(y(330));
        Wi(Z, va);
        Z = Z.nextEffect;
      }
    } while (null !== Z);

    Ij = null;
    Z = d;

    do {
      try {
        for (g = a; null !== Z;) {
          var t = Z.flags;
          t & 16 && pb(Z.stateNode, "");

          if (t & 128) {
            var q = Z.alternate;

            if (null !== q) {
              var v = q.ref;
              null !== v && ("function" === typeof v ? v(null) : v.current = null);
            }
          }

          switch (t & 1038) {
            case 2:
              fj(Z);
              Z.flags &= -3;
              break;

            case 6:
              fj(Z);
              Z.flags &= -3;
              ij(Z.alternate, Z);
              break;

            case 1024:
              Z.flags &= -1025;
              break;

            case 1028:
              Z.flags &= -1025;
              ij(Z.alternate, Z);
              break;

            case 4:
              ij(Z.alternate, Z);
              break;

            case 8:
              h = Z;
              cj(g, h);
              var J = h.alternate;
              dj(h);
              null !== J && dj(J);
          }

          Z = Z.nextEffect;
        }
      } catch (va) {
        if (null === Z) throw Error(y(330));
        Wi(Z, va);
        Z = Z.nextEffect;
      }
    } while (null !== Z);

    v = lf;
    q = Ne();
    t = v.focusedElem;
    g = v.selectionRange;

    if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
      null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
      q = [];

      for (v = t; v = v.parentNode;) {
        1 === v.nodeType && q.push({
          element: v,
          left: v.scrollLeft,
          top: v.scrollTop
        });
      }

      "function" === typeof t.focus && t.focus();

      for (t = 0; t < q.length; t++) {
        v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
      }
    }

    fd = !!kf;
    lf = kf = null;
    a.current = c;
    Z = d;

    do {
      try {
        for (t = a; null !== Z;) {
          var K = Z.flags;
          K & 36 && Yi(t, Z.alternate, Z);

          if (K & 128) {
            q = void 0;
            var Q = Z.ref;

            if (null !== Q) {
              var L = Z.stateNode;

              switch (Z.tag) {
                case 5:
                  q = L;
                  break;

                default:
                  q = L;
              }

              "function" === typeof Q ? Q(q) : Q.current = q;
            }
          }

          Z = Z.nextEffect;
        }
      } catch (va) {
        if (null === Z) throw Error(y(330));
        Wi(Z, va);
        Z = Z.nextEffect;
      }
    } while (null !== Z);

    Z = null;
    $f();
    X = e;
  } else a.current = c;

  if (xj) xj = !1, yj = a, zj = b;else for (Z = d; null !== Z;) {
    b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
  }
  d = a.pendingLanes;
  0 === d && (Ti = null);
  1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
  c = c.stateNode;
  if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
    Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
  } catch (va) {}
  Mj(a, O());
  if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
  if (0 !== (X & 8)) return null;
  ig();
  return null;
}

function ek() {
  for (; null !== Z;) {
    var a = Z.alternate;
    Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
    var b = Z.flags;
    0 !== (b & 256) && Xi(a, Z);
    0 === (b & 512) || xj || (xj = !0, hg(97, function () {
      Oj();
      return null;
    }));
    Z = Z.nextEffect;
  }
}

function Oj() {
  if (90 !== zj) {
    var a = 97 < zj ? 97 : zj;
    zj = 90;
    return gg(a, fk);
  }

  return !1;
}

function $i(a, b) {
  Aj.push(b, a);
  xj || (xj = !0, hg(97, function () {
    Oj();
    return null;
  }));
}

function Zi(a, b) {
  Bj.push(b, a);
  xj || (xj = !0, hg(97, function () {
    Oj();
    return null;
  }));
}

function fk() {
  if (null === yj) return !1;
  var a = yj;
  yj = null;
  if (0 !== (X & 48)) throw Error(y(331));
  var b = X;
  X |= 32;
  var c = Bj;
  Bj = [];

  for (var d = 0; d < c.length; d += 2) {
    var e = c[d],
        f = c[d + 1],
        g = e.destroy;
    e.destroy = void 0;
    if ("function" === typeof g) try {
      g();
    } catch (k) {
      if (null === f) throw Error(y(330));
      Wi(f, k);
    }
  }

  c = Aj;
  Aj = [];

  for (d = 0; d < c.length; d += 2) {
    e = c[d];
    f = c[d + 1];

    try {
      var h = e.create;
      e.destroy = h();
    } catch (k) {
      if (null === f) throw Error(y(330));
      Wi(f, k);
    }
  }

  for (h = a.current.firstEffect; null !== h;) {
    a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
  }

  X = b;
  ig();
  return !0;
}

function gk(a, b, c) {
  b = Mi(c, b);
  b = Pi(a, b, 1);
  Ag(a, b);
  b = Hg();
  a = Kj(a, 1);
  null !== a && ($c(a, 1, b), Mj(a, b));
}

function Wi(a, b) {
  if (3 === a.tag) gk(a, a, b);else for (var c = a.return; null !== c;) {
    if (3 === c.tag) {
      gk(c, a, b);
      break;
    } else if (1 === c.tag) {
      var d = c.stateNode;

      if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
        a = Mi(b, a);
        var e = Si(c, a, 1);
        Ag(c, e);
        e = Hg();
        c = Kj(c, 1);
        if (null !== c) $c(c, 1, e), Mj(c, e);else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
          d.componentDidCatch(b, a);
        } catch (f) {}
        break;
      }
    }

    c = c.return;
  }
}

function Yj(a, b, c) {
  var d = a.pingCache;
  null !== d && d.delete(b);
  b = Hg();
  a.pingedLanes |= a.suspendedLanes & c;
  U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
  Mj(a, b);
}

function lj(a, b) {
  var c = a.stateNode;
  null !== c && c.delete(b);
  b = 0;
  0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
  c = Hg();
  a = Kj(a, b);
  null !== a && ($c(a, b, c), Mj(a, c));
}

var ck;

ck = function ck(a, b, c) {
  var d = b.lanes;
  if (null !== a) {
    if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;else {
      ug = !1;

      switch (b.tag) {
        case 3:
          ri(b);
          sh();
          break;

        case 5:
          gh(b);
          break;

        case 1:
          Ff(b.type) && Jf(b);
          break;

        case 4:
          eh(b, b.stateNode.containerInfo);
          break;

        case 10:
          d = b.memoizedProps.value;
          var e = b.type._context;
          I(mg, e._currentValue);
          e._currentValue = d;
          break;

        case 13:
          if (null !== b.memoizedState) {
            if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
            I(P, P.current & 1);
            b = hi(a, b, c);
            return null !== b ? b.sibling : null;
          }

          I(P, P.current & 1);
          break;

        case 19:
          d = 0 !== (c & b.childLanes);

          if (0 !== (a.flags & 64)) {
            if (d) return Ai(a, b, c);
            b.flags |= 64;
          }

          e = b.memoizedState;
          null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
          I(P, P.current);
          if (d) break;else return null;

        case 23:
        case 24:
          return b.lanes = 0, mi(a, b, c);
      }

      return hi(a, b, c);
    }
  } else ug = !1;
  b.lanes = 0;

  switch (b.tag) {
    case 2:
      d = b.type;
      null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
      a = b.pendingProps;
      e = Ef(b, M.current);
      tg(b, c);
      e = Ch(null, b, d, a, e, c);
      b.flags |= 1;

      if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
        b.tag = 1;
        b.memoizedState = null;
        b.updateQueue = null;

        if (Ff(d)) {
          var f = !0;
          Jf(b);
        } else f = !1;

        b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
        xg(b);
        var g = d.getDerivedStateFromProps;
        "function" === typeof g && Gg(b, d, g, a);
        e.updater = Kg;
        b.stateNode = e;
        e._reactInternals = b;
        Og(b, d, a, c);
        b = qi(null, b, d, !0, f, c);
      } else b.tag = 0, fi(null, b, e, c), b = b.child;

      return b;

    case 16:
      e = b.elementType;

      a: {
        null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
        a = b.pendingProps;
        f = e._init;
        e = f(e._payload);
        b.type = e;
        f = b.tag = hk(e);
        a = lg(e, a);

        switch (f) {
          case 0:
            b = li(null, b, e, a, c);
            break a;

          case 1:
            b = pi(null, b, e, a, c);
            break a;

          case 11:
            b = gi(null, b, e, a, c);
            break a;

          case 14:
            b = ii(null, b, e, lg(e.type, a), d, c);
            break a;
        }

        throw Error(y(306, e, ""));
      }

      return b;

    case 0:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);

    case 1:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);

    case 3:
      ri(b);
      d = b.updateQueue;
      if (null === a || null === d) throw Error(y(282));
      d = b.pendingProps;
      e = b.memoizedState;
      e = null !== e ? e.element : null;
      yg(a, b);
      Cg(b, d, null, c);
      d = b.memoizedState.element;
      if (d === e) sh(), b = hi(a, b, c);else {
        e = b.stateNode;
        if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;

        if (f) {
          a = e.mutableSourceEagerHydrationData;
          if (null != a) for (e = 0; e < a.length; e += 2) {
            f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
          }
          c = Zg(b, null, d, c);

          for (b.child = c; c;) {
            c.flags = c.flags & -3 | 1024, c = c.sibling;
          }
        } else fi(a, b, d, c), sh();

        b = b.child;
      }
      return b;

    case 5:
      return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;

    case 6:
      return null === a && ph(b), null;

    case 13:
      return ti(a, b, c);

    case 4:
      return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;

    case 11:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);

    case 7:
      return fi(a, b, b.pendingProps, c), b.child;

    case 8:
      return fi(a, b, b.pendingProps.children, c), b.child;

    case 12:
      return fi(a, b, b.pendingProps.children, c), b.child;

    case 10:
      a: {
        d = b.type._context;
        e = b.pendingProps;
        g = b.memoizedProps;
        f = e.value;
        var h = b.type._context;
        I(mg, h._currentValue);
        h._currentValue = f;
        if (null !== g) if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
          if (g.children === e.children && !N.current) {
            b = hi(a, b, c);
            break a;
          }
        } else for (h = b.child, null !== h && (h.return = b); null !== h;) {
          var k = h.dependencies;

          if (null !== k) {
            g = h.child;

            for (var l = k.firstContext; null !== l;) {
              if (l.context === d && 0 !== (l.observedBits & f)) {
                1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                h.lanes |= c;
                l = h.alternate;
                null !== l && (l.lanes |= c);
                sg(h.return, c);
                k.lanes |= c;
                break;
              }

              l = l.next;
            }
          } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;

          if (null !== g) g.return = h;else for (g = h; null !== g;) {
            if (g === b) {
              g = null;
              break;
            }

            h = g.sibling;

            if (null !== h) {
              h.return = g.return;
              g = h;
              break;
            }

            g = g.return;
          }
          h = g;
        }
        fi(a, b, e.children, c);
        b = b.child;
      }

      return b;

    case 9:
      return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;

    case 14:
      return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);

    case 15:
      return ki(a, b, b.type, b.pendingProps, d, c);

    case 17:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);

    case 19:
      return Ai(a, b, c);

    case 23:
      return mi(a, b, c);

    case 24:
      return mi(a, b, c);
  }

  throw Error(y(156, b.tag));
};

function ik(a, b, c, d) {
  this.tag = a;
  this.key = c;
  this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
  this.index = 0;
  this.ref = null;
  this.pendingProps = b;
  this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
  this.mode = d;
  this.flags = 0;
  this.lastEffect = this.firstEffect = this.nextEffect = null;
  this.childLanes = this.lanes = 0;
  this.alternate = null;
}

function nh(a, b, c, d) {
  return new ik(a, b, c, d);
}

function ji(a) {
  a = a.prototype;
  return !(!a || !a.isReactComponent);
}

function hk(a) {
  if ("function" === typeof a) return ji(a) ? 1 : 0;

  if (void 0 !== a && null !== a) {
    a = a.$$typeof;
    if (a === Aa) return 11;
    if (a === Da) return 14;
  }

  return 2;
}

function Tg(a, b) {
  var c = a.alternate;
  null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
  c.childLanes = a.childLanes;
  c.lanes = a.lanes;
  c.child = a.child;
  c.memoizedProps = a.memoizedProps;
  c.memoizedState = a.memoizedState;
  c.updateQueue = a.updateQueue;
  b = a.dependencies;
  c.dependencies = null === b ? null : {
    lanes: b.lanes,
    firstContext: b.firstContext
  };
  c.sibling = a.sibling;
  c.index = a.index;
  c.ref = a.ref;
  return c;
}

function Vg(a, b, c, d, e, f) {
  var g = 2;
  d = a;
  if ("function" === typeof a) ji(a) && (g = 1);else if ("string" === typeof a) g = 5;else a: switch (a) {
    case ua:
      return Xg(c.children, e, f, b);

    case Ha:
      g = 8;
      e |= 16;
      break;

    case wa:
      g = 8;
      e |= 1;
      break;

    case xa:
      return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;

    case Ba:
      return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;

    case Ca:
      return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;

    case Ia:
      return vi(c, e, f, b);

    case Ja:
      return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;

    default:
      if ("object" === typeof a && null !== a) switch (a.$$typeof) {
        case ya:
          g = 10;
          break a;

        case za:
          g = 9;
          break a;

        case Aa:
          g = 11;
          break a;

        case Da:
          g = 14;
          break a;

        case Ea:
          g = 16;
          d = null;
          break a;

        case Fa:
          g = 22;
          break a;
      }
      throw Error(y(130, null == a ? a : typeof a, ""));
  }
  b = nh(g, c, b, e);
  b.elementType = a;
  b.type = d;
  b.lanes = f;
  return b;
}

function Xg(a, b, c, d) {
  a = nh(7, a, d, b);
  a.lanes = c;
  return a;
}

function vi(a, b, c, d) {
  a = nh(23, a, d, b);
  a.elementType = Ia;
  a.lanes = c;
  return a;
}

function Ug(a, b, c) {
  a = nh(6, a, null, b);
  a.lanes = c;
  return a;
}

function Wg(a, b, c) {
  b = nh(4, null !== a.children ? a.children : [], a.key, b);
  b.lanes = c;
  b.stateNode = {
    containerInfo: a.containerInfo,
    pendingChildren: null,
    implementation: a.implementation
  };
  return b;
}

function jk(a, b, c) {
  this.tag = b;
  this.containerInfo = a;
  this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
  this.timeoutHandle = -1;
  this.pendingContext = this.context = null;
  this.hydrate = c;
  this.callbackNode = null;
  this.callbackPriority = 0;
  this.eventTimes = Zc(0);
  this.expirationTimes = Zc(-1);
  this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
  this.entanglements = Zc(0);
  this.mutableSourceEagerHydrationData = null;
}

function kk(a, b, c) {
  var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
  return {
    $$typeof: ta,
    key: null == d ? null : "" + d,
    children: a,
    containerInfo: b,
    implementation: c
  };
}

function lk(a, b, c, d) {
  var e = b.current,
      f = Hg(),
      g = Ig(e);

  a: if (c) {
    c = c._reactInternals;

    b: {
      if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
      var h = c;

      do {
        switch (h.tag) {
          case 3:
            h = h.stateNode.context;
            break b;

          case 1:
            if (Ff(h.type)) {
              h = h.stateNode.__reactInternalMemoizedMergedChildContext;
              break b;
            }

        }

        h = h.return;
      } while (null !== h);

      throw Error(y(171));
    }

    if (1 === c.tag) {
      var k = c.type;

      if (Ff(k)) {
        c = If(c, k, h);
        break a;
      }
    }

    c = h;
  } else c = Cf;

  null === b.context ? b.context = c : b.pendingContext = c;
  b = zg(f, g);
  b.payload = {
    element: a
  };
  d = void 0 === d ? null : d;
  null !== d && (b.callback = d);
  Ag(e, b);
  Jg(e, g, f);
  return g;
}

function mk(a) {
  a = a.current;
  if (!a.child) return null;

  switch (a.child.tag) {
    case 5:
      return a.child.stateNode;

    default:
      return a.child.stateNode;
  }
}

function nk(a, b) {
  a = a.memoizedState;

  if (null !== a && null !== a.dehydrated) {
    var c = a.retryLane;
    a.retryLane = 0 !== c && c < b ? c : b;
  }
}

function ok(a, b) {
  nk(a, b);
  (a = a.alternate) && nk(a, b);
}

function pk() {
  return null;
}

function qk(a, b, c) {
  var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
  c = new jk(a, b, null != c && !0 === c.hydrate);
  b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
  c.current = b;
  b.stateNode = c;
  xg(b);
  a[ff] = c.current;
  cf(8 === a.nodeType ? a.parentNode : a);
  if (d) for (a = 0; a < d.length; a++) {
    b = d[a];
    var e = b._getVersion;
    e = e(b._source);
    null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [b, e] : c.mutableSourceEagerHydrationData.push(b, e);
  }
  this._internalRoot = c;
}

qk.prototype.render = function (a) {
  lk(a, this._internalRoot, null, null);
};

qk.prototype.unmount = function () {
  var a = this._internalRoot,
      b = a.containerInfo;
  lk(null, a, null, function () {
    b[ff] = null;
  });
};

function rk(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}

function sk(a, b) {
  b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
  if (!b) for (var c; c = a.lastChild;) {
    a.removeChild(c);
  }
  return new qk(a, 0, b ? {
    hydrate: !0
  } : void 0);
}

function tk(a, b, c, d, e) {
  var f = c._reactRootContainer;

  if (f) {
    var g = f._internalRoot;

    if ("function" === typeof e) {
      var h = e;

      e = function e() {
        var a = mk(g);
        h.call(a);
      };
    }

    lk(b, g, a, e);
  } else {
    f = c._reactRootContainer = sk(c, d);
    g = f._internalRoot;

    if ("function" === typeof e) {
      var k = e;

      e = function e() {
        var a = mk(g);
        k.call(a);
      };
    }

    Xj(function () {
      lk(b, g, a, e);
    });
  }

  return mk(g);
}

ec = function ec(a) {
  if (13 === a.tag) {
    var b = Hg();
    Jg(a, 4, b);
    ok(a, 4);
  }
};

fc = function fc(a) {
  if (13 === a.tag) {
    var b = Hg();
    Jg(a, 67108864, b);
    ok(a, 67108864);
  }
};

gc = function gc(a) {
  if (13 === a.tag) {
    var b = Hg(),
        c = Ig(a);
    Jg(a, c, b);
    ok(a, c);
  }
};

hc = function hc(a, b) {
  return b();
};

yb = function yb(a, b, c) {
  switch (b) {
    case "input":
      ab(a, c);
      b = c.name;

      if ("radio" === c.type && null != b) {
        for (c = a; c.parentNode;) {
          c = c.parentNode;
        }

        c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');

        for (b = 0; b < c.length; b++) {
          var d = c[b];

          if (d !== a && d.form === a.form) {
            var e = Db(d);
            if (!e) throw Error(y(90));
            Wa(d);
            ab(d, e);
          }
        }
      }

      break;

    case "textarea":
      ib(a, c);
      break;

    case "select":
      b = c.value, null != b && fb(a, !!c.multiple, b, !1);
  }
};

Gb = Wj;

Hb = function Hb(a, b, c, d, e) {
  var f = X;
  X |= 4;

  try {
    return gg(98, a.bind(null, b, c, d, e));
  } finally {
    X = f, 0 === X && (wj(), ig());
  }
};

Ib = function Ib() {
  0 === (X & 49) && (Vj(), Oj());
};

Jb = function Jb(a, b) {
  var c = X;
  X |= 2;

  try {
    return a(b);
  } finally {
    X = c, 0 === X && (wj(), ig());
  }
};

function uk(a, b) {
  var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
  if (!rk(b)) throw Error(y(200));
  return kk(a, b, null, c);
}

var vk = {
  Events: [Cb, ue, Db, Eb, Fb, Oj, {
    current: !1
  }]
},
    wk = {
  findFiberByHostInstance: wc,
  bundleType: 0,
  version: "17.0.2",
  rendererPackageName: "react-dom"
};
var xk = {
  bundleType: wk.bundleType,
  version: wk.version,
  rendererPackageName: wk.rendererPackageName,
  rendererConfig: wk.rendererConfig,
  overrideHookState: null,
  overrideHookStateDeletePath: null,
  overrideHookStateRenamePath: null,
  overrideProps: null,
  overridePropsDeletePath: null,
  overridePropsRenamePath: null,
  setSuspenseHandler: null,
  scheduleUpdate: null,
  currentDispatcherRef: ra.ReactCurrentDispatcher,
  findHostInstanceByFiber: function findHostInstanceByFiber(a) {
    a = cc(a);
    return null === a ? null : a.stateNode;
  },
  findFiberByHostInstance: wk.findFiberByHostInstance || pk,
  findHostInstancesForRefresh: null,
  scheduleRefresh: null,
  scheduleRoot: null,
  setRefreshHandler: null,
  getCurrentFiber: null
};

if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
  var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!yk.isDisabled && yk.supportsFiber) try {
    Lf = yk.inject(xk), Mf = yk;
  } catch (a) {}
}

exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;

exports.findDOMNode = function (a) {
  if (null == a) return null;
  if (1 === a.nodeType) return a;
  var b = a._reactInternals;

  if (void 0 === b) {
    if ("function" === typeof a.render) throw Error(y(188));
    throw Error(y(268, Object.keys(a)));
  }

  a = cc(b);
  a = null === a ? null : a.stateNode;
  return a;
};

exports.flushSync = function (a, b) {
  var c = X;
  if (0 !== (c & 48)) return a(b);
  X |= 1;

  try {
    if (a) return gg(99, a.bind(null, b));
  } finally {
    X = c, ig();
  }
};

exports.hydrate = function (a, b, c) {
  if (!rk(b)) throw Error(y(200));
  return tk(null, a, b, !0, c);
};

exports.render = function (a, b, c) {
  if (!rk(b)) throw Error(y(200));
  return tk(null, a, b, !1, c);
};

exports.unmountComponentAtNode = function (a) {
  if (!rk(a)) throw Error(y(40));
  return a._reactRootContainer ? (Xj(function () {
    tk(null, null, a, !1, function () {
      a._reactRootContainer = null;
      a[ff] = null;
    });
  }), !0) : !1;
};

exports.unstable_batchedUpdates = Wj;

exports.unstable_createPortal = function (a, b) {
  return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};

exports.unstable_renderSubtreeIntoContainer = function (a, b, c, d) {
  if (!rk(c)) throw Error(y(200));
  if (null == a || void 0 === a._reactInternals) throw Error(y(38));
  return tk(a, b, c, !1, d);
};

exports.version = "17.0.2";

/***/ }),

/***/ 164:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') {
    return;
  }

  if (false) {}

  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(463);
} else {}

/***/ }),

/***/ 374:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


__webpack_require__(725);

var f = __webpack_require__(791),
    g = 60103;

exports.Fragment = 60107;

if ("function" === typeof Symbol && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  exports.Fragment = h("react.fragment");
}

var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    n = Object.prototype.hasOwnProperty,
    p = {
  key: !0,
  ref: !0,
  __self: !0,
  __source: !0
};

function q(c, a, k) {
  var b,
      d = {},
      e = null,
      l = null;
  void 0 !== k && (e = "" + k);
  void 0 !== a.key && (e = "" + a.key);
  void 0 !== a.ref && (l = a.ref);

  for (b in a) {
    n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  }

  if (c && c.defaultProps) for (b in a = c.defaultProps, a) {
    void 0 === d[b] && (d[b] = a[b]);
  }
  return {
    $$typeof: g,
    type: c,
    key: e,
    ref: l,
    props: d,
    _owner: m.current
  };
}

exports.jsx = q;
exports.jsxs = q;

/***/ }),

/***/ 117:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var l = __webpack_require__(725),
    n = 60103,
    p = 60106;

exports.Fragment = 60107;
exports.StrictMode = 60108;
exports.Profiler = 60114;
var q = 60109,
    r = 60110,
    t = 60112;
exports.Suspense = 60113;
var u = 60115,
    v = 60116;

if ("function" === typeof Symbol && Symbol.for) {
  var w = Symbol.for;
  n = w("react.element");
  p = w("react.portal");
  exports.Fragment = w("react.fragment");
  exports.StrictMode = w("react.strict_mode");
  exports.Profiler = w("react.profiler");
  q = w("react.provider");
  r = w("react.context");
  t = w("react.forward_ref");
  exports.Suspense = w("react.suspense");
  u = w("react.memo");
  v = w("react.lazy");
}

var x = "function" === typeof Symbol && Symbol.iterator;

function y(a) {
  if (null === a || "object" !== typeof a) return null;
  a = x && a[x] || a["@@iterator"];
  return "function" === typeof a ? a : null;
}

function z(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) {
    b += "&args[]=" + encodeURIComponent(arguments[c]);
  }

  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}

var A = {
  isMounted: function isMounted() {
    return !1;
  },
  enqueueForceUpdate: function enqueueForceUpdate() {},
  enqueueReplaceState: function enqueueReplaceState() {},
  enqueueSetState: function enqueueSetState() {}
},
    B = {};

function C(a, b, c) {
  this.props = a;
  this.context = b;
  this.refs = B;
  this.updater = c || A;
}

C.prototype.isReactComponent = {};

C.prototype.setState = function (a, b) {
  if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error(z(85));
  this.updater.enqueueSetState(this, a, b, "setState");
};

C.prototype.forceUpdate = function (a) {
  this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};

function D() {}

D.prototype = C.prototype;

function E(a, b, c) {
  this.props = a;
  this.context = b;
  this.refs = B;
  this.updater = c || A;
}

var F = E.prototype = new D();
F.constructor = E;
l(F, C.prototype);
F.isPureReactComponent = !0;
var G = {
  current: null
},
    H = Object.prototype.hasOwnProperty,
    I = {
  key: !0,
  ref: !0,
  __self: !0,
  __source: !0
};

function J(a, b, c) {
  var e,
      d = {},
      k = null,
      h = null;
  if (null != b) for (e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b) {
    H.call(b, e) && !I.hasOwnProperty(e) && (d[e] = b[e]);
  }
  var g = arguments.length - 2;
  if (1 === g) d.children = c;else if (1 < g) {
    for (var f = Array(g), m = 0; m < g; m++) {
      f[m] = arguments[m + 2];
    }

    d.children = f;
  }
  if (a && a.defaultProps) for (e in g = a.defaultProps, g) {
    void 0 === d[e] && (d[e] = g[e]);
  }
  return {
    $$typeof: n,
    type: a,
    key: k,
    ref: h,
    props: d,
    _owner: G.current
  };
}

function K(a, b) {
  return {
    $$typeof: n,
    type: a.type,
    key: b,
    ref: a.ref,
    props: a.props,
    _owner: a._owner
  };
}

function L(a) {
  return "object" === typeof a && null !== a && a.$$typeof === n;
}

function escape(a) {
  var b = {
    "=": "=0",
    ":": "=2"
  };
  return "$" + a.replace(/[=:]/g, function (a) {
    return b[a];
  });
}

var M = /\/+/g;

function N(a, b) {
  return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}

function O(a, b, c, e, d) {
  var k = typeof a;
  if ("undefined" === k || "boolean" === k) a = null;
  var h = !1;
  if (null === a) h = !0;else switch (k) {
    case "string":
    case "number":
      h = !0;
      break;

    case "object":
      switch (a.$$typeof) {
        case n:
        case p:
          h = !0;
      }

  }
  if (h) return h = a, d = d(h), a = "" === e ? "." + N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace(M, "$&/") + "/"), O(d, b, c, "", function (a) {
    return a;
  })) : null != d && (L(d) && (d = K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace(M, "$&/") + "/") + a)), b.push(d)), 1;
  h = 0;
  e = "" === e ? "." : e + ":";
  if (Array.isArray(a)) for (var g = 0; g < a.length; g++) {
    k = a[g];
    var f = e + N(k, g);
    h += O(k, b, c, f, d);
  } else if (f = y(a), "function" === typeof f) for (a = f.call(a), g = 0; !(k = a.next()).done;) {
    k = k.value, f = e + N(k, g++), h += O(k, b, c, f, d);
  } else if ("object" === k) throw b = "" + a, Error(z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
  return h;
}

function P(a, b, c) {
  if (null == a) return a;
  var e = [],
      d = 0;
  O(a, e, "", "", function (a) {
    return b.call(c, a, d++);
  });
  return e;
}

function Q(a) {
  if (-1 === a._status) {
    var b = a._result;
    b = b();
    a._status = 0;
    a._result = b;
    b.then(function (b) {
      0 === a._status && (b = b.default, a._status = 1, a._result = b);
    }, function (b) {
      0 === a._status && (a._status = 2, a._result = b);
    });
  }

  if (1 === a._status) return a._result;
  throw a._result;
}

var R = {
  current: null
};

function S() {
  var a = R.current;
  if (null === a) throw Error(z(321));
  return a;
}

var T = {
  ReactCurrentDispatcher: R,
  ReactCurrentBatchConfig: {
    transition: 0
  },
  ReactCurrentOwner: G,
  IsSomeRendererActing: {
    current: !1
  },
  assign: l
};
exports.Children = {
  map: P,
  forEach: function forEach(a, b, c) {
    P(a, function () {
      b.apply(this, arguments);
    }, c);
  },
  count: function count(a) {
    var b = 0;
    P(a, function () {
      b++;
    });
    return b;
  },
  toArray: function toArray(a) {
    return P(a, function (a) {
      return a;
    }) || [];
  },
  only: function only(a) {
    if (!L(a)) throw Error(z(143));
    return a;
  }
};
exports.Component = C;
exports.PureComponent = E;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = T;

exports.cloneElement = function (a, b, c) {
  if (null === a || void 0 === a) throw Error(z(267, a));
  var e = l({}, a.props),
      d = a.key,
      k = a.ref,
      h = a._owner;

  if (null != b) {
    void 0 !== b.ref && (k = b.ref, h = G.current);
    void 0 !== b.key && (d = "" + b.key);
    if (a.type && a.type.defaultProps) var g = a.type.defaultProps;

    for (f in b) {
      H.call(b, f) && !I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
  }

  var f = arguments.length - 2;
  if (1 === f) e.children = c;else if (1 < f) {
    g = Array(f);

    for (var m = 0; m < f; m++) {
      g[m] = arguments[m + 2];
    }

    e.children = g;
  }
  return {
    $$typeof: n,
    type: a.type,
    key: d,
    ref: k,
    props: e,
    _owner: h
  };
};

exports.createContext = function (a, b) {
  void 0 === b && (b = null);
  a = {
    $$typeof: r,
    _calculateChangedBits: b,
    _currentValue: a,
    _currentValue2: a,
    _threadCount: 0,
    Provider: null,
    Consumer: null
  };
  a.Provider = {
    $$typeof: q,
    _context: a
  };
  return a.Consumer = a;
};

exports.createElement = J;

exports.createFactory = function (a) {
  var b = J.bind(null, a);
  b.type = a;
  return b;
};

exports.createRef = function () {
  return {
    current: null
  };
};

exports.forwardRef = function (a) {
  return {
    $$typeof: t,
    render: a
  };
};

exports.isValidElement = L;

exports.lazy = function (a) {
  return {
    $$typeof: v,
    _payload: {
      _status: -1,
      _result: a
    },
    _init: Q
  };
};

exports.memo = function (a, b) {
  return {
    $$typeof: u,
    type: a,
    compare: void 0 === b ? null : b
  };
};

exports.useCallback = function (a, b) {
  return S().useCallback(a, b);
};

exports.useContext = function (a, b) {
  return S().useContext(a, b);
};

exports.useDebugValue = function () {};

exports.useEffect = function (a, b) {
  return S().useEffect(a, b);
};

exports.useImperativeHandle = function (a, b, c) {
  return S().useImperativeHandle(a, b, c);
};

exports.useLayoutEffect = function (a, b) {
  return S().useLayoutEffect(a, b);
};

exports.useMemo = function (a, b) {
  return S().useMemo(a, b);
};

exports.useReducer = function (a, b, c) {
  return S().useReducer(a, b, c);
};

exports.useRef = function (a) {
  return S().useRef(a);
};

exports.useState = function (a) {
  return S().useState(a);
};

exports.version = "17.0.2";

/***/ }),

/***/ 791:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



if (true) {
  module.exports = __webpack_require__(117);
} else {}

/***/ }),

/***/ 184:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



if (true) {
  module.exports = __webpack_require__(374);
} else {}

/***/ }),

/***/ 813:
/***/ (function(__unused_webpack_module, exports) {

/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var _f, g, h, k;

if ("object" === typeof performance && "function" === typeof performance.now) {
  var l = performance;

  exports.unstable_now = function () {
    return l.now();
  };
} else {
  var p = Date,
      q = p.now();

  exports.unstable_now = function () {
    return p.now() - q;
  };
}

if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
  var t = null,
      u = null,
      w = function w() {
    if (null !== t) try {
      var a = exports.unstable_now();
      t(!0, a);
      t = null;
    } catch (b) {
      throw setTimeout(w, 0), b;
    }
  };

  _f = function f(a) {
    null !== t ? setTimeout(_f, 0, a) : (t = a, setTimeout(w, 0));
  };

  g = function g(a, b) {
    u = setTimeout(a, b);
  };

  h = function h() {
    clearTimeout(u);
  };

  exports.unstable_shouldYield = function () {
    return !1;
  };

  k = exports.unstable_forceFrameRate = function () {};
} else {
  var x = window.setTimeout,
      y = window.clearTimeout;

  if ("undefined" !== typeof console) {
    var z = window.cancelAnimationFrame;
    "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    "function" !== typeof z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
  }

  var A = !1,
      B = null,
      C = -1,
      D = 5,
      E = 0;

  exports.unstable_shouldYield = function () {
    return exports.unstable_now() >= E;
  };

  k = function k() {};

  exports.unstable_forceFrameRate = function (a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : D = 0 < a ? Math.floor(1E3 / a) : 5;
  };

  var F = new MessageChannel(),
      G = F.port2;

  F.port1.onmessage = function () {
    if (null !== B) {
      var a = exports.unstable_now();
      E = a + D;

      try {
        B(!0, a) ? G.postMessage(null) : (A = !1, B = null);
      } catch (b) {
        throw G.postMessage(null), b;
      }
    } else A = !1;
  };

  _f = function _f(a) {
    B = a;
    A || (A = !0, G.postMessage(null));
  };

  g = function g(a, b) {
    C = x(function () {
      a(exports.unstable_now());
    }, b);
  };

  h = function h() {
    y(C);
    C = -1;
  };
}

function H(a, b) {
  var c = a.length;
  a.push(b);

  a: for (;;) {
    var d = c - 1 >>> 1,
        e = a[d];
    if (void 0 !== e && 0 < I(e, b)) a[d] = b, a[c] = e, c = d;else break a;
  }
}

function J(a) {
  a = a[0];
  return void 0 === a ? null : a;
}

function K(a) {
  var b = a[0];

  if (void 0 !== b) {
    var c = a.pop();

    if (c !== b) {
      a[0] = c;

      a: for (var d = 0, e = a.length; d < e;) {
        var m = 2 * (d + 1) - 1,
            n = a[m],
            v = m + 1,
            r = a[v];
        if (void 0 !== n && 0 > I(n, c)) void 0 !== r && 0 > I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);else if (void 0 !== r && 0 > I(r, c)) a[d] = r, a[v] = c, d = v;else break a;
      }
    }

    return b;
  }

  return null;
}

function I(a, b) {
  var c = a.sortIndex - b.sortIndex;
  return 0 !== c ? c : a.id - b.id;
}

var L = [],
    M = [],
    N = 1,
    O = null,
    P = 3,
    Q = !1,
    R = !1,
    S = !1;

function T(a) {
  for (var b = J(M); null !== b;) {
    if (null === b.callback) K(M);else if (b.startTime <= a) K(M), b.sortIndex = b.expirationTime, H(L, b);else break;
    b = J(M);
  }
}

function U(a) {
  S = !1;
  T(a);
  if (!R) if (null !== J(L)) R = !0, _f(V);else {
    var b = J(M);
    null !== b && g(U, b.startTime - a);
  }
}

function V(a, b) {
  R = !1;
  S && (S = !1, h());
  Q = !0;
  var c = P;

  try {
    T(b);

    for (O = J(L); null !== O && (!(O.expirationTime > b) || a && !exports.unstable_shouldYield());) {
      var d = O.callback;

      if ("function" === typeof d) {
        O.callback = null;
        P = O.priorityLevel;
        var e = d(O.expirationTime <= b);
        b = exports.unstable_now();
        "function" === typeof e ? O.callback = e : O === J(L) && K(L);
        T(b);
      } else K(L);

      O = J(L);
    }

    if (null !== O) var m = !0;else {
      var n = J(M);
      null !== n && g(U, n.startTime - b);
      m = !1;
    }
    return m;
  } finally {
    O = null, P = c, Q = !1;
  }
}

var W = k;
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;

exports.unstable_cancelCallback = function (a) {
  a.callback = null;
};

exports.unstable_continueExecution = function () {
  R || Q || (R = !0, _f(V));
};

exports.unstable_getCurrentPriorityLevel = function () {
  return P;
};

exports.unstable_getFirstCallbackNode = function () {
  return J(L);
};

exports.unstable_next = function (a) {
  switch (P) {
    case 1:
    case 2:
    case 3:
      var b = 3;
      break;

    default:
      b = P;
  }

  var c = P;
  P = b;

  try {
    return a();
  } finally {
    P = c;
  }
};

exports.unstable_pauseExecution = function () {};

exports.unstable_requestPaint = W;

exports.unstable_runWithPriority = function (a, b) {
  switch (a) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
      break;

    default:
      a = 3;
  }

  var c = P;
  P = a;

  try {
    return b();
  } finally {
    P = c;
  }
};

exports.unstable_scheduleCallback = function (a, b, c) {
  var d = exports.unstable_now();
  "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;

  switch (a) {
    case 1:
      var e = -1;
      break;

    case 2:
      e = 250;
      break;

    case 5:
      e = 1073741823;
      break;

    case 4:
      e = 1E4;
      break;

    default:
      e = 5E3;
  }

  e = c + e;
  a = {
    id: N++,
    callback: b,
    priorityLevel: a,
    startTime: c,
    expirationTime: e,
    sortIndex: -1
  };
  c > d ? (a.sortIndex = c, H(M, a), null === J(L) && a === J(M) && (S ? h() : S = !0, g(U, c - d))) : (a.sortIndex = e, H(L, a), R || Q || (R = !0, _f(V)));
  return a;
};

exports.unstable_wrapCallback = function (a) {
  var b = P;
  return function () {
    var c = P;
    P = b;

    try {
      return a.apply(this, arguments);
    } finally {
      P = c;
    }
  };
};

/***/ }),

/***/ 296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {



if (true) {
  module.exports = __webpack_require__(813);
} else {}

/***/ }),

/***/ 907:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 671:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 144:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ 876:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _createSuper; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(120);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createSuper.js



function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = (0,getPrototypeOf/* default */.Z)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

/***/ }),

/***/ 942:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 120:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ 340:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _inherits; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

/***/ }),

/***/ 413:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread2; }
/* harmony export */ });
/* harmony import */ var _defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(942);


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

/***/ }),

/***/ 885:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 982:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}

/***/ }),

/***/ 181:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(907);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/************************************************************************/
/******/ 	/* webpack/runtime/amd options */
/******/ 	!function() {
/******/ 		__webpack_require__.amdO = {};
/******/ 	}();
/******/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/
/******/ 	/* webpack/runtime/harmony module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.hmd = function(module) {
/******/ 			module = Object.create(module);
/******/ 			if (!module.children) module.children = [];
/******/ 			Object.defineProperty(module, 'exports', {
/******/ 				enumerable: true,
/******/ 				set: function() {
/******/ 					throw new Error('ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: ' + module.id);
/******/ 				}
/******/ 			});
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "/";
/******/ 	}();
/******/
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(791);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(164);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = (0,unsupportedIterableToArray/* default */.Z)(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(885);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
function extends_extends() {
  extends_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_extends.apply(this, arguments);
}
;// CONCATENATED MODULE: ./node_modules/history/index.js

/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */

var Action;

(function (Action) {
  /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */
  Action["Pop"] = "POP";
  /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */

  Action["Push"] = "PUSH";
  /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */

  Action["Replace"] = "REPLACE";
})(Action || (Action = {}));

var readOnly =  false ? 0 : function (obj) {
  return obj;
};

function warning(cond, message) {
  if (!cond) {
    // eslint-disable-next-line no-console
    if (typeof console !== 'undefined') console.warn(message);

    try {
      // Welcome to debugging history!
      //
      // This error is thrown as a convenience so you can more easily
      // find the source for a warning that appears in the console by
      // enabling "pause on exceptions" in your JavaScript debugger.
      throw new Error(message); // eslint-disable-next-line no-empty
    } catch (e) {}
  }
}

var BeforeUnloadEventType = 'beforeunload';
var HashChangeEventType = 'hashchange';
var PopStateEventType = 'popstate';
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */

function createBrowserHistory(options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$window = _options.window,
      window = _options$window === void 0 ? document.defaultView : _options$window;
  var globalHistory = window.history;

  function getIndexAndLocation() {
    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var state = globalHistory.state || {};
    return [state.idx, readOnly({
      pathname: pathname,
      search: search,
      hash: hash,
      state: state.usr || null,
      key: state.key || 'default'
    })];
  }

  var blockedPopTx = null;

  function handlePop() {
    if (blockedPopTx) {
      blockers.call(blockedPopTx);
      blockedPopTx = null;
    } else {
      var nextAction = Action.Pop;

      var _getIndexAndLocation = getIndexAndLocation(),
          nextIndex = _getIndexAndLocation[0],
          nextLocation = _getIndexAndLocation[1];

      if (blockers.length) {
        if (nextIndex != null) {
          var delta = index - nextIndex;

          if (delta) {
            // Revert the POP
            blockedPopTx = {
              action: nextAction,
              location: nextLocation,
              retry: function retry() {
                go(delta * -1);
              }
            };
            go(delta);
          }
        } else {
          // Trying to POP to a location with no index. We did not create
          // this location, so we can't effectively block the navigation.
           false ? 0 : void 0;
        }
      } else {
        applyTx(nextAction);
      }
    }
  }

  window.addEventListener(PopStateEventType, handlePop);
  var action = Action.Pop;

  var _getIndexAndLocation2 = getIndexAndLocation(),
      index = _getIndexAndLocation2[0],
      location = _getIndexAndLocation2[1];

  var listeners = createEvents();
  var blockers = createEvents();

  if (index == null) {
    index = 0;
    globalHistory.replaceState(extends_extends({}, globalHistory.state, {
      idx: index
    }), '');
  }

  function createHref(to) {
    return typeof to === 'string' ? to : history_createPath(to);
  } // state defaults to `null` because `window.history.state` does


  function getNextLocation(to, state) {
    if (state === void 0) {
      state = null;
    }

    return readOnly(extends_extends({
      pathname: location.pathname,
      hash: '',
      search: ''
    }, typeof to === 'string' ? history_parsePath(to) : to, {
      state: state,
      key: createKey()
    }));
  }

  function getHistoryStateAndUrl(nextLocation, index) {
    return [{
      usr: nextLocation.state,
      key: nextLocation.key,
      idx: index
    }, createHref(nextLocation)];
  }

  function allowTx(action, location, retry) {
    return !blockers.length || (blockers.call({
      action: action,
      location: location,
      retry: retry
    }), false);
  }

  function applyTx(nextAction) {
    action = nextAction;

    var _getIndexAndLocation3 = getIndexAndLocation();

    index = _getIndexAndLocation3[0];
    location = _getIndexAndLocation3[1];
    listeners.call({
      action: action,
      location: location
    });
  }

  function push(to, state) {
    var nextAction = Action.Push;
    var nextLocation = getNextLocation(to, state);

    function retry() {
      push(to, state);
    }

    if (allowTx(nextAction, nextLocation, retry)) {
      var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1),
          historyState = _getHistoryStateAndUr[0],
          url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
      // try...catch because iOS limits us to 100 pushState calls :/


      try {
        globalHistory.pushState(historyState, '', url);
      } catch (error) {
        // They are going to lose state here, but there is no real
        // way to warn them about it since the page will refresh...
        window.location.assign(url);
      }

      applyTx(nextAction);
    }
  }

  function replace(to, state) {
    var nextAction = Action.Replace;
    var nextLocation = getNextLocation(to, state);

    function retry() {
      replace(to, state);
    }

    if (allowTx(nextAction, nextLocation, retry)) {
      var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index),
          historyState = _getHistoryStateAndUr2[0],
          url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading


      globalHistory.replaceState(historyState, '', url);
      applyTx(nextAction);
    }
  }

  function go(delta) {
    globalHistory.go(delta);
  }

  var history = {
    get action() {
      return action;
    },

    get location() {
      return location;
    },

    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    back: function back() {
      go(-1);
    },
    forward: function forward() {
      go(1);
    },
    listen: function listen(listener) {
      return listeners.push(listener);
    },
    block: function block(blocker) {
      var unblock = blockers.push(blocker);

      if (blockers.length === 1) {
        window.addEventListener(BeforeUnloadEventType, promptBeforeUnload);
      }

      return function () {
        unblock(); // Remove the beforeunload listener so the document may
        // still be salvageable in the pagehide event.
        // See https://html.spec.whatwg.org/#unloading-documents

        if (!blockers.length) {
          window.removeEventListener(BeforeUnloadEventType, promptBeforeUnload);
        }
      };
    }
  };
  return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */


function history_createHashHistory(options) {
  if (options === void 0) {
    options = {};
  }

  var _options2 = options,
      _options2$window = _options2.window,
      window = _options2$window === void 0 ? document.defaultView : _options2$window;
  var globalHistory = window.history;

  function getIndexAndLocation() {
    var _parsePath = history_parsePath(window.location.hash.substr(1)),
        _parsePath$pathname = _parsePath.pathname,
        pathname = _parsePath$pathname === void 0 ? '/' : _parsePath$pathname,
        _parsePath$search = _parsePath.search,
        search = _parsePath$search === void 0 ? '' : _parsePath$search,
        _parsePath$hash = _parsePath.hash,
        hash = _parsePath$hash === void 0 ? '' : _parsePath$hash;

    var state = globalHistory.state || {};
    return [state.idx, readOnly({
      pathname: pathname,
      search: search,
      hash: hash,
      state: state.usr || null,
      key: state.key || 'default'
    })];
  }

  var blockedPopTx = null;

  function handlePop() {
    if (blockedPopTx) {
      blockers.call(blockedPopTx);
      blockedPopTx = null;
    } else {
      var nextAction = Action.Pop;

      var _getIndexAndLocation4 = getIndexAndLocation(),
          nextIndex = _getIndexAndLocation4[0],
          nextLocation = _getIndexAndLocation4[1];

      if (blockers.length) {
        if (nextIndex != null) {
          var delta = index - nextIndex;

          if (delta) {
            // Revert the POP
            blockedPopTx = {
              action: nextAction,
              location: nextLocation,
              retry: function retry() {
                go(delta * -1);
              }
            };
            go(delta);
          }
        } else {
          // Trying to POP to a location with no index. We did not create
          // this location, so we can't effectively block the navigation.
           false ? 0 : void 0;
        }
      } else {
        applyTx(nextAction);
      }
    }
  }

  window.addEventListener(PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
  // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event

  window.addEventListener(HashChangeEventType, function () {
    var _getIndexAndLocation5 = getIndexAndLocation(),
        nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.


    if (history_createPath(nextLocation) !== history_createPath(location)) {
      handlePop();
    }
  });
  var action = Action.Pop;

  var _getIndexAndLocation6 = getIndexAndLocation(),
      index = _getIndexAndLocation6[0],
      location = _getIndexAndLocation6[1];

  var listeners = createEvents();
  var blockers = createEvents();

  if (index == null) {
    index = 0;
    globalHistory.replaceState(_extends({}, globalHistory.state, {
      idx: index
    }), '');
  }

  function getBaseHref() {
    var base = document.querySelector('base');
    var href = '';

    if (base && base.getAttribute('href')) {
      var url = window.location.href;
      var hashIndex = url.indexOf('#');
      href = hashIndex === -1 ? url : url.slice(0, hashIndex);
    }

    return href;
  }

  function createHref(to) {
    return getBaseHref() + '#' + (typeof to === 'string' ? to : history_createPath(to));
  }

  function getNextLocation(to, state) {
    if (state === void 0) {
      state = null;
    }

    return readOnly(_extends({
      pathname: location.pathname,
      hash: '',
      search: ''
    }, typeof to === 'string' ? history_parsePath(to) : to, {
      state: state,
      key: createKey()
    }));
  }

  function getHistoryStateAndUrl(nextLocation, index) {
    return [{
      usr: nextLocation.state,
      key: nextLocation.key,
      idx: index
    }, createHref(nextLocation)];
  }

  function allowTx(action, location, retry) {
    return !blockers.length || (blockers.call({
      action: action,
      location: location,
      retry: retry
    }), false);
  }

  function applyTx(nextAction) {
    action = nextAction;

    var _getIndexAndLocation7 = getIndexAndLocation();

    index = _getIndexAndLocation7[0];
    location = _getIndexAndLocation7[1];
    listeners.call({
      action: action,
      location: location
    });
  }

  function push(to, state) {
    var nextAction = Action.Push;
    var nextLocation = getNextLocation(to, state);

    function retry() {
      push(to, state);
    }

     false ? 0 : void 0;

    if (allowTx(nextAction, nextLocation, retry)) {
      var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1),
          historyState = _getHistoryStateAndUr3[0],
          url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
      // try...catch because iOS limits us to 100 pushState calls :/


      try {
        globalHistory.pushState(historyState, '', url);
      } catch (error) {
        // They are going to lose state here, but there is no real
        // way to warn them about it since the page will refresh...
        window.location.assign(url);
      }

      applyTx(nextAction);
    }
  }

  function replace(to, state) {
    var nextAction = Action.Replace;
    var nextLocation = getNextLocation(to, state);

    function retry() {
      replace(to, state);
    }

     false ? 0 : void 0;

    if (allowTx(nextAction, nextLocation, retry)) {
      var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index),
          historyState = _getHistoryStateAndUr4[0],
          url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading


      globalHistory.replaceState(historyState, '', url);
      applyTx(nextAction);
    }
  }

  function go(delta) {
    globalHistory.go(delta);
  }

  var history = {
    get action() {
      return action;
    },

    get location() {
      return location;
    },

    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    back: function back() {
      go(-1);
    },
    forward: function forward() {
      go(1);
    },
    listen: function listen(listener) {
      return listeners.push(listener);
    },
    block: function block(blocker) {
      var unblock = blockers.push(blocker);

      if (blockers.length === 1) {
        window.addEventListener(BeforeUnloadEventType, promptBeforeUnload);
      }

      return function () {
        unblock(); // Remove the beforeunload listener so the document may
        // still be salvageable in the pagehide event.
        // See https://html.spec.whatwg.org/#unloading-documents

        if (!blockers.length) {
          window.removeEventListener(BeforeUnloadEventType, promptBeforeUnload);
        }
      };
    }
  };
  return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */


function history_createMemoryHistory(options) {
  if (options === void 0) {
    options = {};
  }

  var _options3 = options,
      _options3$initialEntr = _options3.initialEntries,
      initialEntries = _options3$initialEntr === void 0 ? ['/'] : _options3$initialEntr,
      initialIndex = _options3.initialIndex;
  var entries = initialEntries.map(function (entry) {
    var location = readOnly(_extends({
      pathname: '/',
      search: '',
      hash: '',
      state: null,
      key: createKey()
    }, typeof entry === 'string' ? history_parsePath(entry) : entry));
     false ? 0 : void 0;
    return location;
  });
  var index = clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
  var action = Action.Pop;
  var location = entries[index];
  var listeners = createEvents();
  var blockers = createEvents();

  function createHref(to) {
    return typeof to === 'string' ? to : history_createPath(to);
  }

  function getNextLocation(to, state) {
    if (state === void 0) {
      state = null;
    }

    return readOnly(_extends({
      pathname: location.pathname,
      search: '',
      hash: ''
    }, typeof to === 'string' ? history_parsePath(to) : to, {
      state: state,
      key: createKey()
    }));
  }

  function allowTx(action, location, retry) {
    return !blockers.length || (blockers.call({
      action: action,
      location: location,
      retry: retry
    }), false);
  }

  function applyTx(nextAction, nextLocation) {
    action = nextAction;
    location = nextLocation;
    listeners.call({
      action: action,
      location: location
    });
  }

  function push(to, state) {
    var nextAction = Action.Push;
    var nextLocation = getNextLocation(to, state);

    function retry() {
      push(to, state);
    }

     false ? 0 : void 0;

    if (allowTx(nextAction, nextLocation, retry)) {
      index += 1;
      entries.splice(index, entries.length, nextLocation);
      applyTx(nextAction, nextLocation);
    }
  }

  function replace(to, state) {
    var nextAction = Action.Replace;
    var nextLocation = getNextLocation(to, state);

    function retry() {
      replace(to, state);
    }

     false ? 0 : void 0;

    if (allowTx(nextAction, nextLocation, retry)) {
      entries[index] = nextLocation;
      applyTx(nextAction, nextLocation);
    }
  }

  function go(delta) {
    var nextIndex = clamp(index + delta, 0, entries.length - 1);
    var nextAction = Action.Pop;
    var nextLocation = entries[nextIndex];

    function retry() {
      go(delta);
    }

    if (allowTx(nextAction, nextLocation, retry)) {
      index = nextIndex;
      applyTx(nextAction, nextLocation);
    }
  }

  var history = {
    get index() {
      return index;
    },

    get action() {
      return action;
    },

    get location() {
      return location;
    },

    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    back: function back() {
      go(-1);
    },
    forward: function forward() {
      go(1);
    },
    listen: function listen(listener) {
      return listeners.push(listener);
    },
    block: function block(blocker) {
      return blockers.push(blocker);
    }
  };
  return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////


function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}

function promptBeforeUnload(event) {
  // Cancel the event.
  event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.

  event.returnValue = '';
}

function createEvents() {
  var handlers = [];
  return {
    get length() {
      return handlers.length;
    },

    push: function push(fn) {
      handlers.push(fn);
      return function () {
        handlers = handlers.filter(function (handler) {
          return handler !== fn;
        });
      };
    },
    call: function call(arg) {
      handlers.forEach(function (fn) {
        return fn && fn(arg);
      });
    }
  };
}

function createKey() {
  return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */


function history_createPath(_ref) {
  var _ref$pathname = _ref.pathname,
      pathname = _ref$pathname === void 0 ? '/' : _ref$pathname,
      _ref$search = _ref.search,
      search = _ref$search === void 0 ? '' : _ref$search,
      _ref$hash = _ref.hash,
      hash = _ref$hash === void 0 ? '' : _ref$hash;
  if (search && search !== '?') pathname += search.charAt(0) === '?' ? search : '?' + search;
  if (hash && hash !== '#') pathname += hash.charAt(0) === '#' ? hash : '#' + hash;
  return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */


function history_parsePath(path) {
  var parsedPath = {};

  if (path) {
    var hashIndex = path.indexOf('#');

    if (hashIndex >= 0) {
      parsedPath.hash = path.substr(hashIndex);
      path = path.substr(0, hashIndex);
    }

    var searchIndex = path.indexOf('?');

    if (searchIndex >= 0) {
      parsedPath.search = path.substr(searchIndex);
      path = path.substr(0, searchIndex);
    }

    if (path) {
      parsedPath.pathname = path;
    }
  }

  return parsedPath;
}


;// CONCATENATED MODULE: ./node_modules/react-router/index.js


/**
 * React Router v6.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */



var NavigationContext = /*#__PURE__*/(0,react.createContext)(null);

if (false) {}

var LocationContext = /*#__PURE__*/(0,react.createContext)(null);

if (false) {}

var RouteContext = /*#__PURE__*/(0,react.createContext)({
  outlet: null,
  matches: []
});

if (false) {}

function invariant(cond, message) {
  if (!cond) throw new Error(message);
}

function react_router_warning(cond, message) {
  if (!cond) {
    // eslint-disable-next-line no-console
    if (typeof console !== "undefined") console.warn(message);

    try {
      // Welcome to debugging React Router!
      //
      // This error is thrown as a convenience so you can more easily
      // find the source for a warning that appears in the console by
      // enabling "pause on exceptions" in your JavaScript debugger.
      throw new Error(message); // eslint-disable-next-line no-empty
    } catch (e) {}
  }
}

var alreadyWarned = {};

function warningOnce(key, cond, message) {
  if (!cond && !alreadyWarned[key]) {
    alreadyWarned[key] = true;
     false ? 0 : void 0;
  }
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/docs/en/v6/api#generatepath
 */


function generatePath(path, params) {
  if (params === void 0) {
    params = {};
  }

  return path.replace(/:(\w+)/g, function (_, key) {
    !(params[key] != null) ?  false ? 0 : invariant(false) : void 0;
    return params[key];
  }).replace(/\/*\*$/, function (_) {
    return params["*"] == null ? "" : params["*"].replace(/^\/*/, "/");
  });
}
/**
 * A RouteMatch contains info about how a route matched a URL.
 */

/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchroutes
 */


function matchRoutes(routes, locationArg, basename) {
  if (basename === void 0) {
    basename = "/";
  }

  var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
  var pathname = stripBasename(location.pathname || "/", basename);

  if (pathname == null) {
    return null;
  }

  var branches = flattenRoutes(routes);
  rankRouteBranches(branches);
  var matches = null;

  for (var i = 0; matches == null && i < branches.length; ++i) {
    matches = matchRouteBranch(branches[i], pathname);
  }

  return matches;
}

function flattenRoutes(routes, branches, parentsMeta, parentPath) {
  if (branches === void 0) {
    branches = [];
  }

  if (parentsMeta === void 0) {
    parentsMeta = [];
  }

  if (parentPath === void 0) {
    parentPath = "";
  }

  routes.forEach(function (route, index) {
    var meta = {
      relativePath: route.path || "",
      caseSensitive: route.caseSensitive === true,
      childrenIndex: index,
      route: route
    };

    if (meta.relativePath.startsWith("/")) {
      !meta.relativePath.startsWith(parentPath) ?  false ? 0 : invariant(false) : void 0;
      meta.relativePath = meta.relativePath.slice(parentPath.length);
    }

    var path = joinPaths([parentPath, meta.relativePath]);
    var routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
    // route tree depth-first and child routes appear before their parents in
    // the "flattened" version.

    if (route.children && route.children.length > 0) {
      !(route.index !== true) ?  false ? 0 : invariant(false) : void 0;
      flattenRoutes(route.children, branches, routesMeta, path);
    } // Routes without a path shouldn't ever match by themselves unless they are
    // index routes, so don't add them to the list of possible branches.


    if (route.path == null && !route.index) {
      return;
    }

    branches.push({
      path: path,
      score: computeScore(path, route.index),
      routesMeta: routesMeta
    });
  });
  return branches;
}

function rankRouteBranches(branches) {
  branches.sort(function (a, b) {
    return a.score !== b.score ? b.score - a.score // Higher score first
    : compareIndexes(a.routesMeta.map(function (meta) {
      return meta.childrenIndex;
    }), b.routesMeta.map(function (meta) {
      return meta.childrenIndex;
    }));
  });
}

var paramRe = /^:\w+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = (/* unused pure expression or super */ null && (-2));

var isSplat = function isSplat(s) {
  return s === "*";
};

function computeScore(path, index) {
  var segments = path.split("/");
  var initialScore = segments.length;

  if (segments.some(isSplat)) {
    initialScore += splatPenalty;
  }

  if (index) {
    initialScore += indexRouteValue;
  }

  return segments.filter(function (s) {
    return !isSplat(s);
  }).reduce(function (score, segment) {
    return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
  }, initialScore);
}

function compareIndexes(a, b) {
  var siblings = a.length === b.length && a.slice(0, -1).every(function (n, i) {
    return n === b[i];
  });
  return siblings ? // If two routes are siblings, we should try to match the earlier sibling
  // first. This allows people to have fine-grained control over the matching
  // behavior by simply putting routes with identical paths in the order they
  // want them tried.
  a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
  // so they sort equally.
  0;
}

function matchRouteBranch(branch, pathname) {
  var routesMeta = branch.routesMeta;
  var matchedParams = {};
  var matchedPathname = "/";
  var matches = [];

  for (var i = 0; i < routesMeta.length; ++i) {
    var meta = routesMeta[i];
    var end = i === routesMeta.length - 1;
    var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
    var match = matchPath({
      path: meta.relativePath,
      caseSensitive: meta.caseSensitive,
      end: end
    }, remainingPathname);
    if (!match) return null;
    Object.assign(matchedParams, match.params);
    var route = meta.route;
    matches.push({
      params: matchedParams,
      pathname: joinPaths([matchedPathname, match.pathname]),
      pathnameBase: normalizePathname(joinPaths([matchedPathname, match.pathnameBase])),
      route: route
    });

    if (match.pathnameBase !== "/") {
      matchedPathname = joinPaths([matchedPathname, match.pathnameBase]);
    }
  }

  return matches;
}
/**
 * A PathPattern is used to match on some portion of a URL pathname.
 */

/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchpath
 */


function matchPath(pattern, pathname) {
  if (typeof pattern === "string") {
    pattern = {
      path: pattern,
      caseSensitive: false,
      end: true
    };
  }

  var _compilePath = compilePath(pattern.path, pattern.caseSensitive, pattern.end),
      _compilePath2 = _slicedToArray(_compilePath, 2),
      matcher = _compilePath2[0],
      paramNames = _compilePath2[1];

  var match = pathname.match(matcher);
  if (!match) return null;
  var matchedPathname = match[0];
  var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
  var captureGroups = match.slice(1);
  var params = paramNames.reduce(function (memo, paramName, index) {
    // We need to compute the pathnameBase here using the raw splat value
    // instead of using params["*"] later because it will be decoded then
    if (paramName === "*") {
      var splatValue = captureGroups[index] || "";
      pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
    }

    memo[paramName] = safelyDecodeURIComponent(captureGroups[index] || "", paramName);
    return memo;
  }, {});
  return {
    params: params,
    pathname: matchedPathname,
    pathnameBase: pathnameBase,
    pattern: pattern
  };
}

function compilePath(path, caseSensitive, end) {
  if (caseSensitive === void 0) {
    caseSensitive = false;
  }

  if (end === void 0) {
    end = true;
  }

   false ? 0 : void 0;
  var paramNames = [];
  var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
  .replace(/^\/*/, "/") // Make sure it has a leading /
  .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
  .replace(/:(\w+)/g, function (_, paramName) {
    paramNames.push(paramName);
    return "([^\\/]+)";
  });

  if (path.endsWith("*")) {
    paramNames.push("*");
    regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
    : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
  } else {
    regexpSource += end ? "\\/*$" // When matching to the end, ignore trailing slashes
    : // Otherwise, match a word boundary or a proceeding /. The word boundary restricts
    // parent routes to matching only their own words and nothing more, e.g. parent
    // route "/home" should not match "/home2".
    // Additionally, allow paths starting with `.`, `-`, `~`, and url-encoded entities,
    // but do not consume the character in the matched path so they can match against
    // nested paths.
    "(?:(?=[.~-]|%[0-9A-F]{2})|\\b|\\/|$)";
  }

  var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
  return [matcher, paramNames];
}

function safelyDecodeURIComponent(value, paramName) {
  try {
    return decodeURIComponent(value);
  } catch (error) {
     false ? 0 : void 0;
    return value;
  }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/docs/en/v6/api#resolvepath
 */


function resolvePath(to, fromPathname) {
  if (fromPathname === void 0) {
    fromPathname = "/";
  }

  var _ref5 = typeof to === "string" ? history_parsePath(to) : to,
      toPathname = _ref5.pathname,
      _ref5$search = _ref5.search,
      search = _ref5$search === void 0 ? "" : _ref5$search,
      _ref5$hash = _ref5.hash,
      hash = _ref5$hash === void 0 ? "" : _ref5$hash;

  var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
  return {
    pathname: pathname,
    search: normalizeSearch(search),
    hash: normalizeHash(hash)
  };
}

function resolvePathname(relativePath, fromPathname) {
  var segments = fromPathname.replace(/\/+$/, "").split("/");
  var relativeSegments = relativePath.split("/");
  relativeSegments.forEach(function (segment) {
    if (segment === "..") {
      // Keep the root "" segment so the pathname starts at /
      if (segments.length > 1) segments.pop();
    } else if (segment !== ".") {
      segments.push(segment);
    }
  });
  return segments.length > 1 ? segments.join("/") : "/";
}

function resolveTo(toArg, routePathnames, locationPathname) {
  var to = typeof toArg === "string" ? history_parsePath(toArg) : toArg;
  var toPathname = toArg === "" || to.pathname === "" ? "/" : to.pathname; // If a pathname is explicitly provided in `to`, it should be relative to the
  // route context. This is explained in `Note on `<Link to>` values` in our
  // migration guide from v5 as a means of disambiguation between `to` values
  // that begin with `/` and those that do not. However, this is problematic for
  // `to` values that do not provide a pathname. `to` can simply be a search or
  // hash string, in which case we should assume that the navigation is relative
  // to the current location's pathname and *not* the route pathname.

  var from;

  if (toPathname == null) {
    from = locationPathname;
  } else {
    var routePathnameIndex = routePathnames.length - 1;

    if (toPathname.startsWith("..")) {
      var toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
      // URL segment".  This is a key difference from how <a href> works and a
      // major reason we call this a "to" value instead of a "href".

      while (toSegments[0] === "..") {
        toSegments.shift();
        routePathnameIndex -= 1;
      }

      to.pathname = toSegments.join("/");
    } // If there are more ".." segments than parent routes, resolve relative to
    // the root / URL.


    from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
  }

  var path = resolvePath(to, from); // Ensure the pathname has a trailing slash if the original to value had one.

  if (toPathname && toPathname !== "/" && toPathname.endsWith("/") && !path.pathname.endsWith("/")) {
    path.pathname += "/";
  }

  return path;
}

function getToPathname(to) {
  // Empty strings should be treated the same as / paths
  return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}

function stripBasename(pathname, basename) {
  if (basename === "/") return pathname;

  if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) {
    return null;
  }

  var nextChar = pathname.charAt(basename.length);

  if (nextChar && nextChar !== "/") {
    // pathname does not start with basename/
    return null;
  }

  return pathname.slice(basename.length) || "/";
}

var joinPaths = function joinPaths(paths) {
  return paths.join("/").replace(/\/\/+/g, "/");
};

var normalizePathname = function normalizePathname(pathname) {
  return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};

var normalizeSearch = function normalizeSearch(search) {
  return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};

var normalizeHash = function normalizeHash(hash) {
  return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usehref
 */


function react_router_useHref(to) {
  !useInRouterContext() ?  false ? 0 : invariant(false) : void 0;

  var _useContext = useContext(NavigationContext),
      basename = _useContext.basename,
      navigator = _useContext.navigator;

  var _useResolvedPath = react_router_useResolvedPath(to),
      hash = _useResolvedPath.hash,
      pathname = _useResolvedPath.pathname,
      search = _useResolvedPath.search;

  var joinedPathname = pathname;

  if (basename !== "/") {
    var toPathname = getToPathname(to);
    var endsWithSlash = toPathname != null && toPathname.endsWith("/");
    joinedPathname = pathname === "/" ? basename + (endsWithSlash ? "/" : "") : joinPaths([basename, pathname]);
  }

  return navigator.createHref({
    pathname: joinedPathname,
    search: search,
    hash: hash
  });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useinroutercontext
 */


function useInRouterContext() {
  return (0,react.useContext)(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/docs/en/v6/api#uselocation
 */


function react_router_useLocation() {
  !useInRouterContext() ?  false ? 0 : invariant(false) : void 0;
  return (0,react.useContext)(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigationtype
 */


function useNavigationType() {
  return useContext(LocationContext).navigationType;
}
/**
 * Returns true if the URL for the given "to" value matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usematch
 */


function useMatch(pattern) {
  !useInRouterContext() ?  false ? 0 : invariant(false) : void 0;

  var _useLocation = react_router_useLocation(),
      pathname = _useLocation.pathname;

  return useMemo(function () {
    return matchPath(pattern, pathname);
  }, [pathname, pattern]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */

/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigate
 */


function react_router_useNavigate() {
  !useInRouterContext() ?  false ? 0 : invariant(false) : void 0;

  var _useContext2 = (0,react.useContext)(NavigationContext),
      basename = _useContext2.basename,
      navigator = _useContext2.navigator;

  var _useContext3 = (0,react.useContext)(RouteContext),
      matches = _useContext3.matches;

  var _useLocation2 = react_router_useLocation(),
      locationPathname = _useLocation2.pathname;

  var routePathnamesJson = JSON.stringify(matches.map(function (match) {
    return match.pathnameBase;
  }));
  var activeRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    activeRef.current = true;
  });
  var navigate = (0,react.useCallback)(function (to, options) {
    if (options === void 0) {
      options = {};
    }

     false ? 0 : void 0;
    if (!activeRef.current) return;

    if (typeof to === "number") {
      navigator.go(to);
      return;
    }

    var path = resolveTo(to, JSON.parse(routePathnamesJson), locationPathname);

    if (basename !== "/") {
      path.pathname = joinPaths([basename, path.pathname]);
    }

    (!!options.replace ? navigator.replace : navigator.push)(path, options.state);
  }, [basename, navigator, routePathnamesJson, locationPathname]);
  return navigate;
}

var OutletContext = /*#__PURE__*/(/* unused pure expression or super */ null && (createContext(null)));
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/docs/en/v6/api#useoutletcontext
 */

function useOutletContext() {
  return useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useoutlet
 */


function useOutlet(context) {
  var outlet = useContext(RouteContext).outlet;

  if (outlet) {
    return /*#__PURE__*/createElement(OutletContext.Provider, {
      value: context
    }, outlet);
  }

  return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useparams
 */


function useParams() {
  var _useContext4 = useContext(RouteContext),
      matches = _useContext4.matches;

  var routeMatch = matches[matches.length - 1];
  return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useresolvedpath
 */


function react_router_useResolvedPath(to) {
  var _useContext5 = useContext(RouteContext),
      matches = _useContext5.matches;

  var _useLocation3 = react_router_useLocation(),
      locationPathname = _useLocation3.pathname;

  var routePathnamesJson = JSON.stringify(matches.map(function (match) {
    return match.pathnameBase;
  }));
  return useMemo(function () {
    return resolveTo(to, JSON.parse(routePathnamesJson), locationPathname);
  }, [to, routePathnamesJson, locationPathname]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useroutes
 */


function useRoutes(routes, locationArg) {
  !useInRouterContext() ?  false ? 0 : invariant(false) : void 0;

  var _useContext6 = useContext(RouteContext),
      parentMatches = _useContext6.matches;

  var routeMatch = parentMatches[parentMatches.length - 1];
  var parentParams = routeMatch ? routeMatch.params : {};
  var parentPathname = routeMatch ? routeMatch.pathname : "/";
  var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
  var parentRoute = routeMatch && routeMatch.route;

  if (false) { var parentPath; }

  var locationFromContext = react_router_useLocation();
  var location;

  if (locationArg) {
    var _parsedLocationArg$pa;

    var parsedLocationArg = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) ?  false ? 0 : invariant(false) : void 0;
    location = parsedLocationArg;
  } else {
    location = locationFromContext;
  }

  var pathname = location.pathname || "/";
  var remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
  var matches = matchRoutes(routes, {
    pathname: remainingPathname
  });

  if (false) {}

  return _renderMatches(matches && matches.map(function (match) {
    return Object.assign({}, match, {
      params: Object.assign({}, parentParams, match.params),
      pathname: joinPaths([parentPathnameBase, match.pathname]),
      pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : joinPaths([parentPathnameBase, match.pathnameBase])
    });
  }), parentMatches);
}

function _renderMatches(matches, parentMatches) {
  if (parentMatches === void 0) {
    parentMatches = [];
  }

  if (matches == null) return null;
  return matches.reduceRight(function (outlet, match, index) {
    return /*#__PURE__*/createElement(RouteContext.Provider, {
      children: match.route.element !== undefined ? match.route.element : outlet,
      value: {
        outlet: outlet,
        matches: parentMatches.concat(matches.slice(0, index + 1))
      }
    });
  }, null);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/docs/en/v6/api#memoryrouter
 */


function MemoryRouter(_ref) {
  var basename = _ref.basename,
      children = _ref.children,
      initialEntries = _ref.initialEntries,
      initialIndex = _ref.initialIndex;
  var historyRef = useRef();

  if (historyRef.current == null) {
    historyRef.current = createMemoryHistory({
      initialEntries: initialEntries,
      initialIndex: initialIndex
    });
  }

  var history = historyRef.current;

  var _useState = useState({
    action: history.action,
    location: history.location
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useLayoutEffect(function () {
    return history.listen(setState);
  }, [history]);
  return /*#__PURE__*/createElement(react_router_Router, {
    basename: basename,
    children: children,
    location: state.location,
    navigationType: state.action,
    navigator: history
  });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/docs/en/v6/api#navigate
 */


function Navigate(_ref2) {
  var to = _ref2.to,
      replace = _ref2.replace,
      state = _ref2.state;
  !useInRouterContext() ?  false ? 0 : invariant(false) : void 0;
   false ? 0 : void 0;
  var navigate = react_router_useNavigate();
  useEffect(function () {
    navigate(to, {
      replace: replace,
      state: state
    });
  });
  return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/docs/en/v6/api#outlet
 */


function Outlet(props) {
  return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#route
 */


function Route(_props) {
   false ? 0 : invariant(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/docs/en/v6/api#router
 */


function react_router_Router(_ref3) {
  var _ref3$basename = _ref3.basename,
      basenameProp = _ref3$basename === void 0 ? "/" : _ref3$basename,
      _ref3$children = _ref3.children,
      children = _ref3$children === void 0 ? null : _ref3$children,
      locationProp = _ref3.location,
      _ref3$navigationType = _ref3.navigationType,
      navigationType = _ref3$navigationType === void 0 ? Action.Pop : _ref3$navigationType,
      navigator = _ref3.navigator,
      _ref3$static = _ref3.static,
      staticProp = _ref3$static === void 0 ? false : _ref3$static;
  !!useInRouterContext() ?  false ? 0 : invariant(false) : void 0;
  var basename = normalizePathname(basenameProp);
  var navigationContext = (0,react.useMemo)(function () {
    return {
      basename: basename,
      navigator: navigator,
      static: staticProp
    };
  }, [basename, navigator, staticProp]);

  if (typeof locationProp === "string") {
    locationProp = history_parsePath(locationProp);
  }

  var _locationProp = locationProp,
      _locationProp$pathnam = _locationProp.pathname,
      pathname = _locationProp$pathnam === void 0 ? "/" : _locationProp$pathnam,
      _locationProp$search = _locationProp.search,
      search = _locationProp$search === void 0 ? "" : _locationProp$search,
      _locationProp$hash = _locationProp.hash,
      hash = _locationProp$hash === void 0 ? "" : _locationProp$hash,
      _locationProp$state = _locationProp.state,
      state = _locationProp$state === void 0 ? null : _locationProp$state,
      _locationProp$key = _locationProp.key,
      key = _locationProp$key === void 0 ? "default" : _locationProp$key;
  var location = (0,react.useMemo)(function () {
    var trailingPathname = stripBasename(pathname, basename);

    if (trailingPathname == null) {
      return null;
    }

    return {
      pathname: trailingPathname,
      search: search,
      hash: hash,
      state: state,
      key: key
    };
  }, [basename, pathname, search, hash, state, key]);
   false ? 0 : void 0;

  if (location == null) {
    return null;
  }

  return /*#__PURE__*/(0,react.createElement)(NavigationContext.Provider, {
    value: navigationContext
  }, /*#__PURE__*/(0,react.createElement)(LocationContext.Provider, {
    children: children,
    value: {
      location: location,
      navigationType: navigationType
    }
  }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#routes
 */


function Routes(_ref4) {
  var children = _ref4.children,
      location = _ref4.location;
  return useRoutes(createRoutesFromChildren(children), location);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////

/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/docs/en/v6/api#createroutesfromchildren
 */


function createRoutesFromChildren(children) {
  var routes = [];
  Children.forEach(children, function (element) {
    if (! /*#__PURE__*/isValidElement(element)) {
      // Ignore non-elements. This allows people to more easily inline
      // conditionals in their route config.
      return;
    }

    if (element.type === Fragment) {
      // Transparently support React.Fragment and its children.
      routes.push.apply(routes, createRoutesFromChildren(element.props.children));
      return;
    }

    !(element.type === Route) ?  false ? 0 : invariant(false) : void 0;
    var route = {
      caseSensitive: element.props.caseSensitive,
      element: element.props.element,
      index: element.props.index,
      path: element.props.path
    };

    if (element.props.children) {
      route.children = createRoutesFromChildren(element.props.children);
    }

    routes.push(route);
  });
  return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */


function renderMatches(matches) {
  return _renderMatches(matches);
}


;// CONCATENATED MODULE: ./node_modules/react-router-dom/index.js



/**
 * React Router DOM v6.3.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */





function react_router_dom_extends() {
  react_router_dom_extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return react_router_dom_extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = (/* unused pure expression or super */ null && (["onClick", "reloadDocument", "replace", "state", "target", "to"])),
    _excluded2 = (/* unused pure expression or super */ null && (["aria-current", "caseSensitive", "className", "end", "style", "to", "children"]));

function react_router_dom_warning(cond, message) {
  if (!cond) {
    // eslint-disable-next-line no-console
    if (typeof console !== "undefined") console.warn(message);

    try {
      // Welcome to debugging React Router!
      //
      // This error is thrown as a convenience so you can more easily
      // find the source for a warning that appears in the console by
      // enabling "pause on exceptions" in your JavaScript debugger.
      throw new Error(message); // eslint-disable-next-line no-empty
    } catch (e) {}
  }
} ////////////////////////////////////////////////////////////////////////////////
// COMPONENTS
////////////////////////////////////////////////////////////////////////////////

/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */


function BrowserRouter(_ref) {
  var basename = _ref.basename,
      children = _ref.children,
      window = _ref.window;
  var historyRef = (0,react.useRef)();

  if (historyRef.current == null) {
    historyRef.current = createBrowserHistory({
      window: window
    });
  }

  var history = historyRef.current;

  var _useState = (0,react.useState)({
    action: history.action,
    location: history.location
  }),
      _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  (0,react.useLayoutEffect)(function () {
    return history.listen(setState);
  }, [history]);
  return /*#__PURE__*/(0,react.createElement)(react_router_Router, {
    basename: basename,
    children: children,
    location: state.location,
    navigationType: state.action,
    navigator: history
  });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */


function HashRouter(_ref2) {
  var basename = _ref2.basename,
      children = _ref2.children,
      window = _ref2.window;
  var historyRef = useRef();

  if (historyRef.current == null) {
    historyRef.current = createHashHistory({
      window: window
    });
  }

  var history = historyRef.current;

  var _useState3 = useState({
    action: history.action,
    location: history.location
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      state = _useState4[0],
      setState = _useState4[1];

  useLayoutEffect(function () {
    return history.listen(setState);
  }, [history]);
  return /*#__PURE__*/createElement(Router, {
    basename: basename,
    children: children,
    location: state.location,
    navigationType: state.action,
    navigator: history
  });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */


function HistoryRouter(_ref3) {
  var basename = _ref3.basename,
      children = _ref3.children,
      history = _ref3.history;

  var _useState5 = useState({
    action: history.action,
    location: history.location
  }),
      _useState6 = _slicedToArray(_useState5, 2),
      state = _useState6[0],
      setState = _useState6[1];

  useLayoutEffect(function () {
    return history.listen(setState);
  }, [history]);
  return /*#__PURE__*/createElement(Router, {
    basename: basename,
    children: children,
    location: state.location,
    navigationType: state.action,
    navigator: history
  });
}

if (false) {}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function LinkWithRef(_ref4, ref) {
  var onClick = _ref4.onClick,
      reloadDocument = _ref4.reloadDocument,
      _ref4$replace = _ref4.replace,
      replace = _ref4$replace === void 0 ? false : _ref4$replace,
      state = _ref4.state,
      target = _ref4.target,
      to = _ref4.to,
      rest = _objectWithoutPropertiesLoose(_ref4, _excluded);

  var href = useHref(to);
  var internalOnClick = useLinkClickHandler(to, {
    replace: replace,
    state: state,
    target: target
  });

  function handleClick(event) {
    if (onClick) onClick(event);

    if (!event.defaultPrevented && !reloadDocument) {
      internalOnClick(event);
    }
  }

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    createElement("a", react_router_dom_extends({}, rest, {
      href: href,
      onClick: handleClick,
      ref: ref,
      target: target
    }))
  );
})));

if (false) {}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = /*#__PURE__*/(/* unused pure expression or super */ null && (forwardRef(function NavLinkWithRef(_ref5, ref) {
  var _ref5$ariaCurrent = _ref5["aria-current"],
      ariaCurrentProp = _ref5$ariaCurrent === void 0 ? "page" : _ref5$ariaCurrent,
      _ref5$caseSensitive = _ref5.caseSensitive,
      caseSensitive = _ref5$caseSensitive === void 0 ? false : _ref5$caseSensitive,
      _ref5$className = _ref5.className,
      classNameProp = _ref5$className === void 0 ? "" : _ref5$className,
      _ref5$end = _ref5.end,
      end = _ref5$end === void 0 ? false : _ref5$end,
      styleProp = _ref5.style,
      to = _ref5.to,
      children = _ref5.children,
      rest = _objectWithoutPropertiesLoose(_ref5, _excluded2);

  var location = useLocation();
  var path = useResolvedPath(to);
  var locationPathname = location.pathname;
  var toPathname = path.pathname;

  if (!caseSensitive) {
    locationPathname = locationPathname.toLowerCase();
    toPathname = toPathname.toLowerCase();
  }

  var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
  var ariaCurrent = isActive ? ariaCurrentProp : undefined;
  var className;

  if (typeof classNameProp === "function") {
    className = classNameProp({
      isActive: isActive
    });
  } else {
    // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [classNameProp, isActive ? "active" : null].filter(Boolean).join(" ");
  }

  var style = typeof styleProp === "function" ? styleProp({
    isActive: isActive
  }) : styleProp;
  return /*#__PURE__*/createElement(Link, react_router_dom_extends({}, rest, {
    "aria-current": ariaCurrent,
    className: className,
    ref: ref,
    style: style,
    to: to
  }), typeof children === "function" ? children({
    isActive: isActive
  }) : children);
})));

if (false) {} ////////////////////////////////////////////////////////////////////////////////
// HOOKS
////////////////////////////////////////////////////////////////////////////////

/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */


function useLinkClickHandler(to, _temp) {
  var _ref6 = _temp === void 0 ? {} : _temp,
      target = _ref6.target,
      replaceProp = _ref6.replace,
      state = _ref6.state;

  var navigate = useNavigate();
  var location = useLocation();
  var path = useResolvedPath(to);
  return useCallback(function (event) {
    if (event.button === 0 && ( // Ignore everything but left clicks
    !target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ) {
      event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
      // a push, so do the same here.

      var replace = !!replaceProp || createPath(location) === createPath(path);
      navigate(to, {
        replace: replace,
        state: state
      });
    }
  }, [location, navigate, path, replaceProp, state, target, to]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */


function react_router_dom_useSearchParams(defaultInit) {
   false ? 0 : void 0;
  var defaultSearchParamsRef = (0,react.useRef)(createSearchParams(defaultInit));
  var location = react_router_useLocation();
  var searchParams = (0,react.useMemo)(function () {
    var searchParams = createSearchParams(location.search);

    var _iterator = _createForOfIteratorHelper(defaultSearchParamsRef.current.keys()),
        _step;

    try {
      var _loop = function _loop() {
        var key = _step.value;

        if (!searchParams.has(key)) {
          defaultSearchParamsRef.current.getAll(key).forEach(function (value) {
            searchParams.append(key, value);
          });
        }
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return searchParams;
  }, [location.search]);
  var navigate = react_router_useNavigate();
  var setSearchParams = (0,react.useCallback)(function (nextInit, navigateOptions) {
    navigate("?" + createSearchParams(nextInit), navigateOptions);
  }, [navigate]);
  return [searchParams, setSearchParams];
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */


function createSearchParams(init) {
  if (init === void 0) {
    init = "";
  }

  return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function (memo, key) {
    var value = init[key];
    return memo.concat(Array.isArray(value) ? value.map(function (v) {
      return [key, v];
    }) : [[key, value]]);
  }, []));
}


// EXTERNAL MODULE: ./src/assets/ss-logo.svg
var ss_logo = __webpack_require__(683);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(184);
;// CONCATENATED MODULE: ./src/UI/sections/Header.js
var Header=function Header(props){return/*#__PURE__*/_jsx("header",{className:"container-fluid text-center",children:/*#__PURE__*/_jsx("nav",{className:"navbar navbar-expand-lg",children:/*#__PURE__*/_jsx("a",{className:"navbar-brand mx-auto text-secondary",href:props.externalUrl?props.externalUrl:'https://www.sandandsky.com',children:/*#__PURE__*/_jsx(Logo,{})})})});};/* harmony default export */ var sections_Header = ((/* unused pure expression or super */ null && (Header)));
;// CONCATENATED MODULE: ./src/UI/components/AnnouncementBar.js
var AnnouncementBar=function AnnouncementBar(){return/*#__PURE__*/_jsx("div",{id:"announcementBar",className:"announcement-bar carousel slide","data-bs-ride":"carousel","data-bs-interval":"4000",children:/*#__PURE__*/_jsx("div",{className:"carousel-inner container",children:/*#__PURE__*/_jsx("div",{className:"carousel-item text-center text-white active",children:/*#__PURE__*/_jsx("a",{href:"https://www.amazon.com/sandandsky?maas=maas_adg_8EA37C43F6AD95DB249DE08F65E1DCAA_afap_abs&ref_=aa_maas&tag=maas",className:"d-flex align-items-center justify-content-center font-size-sm",children:"Black Friday Cyber Monday: Up to 30% off. 20-29 Nov"})})})});};/* harmony default export */ var components_AnnouncementBar = ((/* unused pure expression or super */ null && (AnnouncementBar)));
;// CONCATENATED MODULE: ./src/UI/layout/Layout.js
// import Footer from '../sections/Footer';
var Footer=/*#__PURE__*/(/* unused pure expression or super */ null && (lazy(function(){return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 644));})));var Layout=function Layout(props){return/*#__PURE__*/_jsx(Fragment,{children:/*#__PURE__*/_jsx("main",{children:props.children})});};/* harmony default export */ var layout_Layout = ((/* unused pure expression or super */ null && (Layout)));
;// CONCATENATED MODULE: ./src/survey.scss
// extracted by mini-css-extract-plugin
/* harmony default export */ var survey = ({});
;// CONCATENATED MODULE: ./src/modules/questions.js
var questions_Questions=[{question:"How does your skin feel today?",answers:['Tends to get shiny throughout the day','A combination of shiny and dry on different areas','Comfortable in summer, but dry in cooler climates','Red and flaky with uneven texture'],type:'SingleChoice',inputType:'Button',showAllLabel:null,category:'Identifying your skin type',btnClass:'btn__choice-bigger'},{question:'How many hours of sun are you exposed to daily?',answers:['Less than 1 hour','2 hours','3 hours','4 hours','5 hours','More than 6 hours'],type:'SingleChoice',inputType:'RangeSlider',showAllLabel:false,category:'Identifying environmental stressors',btnClass:'btn__choice-bigger'},{question:'How much stress do you experience on a regular basis?',answers:['None','Low','Medium','High'],type:'SingleChoice',inputType:'RangeSlider',showAllLabel:true,category:'Identifying environmental stressors'},{question:'Are you exposed to air pollutants?',answers:['Yes','No','Uncertain'],type:'SingleChoice',inputType:'Button',showAllLabel:null,category:'Identifying environmental stressors',btnClass:'btn__choice-bigger'},{question:'Which age range do you fall into?',answers:['< 20 years old','20-25 years old','26-35 years old','36-45 years old','> 45 years old'],type:'SingleChoice',inputType:'Button',showAllLabel:null,category:'Identifying key ingredients',btnClass:'btn__choice-bigger'},{question:'What type of skincare products are you currently using?',answers:[{label:'Cleanser'},{label:'Mask'},{label:'Exfoliator'},{label:'Toner'},{label:'Serum'},{label:'Moisturiser'},{label:'Eye Care'},{label:'None'}],caption:'*Choose up to 7',captionClass:'w-100 font-size-sm mb-4',type:'MultipleChoice',lastFull:false,maxChoose:6,lastDisableForAll:false,category:'Identifying key ingredients',btnClass:'btn__choice-bigger'},{question:'What is your top skin concern?',caption:'*Choose 1',captionClass:'w-100 font-size-sm mb-0',answers:['Clogged or enlarged pores','Blemishes or acne','Excess oil','Scarring or uneven skin texture','Redness','Dryness and dehydration','Fine lines or wrinkles','Dark spots or hyperpigmentation','Dullness or uneven skin tone','Dark circles and/or eye bags'],type:'SingleChoice',inputType:'Button',showAllLabel:null,category:'Identifying key ingredients',btnClass:'btn__choice-medium'}];/* harmony default export */ var questions = ((/* unused pure expression or super */ null && (questions_Questions)));
;// CONCATENATED MODULE: ./src/UI/components/ProgressBarStep.js
var ProgressBarStep_ProgressBarStep=function ProgressBarStep(props){var stepItem=[];for(var i=1;i<=props.totalQuestions;i+=1){var classes='border border-primary rounded-circle zindex-1 ';classes+=props.currentQuestion>=i?'bg-primary':'bg-white';if(i===1){classes+=' me-2';}else if(i===props.totalQuestions){classes+=' ms-2';}else{classes+=' mx-2';}stepItem.push(/*#__PURE__*/_jsx("li",{className:classes},i));}return/*#__PURE__*/_jsxs(_Fragment,{children:[/*#__PURE__*/_jsxs("div",{className:"d-flex justify-content-between align-items-center mt-4",children:[/*#__PURE__*/_jsx("strong",{children:"Start"}),/*#__PURE__*/_jsx("ul",{className:"list-unstyled progress--step d-flex m-0 position-relative mx-3",children:stepItem}),/*#__PURE__*/_jsx("strong",{children:"Done"})]}),/*#__PURE__*/_jsx("p",{className:"w-100 text-center text-secondary font-size-sm mt-g mt-lg-3",children:props.category})]});};/* harmony default export */ var components_ProgressBarStep = ((/* unused pure expression or super */ null && (ProgressBarStep_ProgressBarStep)));
;// CONCATENATED MODULE: ./src/UI/components/ProgressBarStep2.js
var ProgressBarStep2_ProgressBarStep2=function ProgressBarStep2(props){var stepItem=[];for(var i=1;i<=props.totalQuestions;i+=1){var classes='bg-primary zindex-1 ';classes+=props.currentQuestion>=i?'bg-primary':'bg-primary-light';if(i===1){classes+=' me-2';}else if(i===props.totalQuestions){classes+=' ms-2';}else{classes+=' mx-2';}stepItem.push(/*#__PURE__*/_jsx("li",{className:classes},i));}return/*#__PURE__*/_jsx(_Fragment,{children:/*#__PURE__*/_jsx("div",{className:"d-flex justify-content-between align-items-center mt-4",children:/*#__PURE__*/_jsx("ul",{className:"list-unstyled progress--step--flat-strip d-flex m-0 position-relative mx-3",children:stepItem})})});};/* harmony default export */ var components_ProgressBarStep2 = ((/* unused pure expression or super */ null && (ProgressBarStep2_ProgressBarStep2)));
;// CONCATENATED MODULE: ./src/assets/splash-bottom.svg
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

var splash_bottom_excluded = (/* unused pure expression or super */ null && (["title", "titleId"]));

function splash_bottom_extends() { splash_bottom_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return splash_bottom_extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = splash_bottom_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function splash_bottom_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgSplashBottom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, splash_bottom_excluded);

  return /*#__PURE__*/React.createElement("svg", splash_bottom_extends({
    width: 170,
    height: 100,
    viewBox: "0 0 170 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.7018 56.7216C69.7159 61.0712 65.202 65.8891 61.1638 71.1658C59.9367 72.7667 62.1342 75.0415 63.3726 73.4236C67.4108 68.147 71.9266 63.3292 76.9125 58.9795C78.4436 57.6428 76.2234 55.3925 74.7018 56.7216",
    fill: "#CC3195"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7158 35.5139C60.6444 34.0773 54.4974 33.3712 48.2656 33.4146C46.2549 33.4278 46.2493 36.6203 48.2656 36.607C54.2256 36.5655 60.0742 37.2187 65.8851 38.5931C67.8429 39.0556 68.6792 35.9783 66.7158 35.5139Z",
    fill: "#CC3195"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4718 20.4466C81.1125 17.358 79.7551 14.2694 78.3958 11.1809C77.5708 9.31186 74.8768 10.9317 75.6962 12.7931C77.0554 15.8817 78.4147 18.9703 79.7721 22.0588C80.5971 23.9297 83.2911 22.3061 82.4718 20.4466Z",
    fill: "#CC3195"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.816 21.9295C108.315 17.9858 112.815 14.04 117.314 10.0944C118.843 8.75401 116.625 6.50553 115.103 7.8365C110.605 11.7822 106.104 15.7279 101.605 19.6716C100.076 21.012 102.296 23.2624 103.816 21.9295Z",
    fill: "#CC3195"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.249 48.1973C108.515 49.6265 114.782 51.0556 121.048 52.4847C123.008 52.9321 123.844 49.8549 121.879 49.4074C115.613 47.9764 109.347 46.5473 103.079 45.1182C101.12 44.6707 100.284 47.748 102.249 48.1973",
    fill: "#CC3195"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6145 60.7226C93.3457 64.8703 95.075 69.0161 96.8061 73.1618C97.5934 75.046 100.286 73.4224 99.5058 71.5496C97.7746 67.4038 96.0434 63.258 94.3123 59.1104C93.5269 57.2263 90.8329 58.8517 91.6145 60.7226",
    fill: "#CC3195"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.406 87.206C136.247 90.4287 133.387 93.9948 130.829 97.9027C130.053 99.0864 131.445 100.772 132.23 99.5736C134.788 95.6656 137.648 92.0994 140.807 88.8787C141.775 87.8875 140.371 86.2224 139.406 87.206Z",
    fill: "#CC3195"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M139.406 87.206C136.247 90.4287 133.387 93.9948 130.829 97.9027C130.053 99.0864 131.445 100.772 132.23 99.5736C134.788 95.6656 137.648 92.0994 140.807 88.8787C141.775 87.8875 140.371 86.2224 139.406 87.206Z",
    fill: "#CC3195"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M134.347 71.5027C130.5 70.4398 126.607 69.9169 122.659 69.9472C121.385 69.9585 121.381 72.3221 122.659 72.3126C126.435 72.2825 130.139 72.7638 133.82 73.7833C135.059 74.125 135.589 71.8463 134.347 71.5027",
    fill: "#CC3195"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M134.347 71.5027C130.5 70.4398 126.607 69.9169 122.659 69.9472C121.385 69.9585 121.381 72.3221 122.659 72.3126C126.435 72.2825 130.139 72.7638 133.82 73.7833C135.059 74.125 135.589 71.8463 134.347 71.5027",
    fill: "#CC3195"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.328 60.3478C143.467 58.0597 142.606 55.7735 141.745 53.4872C141.222 52.1034 139.517 53.3022 140.037 54.6804C140.897 56.9647 141.758 59.2528 142.617 61.5391C143.14 62.9267 144.847 61.7241 144.328 60.3478Z",
    fill: "#CC3195"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144.328 60.3478C143.467 58.0597 142.606 55.7735 141.745 53.4872C141.222 52.1034 139.517 53.3022 140.037 54.6804C140.897 56.9647 141.758 59.2528 142.617 61.5391C143.14 62.9267 144.847 61.7241 144.328 60.3478Z",
    fill: "#CC3195"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M157.849 61.4443C160.7 58.5237 163.55 55.6032 166.399 52.6808C167.368 51.6896 165.961 50.0226 165 51.01L156.448 59.7735C155.48 60.7647 156.886 62.4298 157.849 61.4443Z",
    fill: "#CC3195"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M157.849 61.4443C160.7 58.5237 163.55 55.6032 166.399 52.6808C167.368 51.6896 165.961 50.0226 165 51.01L156.448 59.7735C155.48 60.7647 156.886 62.4298 157.849 61.4443Z",
    fill: "#CC3195"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.856 80.8929L168.764 84.0683C170.005 84.3987 170.535 82.1201 169.289 81.7878L157.382 78.6124C156.14 78.282 155.61 80.5607 156.856 80.8929Z",
    fill: "#CC3195"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M156.856 80.8929L168.764 84.0683C170.005 84.3987 170.535 82.1201 169.289 81.7878L157.382 78.6124C156.14 78.282 155.61 80.5607 156.856 80.8929Z",
    fill: "#CC3195"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M150.12 90.1688C151.217 93.2385 152.314 96.3082 153.409 99.3798C153.907 100.775 155.614 99.5705 155.119 98.1867C154.022 95.1151 152.925 92.0454 151.83 88.9757C151.332 87.5806 149.625 88.7832 150.12 90.1688Z",
    fill: "#CC3195"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M150.12 90.1688C151.217 93.2385 152.314 96.3082 153.409 99.3798C153.907 100.775 155.614 99.5705 155.119 98.1867C154.022 95.1151 152.925 92.0454 151.83 88.9757C151.332 87.5806 149.625 88.7832 150.12 90.1688Z",
    fill: "#CC3195"
  })));
}

var ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(SvgSplashBottom)));
/* harmony default export */ var splash_bottom = (__webpack_require__.p + "static/media/splash-bottom.52c4c0e12aa560cc1a079d4ff3a7f2ab.svg");

;// CONCATENATED MODULE: ./src/UI/components/QuestionBox.js
var QuestionBox_SurveyContext=/*#__PURE__*/(/* unused pure expression or super */ null && (React.createContext()));var QuestionBox_QuestionBox=function QuestionBox(props){var question=props.question,questionNote=props.questionNote,caption=props.caption,captionClass=props.captionClass,children=props.children,colSize=props.colSize,currentQuestion=props.currentQuestion,setCurrentQuestion=props.setCurrentQuestion,answerAction=props.answerAction,currentAnswer=props.currentAnswer,width=props.width,height=props.height,totalSteps=props.totalSteps,category=props.category,defaultEnabled=props.defaultEnabled,quizType=props.quizType,progressBarType=props.progressBarType;var prevAction=function prevAction(){return function(e){setCurrentQuestion(currentQuestion-1);e.preventDefault();};};var nextAction=function nextAction(){return function(e){setCurrentQuestion(currentQuestion+1);e.preventDefault();};};var answer=function answer(data){answerAction(currentQuestion,data);};var defaultSelected=currentAnswer&&currentAnswer[currentQuestion]?currentAnswer[currentQuestion]:null;var defaultStateEnable=defaultSelected?defaultSelected:!defaultEnabled;var disableState=defaultSelected?false:defaultStateEnable;var _useState=useState(disableState),_useState2=_slicedToArray(_useState,2),isDisabled=_useState2[0],setDisable=_useState2[1];var isLastQuestion=Questions.length===currentQuestion;var footerAction=currentQuestion===6||currentQuestion===7?'my-lg-3':'pt-lg-5';return/*#__PURE__*/_jsxs("div",{className:"".concat(colSize," col-12 d-flex flex-wrap justify-content-center question-box"),children:[progressBarType==="2"?/*#__PURE__*/_jsx(ProgressBarStep2,{category:category,currentQuestion:currentQuestion,totalQuestions:totalSteps}):/*#__PURE__*/_jsx(ProgressBarStep,{category:category,currentQuestion:currentQuestion,totalQuestions:totalSteps}),/*#__PURE__*/_jsxs("div",{className:"d-flex justify-content-center align-items-center flex-column question-box__content mb-2",children:[/*#__PURE__*/_jsx("p",{className:"".concat(caption?'w-100':'w-100 mb-4 mb-lg-2'," h1 mt-4"),children:question}),questionNote&&/*#__PURE__*/_jsx("p",{children:questionNote}),caption&&/*#__PURE__*/_jsx("p",{className:captionClass,children:caption}),/*#__PURE__*/_jsx(QuestionBox_SurveyContext.Provider,{value:{answerAction:answer,currentQuestion:currentQuestion,width:width,height:height,setDisable:setDisable,currentAnswer:currentAnswer},children:children})]}),/*#__PURE__*/_jsxs("div",{className:"footer-action w-100 bg-white ".concat(currentQuestion===6?'my-2':'my-5'," ").concat(footerAction),children:[/*#__PURE__*/_jsxs("div",{className:"row align-items-end ".concat(currentQuestion>1?'':'justify-content-center'),children:[currentQuestion>1&&/*#__PURE__*/_jsx("a",{href:"/",className:"col-3 col-lg-2 text-start text-underline text-body font-size-sm mb-1",onClick:prevAction(),children:"Previous"}),/*#__PURE__*/_jsx("div",{className:"col-6 col-lg-4 ".concat(currentQuestion>1?'offset-lg-2':''),children:/*#__PURE__*/_jsx("button",{className:"btn btn-primary text-white btn-next w-100",onClick:nextAction(),disabled:isDisabled,children:isLastQuestion?'View my results':'Next'})})]}),quizType!=='mask'&&/*#__PURE__*/_jsx(SplashBottom,{className:"d-none d-lg-block question-box__decoration-bottom position-absolute start-0 bottom-0"})]})]});};/* harmony default export */ var components_QuestionBox = ((/* unused pure expression or super */ null && (QuestionBox_QuestionBox)));
;// CONCATENATED MODULE: ./src/UI/components/RangeSlider.js
var RangeSlider_RangeSlider=function RangeSlider(props){var rangeValue=props.rangeValue,rangeMax=props.rangeMax,handleRangeChange=props.handleRangeChange,percentWidth=props.percentWidth;return/*#__PURE__*/_jsxs("div",{className:"position-relative",children:[/*#__PURE__*/_jsx("input",{type:"range",value:rangeValue,className:"form-range",min:"0",max:rangeMax,step:"1",id:"range",onChange:handleRangeChange}),/*#__PURE__*/_jsx("div",{className:"progress progress--range",children:/*#__PURE__*/_jsx("div",{id:"progress--range__bar",className:"progress-bar",style:percentWidth,role:"progressbar","aria-valuenow":"0","aria-valuemin":"0","aria-valuemax":"100"})})]});};/* harmony default export */ var components_RangeSlider = ((/* unused pure expression or super */ null && (RangeSlider_RangeSlider)));
;// CONCATENATED MODULE: ./src/UI/components/SingleChoice.js
var SingleChoice_SingleChoice=function SingleChoice(props){var answers=props.answers,buttonType=props.buttonType,inputType=props.inputType,btnClass=props.btnClass;var _useContext=useContext(SurveyContext),answerAction=_useContext.answerAction,currentQuestion=_useContext.currentQuestion,setDisable=_useContext.setDisable,currentAnswer=_useContext.currentAnswer;var defaultSelected=currentAnswer&&currentAnswer[currentQuestion]?currentAnswer[currentQuestion]:null;var initialRange=currentAnswer&&currentAnswer[currentQuestion]?answers.indexOf(currentAnswer[currentQuestion]):0;var rangeMin=0;var rangeMax=answers.length-1;var _useState=useState(defaultSelected),_useState2=_slicedToArray(_useState,2),selectedItem=_useState2[0],setSelectedItem=_useState2[1];var _useState3=useState(initialRange),_useState4=_slicedToArray(_useState3,2),rangeValue=_useState4[0],setRangeValue=_useState4[1];var selectItem=function selectItem(answersIndex){var selected=answers[answersIndex];setSelectedItem(selected);answerAction(selected);setDisable(false);};var classesCol=buttonType==='full'?'col-12':'col-6';var handleRangeChange=function handleRangeChange(event){setRangeValue(event.target.value);var selected=answers[event.target.value];setSelectedItem(selected);answerAction(selected);setDisable(false);};useEffect(function(){if(inputType==='RangeSlider'){answerAction(answers[0]);}},[]);var percentVal=(rangeValue-rangeMin)*100/(rangeMax-rangeMin);var percentWidth={width:percentVal+"%"};var percentLeft={left:percentVal+"%",transform:"translateX(-"+percentVal+"%)",top:percentVal===100?-20:0};if(percentVal===100){percentLeft.minWidth=84;}return/*#__PURE__*/_jsx("div",{className:"col-12 px-0 pt-1 ".concat(inputType==='RangeSlider'?'pt-lg-5 mt-lg-4':''),children:/*#__PURE__*/_jsxs("div",{className:"".concat(inputType==='Button'?'row':'position-relative pt-4 pt-lg-5'," justify-content-center ").concat(inputType==='RangeSlider'&&props.showAllLabel?'overflow-hidden':''),children:[inputType==='Button'&&answers.map(function(answer,index){var classes=answer===selectedItem?'bg-secondary-light border--default-selected':'';return/*#__PURE__*/_jsx("div",{className:"".concat(classesCol," mt-g mt-lg-3"),children:/*#__PURE__*/_jsx("button",{className:"border--default ".concat(classes," position-relative btn ").concat(btnClass," btn-lg w-100 btn-outline fw-normal h-100 ").concat(btnClass==='btn__choice-medium'?'px-2':'px-g'," px-lg-2 py-2 py-lg-g"),onClick:function onClick(){return selectItem(index);},children:answer})},index);}),inputType==='RangeSlider'&&/*#__PURE__*/_jsxs(_Fragment,{children:[!props.showAllLabel&&/*#__PURE__*/_jsx("span",{style:percentLeft,className:"position-absolute range__value",children:answers[rangeValue]}),props.showAllLabel&&/*#__PURE__*/_jsx("div",{className:"row mx-n4 mx-lg-n6 pb-2",children:answers.map(function(answer,index){return/*#__PURE__*/_jsx("div",{className:"col-3",children:answer},index);})}),/*#__PURE__*/_jsx(RangeSlider,{rangeValue:rangeValue,rangeMax:rangeMax,handleRangeChange:handleRangeChange,percentWidth:percentWidth})]})]})});};/* harmony default export */ var components_SingleChoice = ((/* unused pure expression or super */ null && (SingleChoice_SingleChoice)));
;// CONCATENATED MODULE: ./src/UI/components/MultipleChoice.js
var MultipleChoice_MultipleChoice=function MultipleChoice(props){var _useContext=useContext(SurveyContext),answerAction=_useContext.answerAction,currentQuestion=_useContext.currentQuestion,setDisable=_useContext.setDisable,currentAnswer=_useContext.currentAnswer;var answers=props.answers,lastFull=props.lastFull,btnClass=props.btnClass;var defaultSelected=currentAnswer&&currentAnswer[currentQuestion]?currentAnswer[currentQuestion].split(","):[];var _useState=useState(defaultSelected),_useState2=_slicedToArray(_useState,2),selectedItems=_useState2[0],setSelectedItems=_useState2[1];var disableData=false;if(defaultSelected&&selectedItems.length===1){var disableAllButtons=answers.find(function(item){return item.label===defaultSelected[0];});if(disableAllButtons&&disableAllButtons.type==='checkboxAll')disableData=true;}var _useState3=useState(disableData),_useState4=_slicedToArray(_useState3,2),disableRest=_useState4[0],setDisableRest=_useState4[1];var updateItems=function updateItems(text){var disableAll=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var currentItems=_toConsumableArray(selectedItems);if(text.includes('other:')){// clear other answer
currentItems=currentItems.filter(function(item,index){return!item.includes('other:');});if(text.trim()!=='other:')currentItems.push(text);}else if(text==='None'){currentItems=['None'];// setDisableRest(true);
setSelectedItems(currentItems);answerAction(currentItems);}else{// clear when disableAll
if(disableAll){currentItems=[];setDisableRest(true);}else{setDisableRest(false);}var disableType=answers.find(function(answer){return answer.type==='checkboxAll';});if(disableType)currentItems=currentItems.filter(function(item){return item!==disableType.label;});if(currentItems.includes(text)){// slice item
var curIndex=currentItems.indexOf(text);currentItems.splice(curIndex,1);}else{// push item
currentItems.push(text);}var noneIndex=currentItems.indexOf('None');if(currentItems.indexOf('None')>=0){currentItems.splice(noneIndex,1);}}setDisable(false);setSelectedItems(currentItems);answerAction(currentItems);};var chooseItems=function chooseItems(index){return function(e){if(e.target.localName==='input'){// execute only for target label, since click on label would trigger click by input also
updateItems(answers[index].label,answers[index].type==='checkboxAll');}};};return/*#__PURE__*/_jsx("div",{className:"row justify-content-center",children:answers.map(function(answer,index){var full=lastFull&&index+1===answers.length?'col-12':'col-6';var isLastItem=index+1===answers.length;var classes="d-flex rounded align-items-center mb-g ".concat(isLastItem?'mb-lg-0':' mb-lg-3'," ").concat(btnClass," position-relative border--default");var disabledClass=disableRest&&!selectedItems.includes(answer.label)?'disabled':'';var itemClasses=selectedItems.includes(answer.label)?'border--default-selected position-relative bg-secondary-light':'';return/*#__PURE__*/_jsx("div",{className:full,children:/*#__PURE__*/_jsx("div",{className:"".concat(answer.label!=='None'?disabledClass:''," ").concat(classes," ").concat(itemClasses),role:"button",children:/*#__PURE__*/_jsxs("label",{className:"d-flex checkbox-number align-items-center px-sm-1 w-100 p-2 justify-content-center zindex-1",htmlFor:"".concat(index,"-flexCheckDefault"),onClick:chooseItems(index),role:"button",children:[/*#__PURE__*/_jsx("input",{className:"d-none",type:"checkbox",defaultChecked:selectedItems.includes(answer.label),value:answer,id:"".concat(index,"-flexCheckDefault")}),answer.label]})})},index);})});};/* harmony default export */ var components_MultipleChoice = ((/* unused pure expression or super */ null && (MultipleChoice_MultipleChoice)));
;// CONCATENATED MODULE: ./src/assets/check.svg
var check_path;

var check_excluded = (/* unused pure expression or super */ null && (["title", "titleId"]));

function check_extends() { check_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return check_extends.apply(this, arguments); }

function check_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = check_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function check_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = check_objectWithoutProperties(_ref, check_excluded);

  return /*#__PURE__*/React.createElement("svg", check_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, check_path || (check_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.82.543c.382-.014.752.14 1.012.421.571.615.604 1.556.076 2.208L12.436 23.97a1.312 1.312 0 01-1.992.072 1.693 1.693 0 01-.167-.21 1.578 1.578 0 01-.138-.127L1.127 14.38a1.621 1.621 0 112.33-2.253l8.058 8.335L27.84 1.04c.239-.3.596-.481.98-.496z"
  })));
}

var check_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(SvgCheck)));
/* harmony default export */ var check = (__webpack_require__.p + "static/media/check.17a435a452a0d0862e75fff1b2095209.svg");

;// CONCATENATED MODULE: ./src/modules/Utils.js
var Utils_validateEmail=function validateEmail(t){return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(t).toLowerCase());};var Base64={decode:function decode(str){return decodeURIComponent(atob(str).split('').map(function(c){return"%".concat("00".concat(c.charCodeAt(0).toString(16)).slice(-2));}).join(''));},encode:function encode(str){return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,function toSolidBytes(match,p1){return String.fromCharCode("0x".concat(p1));}));}};var Utils_setCookie=function setCookie(name,value){var days=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var path=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'/';var domain=arguments.length>4?arguments[4]:undefined;var expires='';if(days){var date=new Date();date.setTime(date.getTime()+days*24*60*60*1000);expires="; expires=".concat(date.toUTCString());}document.cookie="".concat(name,"=").concat(value||'').concat(expires,"; path=").concat(path).concat(domain?";domain=".concat(domain):'');};var Utils_getCookie=function getCookie(name){var nameEQ="".concat(name,"=");var ca=document.cookie.split(';');for(var i=0;i<ca.length;i+=1){var c=ca[i];while(c.charAt(0)===' '){c=c.substring(1,c.length);}if(c.indexOf(nameEQ)===0)return c.substring(nameEQ.length,c.length);}return null;};var useWindowSize=function useWindowSize(){var _useState=useState([0,0]),_useState2=_slicedToArray(_useState,2),size=_useState2[0],setSize=_useState2[1];useLayoutEffect(function(){function updateSize(){setSize([window.innerWidth,window.innerHeight]);}window.addEventListener('resize',updateSize);updateSize();return function(){return window.removeEventListener('resize',updateSize);};},[]);return size;};var toTitleCase=function toTitleCase(str){return str.replace(/\w\S*/g,function(txt){return txt.charAt(0).toUpperCase()+txt.substr(1).toLowerCase();});};var waitFor=function waitFor(condition,cb){var errorCb=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var count=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;var counterLimit=arguments.length>4&&arguments[4]!==undefined?arguments[4]:50;// only try for 10s
if(typeof condition==='function'&&typeof cb==='function'&&count<counterLimit){setTimeout(function(){if(condition()){cb();}else{waitFor(condition,cb,errorCb,count+1,counterLimit);}},200);}else if(typeof errorCb==='function'){errorCb();}};var isABTest=function isABTest(testID){return new Promise(function(resolve){waitFor(function(){return window.google_optimize&&window.google_optimize.get;},function(){var testValue=window.google_optimize.get(testID);if(!testValue){resolve({test:false});}else{resolve({test:true,value:"".concat(testValue)});}});});};var truncateWords=function truncateWords(str,no_words){return str.split(" ").splice(0,no_words).join(" ");};var getItemRange=function getItemRange(itemTitle){var range='Aussie Skincare Essentials';if(!itemTitle){return range;}if(itemTitle.includes('Tasmanian Spring Water')){range='Tasmanian Spring Water';}else if(itemTitle.includes('Australian Pink Clay')){range='Australian Pink Clay';}else if(itemTitle.includes('Australian Glow Berries')){range='Australian Glow Berries';}else if(itemTitle.includes('Oil Control')){range='Oil Control';}return range;};var postIframeHeight=function postIframeHeight(key,val,site){if(window.top===window.self)return;window.parent.postMessage({'func':'updateIframeHeight','key':key,'value':val},"https://".concat(site));};var Utils_decodeAnswers=function decodeAnswers(object){Object.entries(object).forEach(function(data){var key=data[0];var value=data[1];object[key]=decodeURI(value);});return object;};var postMessageData=function postMessageData(site,category,action,label){if(window.top===window.self)return;window.parent.postMessage({'func':'callGaEvent','category':category,'action':action,'label':label},"https://".concat(site));};var Utils_postMessageCookie=function postMessageCookie(site,key,val){if(window.top===window.self)return;window.parent.postMessage({'func':'setCookieFromMessage','key':key,'value':val},"https://".concat(site));};var Utils_getCookieAnsweredQuestion=function getCookieAnsweredQuestion(){var answeredQuestion=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'answeredQuestion';if(Utils_getCookie(answeredQuestion)){var object=JSON.parse(Utils_getCookie(answeredQuestion));Object.entries(object).forEach(function(data){var key=data[0];var value=data[1];object[key]=decodeURI(value);});return object;}return null;};var Utils_setCookieAnsweredQuestion=function setCookieAnsweredQuestion(site,object){if(typeof object==='object'){Object.entries(object).forEach(function(data){var key=data[0];var value=decodeURI(data[1]);object[key]=encodeURI(value);});Utils_setCookie('answeredQuestion',JSON.stringify(object));}else{Utils_setCookie('answeredQuestion','');}};var Utils_postMessageToParentCookie=function postMessageToParentCookie(site,key,val){if(window.top===window.self)return;window.parent.postMessage({'func':'setCookieFromMessage','key':key,'value':val},"https://".concat(site));};
;// CONCATENATED MODULE: ./src/assets/splash-top.svg
var splash_top_path, splash_top_path2, splash_top_path3, splash_top_path4, splash_top_path5, splash_top_path6, splash_top_path7, splash_top_path8, splash_top_path9, splash_top_path10, splash_top_path11, splash_top_path12, splash_top_path13, splash_top_path14, splash_top_path15, splash_top_path16, splash_top_path17, splash_top_path18;

var splash_top_excluded = (/* unused pure expression or super */ null && (["title", "titleId"]));

function splash_top_extends() { splash_top_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return splash_top_extends.apply(this, arguments); }

function splash_top_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = splash_top_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function splash_top_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgSplashTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = splash_top_objectWithoutProperties(_ref, splash_top_excluded);

  return /*#__PURE__*/React.createElement("svg", splash_top_extends({
    width: 170,
    height: 100,
    viewBox: "0 0 170 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, splash_top_path || (splash_top_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.2987 43.2785C100.285 38.9289 104.799 34.111 108.837 28.8344C110.064 27.2334 107.866 24.9586 106.628 26.5765C102.59 31.8531 98.0739 36.6709 93.088 41.0206C91.5569 42.3573 93.7771 44.6076 95.2987 43.2785",
    fill: "#CC3195"
  })), splash_top_path2 || (splash_top_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.284 64.4862C109.355 65.9229 115.502 66.6289 121.734 66.5855C123.745 66.5723 123.75 63.3799 121.734 63.3931C115.774 63.4346 109.925 62.7814 104.114 61.4071C102.157 60.9445 101.32 64.0218 103.284 64.4862Z",
    fill: "#CC3195"
  })), splash_top_path3 || (splash_top_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5282 79.5535C88.8875 82.6421 90.2449 85.7307 91.6042 88.8192C92.4292 90.6883 95.1232 89.0685 94.3038 87.207C92.9446 84.1184 91.5853 81.0299 90.2279 77.9413C89.4029 76.0704 86.7089 77.694 87.5282 79.5535Z",
    fill: "#CC3195"
  })), splash_top_path4 || (splash_top_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1842 78.0706C61.6854 82.0144 57.1846 85.9601 52.6858 89.9057C51.1567 91.2461 53.3749 93.4946 54.8965 92.1636C59.3953 88.218 63.896 84.2723 68.3948 80.3285C69.9241 78.9881 67.7039 76.7377 66.1842 78.0706Z",
    fill: "#CC3195"
  })), splash_top_path5 || (splash_top_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7512 51.8028C61.4853 50.3736 55.2175 48.9446 48.9517 47.5154C46.9921 47.068 46.1557 50.1453 48.121 50.5927C54.3869 52.0237 60.6528 53.4528 66.9205 54.882C68.8801 55.3294 69.7165 52.2521 67.7512 51.8029",
    fill: "#CC3195"
  })), splash_top_path6 || (splash_top_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.385 39.2775C76.6538 35.1299 74.9245 30.984 73.1934 26.8383C72.4061 24.9542 69.714 26.5778 70.4937 28.4505C72.2249 32.5963 73.9561 36.7421 75.6872 40.8898C76.4726 42.7738 79.1666 41.1484 78.385 39.2775",
    fill: "#CC3195"
  })), splash_top_path7 || (splash_top_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5941 12.7941C33.7526 9.57145 36.6127 6.00529 39.1708 2.09739C39.9467 0.913672 38.5554 -0.772179 37.77 0.426552C35.2119 4.33451 32.3517 7.90073 29.1934 11.1214C28.2248 12.1126 29.6295 13.7777 30.5941 12.7941Z",
    fill: "#CC3195"
  })), splash_top_path8 || (splash_top_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5941 12.7941C33.7526 9.57145 36.6127 6.00529 39.1708 2.09739C39.9467 0.913672 38.5554 -0.772179 37.77 0.426552C35.2119 4.33451 32.3517 7.90073 29.1934 11.1214C28.2248 12.1126 29.6295 13.7777 30.5941 12.7941Z",
    fill: "#CC3195"
  })), splash_top_path9 || (splash_top_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6532 28.4974C39.5008 29.5603 43.3936 30.0832 47.3411 30.053C48.6154 30.0417 48.6192 27.678 47.3411 27.6875C43.5654 27.7176 39.8613 27.2363 36.18 26.2168C34.9415 25.8751 34.411 28.1538 35.6532 28.4974",
    fill: "#CC3195"
  })), splash_top_path10 || (splash_top_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6532 28.4974C39.5008 29.5603 43.3936 30.0832 47.3411 30.053C48.6154 30.0417 48.6192 27.678 47.3411 27.6875C43.5654 27.7176 39.8613 27.2363 36.18 26.2168C34.9415 25.8751 34.411 28.1538 35.6532 28.4974",
    fill: "#CC3195"
  })), splash_top_path11 || (splash_top_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6723 39.6523C26.5332 41.9405 27.394 44.2267 28.2549 46.5129C28.7779 47.8967 30.4827 46.6979 29.9635 45.3197C29.1026 43.0354 28.2417 40.7473 27.3827 38.461C26.8598 37.0735 25.1532 38.276 25.6723 39.6523Z",
    fill: "#CC3195"
  })), splash_top_path12 || (splash_top_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6723 39.6523C26.5332 41.9405 27.394 44.2267 28.2549 46.5129C28.7779 47.8967 30.4827 46.6979 29.9635 45.3197C29.1026 43.0354 28.2417 40.7473 27.3827 38.461C26.8598 37.0735 25.1532 38.276 25.6723 39.6523Z",
    fill: "#CC3195"
  })), splash_top_path13 || (splash_top_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1516 38.5558C9.30089 41.4764 6.45012 44.3969 3.60131 47.3194C2.63287 48.3105 4.0393 49.9775 5.00024 48.9901L13.5524 40.2266C14.5208 39.2354 13.1144 37.5703 12.1516 38.5558Z",
    fill: "#CC3195"
  })), splash_top_path14 || (splash_top_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1516 38.5558C9.30089 41.4764 6.45012 44.3969 3.60131 47.3194C2.63287 48.3105 4.0393 49.9775 5.00024 48.9901L13.5524 40.2266C14.5208 39.2354 13.1144 37.5703 12.1516 38.5558Z",
    fill: "#CC3195"
  })), splash_top_path15 || (splash_top_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1443 19.1072L1.23559 15.9318C-0.00476956 15.6014 -0.53522 17.8801 0.71075 18.2123L12.6176 21.3878C13.8599 21.7181 14.3903 19.4395 13.1443 19.1072Z",
    fill: "#CC3195"
  })), splash_top_path16 || (splash_top_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1443 19.1072L1.23559 15.9318C-0.00476956 15.6014 -0.53522 17.8801 0.71075 18.2123L12.6176 21.3878C13.8599 21.7181 14.3903 19.4395 13.1443 19.1072Z",
    fill: "#CC3195"
  })), splash_top_path17 || (splash_top_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 9.83128C18.7832 6.76164 17.6863 3.69194 16.5913 0.620276C16.0929 -0.774803 14.3863 0.429667 14.881 1.81346C15.9778 4.88505 17.0746 7.95476 18.1697 11.0245C18.6681 12.4195 20.3747 11.217 19.88 9.83128Z",
    fill: "#CC3195"
  })), splash_top_path18 || (splash_top_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.88 9.83128C18.7832 6.76164 17.6863 3.69194 16.5913 0.620276C16.0929 -0.774803 14.3863 0.429667 14.881 1.81346C15.9778 4.88505 17.0746 7.95476 18.1697 11.0245C18.6681 12.4195 20.3747 11.217 19.88 9.83128Z",
    fill: "#CC3195"
  })));
}

var splash_top_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(SvgSplashTop)));
/* harmony default export */ var splash_top = (__webpack_require__.p + "static/media/splash-top.9632894c247c781998d4bc3e76c37592.svg");

;// CONCATENATED MODULE: ./src/UI/components/EmailForm.js
var EmailForm=function EmailForm(props){var onSubmit=props.onSubmit,skipEmail=props.skipEmail;var _useState=useState(''),_useState2=_slicedToArray(_useState,2),email=_useState2[0],setEmail=_useState2[1];var _useState3=useState(false),_useState4=_slicedToArray(_useState3,2),isValidEmail=_useState4[0],setIsValidEmail=_useState4[1];var _useState5=useState(false),_useState6=_slicedToArray(_useState5,2),termChecked=_useState6[0],setTermCheck=_useState6[1];var onEmailChange=function onEmailChange(e){setIsValidEmail(validateEmail(e.target.value));setEmail(e.target.value);};var onCheckTerm=function onCheckTerm(e){setTermCheck(e.target.checked);};var submitEmail=function submitEmail(e){onSubmit(email);e.preventDefault();};return/*#__PURE__*/_jsx("div",{className:"survey-email-submit container bg-primary-light mt-lg-5",children:/*#__PURE__*/_jsxs("div",{className:"row d-flex align-items-center text-center",children:[/*#__PURE__*/_jsx("div",{className:"col-12 col-lg-6 p-0",children:/*#__PURE__*/_jsxs("picture",{className:"w-100 d-block",children:[/*#__PURE__*/_jsx("source",{type:"image/png",srcSet:"https://imagedelivery.net/ghVX8djKS3R8-n0oGeWHEA/0d8b37c6-fdf3-40a4-5b2d-d46c72ad3200/828x",media:"(min-width: 992px)"}),/*#__PURE__*/_jsx("img",{src:"https://imagedelivery.net/ghVX8djKS3R8-n0oGeWHEA/c197ee9c-de80-4abd-0e3c-aea8e4a6c600/828x",alt:"",className:"w-100 embed-responsive-item fit--cover"})]})}),/*#__PURE__*/_jsxs("div",{className:"col-12 col-lg-6 px-0 py-3",children:[/*#__PURE__*/_jsx("div",{className:"w-100 text-end me-ng me-lg-0 d-none d-lg-block",children:/*#__PURE__*/_jsx(SplashTop,{})}),/*#__PURE__*/_jsxs("div",{className:"emailBox px-g",children:[/*#__PURE__*/_jsx("p",{className:"h1 mb-0",children:"Get 15% Off* your customised routine!"}),/*#__PURE__*/_jsx("p",{className:"mt-2 h4 fw-normal col-lg-9 mx-auto px-lg-3",children:"We've got your routine ready! Enter your email to view your results and get 15% OFF your first purchase."}),/*#__PURE__*/_jsx("div",{className:"col-12 col-lg-11 ms-auto me-auto mt-4",children:/*#__PURE__*/_jsx("div",{className:"form-group",children:/*#__PURE__*/_jsxs("form",{onSubmit:submitEmail,children:[/*#__PURE__*/_jsx("input",{type:"email",className:"form-control bg-light-gray",placeholder:"Email",onChange:onEmailChange}),/*#__PURE__*/_jsxs("div",{className:"d-flex pb-2 justify-content-center align-items-center mt-3",children:[/*#__PURE__*/_jsxs("label",{className:"checkbox-number align-items-center pt-0 font-size-sm justify-content-center",htmlFor:"agree",children:[/*#__PURE__*/_jsx("input",{className:"d-none",type:"checkbox",value:"true",id:"agree",onChange:onCheckTerm}),/*#__PURE__*/_jsx("div",{className:"".concat(termChecked?'bg-primary border-0':''," custom-check me-1 mt-0 form-check-input text-center d-flex align-items-center justify-content-center"),children:/*#__PURE__*/_jsx(Check,{className:"".concat(!termChecked?'d-none':''," svg text-white")})})]}),/*#__PURE__*/_jsxs("label",{className:"font-size-sm",htmlFor:"agree",children:["I agree to ",/*#__PURE__*/_jsx("a",{target:"_blank",href:"https://www.sandandsky.com/pages/privacy-policy",children:"Privacy Policy"})," & ",/*#__PURE__*/_jsx("a",{target:"_blank",href:"https://www.sandandsky.com/pages/term-condition",children:"Terms & Conditions"})]})]}),/*#__PURE__*/_jsx("p",{className:"font-size-sm",children:"By signing up, you agree to receive exclusive offers via email. Sign up not required for purchase. Opt out any time."}),/*#__PURE__*/_jsx("button",{type:"submit",className:"btn btn-lg d-block btn-primary mb-3 px-6 mx-auto mt-3",disabled:!isValidEmail||!termChecked,children:"Submit"})]})})}),/*#__PURE__*/_jsx("div",{className:"footer-action w-100 mt-4",children:/*#__PURE__*/_jsx("a",{href:"#",className:"d-block text-underline text-black w-100 mt-2 mb-lg-4",onClick:skipEmail,children:"Skip this step"})})]}),/*#__PURE__*/_jsx("div",{className:"w-100 text-start ms-ng ms-lg-0 d-none d-lg-block",children:/*#__PURE__*/_jsx(SplashBottom,{})})]})]})});};/* harmony default export */ var components_EmailForm = ((/* unused pure expression or super */ null && (EmailForm)));
;// CONCATENATED MODULE: ./src/UI/components/ResultContent.js
var ResultContent_ResultContent=function ResultContent(props){var viewMyResult=props.viewMyResult;return/*#__PURE__*/_jsx("div",{className:"survey-email-submit container bg-primary-light mt-lg-5",children:/*#__PURE__*/_jsxs("div",{className:"row d-flex align-items-center text-center",children:[/*#__PURE__*/_jsx("div",{className:"col-12 col-lg-6 p-0",children:/*#__PURE__*/_jsxs("picture",{className:"w-100 d-block",children:[/*#__PURE__*/_jsx("source",{type:"image/png",srcSet:"https://imagedelivery.net/ghVX8djKS3R8-n0oGeWHEA/0d8b37c6-fdf3-40a4-5b2d-d46c72ad3200/828x",media:"(min-width: 992px)"}),/*#__PURE__*/_jsx("img",{src:"https://imagedelivery.net/ghVX8djKS3R8-n0oGeWHEA/c197ee9c-de80-4abd-0e3c-aea8e4a6c600/828x",alt:"",className:"w-100 embed-responsive-item fit--cover"})]})}),/*#__PURE__*/_jsxs("div",{className:"col-12 col-lg-5 px-0 py-5 pb-7",children:[/*#__PURE__*/_jsx("div",{className:"w-100 text-end me-ng me-lg-0 d-none d-lg-block",children:/*#__PURE__*/_jsx(SplashTop,{})}),/*#__PURE__*/_jsxs("div",{className:"emailBox px-g mb-5 mb-lg-0",children:[/*#__PURE__*/_jsx("p",{className:"h1",children:"Thanks! Here is your promo code:"}),/*#__PURE__*/_jsxs("div",{className:"col-12 col-lg-8 ms-auto me-auto mt-2 mb-7 mb-lg-0",children:[/*#__PURE__*/_jsx("span",{className:"h1 px-4 py-1 text-primary rounded p-2 bg-light-gray d-inline-block bg-white",children:"SKIN15"}),/*#__PURE__*/_jsx("p",{className:"mt-2 mb-4",children:"Promotion only applies to the first purchase."}),/*#__PURE__*/_jsx("button",{className:"mt-2 btn btn-lg btn-primary w-100",onClick:viewMyResult,children:"View my results"})]})]}),/*#__PURE__*/_jsx("div",{className:"w-100 text-start ms-ng ms-lg-0 d-none d-lg-block",children:/*#__PURE__*/_jsx(SplashBottom,{})})]})]})});};/* harmony default export */ var components_ResultContent = ((/* unused pure expression or super */ null && (ResultContent_ResultContent)));
;// CONCATENATED MODULE: ./src/modules/skin-type.js
var skin_type_getSkinType=function getSkinType(currentAnswers){var skinConcerns=currentAnswers[7];var skinType=currentAnswers[1];var skinConcernsAnswers=Questions[6].answers;var skinTypeAnswers=Questions[0].answers;var skinResult={};var skinResultList={'Oily':{title:'Oily, Acne-Prone',desc:'Your skin tends to over-produce sebum and is more likely to be prone to blemishes or acne. Rebalancing your skin\'s microbiome is crucial to prevent excess oil and breakouts.'},'Combination':{title:'Combination',desc:'Hydrating is key to regulating and balacing sebum production especially for combination skin. Twice a week, pamper your skin by multi-masking to target multiple skin concerns.'},'Normal':{title:'Normal',desc:'Give your skin an extra burst of hydration to maintain its microbiome. Ultra-hydrating ingredients and AHAs will be your best friend.'},'Dry':{title:'Dry',desc:'Add that extra burst of hydration to protect your skin against dryness or dehydration. Ultra-hydrating ingredients such as Hyaluronic Acid will be your best friend.'},'Sensitive':{title:'Sensitive',desc:'Redness and flaky skin are often a signs of comprimised skin barrier. You will find incorporating ingredients with ultra-hydrating and anti-inflammatory properties to your skincare routine helpful to soothe and strengthen your skin barrier.'}};switch(skinConcerns){// Clogged or enlarged pores, Blemishes or acne
case skinConcernsAnswers[0]:case skinConcernsAnswers[1]:switch(skinType){case skinTypeAnswers[0]:skinResult=skinResultList['Oily'];break;case skinTypeAnswers[1]:skinResult=skinResultList['Combination'];break;case skinTypeAnswers[2]:skinResult=skinResultList['Normal'];break;default:skinResult=skinResultList['Sensitive'];break;};break;// Excess oil
case skinConcernsAnswers[2]:switch(skinType){case skinTypeAnswers[0]:skinResult=skinResultList['Oily'];break;case skinTypeAnswers[1]:skinResult=skinResultList['Combination'];break;case skinTypeAnswers[2]:skinResult=skinResultList['Dry'];break;default:skinResult=skinResultList['Sensitive'];break;};break;// Scarring or uneven skin texture, Redness, Dryness and dehydration, Fine lines or wrinkles
case skinConcernsAnswers[3]:case skinConcernsAnswers[4]:case skinConcernsAnswers[5]:case skinConcernsAnswers[6]:switch(skinType){case skinTypeAnswers[0]:skinResult=skinResultList['Oily'];break;case skinTypeAnswers[1]:skinResult=skinResultList['Combination'];break;case skinTypeAnswers[2]:skinResult=skinResultList['Dry'];break;default:skinResult=skinResultList['Sensitive'];break;};break;// Dark spots or hyperpigmentation, Dullness or uneven skin tone
case skinConcernsAnswers[7]:case skinConcernsAnswers[8]:switch(skinType){case skinTypeAnswers[0]:skinResult.title='Oily';skinResult.desc=skinResultList['Oily'].desc;break;case skinTypeAnswers[1]:skinResult=skinResultList['Combination'];break;case skinTypeAnswers[2]:skinResult=skinResultList['Normal'];break;default:skinResult=skinResultList['Sensitive'];break;};break;case skinConcernsAnswers[9]:switch(skinType){case skinTypeAnswers[0]:skinResult=skinResultList['Oily'];break;case skinTypeAnswers[1]:skinResult=skinResultList['Combination'];break;case skinTypeAnswers[2]:skinResult=skinResultList['Normal'];break;default:skinResult=skinResultList['Sensitive'];break;};break;default:skinResult=skinResultList['Sensitive'];break;}return skinResult;};/* harmony default export */ var skin_type = ((/* unused pure expression or super */ null && (skin_type_getSkinType)));
;// CONCATENATED MODULE: ./src/assets/loader.svg
var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var loader_excluded = (/* unused pure expression or super */ null && (["title", "titleId"]));

function loader_extends() { loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return loader_extends.apply(this, arguments); }

function loader_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = loader_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = loader_objectWithoutProperties(_ref, loader_excluded);

  return /*#__PURE__*/React.createElement("svg", loader_extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgb(255, 255, 255)",
      display: "block",
      shapeRendering: "auto"
    },
    width: "54px",
    height: "54px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 32,
    rx: 0.5,
    ry: 2.2,
    width: 1,
    height: 10,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.875s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 32,
    rx: 0.5,
    ry: 2.2,
    width: 1,
    height: 10,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.75s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 32,
    rx: 0.5,
    ry: 2.2,
    width: 1,
    height: 10,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.625s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(135 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 32,
    rx: 0.5,
    ry: 2.2,
    width: 1,
    height: 10,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.5s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 32,
    rx: 0.5,
    ry: 2.2,
    width: 1,
    height: 10,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.375s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(225 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 32,
    rx: 0.5,
    ry: 2.2,
    width: 1,
    height: 10,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.25s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 32,
    rx: 0.5,
    ry: 2.2,
    width: 1,
    height: 10,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "-0.125s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(315 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.5,
    y: 32,
    rx: 0.5,
    ry: 2.2,
    width: 1,
    height: 10,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
}

var loader_ForwardRef = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(SvgLoader)));
/* harmony default export */ var loader = (__webpack_require__.p + "static/media/loader.1fb3be8090c5ed486414810c60b63995.svg");

;// CONCATENATED MODULE: ./src/modules/environment-stress.js
var ENV_DESC={'LOW':{'title':'LOW','desc':'Low exposures to environmental stressors can have a healthy impact on your skin, where skin feels less sensitive to external aggravators. Hydrating is key to regulating and balacing sebum production, giving your skin that supple feel, and use products with antioxidants and AHAs in your routine.'},'AVG':{'title':'AVERAGE','desc':'Low exposures to environmental stressors can reduce implications on your skin, where skin feels less reactive to external aggravators. For maximum protection, reduce the amount of hours exposed outdoors, remember to use sunscreen, cleanse skin with a gentle cleanser to balance oil levels and continue using antioxidants and AHAs in your skincare routine. Hydrating is key to regulating and balacing sebum production.'},'HI':{'title':'HIGH','desc':'Being exposed to environmental stressors may lead to more wrinkles, dryness, saggy and dull skin over time. It can also make skin more sensitive and reactive, resulting in an overproduction of sebum, leading to acne and other skin problems such as dry, rough and much more irritated skin. Rebalancing skin is crucial and hydrating is key. Reduce the amount of hours exposed outdoors, remember to use sunscreen, cleanse skin with a gentle cleanser to maintain skin\'s moisture, and continue using antioxidants and AHAs in your skincare routine.'}};var environment_stress_getEnvironmentStress=function getEnvironmentStress(currentAnswers){var hourAnswer=currentAnswers[2];var stressAnswer=currentAnswers[3];var airAnswer=currentAnswers[4];var resultKey;if(['Less than 1 hour','2 hours','3 hours','4 hours'].includes(hourAnswer)){if(['No','Uncertain'].includes(airAnswer)&&['None','Low'].includes(stressAnswer)){resultKey='LOW';}else if(['Yes'].includes(airAnswer)&&['Medium','High'].includes(stressAnswer)){resultKey='HI';}else{resultKey='AVG';}}else{resultKey=['No','Uncertain'].includes(airAnswer)&&['None','Low'].includes(stressAnswer)?'AVG':'HI';}return ENV_DESC[resultKey]?ENV_DESC[resultKey]:ENV_DESC['HI'];};/* harmony default export */ var environment_stress = ((/* unused pure expression or super */ null && (environment_stress_getEnvironmentStress)));
;// CONCATENATED MODULE: ./src/modules/product-result.js
var getProductRecommendation=function getProductRecommendation(Questions,currentAnswer,store){var envStressResult=getEnvironmentStress(currentAnswer);var skinConcernsQ=Questions[6].answers;var skinConcernsA=currentAnswer[7];var ageRanges=Questions[4].answers;var ageRangesA=currentAnswer[5];var productsRecommend=[];var activePriority=[];var skinTypeQuestions=Questions[0].answers;var skinTypeAnswer=currentAnswer[1];// console.log(skinConcernsA, 'testing');
switch(skinConcernsA){case skinConcernsQ[0]://Clogged or enlarged pores
switch(ageRangesA){case ageRanges[0]:// <20, 20-25
case ageRanges[1]:switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}else{productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','APC Mask','Marshmallow Toner'];activePriority=['AHAs','Vitamin E','Glycolic Acid'];}else{productsRecommend=['APC Mask','Marshmallow Toner','TSW Serum'];activePriority=['Vitamin E','Glycolic Acid','Hyaluronic Acid'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Mask','Marshmallow Toner','TSW Night Cream'];activePriority=['Vitamin E','Glycolic Acid','Hyaluronic Acid'];}else{productsRecommend=['APC Mask','Marshmallow Toner','TSW Night Cream'];activePriority=['Vitamin E','Glycolic Acid','Hyaluronic Acid'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','Marshmallow Toner','OC Moisturiser'];activePriority=['AHAs','Glycolic Acid','Niacinamide'];}else{productsRecommend=['APC Mask','TSW Serum','OC Moisturiser'];activePriority=['Vitamin E','Hyaluronic Acid','Niacinamide'];}break;}break;default://26-35, 36-45, >45
switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}else{productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','APC Mask','Marshmallow Toner'];activePriority=['AHAs','Vitamin E','Glycolic Acid'];}else{productsRecommend=['Marshmallow Toner','APC Mask','TSW Serum'];activePriority=['Glycolic Acid','Vitamin E','Hyaluronic Acid'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Mask','AEA Serum','TSW Night Cream'];activePriority=['AHAs','Vitamin C','Hyaluronic Acid'];}else{productsRecommend=['Marshmallow Toner','APC Mask','TSW Night Cream'];activePriority=['Glycolic Acid','Vitamin E','Hyaluronic Acid'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['Marshmallow Toner','TSW Mask','TSW Cream'];activePriority=['Glycolic Acid','Vegan Squalane','Hyaluronic Acid'];}else{productsRecommend=['AEA Enzyme Polish','Marshmallow Toner','TSW Cream'];activePriority=['Vitamin C','AHAs','Hyaluronic Acid'];}break;}break;}break;case skinConcernsQ[1]://Blemishes or acne
switch(ageRangesA){case ageRanges[0]:// <20, 20-25
case ageRanges[1]:switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}else{productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}else{productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','Marshmallow Toner','OC Moisturiser'];activePriority=['AHAs','Glycolic Acid','Niacinamide'];}else{productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','TSW Mask','Marshmallow Toner'];activePriority=['AHAs','Vegan Squalane','Glycolic Acid'];}else{productsRecommend=['OC Cleanser','TSW Mask','Marshmallow Toner'];activePriority=['AHAs','Vegan Squalane','Glycolic Acid'];}break;}break;default://26-35, 36-45, >45
switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}else{productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','OC Mask','TSW Serum'];activePriority=['AHAs','Salicylic Acid','Hyaluronic Acid'];}else{productsRecommend=['OC Cleanser','OC Mask','TSW Cream'];activePriority=['AHAs','Salicylic Acid','Hyaluronic Acid'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','Marshmallow Toner','TSW Night Cream'];activePriority=['AHAs','Glycolic Acid','Hyaluronic Acid'];}else{productsRecommend=['APC Cleanser','APC Mask','TSW Night Cream'];activePriority=['AHAs','Vitamin E','Hyaluronic Acid'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['Marshmallow Toner','APC Cleanser','TSW Mask'];activePriority=['Glycolic Acid','AHAs','Vegan Squalane'];}else{productsRecommend=['Marshmallow Toner','OC Cleanser','TSW Mask'];activePriority=['Glycolic Acid','AHAs','Vegan Squalane'];}break;}break;}break;case skinConcernsQ[2]://Excess oil
switch(ageRangesA){case ageRanges[0]:// <20, 20-25
case ageRanges[1]:switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}else{productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','APC Mask','OC Moisturiser'];activePriority=['AHAs','Vitamin E','Niacinamide'];}else{productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['Marshmallow Toner','TSW Mask','TSW Night Cream'];activePriority=['Glycolic Acid','Vegan Squalane','Hyaluronic Acid'];}else{productsRecommend=['Marshmallow Toner','TSW Mask','TSW Night Cream'];activePriority=['Glycolic Acid','Vegan Squalane','Hyaluronic Acid'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','Marshmallow Toner','TSW Cream'];activePriority=['AHAs','Glycolic Acid','Hyaluronic Acid'];}else{productsRecommend=['OC Cleanser','Marshmallow Toner','TSW Cream'];activePriority=['AHAs','Glycolic Acid','Hyaluronic Acid'];}break;}break;default://26-35, 36-45, >45
switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}else{productsRecommend=['OC Cleanser','OC Mask','OC Moisturiser'];activePriority=['AHAs','Salicylic Acid','Niacinamide'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','APC Mask','TSW Serum'];activePriority=['AHAs','Vitamin E','Hyaluronic Acid'];}else{productsRecommend=['OC Cleanser','OC Mask','TSW Cream'];activePriority=['AHAs','Salicylic Acid','Hyaluronic Acid'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['Marshmallow Toner','APC Mask','TSW Night Cream'];activePriority=['AHAs','Vitamin E','Hyaluronic Acid'];}else{productsRecommend=['Marshmallow Toner','TSW Mask','TSW Night Cream'];activePriority=['AHAs','Vegan Squalane','Hyaluronic Acid'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','Marshmallow Toner','TSW Serum'];activePriority=['AHAs','Glycolic Acid','Hyaluronic Acid'];}else{productsRecommend=['OC Cleanser','Marshmallow Toner','TSW Cream'];activePriority=['AHAs','Glycolic Acid','Hyaluronic Acid'];}break;}break;}break;case skinConcernsQ[3]://Scarring or uneven skin texture
switch(ageRangesA){case ageRanges[0]:// <20, 20-25
case ageRanges[1]:switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','APC Exfoliator','AEA Serum'];activePriority=['AHAs','Vitamin E','Vitamin C'];}else{productsRecommend=['AEA Enzyme Polish','AEA Mask','AEA Moisturiser'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Exfoliator','Marshmallow Toner','TSW Cream'];activePriority=['Vitamin E','AHAs','Hyaluronic Acid'];}else{productsRecommend=['AEA Enzyme Polish','AEA Mask','AEA Moisturiser'];activePriority=['Vitamin C','Glycolic Acid','Hyaluronic Acid'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','APC Exfoliator','Pro Youth Dark Spot Serum'];activePriority=['AHAs','Vitamin E','Glycolic Acid'];}else{productsRecommend=['APC Exfoliator','AEA Moisturiser','Pro Youth Dark Spot Serum'];activePriority=['Vitamin E','Vitamin C','Glycolic Acid'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Enzyme Polish','AEA Serum','TSW Cream'];activePriority=['AHAs','Vitamin C','Hyaluronic Acid'];}else{productsRecommend=['AEA Enzyme Polish','Pro Youth Dark Spot Serum','AEA Moisturiser'];activePriority=['AHAs','Glycolic Acid','Vegan Squalane'];}break;}break;default://26-35, 36-45, >45
switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','APC Exfoliator','AEA Serum'];activePriority=['AHAs','Vitamin E','Vitamin C'];}else{productsRecommend=['AEA Enzyme Polish','AEA Mask','AEA Serum'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','AEA Enzyme Polish','AEA Mask'];activePriority=['AHAs','Vitamin C','Hyaluronic Acid'];}else{productsRecommend=['APC Cleanser','AEA Enzyme Polish','AEA Mask'];activePriority=['AHAs','Vitamin C','Hyaluronic Acid'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','APC Exfoliator','AEA Moisturiser'];activePriority=['AHAs','Vitamin E','Vitamin C'];}else{productsRecommend=['APC Cleanser','AEA Mask','Pro Youth Dark Spot Serum'];activePriority=['AHAs','Hyaluronic Acid','Glycolic Acid'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Enzyme Polish','Pro Youth Dark Spot Serum','AEA Moisturiser'];activePriority=['AHAs','Glycolic Acid','Vegan Squalane'];}else{productsRecommend=['AEA Enzyme Polish','Pro Youth Dark Spot Serum','AEA Moisturiser'];activePriority=['AHAs','Glycolic Acid','Vegan Squalane'];}break;}break;}break;case skinConcernsQ[4]://Redness
switch(ageRangesA){case ageRanges[0]:// <20, 20-25
case ageRanges[1]:switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','OC Mask','Marshmallow Toner'];activePriority=['AHAs','Salicylic Acid','Glycolic Acid'];}else{productsRecommend=['OC Cleanser','OC Mask','Marshmallow Toner'];activePriority=['AHAs','Salicylic Acid','Glycolic Acid'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','TSW Mask','TSW Cream'];activePriority=['AHAs','Vegan Squalane','Hyaluronic Acid'];}else{productsRecommend=['APC Cleanser','APC Mask','TSW Cream'];activePriority=['AHAs','Vitamin E','Hyaluronic Acid'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Mask','TSW Serum','TSW Night Cream'];activePriority=['Vitamin E','Hyaluronic Acid','Vegan Squalane'];}else{productsRecommend=['AEA Enzyme Polish','TSW Mask','TSW Night Cream'];activePriority=['AHAs','Vegan Squalane','Hyaluronic Acid'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['Marshmallow Toner','Pro Youth Dark Spot Serum','TSW Cream'];activePriority=['Glycolic Acid','Glycolic Acid','AHAs'];}else{productsRecommend=['TSW Mask','Marshmallow Toner','TSW Cream'];activePriority=['Vegan Squalane','Glycolic Acid','AHAs'];}break;}break;default://26-35, 36-45, >45
switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','APC Mask','TSW Serum'];activePriority=['AHAs','Vitamin E','Hyaluronic Acid'];}else{productsRecommend=['OC Cleanser','OC Mask','TSW Serum'];activePriority=['AHAs','Salicylic Acid','Hyaluronic Acid'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Mask','TSW Serum','TSW Night Cream'];activePriority=['Vitamin E','AHAs','Hyaluronic Acid'];}else{productsRecommend=['APC Cleanser','APC Mask','TSW Night Cream'];activePriority=['AHAs','Vitamin E','Hyaluronic Acid'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['TSW Mask','Marshmallow Toner','TSW Night Cream'];activePriority=['Vegan Squalane','Glycolic Acid','Hyaluronic Acid'];}else{productsRecommend=['Marshmallow Toner','TSW Mask','OC Moisturiser'];activePriority=['AHAs','Vegan Squalane','Niacinamide'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['Marshmallow Toner','Pro Youth Dark Spot Serum','TSW Cream'];activePriority=['Glycolic Acid','Glycolic Acid','Hyaluronic Acid'];}else{productsRecommend=['TSW Mask','Marshmallow Toner','Pro Youth Dark Spot Serum'];activePriority=['Vegan Squalane','Glycolic Acid','Glycolic Acid'];}break;}break;}break;case skinConcernsQ[5]://Dryness and dehydration
switch(ageRangesA){case ageRanges[0]:// <20, 20-25
case ageRanges[1]:switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Mask','Marshmallow Toner','TSW Cream'];activePriority=['Vitamin E','Glycolic Acid','Hyaluronic Acid'];}else{productsRecommend=['APC Cleanser','Marshmallow Toner','TSW Cream'];activePriority=['AHAs','Glycolic Acid','Hyaluronic Acid'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Mask','TSW Serum','TSW Night Cream'];activePriority=['Vitamin E','Hyaluronic Acid','Vegan Squalane'];}else{productsRecommend=['APC Mask','TSW Serum','TSW Night Cream'];activePriority=['Vitamin E','Hyaluronic Acid','Vegan Squalane'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['Marshmallow Toner','TSW Serum','TSW Night Cream'];activePriority=['Glycolic Acid','Hyaluronic Acid','Vegan Squalane'];}else{productsRecommend=['Marshmallow Toner','TSW Serum','TSW Night Cream'];activePriority=['Glycolic Acid','Hyaluronic Acid','Vegan Squalane'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['TSW Mask','Marshmallow Toner','TSW Serum'];activePriority=['Vegan Squalane','Glycolic Acid','Hyaluronic Acid'];}else{productsRecommend=['TSW Mask','TSW Serum','TSW Cream'];activePriority=['Vegan Squalane','Hyaluronic Acid','AHAs'];}break;}break;default://26-35, 36-45, >45
switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','TSW Mask','TSW Serum'];activePriority=['AHAs','Vegan Squalane','Hyaluronic Acid'];}else{productsRecommend=['TSW Mask','TSW Serum','TSW Cream'];activePriority=['Vegan Squalane','Hyaluronic Acid','AHAs'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Enzyme Polish','TSW Mask','TSW Serum'];activePriority=['AHAs','Vegan Squalane','Hyaluronic Acid'];}else{productsRecommend=['TSW Mask','Marshmallow Toner','TSW Night Cream'];activePriority=['Vegan Squalane','Glycolic Acid','Hyaluronic Acid'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['TSW Mask','AEA Serum','TSW Night Cream'];activePriority=['Vegan Squalane','Vitamin C','Hyaluronic Acid'];}else{productsRecommend=['Marshmallow Toner','TSW Mask','TSW Serum'];activePriority=['Glycolic Acid','Vegan Squalane','Hyaluronic Acid'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Enzyme Polish','Marshmallow Toner','TSW Cream'];activePriority=['Vitamin C','Glycolic Acid','Hyaluronic Acid'];}else{productsRecommend=['TSW Mask','TSW Serum','Marshmallow Toner'];activePriority=['Vegan Squalane','Hyaluronic Acid','Glycolic Acid'];}break;}break;}break;case skinConcernsQ[6]://Fine lines or wrinkles
switch(ageRangesA){case ageRanges[0]:// <20, 20-25
case ageRanges[1]:switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','OC Mask','AEA Serum'];activePriority=['AHAs','Salicylic Acid','Vitamin C'];}else{productsRecommend=['APC Cleanser','AEA Mask','AEA Moisturiser'];activePriority=['AHAs','Vitamin C','Vegan Squalane'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','AEA Mask','TSW Cream'];activePriority=['AHAs','Vitamin C','Hyaluronic Acid'];}else{productsRecommend=['APC Cleanser','AEA Mask','TSW Cream'];activePriority=['AHAs','Vitamin C','Hyaluronic Acid'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Mask','APC Cleanser','Pro Youth Dark Spot Serum'];activePriority=['Vitamin C','AHAs','Glycolic Acid'];}else{productsRecommend=['APC Mask','APC Cleanser','Pro Youth Dark Spot Serum'];activePriority=['Vitamin C','AHAs','Glycolic Acid'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Mask','Pro Youth Dark Spot Serum','TSW Cream'];activePriority=['Vitamin C','Glycolic Acid','Hyaluronic Acid'];}else{productsRecommend=['AEA Mask','Pro Youth Dark Spot Serum','TSW Cream'];activePriority=['Vitamin C','Glycolic Acid','Hyaluronic Acid'];}break;}break;default://26-35, 36-45, >45
switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','AEA Mask','Anti-Aging Eye Cream'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}else{productsRecommend=['APC Cleanser','AEA Moisturiser','Anti-Aging Eye Cream'];activePriority=['AHAs','Vegan Squalane','Vitamin C'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','AEA Serum','Anti-Aging Eye Cream'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}else{productsRecommend=['APC Cleanser','AEA Mask','Anti-Aging Eye Cream'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Enzyme Polish','Pro Youth Dark Spot Serum','Anti-Aging Eye Cream'];activePriority=['AHAs','Glycolic Acid','Vitamin C'];}else{productsRecommend=['AEA Enzyme Polish','Pro Youth Dark Spot Serum','Anti-Aging Eye Cream'];activePriority=['AHAs','Glycolic Acid','Vitamin C'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Enzyme Polish','AEA Moisturiser','Anti-Aging Eye Cream'];activePriority=['AHAs','Vegan Squalane','Vitamin C'];}else{productsRecommend=['AEA Enzyme Polish','Pro Youth Dark Spot Serum','Anti-Aging Eye Cream'];activePriority=['Vitamin C','Glycolic Acid','Vitamin C'];}break;}break;}break;case skinConcernsQ[7]://Dark spots or hyperpigmentation
switch(ageRangesA){case ageRanges[0]:// <20, 20-25
case ageRanges[1]:switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Enzyme Polish','AEA Serum','AEA Moisturiser'];activePriority=['Vitamin C','Hyaluronic Acid','Vegan Squalane'];}else{productsRecommend=['APC Cleanser','APC Mask','Pro Youth Dark Spot Serum'];activePriority=['AHAs','Vitamin E','Glycolic Acid'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','Pro Youth Dark Spot Serum','TSW Cream'];activePriority=['AHAs','Glycolic Acid','Hyaluronic Acid'];}else{productsRecommend=['APC Cleanser','Pro Youth Dark Spot Serum','AEA Moisturiser'];activePriority=['AHAs','Glycolic Acid','Vegan Squalane'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Enzyme Polish','AEA Mask','AEA Moisturiser'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}else{productsRecommend=['APC Cleanser','AEA Mask','Pro Youth Dark Spot Serum'];activePriority=['AHAs','Vitamin C','Glycolic Acid'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Enzyme Polish','Pro Youth Dark Spot Serum','TSW Cream'];activePriority=['AHAs','Glycolic Acid','Hyaluronic Acid'];}else{productsRecommend=['APC Cleanser','AEA Mask','Pro Youth Dark Spot Serum'];activePriority=['AHAs','Vitamin C','Glycolic Acid'];}break;}break;default://26-35, 36-45, >45
switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','AEA Enzyme Polish','Pro Youth Dark Spot Serum'];activePriority=['AHAs','Vitamin C','Glycolic Acid'];}else{productsRecommend=['APC Cleanser','APC Mask','Pro Youth Dark Spot Serum'];activePriority=['AHAs','Vitamin E','Glycolic Acid'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','AEA Serum','AEA Moisturiser'];activePriority=['AHAs','Vitamin C','Vegan Squalane'];}else{productsRecommend=['APC Cleanser','AEA Mask','Pro Youth Dark Spot Serum'];activePriority=['AHAs','Vitamin C','Glycolic Acid'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Enzyme Polish','AEA Mask','Pro Youth Dark Spot Serum'];activePriority=['AHAs','Hyaluronic Acid','Glycolic Acid'];}else{productsRecommend=['AEA Enzyme Polish','AEA Mask','Pro Youth Dark Spot Serum'];activePriority=['AHAs','Hyaluronic Acid','Glycolic Acid'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Enzyme Polish','Pro Youth Dark Spot Serum','AEA Moisturiser'];activePriority=['AHAs','Glycolic Acid','Vegan Squalane'];}else{productsRecommend=['APC Cleanser','AEA Mask','Pro Youth Dark Spot Serum'];activePriority=['AHAs','Vitamin C','Glycolic Acid'];}break;}break;}break;case skinConcernsQ[8]://Dullness or uneven skin tone
switch(ageRangesA){case ageRanges[0]:// <20, 20-25
case ageRanges[1]:switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','APC Mask','Marshmallow Toner'];activePriority=['AHAs','Vitamin E','Glycolic Acid'];}else{productsRecommend=['Marshmallow Toner','OC Mask','AEA Serum'];activePriority=['AHAs','Salicylic Acid','Vitamin C'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','AEA Serum','AEA Moisturiser'];activePriority=['AHAs','Vitamin C','Vegan Squalane'];}else{productsRecommend=['Marshmallow Toner','AEA Mask','Pro Youth Dark Spot Serum'];activePriority=['Glycolic Acid','Hyaluronic Acid','Glycolic Acid'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['Marshmallow Toner','AEA Mask','AEA Moisturiser'];activePriority=['Glycolic Acid','Hyaluronic Acid','Vitamin C'];}else{productsRecommend=['APC Cleanser','AEA Mask','AEA Moisturiser'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Exfoliator','Pro Youth Dark Spot Serum','TSW Cream'];activePriority=['AHAs','Glycolic Acid','Hyaluronic Acid'];}else{productsRecommend=['APC Exfoliator','AEA Mask','Pro Youth Dark Spot Serum'];activePriority=['AHAs','Hyaluronic Acid','Glycolic Acid'];}break;}break;default://26-35, 36-45, >45
switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','AEA Enzyme Polish','AEA Serum'];activePriority=['AHAs','Vitamin C','Hyaluronic Acid'];}else{productsRecommend=['Marshmallow Toner','OC Mask','Pro Youth Dark Spot Serum'];activePriority=['Glycolic Acid','Salicylic Acid','Glycolic Acid'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','AEA Serum','AEA Moisturiser'];activePriority=['AHAs','Vitamin C','Vegan Squalane'];}else{productsRecommend=['Marshmallow Toner','AEA Mask','Pro Youth Dark Spot Serum'];activePriority=['Glycolic Acid','Hyaluronic Acid','Glycolic Acid'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Enzyme Polish','AEA Mask','AEA Moisturiser'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}else{productsRecommend=['Marshmallow Toner','AEA Mask','AEA Moisturiser'];activePriority=['Glycolic Acid','Hyaluronic Acid','Vitamin C'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Enzyme Polish','Pro Youth Dark Spot Serum','AEA Moisturiser'];activePriority=['AHAs','Glycolic Acid','Vitamin C'];}else{productsRecommend=['AEA Enzyme Polish','TSW Mask','Pro Youth Dark Spot Serum'];activePriority=['AHAs','Hyaluronic Acid','Glycolic Acid'];}break;}break;}break;default://Dark circles and/or eye bags
switch(ageRangesA){case ageRanges[0]:// <20, 20-25
case ageRanges[1]:switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','AEA Moisturiser','Anti-Aging Eye Cream'];activePriority=['AHAs','Vegan Squalane','Vitamin C'];}else{productsRecommend=['OC Cleanser','Pro Youth Dark Spot Serum','Anti-Aging Eye Cream'];activePriority=['AHAs','Glycolic Acid','Vitamin C'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','AEA Mask','Anti-Aging Eye Cream'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}else{productsRecommend=['APC Cleanser','AEA Mask','Anti-Aging Eye Cream'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Mask','Pro Youth Dark Spot Serum','Anti-Aging Eye Cream'];activePriority=['Hyaluronic Acid','Glycolic Acid','Vitamin C'];}else{productsRecommend=['AEA Mask','TSW Night Cream','Anti-Aging Eye Cream'];activePriority=['Hyaluronic Acid','Vegan Squalane','Vitamin C'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Mask','TSW Cream','Anti-Aging Eye Cream'];activePriority=['Hyaluronic Acid','AHAs','Vitamin C'];}else{productsRecommend=['OC Cleanser','TSW Serum','Anti-Aging Eye Cream'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}break;}break;default://26-35, 36-45, >45
switch(skinTypeAnswer){case skinTypeQuestions[0]://Tends to get shiny throughout the day
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['OC Cleanser','AEA Moisturiser','Anti-Aging Eye Cream'];activePriority=['AHAs','Vegan Squalane','Vitamin C'];}else{productsRecommend=['OC Cleanser','Pro Youth Dark Spot Serum','Anti-Aging Eye Cream'];activePriority=['AHAs','Glycolic Acid','Vitamin C'];}break;case skinTypeQuestions[1]://A combination of shiny and dry on different areas
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['APC Cleanser','TSW Serum','Anti-Aging Eye Cream'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}else{productsRecommend=['APC Cleanser','AEA Mask','Anti-Aging Eye Cream'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}break;case skinTypeQuestions[2]://Comfortable in summer, but dry in cooler climates
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Enzyme Polish','AEA Moisturiser','Anti-Aging Eye Cream'];activePriority=['AHAs','Vegan Squalane','Vitamin C'];}else{productsRecommend=['AEA Enzyme Polish','AEA Mask','Anti-Aging Eye Cream'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}break;default://Red and flaky with uneven texture
if(envStressResult.title==='LOW'||envStressResult.title==='AVERAGE'){productsRecommend=['AEA Enzyme Polish','TSW Serum','Anti-Aging Eye Cream'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}else{productsRecommend=['AEA Enzyme Polish','AEA Serum','Anti-Aging Eye Cream'];activePriority=['AHAs','Hyaluronic Acid','Vitamin C'];}break;}break;}break;}if(['www.sandandsky.com','us.sandandsky.com','ca.sandandsky.com'].indexOf(store)===-1){productsRecommend.push('Daily Hydrating Sunscreen');activePriority.push('Vitamin E');}return{productsRecommend:productsRecommend,activePriority:activePriority};};var product_result_getProductResult=function getProductResult(Questions,currentAnswer,store){return getProductRecommendation(Questions,currentAnswer,store);};/* harmony default export */ var product_result = ((/* unused pure expression or super */ null && (product_result_getProductResult)));
;// CONCATENATED MODULE: ./src/modules/product-list.js
var product_list_productList={'APC Mask':{handle:'porefining-face-mask',usp:'Deeply detoxes and tightens pores in 10 minutes with Australian Pink Clay, a magnet for toxins',howto:'Use 2-3 times a week for about 10 minutes or until dry',title:'Australian Pink Clay Porefining Face Mask',description:'Refine pores, clear congestion, and instantly boost radiance with our <span class="text-primary">Australian Pink Clay Mask</span>.',sku:'SS0000012010',dev:{id:39409261805639,price:'$39.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg'},ca:{id:23001089769557,price:'$52.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg'},us:{id:39541809348713,price:'$39.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg'},uk:{id:20459053809726,price:'£36.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg'},eu:{id:28868344578125,price:'€40.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg'},au:{id:15334016417827,price:'$60.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg'},int:{id:29529490063446,price:'$39.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg'},my:{id:41477569839280,price:'RM178.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_236x404_crop_center.jpg',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_EcommHeo_SB_All_SetUp_1121SS_Ecomm_Hero_SB_APC_PFM_Crop_23_1_1140x1440_crop_center.jpg'}},'APC Cleanser':{handle:'pink-clay-deep-pore-cleanser',usp:'Removes makeup, tightens pores and gently exfoliates with AHAs',howto:'Use it daily as a morning and night cleanser',title:'Australian Pink Clay Deep Pore Cleanser',description:'',sku:'SS0001612020',dev:{id:39409197580359,price:'$29.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557'},ca:{id:39464477327445,price:'$38.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557'},us:{id:39541817114729,price:'$29.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557'},uk:{id:39520730513470,price:'£27.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557'},eu:{id:39397291360333,price:'€29.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557'},au:{id:40168078606512,price:'$45.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557'},int:{id:39474532253782,price:'$29.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557'},my:{id:41477569904816,price:'RM135.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_236x404_crop_center.jpg?v=1638426557',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_Cleanser_1_1140x1440_crop_center.jpg?v=1638426557'}},'APC Exfoliator':{handle:'flash-perfection-exfoliating-treatment',usp:'Mattify skin, clear congestion and resurface skin with Bamboo & Macadamia for gentle physical exfoliation',howto:'Use up to 3 times a week after cleansing, and before serums or toners',title:'Australian Pink Clay Flash Perfection Exfoliator',sku:'SS0000022020',dev:{id:32227653910599,price:'$36.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001'},ca:{id:23001089507413,price:'$48.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001'},us:{id:28542852169833,price:'$36.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001'},uk:{id:20459053711422,price:'£33.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001'},eu:{id:28868344512589,price:'€30.00',compare_at_price:'€37.90',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001'},au:{id:15334016352291,price:'$56.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001'},int:{id:29529489932374,price:'$36.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001'},my:{id:41477568889008,price:'RM165.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_APC_ExfoNew_236x404_crop_center.jpg?v=1638426001'}},'AEA Mask':{handle:'australian-skincare-face-mask-emu-apple-super-bounce',usp:'Ultra-nourishing, brightens and protects skin with super-potent antioxidants, Hyaluronic Acid and Kakadu Plum',howto:'Use 2-3 times a week for about 10 minutes for best results',title:'Australian Glow Berries Super Bounce Mask',description:'Deeply hydrate, brighten and protect the skin with this antioxidant rich <span class="text-range-aea">Australian Glow Berries Super Bounce Mask</span>.',sku:'SS0000102020',dev:{id:32227654402119,price:'$94.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493'},ca:{id:30208262144085,price:'$81.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493'},us:{id:30927340437609,price:'$61.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493'},uk:{id:39520753057854,price:'£56.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493'},eu:{id:30936318836813,price:'€62.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493'},au:{id:40167967981744,price:'$94.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493'},int:{id:30942698373206,price:'$62.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493'},my:{id:41477569478832,price:'RM276.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_236x404_crop_center.jpg?v=1637739493',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_SuperBounce_Crop_23_1_1140x1440_crop_center.jpg?v=1637739493'}},'AEA Serum':{handle:'australian-skincare-serum-emu-apple-dreamy-glow-drops',howto:'Morning or night, apply 4-6 drops to clean skin and massage in circular motions',usp:'Defeat dryness, dull skin & daily pollutants with this bi-phase serum for extra nourishment',title:'Australian Glow Berries Dreamy Glow Drops',sku:'SS0000112020',dev:{id:39409199218759,price:'$54.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082'},ca:{id:30322465144917,price:'$72.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082'},us:{id:30927340994665,price:'$54.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082'},uk:{id:30931460948030,price:'£50.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082'},eu:{id:30936319033421,price:'€55.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082'},au:{id:30926921859107,price:'$83.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082'},int:{id:30942698569814,price:'$55.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082'},my:{id:41477570461872,price:'RM246.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_GlowDrops_Crop_23_236x404_crop_center.jpg?v=1637739082'}},'AEA Enzyme Polish':{handle:'australian-skincare-exfoliant-emu-apple-enzyme-powder-polish',howto:'Day or night, pour a half-spoon of polish, lather it and gently massage onto cleansed skin for 15 seconds',usp:'Glow beyond bright skin with our advanced, triple-action enzyme powder exfoliant, packed with antioxidants and Vitamin C',title:'Australian Glow Berries Enzyme Powder Polish',sku:'SS0000122020',dev:{id:32772333731911,price:'$44.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620'},ca:{id:39464482799701,price:'$59.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620'},us:{id:39541817639017,price:'$44.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620'},uk:{id:39520743850046,price:'£44.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620'},eu:{id:39397294669901,price:'€46.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620'},au:{id:40168076673200,price:'$72.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620'},int:{id:39474532646998,price:'$44.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620'},my:{id:41477569446064,price:'RM184.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_AEA_EP_Crop_23_1_236x404_crop_center.jpg?v=1637739620'}},'TSW Mask':{handle:'intense-hydrating-mask',howto:'Use 2-3 times a week, leave on for 10 minutes for an instant hydration perk',usp:'Intensively hydrates, soothes redness and strengthens skin barrier in 10 minutes with Hyaluronic Acid, Squalane and Pentavitin',title:'Tasmanian Spring Water Intense Hydrating Mask',description:'The <span class="text-range-tsw">Tasmanian Spring Water Intense Hydrating Mask</span> intensively hydrates, soothes redness and repairs skin barrier, achieving instant luminous skin in 10 minutes.',sku:'SS0002242020',dev:{id:39567979839559,price:'$35.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320'},ca:{id:39914836066389,price:'$45.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320'},us:{id:39858151096425,price:'$35.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320'},uk:{id:39696452517950,price:'£29.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320'},eu:{id:39606407168077,price:'€35.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320'},au:{id:41352157626544,price:'$48.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320'},int:{id:39722868244566,price:'$35.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320'},my:{id:41477570265264,price:'RM175.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_236x404_crop_center.jpg?v=1645761320',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_TSW_Intense_Hydrating_Mask_1b_1140x1440_crop_center.jpg?v=1645761320'}},'TSW Cream':{handle:'australian-skincare-tasmanian-spring-water-moisturiser',howto:'Use morning or night as the final step of your skincare routine',usp:'Drench and quench with our ultra-hydrating gel-cream that smoothens skin and targets wrinkles with Fermented Sea Kelp',title:'Tasmanian Spring Water Hydration Boost Cream',sku:'SS0000442020',dev:{id:39409201774663,price:'$64.00',compare_at_price:'$79.90',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'},ca:{id:39464508522581,price:'$69.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'},us:{id:39541825077353,price:'$49.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'},uk:{id:39520740671550,price:'£44.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'},eu:{id:39397301223501,price:'€49.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'},au:{id:40168219017392,price:'$79.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'},int:{id:39474540707926,price:'$49.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'},my:{id:41477569249456,price:'RM230.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'}},'TSW Boost Cream':{handle:'australian-skincare-tasmanian-spring-water-moisturiser',howto:'Use morning or night as the final step of your skincare routine',usp:'Drench and quench with our ultra-hydrating gel-cream that smoothens skin and targets wrinkles with Fermented Sea Kelp',title:'Tasmanian Spring Water Hydration Boost Cream',sku:'SS0000442020',dev:{id:39409201774663,price:'$64.00',compare_at_price:'$79.90',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'},ca:{id:39464508522581,price:'$69.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'},us:{id:39541825077353,price:'$49.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'},uk:{id:39520740671550,price:'£44.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'},eu:{id:39397301223501,price:'€49.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'},au:{id:40168219017392,price:'$79.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'},int:{id:39474540707926,price:'$49.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'},my:{id:41477569249456,price:'RM230.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW-HBC_Crop_23_236x404_crop_center.jpg?v=1637739563'}},'TSW Serum':{handle:'australian-skincare-tasmanian-spring-water-serum',howto:'Morning or night, apply 4-6 drops after cleansing or exfoliating and massage in circular motions',usp:'Ultra-hydrating serum strengthens and smoothens skin barrier, powered by essential minerals, probiotics and Hyaluronic Acid',title:'Tasmanian Spring Water Splash Serum',sku:'SS0000402020',dev:{id:39408221454407,price:'$51.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718'},ca:{id:39464488829013,price:'$70.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718'},us:{id:39541816459369,price:'$51.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718'},uk:{id:39520742867006,price:'£49.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718'},eu:{id:39397296308301,price:'€51.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718'},au:{id:40168130969776,price:'$82.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718'},int:{id:39474532745302,price:'$51.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718'},my:{id:41477571248304,price:'RM239.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_Ecomm_Hero_SB_TSW_SplashSerum_Crop_23_236x404_crop_center.jpg?v=1637739718'}},'OC Mask':{handle:'oil-control-clearing-face-mask',howto:'Use 2-3 times a week for about 5-10 minutes',usp:'Combats acne, unclogs pores and eliminates sebum for clear skin, with powerful ingredients like Salicylic Acid and Prebiotics',title:'Oil Control Clearing Face Mask',description:'The nemesis of excess sebum, enlarged pores and blemishes, this <span class="text-range-oil">Oil Control Clearing Face Mask</span> rebalances microbiome, leaving skin clear of imperfections.',sku:'SS0001182020',dev:{id:39652548771911,price:'$34.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_1140x1440_crop_center.jpg?v=1651721754'},ca:{id:40047429386325,price:'$43.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_1140x1440_crop_center.jpg?v=1651721754'},us:{id:39989271789673,price:'$34.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_1140x1440_crop_center.jpg?v=1651721754'},uk:{id:39750473187390,price:'£30.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_1140x1440_crop_center.jpg?v=1651721754'},eu:{id:39665132666957,price:'€34.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_1140x1440_crop_center.jpg?v=1651721754'},au:{id:41591817142448,price:'$50.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754'},int:{id:39807867584598,price:'$34.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_1140x1440_crop_center.jpg?v=1651721754'},my:{id:41692416311472,price:'RM156.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_236x404_crop_center.jpg?v=1651721754',image2:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Mask_1_Hero_1140x1440_crop_center.jpg?v=1651721754'}},'OC Cleanser':{handle:'oil-control-clearing-cleanser',howto:'Use it daily as a morning and night cleanser',usp:'Unclogs pores, regulates sebum production and soothes skin to combat blemishes, with Salicylic Acid and Old Man’s Weed',title:'Oil Control Clearing Cleanser',sku:'SS0001172020',dev:{id:39652548411463,price:'$29.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430'},ca:{id:40047422210133,price:'$36.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430'},us:{id:39989269889129,price:'$29.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430'},uk:{id:39750472958014,price:'£25.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430'},eu:{id:39665132470349,price:'€29.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430'},au:{id:41591815078064,price:'$43.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430'},int:{id:39807867125846,price:'$29.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430'},my:{id:41692415164592,price:'RM135.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_OC_PDP_Cleanser_1_Hero_236x404_crop_center.jpg?v=1651721430'}},'OC Moisturiser':{handle:'oil-control-clearing-moisturiser',howto:'Suitable for daily use, both morning and night as the final step of your skincare routine',usp:'Eliminates oily skin, balances and calms inflammation, while delivering essential hydration with Salicylic Acid and Niacinamide',title:'Oil Control Clearing Moisturiser',sku:'SS0002132020',dev:{id:39685317361735,price:'$39.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654'},ca:{id:40125489315925,price:'$48.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654'},us:{id:40081432576105,price:'$39.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654'},uk:{id:39789739409470,price:'£34.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654'},eu:{id:39688134918221,price:'€39,90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654'},au:{id:41732010377392,price:'$58.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654'},int:{id:39907237494870,price:'$39.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654'},my:{id:41731988422832,price:'RM122.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_OC_PDP_Moisturiser_1_Hero_236x404_crop_center.jpg?v=1657163654'}},'AEA Moisturiser':{handle:'australian-glow-berries-intense-glow-moisturiser',howto:'Suitable for daily use, both morning and night as the final step of your skincare routine',usp:'A multi-tasking moisturiser powered by Glow Berries™ complex and 2 forms of Vitamin C for a plump-looking and radiant complexion.',title:'Australian Glow Berries Intense Glow Moisturizer',sku:'SS0000452020',dev:{id:40182531457129,price:'$49.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297'},ca:{id:40176785555541,price:'$61.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297'},us:{id:40182531457129,price:'$49.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297'},uk:{id:39814370197566,price:'£43.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297'},eu:{id:39720299954253,price:'€49,90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297'},au:{id:41823720210608,price:'$72.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297'},int:{id:39963692695638,price:'$49.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297'},my:{id:41823722471600,price:'RM221.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_GB_PDP_Moisturiser_1_Hero_54ad2de5-18ec-45d6-b5d2-b8370d467742_236x404_crop_center.jpg?v=1658936297'}},'TSW Night Cream':{handle:'tasmanian-spring-water-renewing-night-cream',howto:'Use at night as the final step of your skincare routine, and after using any serums or oils',usp:'Deeply hydrates skin, prepping it for an overnight boosted regeneration and replenishing process, for more youthful radiance by morning',title:'Tasmanian Spring Water Renewing Night Cream',sku:'SS0000102040',dev:{id:39769222086727,price:'$49.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228'},ca:{id:40283577286741,price:'$63.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228'},us:{id:40277848719465,price:'$49.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228'},uk:{id:39868290564158,price:'£43.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228'},eu:{id:39812349591629,price:'€49,90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228'},au:{id:41968357769392,price:'$71.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228'},int:{id:40043332436054,price:'$49.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228'},my:{id:41968357900464,price:'RM218.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/products/SS_TSW_PDP_Renewing_night_cream_1_Hero_236x404_crop_center.jpg?v=1662963228'}},'Marshmallow Toner':{handle:'marshmallow-toner',howto:'Use it daily both morning and night, after cleansing your skin and before your serum and moisturiser',usp:'AHA, BHA and Niacinamide-infused toner that cleanses, exfoliates and purifies, to hydrate and brighten skin, minimize pores and refine skin texture.',title:'Marshmallow Toner',sku:'SS0002592020',dev:{id:6738811813959,price:'$34.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056'},us:{id:6984017477737,price:'$34.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056'},au:{id:7257346048176,price:'$54.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056'},ca:{id:6883326689365,price:'$47.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056'},eu:{id:6835592101965,price:'€35.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056'},int:{id:6839364616278,price:'$34.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056'},my:{id:7257346146480,price:'RM166.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056'},uk:{id:7122147377214,price:'£30.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_MarshmallowToner_1_Hero_186x322_crop_center.jpg?v=1673599056'}},'Pro Youth Dark Spot Serum':{handle:'pro-youth-dark-spot-serum',howto:'Use 2-3 times a week, apply 4 drops after cleansing your skin in the evening',usp:'A retinol-alternative serum enriched with AHA-Bakuchiol duo that treats pigmentation and dark spots, while improving the look of fine lines and uneven skin tone',title:'Pro Youth Dark Spot Serum',sku:'SS0003132020',dev:{id:6738815680583,price:'$49.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711'},us:{id:6984037630057,price:'$34.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711'},au:{id:7257358237872,price:'$54.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711'},ca:{id:7257358237872,price:'$54.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711'},eu:{id:6835596591181,price:'€35.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711'},int:{id:6839365763158,price:'$34.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711'},my:{id:7257358368944,price:'RM166.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711'},uk:{id:7122154553406,price:'£30.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/products/SS_PDP_ProYouthSerum_1_Hero_1140x1440_crop_center.jpg?v=1675308711'}},'Daily Hydrating Sunscreen':{handle:'daily-hydrating-sunscreen-spf50',howto:'Use it everyday as the last step of your skincare routine, at least 30 minutes before being exposed to the sun',usp:'Our ultimate daily sunscreen with SPF50+ PA++++ broad spectrum sun protection blocks out UVA/UVB rays and is antioxidant-rich!',title:'Australian Sunshield Daily Hydrating Sunscreen SPF50+',sku:'SS0002852010',dev:{id:6738815680583,price:'$39.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994'},us:{id:7302693617840,price:'',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994'},au:{id:7302693617840,price:'$39.90',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994'},ca:{id:7257358237872,price:'',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994'},eu:{id:6852779573325,price:'€26.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994'},int:{id:6853136810070,price:'$29.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994'},my:{id:7302693650608,price:'RM99.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994'},uk:{id:7142873301054,price:'£22.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0043/2734/2115/products/SS_PDP_DailyHydratingSunscreen_1_Hero_186x322_crop_center.jpg?v=1679550994'}},'Anti-Aging Eye Cream':{handle:'anti-aging-eye-cream',howto:'Apply a pea-sized amount to the contours of your eyes and eyelids, up to the brow bone, both morning and evening',usp:'Tackle dark circles, eye bags and wrinkles with our 8% Vitamin C-infused and Peptide-powered formula, while visibly firming, reviving and brightening skin.',title:'Anti-aging Eye Cream',sku:'SS0002792020',au:{id:7320365301936,price:'$52.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0043/2734/2115/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683708076'},ca:{id:6913433010261,price:'$46.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0093/6096/5717/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683708055'},eu:{id:8353173766468,price:'€35.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0239/8928/9037/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683708089'},int:{id:6858074783830,price:'$49.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0248/5370/8886/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683708125'},uk:{id:7148662489150,price:'£31.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0110/9413/0750/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683708165'},us:{id:7008480165993,price:'$35.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0253/9847/6905/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683708190'},my:{id:7320365334704,price:'RM129.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0612/2799/1216/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683708139'},dev:{id:6775910563911,price:'$35.00',compare_at_price:'',image:'https://cdn.shopify.com/s/files/1/0277/5262/8295/files/SS_PDP_Anti-AgingEyeCream_1_Hero_186x322_crop_center.jpg?v=1683685618'}}};/* harmony default export */ var product_list = (product_list_productList);
;// CONCATENATED MODULE: ./src/UI/templates/Survey.js
window.getCookie=Utils_getCookie;var Survey=function Survey(){var site=window.site?window.site:'www.sandandsky.com';var gId=getCookie('_ga');var surveyState='start';var setCookieAnsweredQuestion=function setCookieAnsweredQuestion(object){if(typeof object==='object'){Object.entries(object).forEach(function(data){var key=data[0];var value=decodeURI(data[1]);object[key]=encodeURI(value);});setCookie('answeredQuestion',JSON.stringify(object));postMessageCookie('answeredQuestion',JSON.stringify(object));}else{setCookie('answeredQuestion','');}};var getCookieAnsweredQuestion=function getCookieAnsweredQuestion(){if(getCookie('answeredQuestion')){var object=JSON.parse(getCookie('answeredQuestion'));Object.entries(object).forEach(function(data){var key=data[0];var value=data[1];object[key]=decodeURI(value);});return object;}return null;};var decodeAnswers=function decodeAnswers(object){Object.entries(object).forEach(function(data){var key=data[0];var value=data[1];object[key]=decodeURI(value);});return object;};var postMessageToParentCookie=function postMessageToParentCookie(key,val){if(window.top===window.self)return;window.parent.postMessage({'func':'setCookieFromMessage','key':key,'value':val},"https://".concat(site));};var postMessageData=function postMessageData(category,action,label){if(window.top===window.self)return;window.parent.postMessage({'func':'callGaEvent','category':category,'action':action,'label':label},"https://".concat(site));};// refference width and height
var targetRef=useRef();// const { width, height } = useResizeDetector({ targetRef });
// initial data
var initialState=getCookie('surveyPosition')||'start';if(surveyState==='started'&&(getCookie('surveyPosition')==='start'||getCookie('surveyPosition')===null||getCookie('surveyPosition')==='')){postMessageData('Survey','started');initialState='question-1';setCookie('answeredQuestion','');}var initialCurrentQuestion=getCookie('currentQuestion')?parseInt(getCookie('currentQuestion'),10):1;var initialSubmitted=getCookie('quizEmail')?true:false;var answerData=getCookieAnsweredQuestion()?getCookieAnsweredQuestion():{};// states
var _useState=useState(initialState),_useState2=_slicedToArray(_useState,2),currentPosition=_useState2[0],setPosition=_useState2[1];var _useState3=useState(initialCurrentQuestion),_useState4=_slicedToArray(_useState3,2),currentQuestion=_useState4[0],setQuestion=_useState4[1];var _useState5=useState(answerData),_useState6=_slicedToArray(_useState5,2),currentAnswer=_useState6[0],setAnswer=_useState6[1];var _useState7=useState(initialSubmitted),_useState8=_slicedToArray(_useState7,2),submitted=_useState8[0],setSubmitted=_useState8[1];var _useState9=useState(false),_useState10=_slicedToArray(_useState9,2),redirect=_useState10[0],setRedirect=_useState10[1];var _useState11=useState(''),_useState12=_slicedToArray(_useState11,2),email=_useState12[0],setEmail=_useState12[1];var additionalStep=true;var postMessageCookie=function postMessageCookie(key,val){if(window.top===window.self)return;window.parent.postMessage({'func':'setCookieFromMessage','key':key,'value':val},"https://".concat(site));};// handler hook side effect when state changed
useEffect(function(){if(currentPosition==='start'){document.getElementById('root').classList.add('bg-primary-light-second');}else{document.getElementById('root').classList.remove('bg-primary-light-second');}// setCookie('surveyPosition', currentPosition);
// postMessageCookie('surveyPosition', currentPosition); don't send to parent window when initialize survey state
if(currentPosition==='finished'&&!additionalStep)clearCookie();},[currentPosition]);useEffect(function(){if(currentQuestion<=Questions.length&&currentPosition!=='finished'&&currentPosition!=='start'&&currentPosition!=='result'){setCookie('currentQuestion',currentQuestion);setCookie('surveyPosition',"question-".concat(currentQuestion));// send cookie data to the parent window
postMessageCookie('currentQuestion',currentQuestion);postMessageCookie('surveyPosition',"question-".concat(currentQuestion));}},[currentQuestion,currentPosition]);var answerAction=function answerAction(question,answers){currentAnswer[question]=answers;setAnswer(decodeAnswers(currentAnswer));setCookieAnsweredQuestion(decodeAnswers(currentAnswer));};var clearCookie=function clearCookie(){setCookie('currentQuestion',1);setCookie('surveyPosition','start');setCookie('answeredQuestion','');postMessageCookie('currentQuestion',1);postMessageCookie('surveyPosition','start');postMessageCookie('answeredQuestion','');};var sendTodataLayer=function sendTodataLayer(action){var dataToPush={event:'quiz',event_params:{category:'Survey',target:action}};if(typeof window.dataLayer==='object'){window.dataLayer.push(dataToPush);}};var gettingResult=function gettingResult(){var close=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var selectedSite=site?site:'dev.sandandsky.com';sendTodataLayer('completed');var skinType=getSkinType(currentAnswer);var envStressResult=getEnvironmentStress(currentAnswer);var _getProductResult=getProductResult(Questions,currentAnswer,selectedSite),productsRecommend=_getProductResult.productsRecommend,activePriority=_getProductResult.activePriority;var productHandle=[];var productSkus=[];var sku='';productsRecommend.forEach(function(item,index){productHandle.push(productList[item].handle);productSkus.push(productList[item].sku);sku="".concat(sku).concat(index===0?'':',').concat(productList[item].sku);});if(close){setCookie('surveyPosition','finished');setPosition('finished');postMessageCookie('surveyPosition','finished');var surveyResultObj={skinType:skinType,envStressResult:envStressResult,productsRecommend:productsRecommend,productHandle:productHandle,productSkus:productSkus,activePriority:activePriority};var surveyResultJson=JSON.stringify(surveyResultObj);setCookie('surveyResult',surveyResultJson);postMessageCookie('surveyResult',surveyResultJson);saveData(sku);setTimeout(function(){setCookie('surveyPosition','result');setPosition('result');postMessageCookie('surveyPosition','result');setCookie('surveyResult',surveyResultJson);postMessageCookie('surveyResult',surveyResultJson);clearCookie();window.top.location.href="https://".concat(selectedSite).concat(window.pageResult);},1500);}};var setFinished=function setFinished(){postMessageData('Survey','viewMyResult');setCookie('surveyPosition','finished');setPosition('finished');};var setQuestionState=function setQuestionState(questionIndex){if(questionIndex<=Questions.length){var targetQuestion=Questions[questionIndex];if(targetQuestion&&targetQuestion.rule&&targetQuestion.rule.skipped){var targetAnswer=decodeAnswers(currentAnswer)[targetQuestion.rule.question];if(targetAnswer===targetQuestion.rule.answer){answerAction(questionIndex,'');var targetQuestionIndex=currentQuestion<questionIndex?questionIndex+1:questionIndex-1;setQuestion(targetQuestionIndex);}else{setQuestion(questionIndex);}}else{setQuestion(questionIndex);}}else if(questionIndex>=Questions.length){if(additionalStep){setFinished();if(submitted){gettingResult(true);}}else{gettingResult(true);// call saving data to analytics and database
postMessageGaParent();gettingResult(true);}}};var postMessageGaParent=function postMessageGaParent(){if(window.top===window.self)return;var gaAnswers=decodeAnswers(currentAnswer);var keys=Object.keys(gaAnswers);postMessageData('Survey','completed',email);postMessageCookie('surveySubmitNew','true');keys.forEach(function(key,index){var q=Questions[index];var a=gaAnswers[key];var label=q.question;var action=typeof a==='object'?a.join(','):a;postMessageData('Survey',action,label);});};var saveData=function saveData(sku){var dataForSaving={};for(var _i=0,_Object$entries=Object.entries(currentAnswer);_i<_Object$entries.length;_i++){var _Object$entries$_i=_slicedToArray(_Object$entries[_i],2),key=_Object$entries$_i[0],value=_Object$entries$_i[1];var idxQ=key-1;if(Questions[idxQ]){var questionText="".concat(key,": ").concat(Questions[idxQ].question);dataForSaving[questionText]=value;}}var data={store:site,_ga:gId,questions_answers:dataForSaving,email:email,sku:sku};};useEffect(function(){if(currentPosition==='finished'||currentPosition==='result')gettingResult();},[currentPosition]);var classes=currentPosition!=='result'?'':'overflow-hidden';var startQuiz=function startQuiz(){postMessageData('Survey','started');setPosition('question-1');};var viewMyResult=function viewMyResult(){setRedirect(true);postMessageGaParent();gettingResult(true);};var skipEmail=function skipEmail(){gettingResult(true);// setSubmitted(true);
};var onSubmit=function onSubmit(email){setCookie('quizEmail',email);setEmail(email);setSubmitted(true);postMessageToParentCookie('quizEmail',email);if(window.top!==window.self){window.parent.postMessage({'func':'callGaEvent','category':'Survey','action':'submitEmail','label':email},"https://".concat(site));}};return/*#__PURE__*/_jsx("div",{ref:targetRef,className:"".concat(currentPosition==='start'?'cover survey-skin m-0 w-100':classes," ").concat(currentPosition!=='result'?'container':''),children:/*#__PURE__*/_jsxs("div",{className:"row justify-content-center survey-content ".concat(currentPosition==='start'?' survey-content__start align-items-start':'align-content-start'," "),children:[currentPosition==='start'&&/*#__PURE__*/_jsx(_Fragment,{children:/*#__PURE__*/_jsxs("div",{className:"px-g d-flex align-items-center flex-column justify-content-center text-center ".concat(currentPosition==='start'?'heading-wrapper':''),children:[/*#__PURE__*/_jsx("h1",{className:"mb-g",children:"Discover your routine to flawless skin"}),/*#__PURE__*/_jsxs("p",{className:"font-size-sm mb-4",children:["Find the perfect solution to your skin\u2019s needs in just a few steps! ",/*#__PURE__*/_jsx("br",{})," Get 15% off!"]}),/*#__PURE__*/_jsx("button",{className:"btn btn-primary text-white",onClick:function onClick(){return startQuiz();},children:"Take the quiz"})]})}),currentPosition!=='start'&&currentPosition!=='finished'&&currentPosition!=='result'&&/*#__PURE__*/_jsx(_Fragment,{children:/*#__PURE__*/_jsxs("div",{className:"text-center position-relative",children:[/*#__PURE__*/_jsx(SplashTop,{className:"d-none d-lg-block question-box__decoration-top position-absolute end-0"}),Questions.map(function(item,index){var key="question-".concat(index);if(currentQuestion===index+1){switch(item.type){case'MultipleChoice':return/*#__PURE__*/_jsx(QuestionBox,{currentAnswer:decodeAnswers(currentAnswer)// width={width}
// height={height}
,totalQuestions:item.answers.length,totalSteps:Questions.length,answerAction:answerAction,setCurrentQuestion:setQuestionState,currentQuestion:currentQuestion,colSize:"col-lg-8 offset-lg-2 col-xl-6 offset-xl-3",question:item.question,caption:item.caption?item.caption:'',captionClass:item.captionClass?item.captionClass:'',category:item.category,children:/*#__PURE__*/_jsx(MultipleChoice,{answers:item.answers,lastFull:item.lastFull,maxChoose:item.maxChoose,lastDisableForAll:item.lastDisableForAll,btnClass:item.btnClass})},key);default:return/*#__PURE__*/_jsx(QuestionBox,{currentAnswer:decodeAnswers(currentAnswer)// width={width}
// height={height}
,totalQuestions:item.answers.length,answerAction:answerAction,setCurrentQuestion:setQuestionState,currentQuestion:currentQuestion,totalSteps:Questions.length,colSize:"col-lg-8 offset-lg-2 col-xl-6 offset-xl-3",question:item.question,caption:item.caption?item.caption:'',captionClass:item.captionClass?item.captionClass:'',category:item.category,defaultEnabled:item.inputType==='RangeSlider'?true:null,children:/*#__PURE__*/_jsx(SingleChoice,{answers:item.answers,buttonType:item.buttonType,inputType:item.inputType,showAllLabel:item.showAllLabel,btnClass:item.btnClass})},key);}}return false;})]})}),currentPosition==='finished'&&!submitted&&additionalStep&&!redirect&&/*#__PURE__*/_jsx("div",{className:"survey-email-submit container bg-primary-light mt-lg-5",children:/*#__PURE__*/_jsxs("div",{className:"row d-flex align-items-center text-center",children:[/*#__PURE__*/_jsx("div",{className:"col-12 col-lg-6 p-0",children:/*#__PURE__*/_jsxs("picture",{className:"w-100 d-block",children:[/*#__PURE__*/_jsx("source",{type:"image/png",srcSet:"https://imagedelivery.net/ghVX8djKS3R8-n0oGeWHEA/0d8b37c6-fdf3-40a4-5b2d-d46c72ad3200/828x",media:"(min-width: 992px)"}),/*#__PURE__*/_jsx("img",{src:"https://imagedelivery.net/ghVX8djKS3R8-n0oGeWHEA/c197ee9c-de80-4abd-0e3c-aea8e4a6c600/828x",alt:"",className:"w-100 embed-responsive-item fit--cover"})]})}),/*#__PURE__*/_jsxs("div",{className:"col-12 col-lg-6 px-0 py-3",children:[/*#__PURE__*/_jsx("div",{className:"w-100 text-end me-ng me-lg-0 d-none d-lg-block",children:/*#__PURE__*/_jsx(SplashTop,{})}),/*#__PURE__*/_jsxs("div",{className:"emailBox px-g",children:[/*#__PURE__*/_jsx("p",{className:"h1 mb-0",children:"Get 15% Off* your customised routine!"}),/*#__PURE__*/_jsx("p",{className:"mt-2 h4 fw-normal col-lg-9 mx-auto px-lg-3",children:"We've got your routine ready! Enter your email to view your results and get 15% OFF your first purchase."}),/*#__PURE__*/_jsx("div",{className:"footer-action w-100 mt-4",children:/*#__PURE__*/_jsx("a",{href:"#",className:"d-block text-underline text-black w-100 mt-2 mb-lg-4",onClick:skipEmail,children:"Continue"})})]}),/*#__PURE__*/_jsx("div",{className:"w-100 text-start ms-ng ms-lg-0 d-none d-lg-block",children:/*#__PURE__*/_jsx(SplashBottom,{})})]})]})}),currentPosition==='finished'&&submitted&&additionalStep&&!redirect&&/*#__PURE__*/_jsx(ResultContent,{viewMyResult:viewMyResult}),(currentPosition==='finished'||currentPosition==='result')&&redirect&&/*#__PURE__*/_jsxs("div",{className:"question-box analyzing d-flex justify-content-center align-items-center flex-column",children:[/*#__PURE__*/_jsx("p",{className:"question-box__title",children:"Analysing your answers"}),/*#__PURE__*/_jsx(LoaderSvg,{className:"loader mt-0 mb-0"})]})]})});};/* harmony default export */ var templates_Survey = ((/* unused pure expression or super */ null && (Survey)));
// EXTERNAL MODULE: ./node_modules/bootstrap/dist/js/bootstrap.esm.js + 57 modules
var bootstrap_esm = __webpack_require__(651);
;// CONCATENATED MODULE: ./src/assets/chevron-up.svg
var chevron_up_path;

var chevron_up_excluded = ["title", "titleId"];

function chevron_up_extends() { chevron_up_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_up_extends.apply(this, arguments); }

function chevron_up_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = chevron_up_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function chevron_up_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgChevronUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = chevron_up_objectWithoutProperties(_ref, chevron_up_excluded);

  return /*#__PURE__*/react.createElement("svg", chevron_up_extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, chevron_up_path || (chevron_up_path = /*#__PURE__*/react.createElement("path", {
    d: "M5.00097 0.000740965C5.25097 -0.0056091 5.5039 0.0879006 5.69531 0.281501L9.7207 4.35718C10.0928 4.73267 10.0928 5.34302 9.7207 5.71826C9.35351 6.09375 8.75097 6.09375 8.3789 5.71826L4.99999 2.2937L1.62011 5.71826C1.24804 6.09375 0.650384 6.09375 0.278314 5.71826C-0.0927764 5.34302 -0.0927764 4.73266 0.278313 4.35718L4.3037 0.281501C4.49022 0.0940008 4.73339 1.09508e-05 4.97655 1.09296e-05C4.98436 1.09289e-05 4.99217 0.000501117 5.00096 0.000740965L5.00097 0.000740965Z",
    fill: "#484848"
  })));
}

var chevron_up_ForwardRef = /*#__PURE__*/react.forwardRef(SvgChevronUp);
/* harmony default export */ var chevron_up = (__webpack_require__.p + "static/media/chevron-up.a6f3b0e375737808fa94b0defc4f10ee.svg");

;// CONCATENATED MODULE: ./src/assets/chevron-down.svg
var chevron_down_path;

var chevron_down_excluded = ["title", "titleId"];

function chevron_down_extends() { chevron_down_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chevron_down_extends.apply(this, arguments); }

function chevron_down_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = chevron_down_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function chevron_down_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = chevron_down_objectWithoutProperties(_ref, chevron_down_excluded);

  return /*#__PURE__*/react.createElement("svg", chevron_down_extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, chevron_down_path || (chevron_down_path = /*#__PURE__*/react.createElement("path", {
    d: "M4.99878 5.99914C4.74878 6.00549 4.49585 5.91198 4.30444 5.71838L0.279052 1.6427C-0.0930175 1.26721 -0.0930175 0.656857 0.279052 0.281617C0.646242 -0.0938725 1.24878 -0.0938725 1.62085 0.281617L4.99976 3.70618L8.37964 0.281617C8.75171 -0.0938725 9.34937 -0.0938725 9.72144 0.281617C10.0925 0.656857 10.0925 1.26722 9.72144 1.6427L5.69605 5.71838C5.50953 5.90588 5.26636 5.99987 5.0232 5.99987C5.01539 5.99987 5.00758 5.99938 4.99879 5.99914H4.99878Z",
    fill: "#484848"
  })));
}

var chevron_down_ForwardRef = /*#__PURE__*/react.forwardRef(SvgChevronDown);
/* harmony default export */ var chevron_down = (__webpack_require__.p + "static/media/chevron-down.1eca20ebd32d846b93c35fa420f1df42.svg");

;// CONCATENATED MODULE: ./src/assets/hyaluronic-acid.svg
var hyaluronic_acid_path, hyaluronic_acid_path2, hyaluronic_acid_path3, hyaluronic_acid_path4, hyaluronic_acid_path5, hyaluronic_acid_path6, hyaluronic_acid_path7, hyaluronic_acid_path8, hyaluronic_acid_path9, hyaluronic_acid_path10, hyaluronic_acid_path11;

var hyaluronic_acid_excluded = ["title", "titleId"];

function hyaluronic_acid_extends() { hyaluronic_acid_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return hyaluronic_acid_extends.apply(this, arguments); }

function hyaluronic_acid_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = hyaluronic_acid_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function hyaluronic_acid_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgHyaluronicAcid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = hyaluronic_acid_objectWithoutProperties(_ref, hyaluronic_acid_excluded);

  return /*#__PURE__*/react.createElement("svg", hyaluronic_acid_extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, hyaluronic_acid_path || (hyaluronic_acid_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.2897 21.2763C17.5812 21.2763 19.4389 19.3915 19.4389 17.0665C19.4389 14.7415 17.5812 12.8567 15.2897 12.8567C12.9983 12.8567 11.1406 14.7415 11.1406 17.0665C11.1406 19.3915 12.9983 21.2763 15.2897 21.2763Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), hyaluronic_acid_path2 || (hyaluronic_acid_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M18.0873 17.1644C18.0873 18.7309 16.8329 20.0036 15.2891 20.0036",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), hyaluronic_acid_path3 || (hyaluronic_acid_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M20.4033 10.8986C21.7889 10.8986 22.9121 9.75901 22.9121 8.35319C22.9121 6.94738 21.7889 5.80774 20.4033 5.80774C19.0177 5.80774 17.8945 6.94738 17.8945 8.35319C17.8945 9.75901 19.0177 10.8986 20.4033 10.8986Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), hyaluronic_acid_path4 || (hyaluronic_acid_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M21.9472 8.35315C21.9472 9.23427 21.2717 9.91958 20.4033 9.91958",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), hyaluronic_acid_path5 || (hyaluronic_acid_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M5.73684 21.2762C6.69607 21.2762 7.47368 20.4872 7.47368 19.5139C7.47368 18.5407 6.69607 17.7517 5.73684 17.7517C4.77761 17.7517 4 18.5407 4 19.5139C4 20.4872 4.77761 21.2762 5.73684 21.2762Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), hyaluronic_acid_path6 || (hyaluronic_acid_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M6.70222 19.6119C6.70222 20.1014 6.31625 20.591 5.7373 20.591",
    stroke: "black",
    strokeWidth: 0.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), hyaluronic_acid_path7 || (hyaluronic_acid_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M7.47363 19.1225L11.2368 18.2413",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), hyaluronic_acid_path8 || (hyaluronic_acid_path8 = /*#__PURE__*/react.createElement("path", {
    d: "M17.2197 13.2483L18.8601 10.5071",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), hyaluronic_acid_path9 || (hyaluronic_acid_path9 = /*#__PURE__*/react.createElement("path", {
    d: "M22.0441 10.4091C23.9739 14.3252 25.8073 18.535 25.8073 20.7867C25.8073 25.5839 21.9476 29.5 17.2196 29.5C12.4915 29.5 8.63184 25.5839 8.63184 20.7867C8.63184 15.9895 17.2196 1.5 17.2196 1.5C17.2196 1.5 18.281 3.26224 19.6318 5.80769",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), hyaluronic_acid_path10 || (hyaluronic_acid_path10 = /*#__PURE__*/react.createElement("path", {
    d: "M25.9997 24.6049C25.9997 25.6818 25.1313 26.4651 24.1663 26.4651C23.1049 26.4651 22.333 25.5839 22.333 24.6049C22.333 23.528 24.1663 21.2762 24.1663 21.2762C24.1663 21.2762 25.9997 23.6259 25.9997 24.6049Z",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), hyaluronic_acid_path11 || (hyaluronic_acid_path11 = /*#__PURE__*/react.createElement("path", {
    d: "M12.3938 5.26488C12.3938 6.09557 11.7907 6.68891 10.9464 6.68891C10.1021 6.68891 9.49902 6.09557 9.49902 5.26488C9.49902 4.4342 10.9464 2.77283 10.9464 2.77283C10.9464 2.77283 12.3938 4.55287 12.3938 5.26488Z",
    stroke: "black",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var hyaluronic_acid_ForwardRef = /*#__PURE__*/react.forwardRef(SvgHyaluronicAcid);
/* harmony default export */ var hyaluronic_acid = (__webpack_require__.p + "static/media/hyaluronic-acid.892b3f33559f848965b34d5dcf83d6f2.svg");

;// CONCATENATED MODULE: ./src/assets/vegan-squalane.svg
var vegan_squalane_path, vegan_squalane_path2, vegan_squalane_path3, vegan_squalane_path4, vegan_squalane_path5;

var vegan_squalane_excluded = ["title", "titleId"];

function vegan_squalane_extends() { vegan_squalane_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return vegan_squalane_extends.apply(this, arguments); }

function vegan_squalane_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = vegan_squalane_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function vegan_squalane_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgVeganSqualane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = vegan_squalane_objectWithoutProperties(_ref, vegan_squalane_excluded);

  return /*#__PURE__*/react.createElement("svg", vegan_squalane_extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, vegan_squalane_path || (vegan_squalane_path = /*#__PURE__*/react.createElement("path", {
    d: "M21.8978 20.3871C21.6069 22.2258 20.4433 23.7742 18.7949 24.7419",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), vegan_squalane_path2 || (vegan_squalane_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M21.8965 17.2905V16.613",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), vegan_squalane_path3 || (vegan_squalane_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M8.22461 11.4839C10.9396 5.77419 15.5939 2 15.5939 2C15.5939 2 24.9994 9.64516 24.9994 19.6129C24.9994 24.7419 20.83 29 15.5939 29C15.206 29 14.9151 29 14.5273 28.9032",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), vegan_squalane_path4 || (vegan_squalane_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M7.93359 16.2258C8.22449 23.1936 11.1334 26.7742 12.8788 28.5162",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), vegan_squalane_path5 || (vegan_squalane_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M10.455 25.9031C8.8066 26.3869 7.06124 25.7095 6.0916 24.3547C5.025 22.9031 4.83107 20.9676 5.12196 19.2257C5.50982 16.9998 6.47946 14.8708 7.83696 13.0321C8.51571 14.0966 9.48535 14.9676 10.358 15.8386C11.4246 16.9031 12.3943 18.0644 12.8791 19.4192C13.9457 21.9353 13.3639 25.1289 10.455 25.9031Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var vegan_squalane_ForwardRef = /*#__PURE__*/react.forwardRef(SvgVeganSqualane);
/* harmony default export */ var vegan_squalane = (__webpack_require__.p + "static/media/vegan-squalane.c52b5a8fbf8130915944e86b5e8ff1e9.svg");

;// CONCATENATED MODULE: ./src/assets/ahas.svg
var ahas_path, ahas_path2, ahas_path3, ahas_path4, ahas_path5, ahas_path6, ahas_path7;

var ahas_excluded = ["title", "titleId"];

function ahas_extends() { ahas_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ahas_extends.apply(this, arguments); }

function ahas_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = ahas_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function ahas_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgAhas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = ahas_objectWithoutProperties(_ref, ahas_excluded);

  return /*#__PURE__*/react.createElement("svg", ahas_extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, ahas_path || (ahas_path = /*#__PURE__*/react.createElement("path", {
    d: "M15.9992 23.4276C18.6534 23.4276 20.805 21.2459 20.805 18.5548C20.805 15.8636 18.6534 13.682 15.9992 13.682C13.345 13.682 11.1934 15.8636 11.1934 18.5548C11.1934 21.2459 13.345 23.4276 15.9992 23.4276Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), ahas_path2 || (ahas_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M15.9997 7.59097C17.6586 7.59097 19.0034 6.22746 19.0034 4.54549C19.0034 2.86351 17.6586 1.5 15.9997 1.5C14.3409 1.5 12.9961 2.86351 12.9961 4.54549C12.9961 6.22746 14.3409 7.59097 15.9997 7.59097Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), ahas_path3 || (ahas_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M16 13.6819V7.59094",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), ahas_path4 || (ahas_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M26.5129 29.1124C27.9146 29.9245 29.8169 29.4169 30.6179 27.9957C31.4188 26.5744 30.9182 24.6456 29.5165 23.8335C28.1148 23.0214 26.2125 23.529 25.4116 24.9502C24.6106 26.3714 25.1112 28.3002 26.5129 29.1124Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), ahas_path5 || (ahas_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M5.48724 29.1124C4.08554 29.9245 2.18323 29.4169 1.38226 27.9957C0.581291 26.5744 1.0819 24.6456 2.4836 23.8335C3.8853 23.0214 5.78761 23.529 6.58858 24.9502C7.38955 26.3714 6.88894 28.3002 5.48724 29.1124Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), ahas_path6 || (ahas_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M11.995 21.1941L6.48828 24.8487",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), ahas_path7 || (ahas_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M25.5125 24.8487L20.0059 21.1941",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ahas_ForwardRef = /*#__PURE__*/react.forwardRef(SvgAhas);
/* harmony default export */ var ahas = (__webpack_require__.p + "static/media/ahas.f60c62e6be088bdd1492b3aafbe6140a.svg");

;// CONCATENATED MODULE: ./src/assets/vitamin-c.svg
var vitamin_c_path, vitamin_c_path2, vitamin_c_path3, vitamin_c_path4, vitamin_c_path5, vitamin_c_path6, vitamin_c_path7;

var vitamin_c_excluded = ["title", "titleId"];

function vitamin_c_extends() { vitamin_c_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return vitamin_c_extends.apply(this, arguments); }

function vitamin_c_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = vitamin_c_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function vitamin_c_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgVitaminC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = vitamin_c_objectWithoutProperties(_ref, vitamin_c_excluded);

  return /*#__PURE__*/react.createElement("svg", vitamin_c_extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, vitamin_c_path || (vitamin_c_path = /*#__PURE__*/react.createElement("path", {
    d: "M21.5 27.3C19.6 28.4 17.4 29 15 29C7.5 29 1.5 23 1.5 15.5C1.5 8 7.6 2 15 2C22.5 2 28.5 8 28.5 15.5C28.5 17.1 28.2 18.6 27.7 20",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), vitamin_c_path2 || (vitamin_c_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M21.6 24.9C19.7 26.2 17.5 27 15 27C8.6 27 3.5 21.9 3.5 15.5C3.5 9.1 8.7 4 15 4C21.4 4 26.5 9.1 26.5 15.5C26.5 17.1 26.2 18.6 25.6 19.9",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), vitamin_c_path3 || (vitamin_c_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M15 4V27",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), vitamin_c_path4 || (vitamin_c_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M6.90039 7.40002L22.1004 22.6",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), vitamin_c_path5 || (vitamin_c_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M3.5 15.5H26.5",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), vitamin_c_path6 || (vitamin_c_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M6.90039 23.6L23.2004 7.40002",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), vitamin_c_path7 || (vitamin_c_path7 = /*#__PURE__*/react.createElement("path", {
    d: "M28.5 26.5C28.5 27.9 27.4 29 26 29C24.6 29 23.5 27.9 23.5 26.5C23.5 25.1 26 22 26 22C26 22 28.5 25.1 28.5 26.5Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var vitamin_c_ForwardRef = /*#__PURE__*/react.forwardRef(SvgVitaminC);
/* harmony default export */ var vitamin_c = (__webpack_require__.p + "static/media/vitamin-c.b4d84e80bbbaffe226d858fde94c7d03.svg");

;// CONCATENATED MODULE: ./src/assets/niacinamide.svg
var niacinamide_path, niacinamide_path2, niacinamide_path3, niacinamide_path4;

var niacinamide_excluded = ["title", "titleId"];

function niacinamide_extends() { niacinamide_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return niacinamide_extends.apply(this, arguments); }

function niacinamide_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = niacinamide_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function niacinamide_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgNiacinamide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = niacinamide_objectWithoutProperties(_ref, niacinamide_excluded);

  return /*#__PURE__*/react.createElement("svg", niacinamide_extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, niacinamide_path || (niacinamide_path = /*#__PURE__*/react.createElement("path", {
    d: "M6.9932 27.4118C6.9932 28.3052 6.29478 29.0001 5.4966 29.0001C4.69841 29.0001 4 28.3052 4 27.4118C4 27.114 4.09977 26.9155 4.19955 26.6177L5.4966 23.9376L6.79365 26.6177C6.9932 26.8162 6.9932 27.114 6.9932 27.4118Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), niacinamide_path2 || (niacinamide_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M16.482 4.50112L12.5312 8.43176L19.6568 15.521L23.6075 11.5903L16.482 4.50112Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), niacinamide_path3 || (niacinamide_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M18.0684 6.06979L21.2611 2.89332C21.76 2.397 22.5582 1.99994 23.2566 1.99994C24.0548 1.99994 24.7532 2.29773 25.252 2.89332C26.2498 3.88597 26.2498 5.67273 25.252 6.66538L21.8597 10.0404",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), niacinamide_path4 || (niacinamide_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M14.8746 10.7353L8.18981 17.386C7.49139 18.0809 6.89276 18.9743 6.59344 19.9669L5.5957 20.9596L7.0923 22.4485L8.09003 21.4559C9.08777 21.1581 9.98573 20.5625 10.6841 19.8676L17.3689 13.2169",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var niacinamide_ForwardRef = /*#__PURE__*/react.forwardRef(SvgNiacinamide);
/* harmony default export */ var niacinamide = (__webpack_require__.p + "static/media/niacinamide.8fac90519613ae068e6e86d01ea4c9bb.svg");

;// CONCATENATED MODULE: ./src/assets/vitamin-e.svg
var vitamin_e_path, vitamin_e_path2, vitamin_e_path3, vitamin_e_path4;

var vitamin_e_excluded = ["title", "titleId"];

function vitamin_e_extends() { vitamin_e_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return vitamin_e_extends.apply(this, arguments); }

function vitamin_e_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = vitamin_e_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function vitamin_e_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgVitaminE(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = vitamin_e_objectWithoutProperties(_ref, vitamin_e_excluded);

  return /*#__PURE__*/react.createElement("svg", vitamin_e_extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, vitamin_e_path || (vitamin_e_path = /*#__PURE__*/react.createElement("path", {
    d: "M22 19.6088C22 24.6583 18 28.7177 13 28.7177C8 28.7177 4 24.6583 4 19.6088C4 18.0247 4.4 16.5396 5.1 15.3514L13.1 0.5L21 15.3514C21.6 16.5396 22 18.0247 22 19.6088Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), vitamin_e_path2 || (vitamin_e_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M13 24.6584C10.2 24.6584 8 22.3812 8 19.6089",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), vitamin_e_path3 || (vitamin_e_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M21 27.8268C23.4853 27.8268 25.5 25.832 25.5 23.3713C25.5 20.9107 23.4853 18.9159 21 18.9159C18.5147 18.9159 16.5 20.9107 16.5 23.3713C16.5 25.832 18.5147 27.8268 21 27.8268Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10
  })), vitamin_e_path4 || (vitamin_e_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M19.855 21.59V25.724H22.363V25.202H20.413V23.954H22.063V23.432H20.413V22.112H22.303V21.59H19.855Z",
    fill: "black"
  })));
}

var vitamin_e_ForwardRef = /*#__PURE__*/react.forwardRef(SvgVitaminE);
/* harmony default export */ var vitamin_e = (__webpack_require__.p + "static/media/vitamin-e.39cfafa2da5d9a645c0d4a5e0b82b1c9.svg");

;// CONCATENATED MODULE: ./src/assets/salicylic-acid.svg
var _mask, salicylic_acid_path, salicylic_acid_path2, salicylic_acid_path3, salicylic_acid_path4, salicylic_acid_path5, salicylic_acid_path6;

var salicylic_acid_excluded = ["title", "titleId"];

function salicylic_acid_extends() { salicylic_acid_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return salicylic_acid_extends.apply(this, arguments); }

function salicylic_acid_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = salicylic_acid_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function salicylic_acid_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgSalicylicAcid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = salicylic_acid_objectWithoutProperties(_ref, salicylic_acid_excluded);

  return /*#__PURE__*/react.createElement("svg", salicylic_acid_extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/react.createElement("mask", {
    id: "path-1-outside-1_907_60305",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 26,
    fill: "black"
  }, /*#__PURE__*/react.createElement("rect", {
    fill: "white",
    width: 32,
    height: 26
  }), /*#__PURE__*/react.createElement("path", {
    d: "M16.0048 25C13.7474 25 12.9501 23.1235 12.9501 21.491C12.973 20.5061 13.1545 19.5309 13.488 18.6012C13.8343 17.6551 14.0193 16.6599 14.0356 15.6552C14.0368 15.4885 14.0042 15.3232 13.9395 15.169C13.8747 15.0148 13.7793 14.8746 13.6586 14.7568C13.5379 14.6389 13.3944 14.5457 13.2365 14.4824C13.0786 14.4192 12.9094 14.3873 12.7387 14.3886H1.33636C1.29184 14.3899 1.24753 14.3823 1.20614 14.3662C1.16475 14.3502 1.12715 14.326 1.09566 14.2953C1.06417 14.2645 1.03945 14.2278 1.02303 14.1874C1.0066 14.147 0.998816 14.1037 1.00015 14.0602C1.00015 14.0171 1.00884 13.9744 1.02574 13.9345C1.04263 13.8947 1.0674 13.8585 1.09862 13.828C1.12984 13.7975 1.1669 13.7733 1.20769 13.7568C1.24849 13.7403 1.29221 13.7318 1.33636 13.7318H12.7387C12.9991 13.7254 13.2582 13.7707 13.5001 13.8651C13.742 13.9595 13.9617 14.1009 14.1459 14.2808C14.3301 14.4607 14.4749 14.6753 14.5715 14.9116C14.6682 15.1479 14.7146 15.4009 14.708 15.6552C14.6947 16.7268 14.5 17.7888 14.1316 18.7983C13.8158 19.6636 13.6439 20.5726 13.6225 21.491C13.6225 22.1572 13.7954 24.3057 16.0048 24.3057C18.2142 24.3057 18.3775 22.1196 18.3775 21.491C18.3561 20.5726 18.1842 19.6636 17.8684 18.7983C17.5047 17.7876 17.3101 16.7263 17.292 15.6552C17.2854 15.4009 17.3318 15.1479 17.4285 14.9116C17.5251 14.6753 17.6699 14.4607 17.8541 14.2808C18.0383 14.1009 18.258 13.9595 18.4999 13.8651C18.7418 13.7707 19.0009 13.7254 19.2613 13.7318H30.6636C30.7078 13.7318 30.7515 13.7403 30.7923 13.7568C30.8331 13.7733 30.8702 13.7975 30.9014 13.828C30.9326 13.8585 30.9574 13.8947 30.9743 13.9345C30.9912 13.9744 30.9999 14.0171 30.9999 14.0602C31.0012 14.1037 30.9934 14.147 30.977 14.1874C30.9605 14.2278 30.9358 14.2645 30.9043 14.2953C30.8729 14.326 30.8353 14.3502 30.7939 14.3662C30.7525 14.3823 30.7082 14.3899 30.6636 14.3886H19.2613C19.0906 14.3873 18.9214 14.4192 18.7635 14.4824C18.6056 14.5457 18.4621 14.6389 18.3414 14.7568C18.2207 14.8746 18.1253 15.0148 18.0606 15.169C17.9958 15.3232 17.9632 15.4885 17.9644 15.6552C17.9808 16.6599 18.1657 17.6551 18.512 18.6012C18.8572 19.5285 19.0454 20.5046 19.0691 21.491C19.0691 23.1048 18.2526 25 16.0048 25Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M12.7387 10.1478C12.6495 10.1478 12.564 10.1132 12.501 10.0516C12.4379 9.99002 12.4025 9.90649 12.4025 9.8194C12.4025 7.22049 11.0576 5.89758 8.39676 5.89758C8.30759 5.89758 8.22207 5.86298 8.15902 5.8014C8.09597 5.73982 8.06055 5.65629 8.06055 5.5692C8.06055 5.48211 8.09597 5.39858 8.15902 5.337C8.22207 5.27541 8.30759 5.24082 8.39676 5.24082C11.0576 5.24082 12.4025 3.92729 12.4025 1.32838C12.4025 1.24129 12.4379 1.15776 12.501 1.09618C12.564 1.0346 12.6495 1 12.7387 1C12.8279 1 12.9134 1.0346 12.9764 1.09618C13.0395 1.15776 13.0749 1.24129 13.0749 1.32838C13.0749 3.92729 14.4294 5.24082 17.0902 5.24082C17.1794 5.24082 17.2649 5.27541 17.328 5.337C17.391 5.39858 17.4265 5.48211 17.4265 5.5692C17.4265 5.65629 17.391 5.73982 17.328 5.8014C17.2649 5.86298 17.1794 5.89758 17.0902 5.89758C14.4294 5.89758 13.0749 7.22049 13.0749 9.8194C13.0749 9.90649 13.0395 9.99002 12.9764 10.0516C12.9134 10.1132 12.8279 10.1478 12.7387 10.1478ZM10.4813 5.5692C11.0033 5.74967 11.4771 6.04233 11.8678 6.42556C12.2585 6.8088 12.5561 7.27284 12.7387 7.78343C12.9229 7.2722 13.2222 6.80785 13.6145 6.42463C14.0069 6.04141 14.4823 5.74908 15.0057 5.5692C14.4819 5.3927 14.0059 5.10265 13.6132 4.72079C13.2206 4.33893 12.9216 3.87519 12.7387 3.36435C12.5574 3.87454 12.2601 4.33798 11.8691 4.71985C11.4781 5.10172 11.0036 5.39211 10.4813 5.5692Z"
  }), /*#__PURE__*/react.createElement("path", {
    d: "M20.3454 12.2682C20.2562 12.2682 20.1707 12.2336 20.1077 12.1721C20.0446 12.1105 20.0092 12.027 20.0092 11.9399C20.0575 11.559 20.0161 11.1723 19.8884 10.8094C19.7606 10.4464 19.5498 10.1167 19.2719 9.84527C18.994 9.57388 18.6565 9.36795 18.2848 9.24317C17.9132 9.11838 17.5174 9.07802 17.1274 9.12516C17.0382 9.12516 16.9527 9.09056 16.8896 9.02898C16.8266 8.9674 16.7912 8.88387 16.7912 8.79678C16.7898 8.7533 16.7976 8.71002 16.814 8.66959C16.8305 8.62916 16.8552 8.59244 16.8867 8.56169C16.9182 8.53093 16.9558 8.50679 16.9972 8.49075C17.0385 8.4747 17.0829 8.4671 17.1274 8.4684C17.5215 8.51514 17.9214 8.47287 18.2962 8.34486C18.6709 8.21684 19.0106 8.0065 19.2891 7.73003C19.5675 7.45357 19.7772 7.11836 19.902 6.75024C20.0269 6.38212 20.0636 5.99092 20.0092 5.60678C20.0092 5.51969 20.0446 5.43617 20.1077 5.37458C20.1707 5.313 20.2562 5.2784 20.3454 5.2784C20.4346 5.2784 20.5201 5.313 20.5831 5.37458C20.6462 5.43617 20.6816 5.51969 20.6816 5.60678C20.6273 5.99092 20.6639 6.38212 20.7888 6.75024C20.9136 7.11836 21.1233 7.45357 21.4018 7.73003C21.6802 8.0065 22.0199 8.21684 22.3946 8.34486C22.7694 8.47287 23.1693 8.51514 23.5634 8.4684C23.6079 8.4671 23.6523 8.4747 23.6936 8.49075C23.735 8.50679 23.7726 8.53093 23.8041 8.56169C23.8356 8.59244 23.8603 8.62916 23.8768 8.66959C23.8932 8.71002 23.901 8.7533 23.8996 8.79678C23.8996 8.88387 23.8642 8.9674 23.8012 9.02898C23.7381 9.09056 23.6526 9.12516 23.5634 9.12516C23.1734 9.07802 22.7776 9.11838 22.406 9.24317C22.0343 9.36795 21.6968 9.57388 21.4189 9.84527C21.141 10.1167 20.9302 10.4464 20.8024 10.8094C20.6747 11.1723 20.6334 11.559 20.6816 11.9399C20.6816 12.027 20.6462 12.1105 20.5831 12.1721C20.5201 12.2336 20.4346 12.2682 20.3454 12.2682ZM18.8757 8.75925C19.5362 9.03075 20.0631 9.54201 20.3454 10.1854C20.6271 9.54486 21.1497 9.03438 21.8055 8.75925C21.1485 8.48107 20.6259 7.96725 20.3454 7.32375C20.0634 7.96953 19.5368 8.48386 18.8757 8.75925Z"
  }))), salicylic_acid_path || (salicylic_acid_path = /*#__PURE__*/react.createElement("path", {
    d: "M16.0048 25C13.7474 25 12.9501 23.1235 12.9501 21.491C12.973 20.5061 13.1545 19.5309 13.488 18.6012C13.8343 17.6551 14.0193 16.6599 14.0356 15.6552C14.0368 15.4885 14.0042 15.3232 13.9395 15.169C13.8747 15.0148 13.7793 14.8746 13.6586 14.7568C13.5379 14.6389 13.3944 14.5457 13.2365 14.4824C13.0786 14.4192 12.9094 14.3873 12.7387 14.3886H1.33636C1.29184 14.3899 1.24753 14.3823 1.20614 14.3662C1.16475 14.3502 1.12715 14.326 1.09566 14.2953C1.06417 14.2645 1.03945 14.2278 1.02303 14.1874C1.0066 14.147 0.998816 14.1037 1.00015 14.0602C1.00015 14.0171 1.00884 13.9744 1.02574 13.9345C1.04263 13.8947 1.0674 13.8585 1.09862 13.828C1.12984 13.7975 1.1669 13.7733 1.20769 13.7568C1.24849 13.7403 1.29221 13.7318 1.33636 13.7318H12.7387C12.9991 13.7254 13.2582 13.7707 13.5001 13.8651C13.742 13.9595 13.9617 14.1009 14.1459 14.2808C14.3301 14.4607 14.4749 14.6753 14.5715 14.9116C14.6682 15.1479 14.7146 15.4009 14.708 15.6552C14.6947 16.7268 14.5 17.7888 14.1316 18.7983C13.8158 19.6636 13.6439 20.5726 13.6225 21.491C13.6225 22.1572 13.7954 24.3057 16.0048 24.3057C18.2142 24.3057 18.3775 22.1196 18.3775 21.491C18.3561 20.5726 18.1842 19.6636 17.8684 18.7983C17.5047 17.7876 17.3101 16.7263 17.292 15.6552C17.2854 15.4009 17.3318 15.1479 17.4285 14.9116C17.5251 14.6753 17.6699 14.4607 17.8541 14.2808C18.0383 14.1009 18.258 13.9595 18.4999 13.8651C18.7418 13.7707 19.0009 13.7254 19.2613 13.7318H30.6636C30.7078 13.7318 30.7515 13.7403 30.7923 13.7568C30.8331 13.7733 30.8702 13.7975 30.9014 13.828C30.9326 13.8585 30.9574 13.8947 30.9743 13.9345C30.9912 13.9744 30.9999 14.0171 30.9999 14.0602C31.0012 14.1037 30.9934 14.147 30.977 14.1874C30.9605 14.2278 30.9358 14.2645 30.9043 14.2953C30.8729 14.326 30.8353 14.3502 30.7939 14.3662C30.7525 14.3823 30.7082 14.3899 30.6636 14.3886H19.2613C19.0906 14.3873 18.9214 14.4192 18.7635 14.4824C18.6056 14.5457 18.4621 14.6389 18.3414 14.7568C18.2207 14.8746 18.1253 15.0148 18.0606 15.169C17.9958 15.3232 17.9632 15.4885 17.9644 15.6552C17.9808 16.6599 18.1657 17.6551 18.512 18.6012C18.8572 19.5285 19.0454 20.5046 19.0691 21.491C19.0691 23.1048 18.2526 25 16.0048 25Z",
    fill: "black"
  })), salicylic_acid_path2 || (salicylic_acid_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12.7387 10.1478C12.6495 10.1478 12.564 10.1132 12.501 10.0516C12.4379 9.99002 12.4025 9.90649 12.4025 9.8194C12.4025 7.22049 11.0576 5.89758 8.39676 5.89758C8.30759 5.89758 8.22207 5.86298 8.15902 5.8014C8.09597 5.73982 8.06055 5.65629 8.06055 5.5692C8.06055 5.48211 8.09597 5.39858 8.15902 5.337C8.22207 5.27541 8.30759 5.24082 8.39676 5.24082C11.0576 5.24082 12.4025 3.92729 12.4025 1.32838C12.4025 1.24129 12.4379 1.15776 12.501 1.09618C12.564 1.0346 12.6495 1 12.7387 1C12.8279 1 12.9134 1.0346 12.9764 1.09618C13.0395 1.15776 13.0749 1.24129 13.0749 1.32838C13.0749 3.92729 14.4294 5.24082 17.0902 5.24082C17.1794 5.24082 17.2649 5.27541 17.328 5.337C17.391 5.39858 17.4265 5.48211 17.4265 5.5692C17.4265 5.65629 17.391 5.73982 17.328 5.8014C17.2649 5.86298 17.1794 5.89758 17.0902 5.89758C14.4294 5.89758 13.0749 7.22049 13.0749 9.8194C13.0749 9.90649 13.0395 9.99002 12.9764 10.0516C12.9134 10.1132 12.8279 10.1478 12.7387 10.1478ZM10.4813 5.5692C11.0033 5.74967 11.4771 6.04233 11.8678 6.42556C12.2585 6.8088 12.5561 7.27284 12.7387 7.78343C12.9229 7.2722 13.2222 6.80785 13.6145 6.42463C14.0069 6.04141 14.4823 5.74908 15.0057 5.5692C14.4819 5.3927 14.0059 5.10265 13.6132 4.72079C13.2206 4.33893 12.9216 3.87519 12.7387 3.36435C12.5574 3.87454 12.2601 4.33798 11.8691 4.71985C11.4781 5.10172 11.0036 5.39211 10.4813 5.5692Z",
    fill: "black"
  })), salicylic_acid_path3 || (salicylic_acid_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M20.3454 12.2682C20.2562 12.2682 20.1707 12.2336 20.1077 12.1721C20.0446 12.1105 20.0092 12.027 20.0092 11.9399C20.0575 11.559 20.0161 11.1723 19.8884 10.8094C19.7606 10.4464 19.5498 10.1167 19.2719 9.84527C18.994 9.57388 18.6565 9.36795 18.2848 9.24317C17.9132 9.11838 17.5174 9.07802 17.1274 9.12516C17.0382 9.12516 16.9527 9.09056 16.8896 9.02898C16.8266 8.9674 16.7912 8.88387 16.7912 8.79678C16.7898 8.7533 16.7976 8.71002 16.814 8.66959C16.8305 8.62916 16.8552 8.59244 16.8867 8.56169C16.9182 8.53093 16.9558 8.50679 16.9972 8.49075C17.0385 8.4747 17.0829 8.4671 17.1274 8.4684C17.5215 8.51514 17.9214 8.47287 18.2962 8.34486C18.6709 8.21684 19.0106 8.0065 19.2891 7.73003C19.5675 7.45357 19.7772 7.11836 19.902 6.75024C20.0269 6.38212 20.0636 5.99092 20.0092 5.60678C20.0092 5.51969 20.0446 5.43617 20.1077 5.37458C20.1707 5.313 20.2562 5.2784 20.3454 5.2784C20.4346 5.2784 20.5201 5.313 20.5831 5.37458C20.6462 5.43617 20.6816 5.51969 20.6816 5.60678C20.6273 5.99092 20.6639 6.38212 20.7888 6.75024C20.9136 7.11836 21.1233 7.45357 21.4018 7.73003C21.6802 8.0065 22.0199 8.21684 22.3946 8.34486C22.7694 8.47287 23.1693 8.51514 23.5634 8.4684C23.6079 8.4671 23.6523 8.4747 23.6936 8.49075C23.735 8.50679 23.7726 8.53093 23.8041 8.56169C23.8356 8.59244 23.8603 8.62916 23.8768 8.66959C23.8932 8.71002 23.901 8.7533 23.8996 8.79678C23.8996 8.88387 23.8642 8.9674 23.8012 9.02898C23.7381 9.09056 23.6526 9.12516 23.5634 9.12516C23.1734 9.07802 22.7776 9.11838 22.406 9.24317C22.0343 9.36795 21.6968 9.57388 21.4189 9.84527C21.141 10.1167 20.9302 10.4464 20.8024 10.8094C20.6747 11.1723 20.6334 11.559 20.6816 11.9399C20.6816 12.027 20.6462 12.1105 20.5831 12.1721C20.5201 12.2336 20.4346 12.2682 20.3454 12.2682ZM18.8757 8.75925C19.5362 9.03075 20.0631 9.54201 20.3454 10.1854C20.6271 9.54486 21.1497 9.03438 21.8055 8.75925C21.1485 8.48107 20.6259 7.96725 20.3454 7.32375C20.0634 7.96953 19.5368 8.48386 18.8757 8.75925Z",
    fill: "black"
  })), salicylic_acid_path4 || (salicylic_acid_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M16.0048 25C13.7474 25 12.9501 23.1235 12.9501 21.491C12.973 20.5061 13.1545 19.5309 13.488 18.6012C13.8343 17.6551 14.0193 16.6599 14.0356 15.6552C14.0368 15.4885 14.0042 15.3232 13.9395 15.169C13.8747 15.0148 13.7793 14.8746 13.6586 14.7568C13.5379 14.6389 13.3944 14.5457 13.2365 14.4824C13.0786 14.4192 12.9094 14.3873 12.7387 14.3886H1.33636C1.29184 14.3899 1.24753 14.3823 1.20614 14.3662C1.16475 14.3502 1.12715 14.326 1.09566 14.2953C1.06417 14.2645 1.03945 14.2278 1.02303 14.1874C1.0066 14.147 0.998816 14.1037 1.00015 14.0602C1.00015 14.0171 1.00884 13.9744 1.02574 13.9345C1.04263 13.8947 1.0674 13.8585 1.09862 13.828C1.12984 13.7975 1.1669 13.7733 1.20769 13.7568C1.24849 13.7403 1.29221 13.7318 1.33636 13.7318H12.7387C12.9991 13.7254 13.2582 13.7707 13.5001 13.8651C13.742 13.9595 13.9617 14.1009 14.1459 14.2808C14.3301 14.4607 14.4749 14.6753 14.5715 14.9116C14.6682 15.1479 14.7146 15.4009 14.708 15.6552C14.6947 16.7268 14.5 17.7888 14.1316 18.7983C13.8158 19.6636 13.6439 20.5726 13.6225 21.491C13.6225 22.1572 13.7954 24.3057 16.0048 24.3057C18.2142 24.3057 18.3775 22.1196 18.3775 21.491C18.3561 20.5726 18.1842 19.6636 17.8684 18.7983C17.5047 17.7876 17.3101 16.7263 17.292 15.6552C17.2854 15.4009 17.3318 15.1479 17.4285 14.9116C17.5251 14.6753 17.6699 14.4607 17.8541 14.2808C18.0383 14.1009 18.258 13.9595 18.4999 13.8651C18.7418 13.7707 19.0009 13.7254 19.2613 13.7318H30.6636C30.7078 13.7318 30.7515 13.7403 30.7923 13.7568C30.8331 13.7733 30.8702 13.7975 30.9014 13.828C30.9326 13.8585 30.9574 13.8947 30.9743 13.9345C30.9912 13.9744 30.9999 14.0171 30.9999 14.0602C31.0012 14.1037 30.9934 14.147 30.977 14.1874C30.9605 14.2278 30.9358 14.2645 30.9043 14.2953C30.8729 14.326 30.8353 14.3502 30.7939 14.3662C30.7525 14.3823 30.7082 14.3899 30.6636 14.3886H19.2613C19.0906 14.3873 18.9214 14.4192 18.7635 14.4824C18.6056 14.5457 18.4621 14.6389 18.3414 14.7568C18.2207 14.8746 18.1253 15.0148 18.0606 15.169C17.9958 15.3232 17.9632 15.4885 17.9644 15.6552C17.9808 16.6599 18.1657 17.6551 18.512 18.6012C18.8572 19.5285 19.0454 20.5046 19.0691 21.491C19.0691 23.1048 18.2526 25 16.0048 25Z",
    stroke: "black",
    strokeWidth: 0.2,
    mask: "url(#path-1-outside-1_907_60305)"
  })), salicylic_acid_path5 || (salicylic_acid_path5 = /*#__PURE__*/react.createElement("path", {
    d: "M12.7387 10.1478C12.6495 10.1478 12.564 10.1132 12.501 10.0516C12.4379 9.99002 12.4025 9.90649 12.4025 9.8194C12.4025 7.22049 11.0576 5.89758 8.39676 5.89758C8.30759 5.89758 8.22207 5.86298 8.15902 5.8014C8.09597 5.73982 8.06055 5.65629 8.06055 5.5692C8.06055 5.48211 8.09597 5.39858 8.15902 5.337C8.22207 5.27541 8.30759 5.24082 8.39676 5.24082C11.0576 5.24082 12.4025 3.92729 12.4025 1.32838C12.4025 1.24129 12.4379 1.15776 12.501 1.09618C12.564 1.0346 12.6495 1 12.7387 1C12.8279 1 12.9134 1.0346 12.9764 1.09618C13.0395 1.15776 13.0749 1.24129 13.0749 1.32838C13.0749 3.92729 14.4294 5.24082 17.0902 5.24082C17.1794 5.24082 17.2649 5.27541 17.328 5.337C17.391 5.39858 17.4265 5.48211 17.4265 5.5692C17.4265 5.65629 17.391 5.73982 17.328 5.8014C17.2649 5.86298 17.1794 5.89758 17.0902 5.89758C14.4294 5.89758 13.0749 7.22049 13.0749 9.8194C13.0749 9.90649 13.0395 9.99002 12.9764 10.0516C12.9134 10.1132 12.8279 10.1478 12.7387 10.1478ZM10.4813 5.5692C11.0033 5.74967 11.4771 6.04233 11.8678 6.42556C12.2585 6.8088 12.5561 7.27284 12.7387 7.78343C12.9229 7.2722 13.2222 6.80785 13.6145 6.42463C14.0069 6.04141 14.4823 5.74908 15.0057 5.5692C14.4819 5.3927 14.0059 5.10265 13.6132 4.72079C13.2206 4.33893 12.9216 3.87519 12.7387 3.36435C12.5574 3.87454 12.2601 4.33798 11.8691 4.71985C11.4781 5.10172 11.0036 5.39211 10.4813 5.5692Z",
    stroke: "black",
    strokeWidth: 0.2,
    mask: "url(#path-1-outside-1_907_60305)"
  })), salicylic_acid_path6 || (salicylic_acid_path6 = /*#__PURE__*/react.createElement("path", {
    d: "M20.3454 12.2682C20.2562 12.2682 20.1707 12.2336 20.1077 12.1721C20.0446 12.1105 20.0092 12.027 20.0092 11.9399C20.0575 11.559 20.0161 11.1723 19.8884 10.8094C19.7606 10.4464 19.5498 10.1167 19.2719 9.84527C18.994 9.57388 18.6565 9.36795 18.2848 9.24317C17.9132 9.11838 17.5174 9.07802 17.1274 9.12516C17.0382 9.12516 16.9527 9.09056 16.8896 9.02898C16.8266 8.9674 16.7912 8.88387 16.7912 8.79678C16.7898 8.7533 16.7976 8.71002 16.814 8.66959C16.8305 8.62916 16.8552 8.59244 16.8867 8.56169C16.9182 8.53093 16.9558 8.50679 16.9972 8.49075C17.0385 8.4747 17.0829 8.4671 17.1274 8.4684C17.5215 8.51514 17.9214 8.47287 18.2962 8.34486C18.6709 8.21684 19.0106 8.0065 19.2891 7.73003C19.5675 7.45357 19.7772 7.11836 19.902 6.75024C20.0269 6.38212 20.0636 5.99092 20.0092 5.60678C20.0092 5.51969 20.0446 5.43617 20.1077 5.37458C20.1707 5.313 20.2562 5.2784 20.3454 5.2784C20.4346 5.2784 20.5201 5.313 20.5831 5.37458C20.6462 5.43617 20.6816 5.51969 20.6816 5.60678C20.6273 5.99092 20.6639 6.38212 20.7888 6.75024C20.9136 7.11836 21.1233 7.45357 21.4018 7.73003C21.6802 8.0065 22.0199 8.21684 22.3946 8.34486C22.7694 8.47287 23.1693 8.51514 23.5634 8.4684C23.6079 8.4671 23.6523 8.4747 23.6936 8.49075C23.735 8.50679 23.7726 8.53093 23.8041 8.56169C23.8356 8.59244 23.8603 8.62916 23.8768 8.66959C23.8932 8.71002 23.901 8.7533 23.8996 8.79678C23.8996 8.88387 23.8642 8.9674 23.8012 9.02898C23.7381 9.09056 23.6526 9.12516 23.5634 9.12516C23.1734 9.07802 22.7776 9.11838 22.406 9.24317C22.0343 9.36795 21.6968 9.57388 21.4189 9.84527C21.141 10.1167 20.9302 10.4464 20.8024 10.8094C20.6747 11.1723 20.6334 11.559 20.6816 11.9399C20.6816 12.027 20.6462 12.1105 20.5831 12.1721C20.5201 12.2336 20.4346 12.2682 20.3454 12.2682ZM18.8757 8.75925C19.5362 9.03075 20.0631 9.54201 20.3454 10.1854C20.6271 9.54486 21.1497 9.03438 21.8055 8.75925C21.1485 8.48107 20.6259 7.96725 20.3454 7.32375C20.0634 7.96953 19.5368 8.48386 18.8757 8.75925Z",
    stroke: "black",
    strokeWidth: 0.2,
    mask: "url(#path-1-outside-1_907_60305)"
  })));
}

var salicylic_acid_ForwardRef = /*#__PURE__*/react.forwardRef(SvgSalicylicAcid);
/* harmony default export */ var salicylic_acid = (__webpack_require__.p + "static/media/salicylic-acid.56f1867c2ea922fc45f8128fc1078203.svg");

;// CONCATENATED MODULE: ./src/assets/glycolic-acid.svg
var glycolic_acid_excluded = ["title", "titleId"];

function glycolic_acid_extends() { glycolic_acid_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return glycolic_acid_extends.apply(this, arguments); }

function glycolic_acid_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = glycolic_acid_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function glycolic_acid_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgGlycolicAcid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = glycolic_acid_objectWithoutProperties(_ref, glycolic_acid_excluded);

  return /*#__PURE__*/react.createElement("svg", glycolic_acid_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31,
    className: "svg--active-priority",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    d: "m13.73 19.58-3.04-5.33 3.04-5.33h6.09l3.05 5.33-3.05 5.33h-6.09zM15.04 11.17h3.48M22.87 14.25h6.09L32 19.58l-3.04 5.32h-6.09l-3.05-5.32M24.17 22.66h3.48M22.87 24.91l-3.05 5.32h-6.09l-3.04-5.32 3.04-5.33M15.01 21.86l-1.74 3.05M10.69 14.25H6.2M28.96 14.25 32 8.92M11.03 34.72l2.7-4.49",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: ".6000000000000001px"
    }
  }));
}

var glycolic_acid_ForwardRef = /*#__PURE__*/react.forwardRef(SvgGlycolicAcid);
/* harmony default export */ var glycolic_acid = (__webpack_require__.p + "static/media/glycolic-acid.e9d3501c5e06173192ed582c1a4fdc75.svg");

;// CONCATENATED MODULE: ./src/modules/priority-actives.js
var activeDescription={'Salicylic Acid':{icon:/*#__PURE__*/(0,jsx_runtime.jsx)(salicylic_acid_ForwardRef,{className:"svg--active-priority"}),title:'Salicylic Acid',desc:'Salicylic acid is a BHA well-known for eliminating oil, reducing acne by exfoliating the skin and keeping pores clear.'},'Niacinamide':{icon:/*#__PURE__*/(0,jsx_runtime.jsx)(niacinamide_ForwardRef,{className:"svg--active-priority"}),title:'Niacinamide',desc:'Niacinamide is a form of vitamin B3 that helps build proteins in the skin, retains moisture and offers protection against environmental damage.'},'Vitamin C':{icon:/*#__PURE__*/(0,jsx_runtime.jsx)(vitamin_c_ForwardRef,{className:"svg--active-priority"}),title:'Vitamin C',desc:'Vitamin C is an antioxidant that helps heal blemishes, reduce hyperpigmentation, and give your skin an out-of-this-world glow.'},'Vitamin E':{icon:/*#__PURE__*/(0,jsx_runtime.jsx)(vitamin_e_ForwardRef,{className:"svg--active-priority"}),title:'Vitamin E',desc:'Vitamin E is an anti-inflammatory agent in the skin that has moisturizing and healing benefits, and helps to strengthen skin barrier function.'},'AHAs':{icon:/*#__PURE__*/(0,jsx_runtime.jsx)(ahas_ForwardRef,{className:"svg--active-priority"}),title:'AHAs',desc:'AHAs help to exfoliate the skin and treat acne. Over time, AHAs may help to improve skin texture, fade dark spots, and reduce the visible signs of aging.'},'Hyaluronic Acid':{icon:/*#__PURE__*/(0,jsx_runtime.jsx)(hyaluronic_acid_ForwardRef,{className:"svg--active-priority"}),title:'Hyaluronic Acid',desc:'Hyaluronic acid helps increase skin moisture and reduce the appearance of fine lines and wrinkles.'},'Vegan Squalane':{icon:/*#__PURE__*/(0,jsx_runtime.jsx)(vegan_squalane_ForwardRef,{className:"svg--active-priority"}),title:'Vegan Squalane',desc:'Squalane has anti-inflammatory properties that can reduce redness and swelling, as it helps moisturize and repair dry, rough skin to improve skin texture and appearance.'},'Glycolic Acid':{icon:/*#__PURE__*/(0,jsx_runtime.jsx)(glycolic_acid_ForwardRef,{className:"svg--active-priority"}),title:'Glycolic Acid',desc:'One of the most powerful and effective AHAs given its ability to retexturize and brighten skin, while diminishing the look of fine lines, wrinkles, and discolouration.'}};/* harmony default export */ var priority_actives = (activeDescription);
;// CONCATENATED MODULE: ./src/assets/minus.svg
var minus_path;

var minus_excluded = ["title", "titleId"];

function minus_extends() { minus_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return minus_extends.apply(this, arguments); }

function minus_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = minus_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function minus_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgMinus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = minus_objectWithoutProperties(_ref, minus_excluded);

  return /*#__PURE__*/react.createElement("svg", minus_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, minus_path || (minus_path = /*#__PURE__*/react.createElement("path", {
    d: "M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"
  })));
}

var minus_ForwardRef = /*#__PURE__*/react.forwardRef(SvgMinus);
/* harmony default export */ var minus = (__webpack_require__.p + "static/media/minus.29e773f679433efc766a0bf9ac0324f6.svg");

;// CONCATENATED MODULE: ./src/assets/plus.svg
var plus_path;

var plus_excluded = ["title", "titleId"];

function plus_extends() { plus_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return plus_extends.apply(this, arguments); }

function plus_objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = plus_objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function plus_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = plus_objectWithoutProperties(_ref, plus_excluded);

  return /*#__PURE__*/react.createElement("svg", plus_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, plus_path || (plus_path = /*#__PURE__*/react.createElement("path", {
    d: "M6 0a.6.6 0 01.6.6v4.799l4.8.001a.6.6 0 010 1.2H6.6v4.8a.6.6 0 01-1.2 0V6.6H.6a.6.6 0 110-1.2l4.8-.001V.6A.6.6 0 016 0z"
  })));
}

var plus_ForwardRef = /*#__PURE__*/react.forwardRef(SvgPlus);
/* harmony default export */ var plus = (__webpack_require__.p + "static/media/plus.7616c571aaf98971a53149f95e552f2a.svg");

;// CONCATENATED MODULE: ./src/UI/components/SurveyCard.js
var SurveyCard=function SurveyCard(props){var productDetail=props.productDetail,productList=props.productList,activePriority=props.activePriority,accordionHandle=props.accordionHandle;var _useSearchParams=react_router_dom_useSearchParams(),_useSearchParams2=(0,slicedToArray/* default */.Z)(_useSearchParams,1),searchParams=_useSearchParams2[0];var site=searchParams.get('site');var titleRange=getItemRange(productDetail.title);var selectedSite=site?site.replace('.sandandsky.com',''):'dev';var storeDomain=selectedSite==='www'?'us':selectedSite;var learnMoreSendGA=function learnMoreSendGA(e){if(window.top===window.self)return true;window.parent.postMessage({'func':'callGaEvent','category':'Survey','action':'Learn More','label':e.target.dataset.title},"https://".concat(site));window.parent.location.href=e.target.href;};return/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"survey-result__product-list",children:/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"container p-g mb-g survey-result__bg",children:[/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"row",children:[/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"col-4",children:/*#__PURE__*/(0,jsx_runtime.jsx)("a",{href:"https://".concat(selectedSite,".sandandsky.com/products/").concat(productDetail.handle),"aria-label":productDetail.title,children:/*#__PURE__*/(0,jsx_runtime.jsxs)("picture",{children:[/*#__PURE__*/(0,jsx_runtime.jsx)("source",{srcSet:productDetail[storeDomain].image.replace('236x404','186x322'),media:"(min-width: 992px)"}),/*#__PURE__*/(0,jsx_runtime.jsx)("img",{src:productDetail[storeDomain].image,alt:productDetail.title,className:"w-100 mb-3"})]})})}),/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"col-8 ps-lg-0",children:[/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"font-size-sm mb-0",children:titleRange}),/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"survey-result__product-list__title mb-1 fw-bold",children:productDetail.title.replace(titleRange,'').trim()}),activePriority&&/*#__PURE__*/(0,jsx_runtime.jsxs)("p",{className:"d-flex font-size-sm align-items-center mb-1",children:[activePriority.icon,activePriority.title]}),productDetail.howto&&/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"accordion border-top border-bottom",children:[/*#__PURE__*/(0,jsx_runtime.jsxs)("button",{className:"accordion-button shadow-none bg-transparent text-body px-0 border-0 py-2 mb-0 d-flex justify-content-between font-size-sm","data-target":"collapse".concat(productDetail[storeDomain].id),id:"btnCollapse".concat(productDetail[storeDomain].id),"data-btnindex":productDetail[storeDomain].id,onClick:accordionHandle,"data-parent":"#accordion__products",children:["How to Use",/*#__PURE__*/(0,jsx_runtime.jsx)(plus_ForwardRef,{className:"minus"}),/*#__PURE__*/(0,jsx_runtime.jsx)(minus_ForwardRef,{className:"plus"})]}),/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"collapse",id:"collapse".concat(productDetail[storeDomain].id),"data-bs-parent":"#accordion__products",children:/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"mb-0 pb-2",children:productList.howto})})]}),/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"d-flex font-size-sm mt-g mb-3",children:[productDetail[storeDomain].compare_at_price&&/*#__PURE__*/(0,jsx_runtime.jsx)("span",{className:"text-decoration-line-through me-1 text-muted",children:productDetail[storeDomain].compare_at_price}),productDetail[storeDomain].price&&/*#__PURE__*/(0,jsx_runtime.jsx)("span",{className:"text-secondary fw-bold",children:productDetail[storeDomain].price})]})]})]}),/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"row",children:/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"col-12",children:/*#__PURE__*/(0,jsx_runtime.jsx)("a",{href:"https://".concat(selectedSite,".sandandsky.com/products/").concat(productDetail.handle),className:"btn btn-block btn-primary w-100","data-title":productDetail.title,onClick:learnMoreSendGA,children:"Learn More"})})})]})});};/* harmony default export */ var components_SurveyCard = (SurveyCard);
;// CONCATENATED MODULE: ./src/UI/components/SurveyResult.js
// import { useSearchParams } from "react-router-dom";
// import { useEffect, useState } from 'react';
var SurveyResult=function SurveyResult(props){// const [resultProducts, setProducts] = useState([]);
var _useSearchParams=react_router_dom_useSearchParams(),_useSearchParams2=(0,slicedToArray/* default */.Z)(_useSearchParams,1),searchParams=_useSearchParams2[0];var site=searchParams.get('site');var _props$answerResult=props.answerResult,activePriority=_props$answerResult.activePriority,envStressResult=_props$answerResult.envStressResult,productsRecommend=_props$answerResult.productsRecommend,skinType=_props$answerResult.skinType;var accordionHandle=function accordionHandle(e){var parentId=e.currentTarget.dataset.parent;var btnToggle=document.querySelectorAll("".concat(parentId," .accordion-button"));for(var i=0;i<btnToggle.length;i++){btnToggle[i].classList.remove('collapsed');}var collapse=new bootstrap_esm.Collapse(document.getElementById(e.currentTarget.dataset.target),{toggle:true});var btnIndex=e.currentTarget.dataset.btnindex;document.querySelector("#btnCollapse".concat(btnIndex)).classList.toggle('collapsed');setTimeout(function(){if(collapse._element.classList.contains('show')){document.getElementById("collapse".concat(btnIndex)).classList.remove('collapsed');}else{document.querySelector("#btnCollapse".concat(btnIndex)).classList.toggle('collapsed');}var height=document.querySelector('.survey-content').clientHeight;postIframeHeight('height',height,site);},390);};// const selectedSite = site ? site : 'dev';
// useEffect(() => {
// 	setProducts([]);
// 	for (let i=0; i<=productsRecommend.length - 1; i+=1) {
// 		const productInfo = productList[productsRecommend[i]];
// 		fetch(`https://${selectedSite}/products/${productInfo.handle}.json`)
// 			.then((response) => response.json())
// 			.then((data) => {
// 				setProducts(oldArray => [...oldArray, data.product]);
// 			});
// 	}
// }, [productList]);
var resultProducts=[];if(productsRecommend){for(var i=0;i<=productsRecommend.length-1;i+=1){var productInfo=product_list[productsRecommend[i]];resultProducts.push(productInfo);}}var rangeValue;var rangeStyleVal;switch(envStressResult===null||envStressResult===void 0?void 0:envStressResult.title){case'LOW':rangeValue=0.25;rangeStyleVal=0.125;break;case'AVERAGE':rangeValue=1;rangeStyleVal=0.5;break;default:rangeValue=2;rangeStyleVal=1;break;}var rangeMin=0;var rangeMax=2;var rangeStyle={backgroundImage:"-webkit-gradient(linear, 0% 0%, 100% 0%, color-stop(".concat(rangeStyleVal,", #42A1CA), color-stop(").concat(rangeStyleVal,", #DFF4F9))")};return/*#__PURE__*/(0,jsx_runtime.jsxs)("section",{className:"survey-result mt-4 mt-lg-0",children:[/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"d-lg-none container px-g",children:[/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"h2 mb-2",children:"Your Skin Analysis"}),/*#__PURE__*/(0,jsx_runtime.jsx)("p",{children:"Below is your skin analysis:"})]}),/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"survey-result__bg",children:/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"container px-2 py-4 my-g my-lg-4",children:/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"row",children:[/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"col-12 col-lg-5 col-xl-6",children:[/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"d-none d-lg-block h1 mb-2",children:"Your Skin Analysis"}),/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"d-none d-lg-block survey-result__subtitle",children:"Below is your skin analysis:"})]}),/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"col-12 col-lg-7 col-xl-6",children:/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"accordion",id:"surveyResult",children:[/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"accordion-item border-0 mb-g",children:[/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"accordion-button shadow-sm bg-white justify-content-between rounded","data-target":"collapse1",id:"btnCollapse1","data-btnindex":"1",onClick:accordionHandle,"data-parent":"#surveyResult",children:["Skin Type",/*#__PURE__*/(0,jsx_runtime.jsxs)("p",{className:"d-flex align-items-center font-size-sm mb-0",children:[skinType===null||skinType===void 0?void 0:skinType.title,/*#__PURE__*/(0,jsx_runtime.jsx)(chevron_down_ForwardRef,{className:"minus ms-2"}),/*#__PURE__*/(0,jsx_runtime.jsx)(chevron_up_ForwardRef,{className:"plus ms-2"})]})]}),/*#__PURE__*/(0,jsx_runtime.jsx)("div",{id:"collapse1",className:"accordion-collapse bg-white mt-1 collapse","data-bs-parent":"#surveyResult",children:/*#__PURE__*/(0,jsx_runtime.jsxs)("p",{className:"p-g px-lg-4 survey-result__desc",children:[/*#__PURE__*/(0,jsx_runtime.jsx)("strong",{className:"mb-g d-block",children:skinType===null||skinType===void 0?void 0:skinType.title}),skinType===null||skinType===void 0?void 0:skinType.desc]})})]}),/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"accordion-item border-0",children:[/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"accordion-button shadow-sm bg-white justify-content-between rounded","data-target":"collapse2",id:"btnCollapse2","data-btnindex":"2",onClick:accordionHandle,"data-parent":"#surveyResult",children:["Environmental Stress",/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"d-flex align-items-center font-size-sm mb-0",children:[/*#__PURE__*/(0,jsx_runtime.jsx)("input",{style:rangeStyle,className:"survey-result__range",type:"range",min:rangeMin,max:rangeMax,step:"0.25",value:rangeValue,readOnly:true,"data-target":"collapse2",id:"btnCollapse2","data-btnindex":"2",onTouchStart:accordionHandle,role:"button"}),/*#__PURE__*/(0,jsx_runtime.jsx)(chevron_down_ForwardRef,{className:"minus ms-2"}),/*#__PURE__*/(0,jsx_runtime.jsx)(chevron_up_ForwardRef,{className:"plus ms-2"})]})]}),/*#__PURE__*/(0,jsx_runtime.jsx)("div",{id:"collapse2",className:"accordion-collapse bg-white mt-1 collapse","data-bs-parent":"#surveyResult",children:/*#__PURE__*/(0,jsx_runtime.jsxs)("p",{className:"p-g px-lg-4 survey-result__desc",children:[/*#__PURE__*/(0,jsx_runtime.jsx)("strong",{className:"mb-g d-block",children:(envStressResult===null||envStressResult===void 0?void 0:envStressResult.title.charAt(0).toUpperCase())+(envStressResult===null||envStressResult===void 0?void 0:envStressResult.title.toLowerCase().slice(1))}),envStressResult===null||envStressResult===void 0?void 0:envStressResult.desc]})})]})]})})]})})}),/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"container px-g mt-4 mb-g d-lg-none",children:[/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"h2 mb-2",children:"Priority Actives"}),/*#__PURE__*/(0,jsx_runtime.jsx)("p",{children:"These active ingredients have been identified to suit your skin\u2019s needs and concerns:"})]}),/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"survey-result__bg survey-result__priority-actives",children:/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"container px-2 py-4 my-g",children:/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"row",children:[/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"col-12 col-lg-5 ".concat(activePriority&&activePriority.length===3?'col-xl-6':'col-xl-4'," mb-2"),children:[/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"h1 mb-2 d-none d-lg-block mb-2",children:"Priority Actives"}),/*#__PURE__*/(0,jsx_runtime.jsxs)("p",{className:"d-none d-lg-block survey-result__subtitle",children:["These active ingredients have been identified to",/*#__PURE__*/(0,jsx_runtime.jsx)("br",{}),"suit your skin\u2019s needs and concerns:"]})]}),/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"col-12 col-lg-7 ".concat(activePriority&&activePriority.length===3?'col-xl-6':'col-xl-8'),children:[/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"accordion d-lg-none accordion__priority",id:"surveyResult_2",children:activePriority&&activePriority.map(function(item,index){var itemIndex=index+3;return/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"accordion-item border-0 mb-g",children:[/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"accordion-button ps-2 shadow-sm bg-white justify-content-start rounded","data-target":"collapse".concat(itemIndex),id:"btnCollapse".concat(itemIndex),"data-btnindex":itemIndex,onClick:accordionHandle,"data-parent":"#surveyResult_2",children:[priority_actives[item].icon,/*#__PURE__*/(0,jsx_runtime.jsx)("span",{className:"ms-1",children:priority_actives[item].title}),/*#__PURE__*/(0,jsx_runtime.jsxs)("p",{className:"d-flex align-items-center font-size-sm mb-0 ms-auto",children:[/*#__PURE__*/(0,jsx_runtime.jsx)(chevron_down_ForwardRef,{className:"minus ms-2"}),/*#__PURE__*/(0,jsx_runtime.jsx)(chevron_up_ForwardRef,{className:"plus ms-2"})]})]}),/*#__PURE__*/(0,jsx_runtime.jsx)("div",{id:"collapse".concat(itemIndex),className:"accordion-collapse bg-white mt-1 collapse","data-bs-parent":"#surveyResult_2",children:/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"p-g row align-items-center",children:[/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"col-5 text-center",children:[priority_actives[item].icon,/*#__PURE__*/(0,jsx_runtime.jsx)("strong",{className:"d-block mt-g px-g",children:priority_actives[item].title})]}),/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"col-7 text-center border-start",children:priority_actives[item].desc})]})})]},index);})}),/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"row d-none d-lg-flex px-lg-hg",children:activePriority&&activePriority.map(function(item,index){return/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"".concat(activePriority.length===3?'col-lg-4':'col-lg-3'," px-lg-hg"),children:/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"pt-2 px-g bg-white text-center h-100",children:[priority_actives[item].icon,/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"fw-bold border-bottom py-g",children:priority_actives[item].title}),/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"pt-2 pb-3",children:priority_actives[item].desc})]})},index);})})]})]})})}),/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"container px-g mt-4 mb-g",children:/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"row",children:[/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"col-12 ".concat(resultProducts.length===3?'col-lg-12':'col-lg-12'),children:[/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"survey-result__product fw-bold mb-2",children:"Your Skincare Essentials"}),/*#__PURE__*/(0,jsx_runtime.jsx)("p",{children:"Below are the essential products for your skin based off your skin analysis:"})]}),/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"col-12 mt-4  ".concat(resultProducts.length===3?'col-lg-12 mt-4':'col-lg-12'),children:/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"row",id:"accordion__products",children:resultProducts.length>0&&resultProducts.map(function(item,index){return/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"col-12 ".concat(resultProducts.length===3?'col-lg-4':'col-lg-4'),children:/*#__PURE__*/(0,jsx_runtime.jsx)(components_SurveyCard,{accordionHandle:accordionHandle,activePriority:priority_actives[activePriority[index]],productDetail:item,productList:product_list[productsRecommend[index]]})},index);})})})]})})]});};/* harmony default export */ var components_SurveyResult = (SurveyResult);
;// CONCATENATED MODULE: ./src/UI/components/SurveyResultMask.js
var SurveyResultMask_SurveyResult=function SurveyResult(props){var _productDetail,_productDetail$storeD,_productDetail$storeD2,_productDetail$title,_productDetail$storeD3,_productDetail$storeD4,_productDetail$storeD5,_productDetail$storeD6,_productDetail$storeD7,_productDetail$storeD8,_productDetail$storeD9,_productDetail$storeD10;// const [resultProducts, setProducts] = useState([]);
var site=window.site?window.site:'www.sandandsky.com';var productsRecommend=props.answerResult.productsRecommend;console.log(productsRecommend,'testing');var productDetail={};if(productsRecommend){productDetail=product_list[productsRecommend[0]];}var titleRange=getItemRange((_productDetail=productDetail)===null||_productDetail===void 0?void 0:_productDetail.title);var selectedSite=site?site.replace('.sandandsky.com',''):'dev';var storeDomain=selectedSite==='www'?'us':selectedSite;var learnMoreSendGA=function learnMoreSendGA(e){if(typeof fbq==='function'){window.fbq('track','View my results');}if(typeof ttq==='object')window.ttq.track('ClickButton',{content_id:'View my results',content_type:'product'});window.parent.location.href=e.target.href;};var accordionHandle=function accordionHandle(e){var parentId=e.currentTarget.dataset.parent;var btnToggle=document.querySelectorAll("".concat(parentId," .accordion-button"));for(var i=0;i<btnToggle.length;i++){btnToggle[i].classList.remove('collapsed');}var collapse=new bootstrap_esm.Collapse(document.getElementById(e.currentTarget.dataset.target),{toggle:true});var btnIndex=e.currentTarget.dataset.btnindex;document.querySelector("#btnCollapse".concat(btnIndex)).classList.toggle('collapsed');setTimeout(function(){if(collapse._element.classList.contains('show')){document.getElementById("collapse".concat(btnIndex)).classList.remove('collapsed');}else{document.querySelector("#btnCollapse".concat(btnIndex)).classList.toggle('collapsed');}var height=document.querySelector('.survey-content').clientHeight;postIframeHeight('height',height,site);},390);};var resultProducts=[];if(productsRecommend){for(var i=0;i<=productsRecommend.length-1;i+=1){var productInfo=product_list[productsRecommend[i]];resultProducts.push(productInfo);}}return/*#__PURE__*/(0,jsx_runtime.jsx)("section",{className:"survey-result mt-4 mt-lg-0",children:/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"survey-result__bg",children:/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"container px-2 py-4",children:/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"row",children:[/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"col-12 col-lg-6 col-xl-6",children:[/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"h1 mb-2",children:"Your Recommended Mask"}),/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"survey-result__subtitle",dangerouslySetInnerHTML:{__html:productDetail.description}})]}),/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"col-12 col-lg-6 col-xl-6",children:/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"survey-result__product-list",children:/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"container p-g my-g",children:[/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"row",children:[/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"col-6",children:/*#__PURE__*/(0,jsx_runtime.jsx)("a",{href:"https://".concat(selectedSite,".sandandsky.com/products/").concat(productDetail.handle),"aria-label":productDetail.title,children:/*#__PURE__*/(0,jsx_runtime.jsxs)("picture",{children:[/*#__PURE__*/(0,jsx_runtime.jsx)("source",{srcSet:(_productDetail$storeD=productDetail[storeDomain])===null||_productDetail$storeD===void 0?void 0:_productDetail$storeD.image2.replace('236x404','186x322'),media:"(min-width: 992px)"}),/*#__PURE__*/(0,jsx_runtime.jsx)("img",{src:(_productDetail$storeD2=productDetail[storeDomain])===null||_productDetail$storeD2===void 0?void 0:_productDetail$storeD2.image2,alt:productDetail.title,className:"w-100 mb-3"})]})})}),/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"col-6 ps-lg-0",children:[/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"font-size-sm mb-0",children:titleRange}),/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"mb-1 fw-bold",children:(_productDetail$title=productDetail.title)===null||_productDetail$title===void 0?void 0:_productDetail$title.replace(titleRange,'').trim()}),/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"accordion border-top border-bottom",children:[/*#__PURE__*/(0,jsx_runtime.jsxs)("button",{className:"accordion-button shadow-none bg-transparent text-body px-0 border-0 py-2 mb-0 d-flex justify-content-between font-size-sm","data-target":"collapse".concat((_productDetail$storeD3=productDetail[storeDomain])===null||_productDetail$storeD3===void 0?void 0:_productDetail$storeD3.id),id:"btnCollapse".concat((_productDetail$storeD4=productDetail[storeDomain])===null||_productDetail$storeD4===void 0?void 0:_productDetail$storeD4.id),"data-btnindex":(_productDetail$storeD5=productDetail[storeDomain])===null||_productDetail$storeD5===void 0?void 0:_productDetail$storeD5.id,onClick:accordionHandle,"data-parent":"#accordion__products",children:["How to Use",/*#__PURE__*/(0,jsx_runtime.jsx)(plus_ForwardRef,{className:"minus"}),/*#__PURE__*/(0,jsx_runtime.jsx)(minus_ForwardRef,{className:"plus"})]}),/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"collapse show",id:"collapse".concat((_productDetail$storeD6=productDetail[storeDomain])===null||_productDetail$storeD6===void 0?void 0:_productDetail$storeD6.id),"data-bs-parent":"#accordion__products",children:/*#__PURE__*/(0,jsx_runtime.jsx)("p",{className:"mb-0 pb-2",children:productDetail.howto})})]}),/*#__PURE__*/(0,jsx_runtime.jsxs)("div",{className:"d-flex mt-g mb-3",children:[((_productDetail$storeD7=productDetail[storeDomain])===null||_productDetail$storeD7===void 0?void 0:_productDetail$storeD7.compare_at_price)&&/*#__PURE__*/(0,jsx_runtime.jsx)("span",{className:"text-decoration-line-through me-1 text-muted",children:(_productDetail$storeD8=productDetail[storeDomain])===null||_productDetail$storeD8===void 0?void 0:_productDetail$storeD8.compare_at_price}),((_productDetail$storeD9=productDetail[storeDomain])===null||_productDetail$storeD9===void 0?void 0:_productDetail$storeD9.price)&&/*#__PURE__*/(0,jsx_runtime.jsx)("span",{className:"text-primary fw-bold",children:(_productDetail$storeD10=productDetail[storeDomain])===null||_productDetail$storeD10===void 0?void 0:_productDetail$storeD10.price})]})]})]}),/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"row",children:/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"col-12",children:/*#__PURE__*/(0,jsx_runtime.jsx)("a",{href:"https://".concat(selectedSite,".sandandsky.com/products/").concat(productDetail.handle),className:"btn btn-block btn-primary w-100","data-title":productDetail.title,onClick:learnMoreSendGA,children:"Learn More"})})})]})})})]})})})});};/* harmony default export */ var SurveyResultMask = (SurveyResultMask_SurveyResult);
;// CONCATENATED MODULE: ./src/UI/templates/SurveyResultTemplate.js
window.getCookie=Utils_getCookie;var SurveyResultTemplate=function SurveyResultTemplate(props){var targetRef=(0,react.useRef)();// const { width, height } = useResizeDetector({ targetRef });
// useEffect(() => {
// 	postIframeHeight('height', height, site);
// }, [height]);
var answerResult=Utils_getCookie('surveyResult')?JSON.parse(Utils_getCookie('surveyResult')):{};// console.log(answerResult, 'answer result testing');
return/*#__PURE__*/(0,jsx_runtime.jsx)("div",{ref:targetRef,className:"overflow-hidden",children:/*#__PURE__*/(0,jsx_runtime.jsx)("div",{className:"row justify-content-center survey-content align-content-start",children:props.quizType==='mask'?/*#__PURE__*/(0,jsx_runtime.jsx)(SurveyResultMask,{answerResult:answerResult}):/*#__PURE__*/(0,jsx_runtime.jsx)(components_SurveyResult,{answerResult:answerResult})})});};/* harmony default export */ var templates_SurveyResultTemplate = (SurveyResultTemplate);
;// CONCATENATED MODULE: ./src/modules/mask-questions.js
var mask_questions_Questions=[{question:"How does your skin feel most days?",questionNote:"*Choose 1",answers:['Dry and flaky','Tends to get oily throughout the day','A combination of oily and dry on different areas','Red and sensitive with uneven texture','Normal and flawless'],type:'SingleChoice',inputType:'Button',showAllLabel:null,category:'',btnClass:'btn__choice-bigger'},{question:"About how many glasses of water do you drink per day?",questionNote:"*Choose 1",answers:['3 or less','4 to 6','7 to 9','More than 10'],type:'SingleChoice',inputType:'Button',showAllLabel:null,category:'',btnClass:'btn__choice-bigger',buttonType:'full'},{question:"What is your local climate like?",questionNote:"*Choose 1",answers:['Dry','Neutral','Humid & Hot','Seasonal'],type:'SingleChoice',inputType:'Button',showAllLabel:null,category:'',btnClass:'btn__choice-bigger',buttonType:'full'},{question:"What is your main concern?",questionNote:"*Choose 1",answers:['Clogged and enlarged pores','Dull skin with fine lines and wrinkles','Dark spots or hyperpigmentation','Dehydrated and flaky skin','Acne and/or skin inflammation','Excess oil'],type:'SingleChoice',inputType:'Button',showAllLabel:null,category:'',btnClass:'btn__choice-bigger'}];/* harmony default export */ var mask_questions = ((/* unused pure expression or super */ null && (mask_questions_Questions)));
;// CONCATENATED MODULE: ./src/UI/components/EmailForm2.js
var EmailForm2_EmailForm=function EmailForm(props){var onSubmit=props.onSubmit,skipEmail=props.skipEmail;var _useState=useState(''),_useState2=_slicedToArray(_useState,2),email=_useState2[0],setEmail=_useState2[1];var _useState3=useState(false),_useState4=_slicedToArray(_useState3,2),isValidEmail=_useState4[0],setIsValidEmail=_useState4[1];var _useState5=useState(false),_useState6=_slicedToArray(_useState5,2),termChecked=_useState6[0],setTermCheck=_useState6[1];var onEmailChange=function onEmailChange(e){setIsValidEmail(validateEmail(e.target.value));setEmail(e.target.value);};var onCheckTerm=function onCheckTerm(e){setTermCheck(e.target.checked);};var submitEmail=function submitEmail(e){onSubmit(email);e.preventDefault();};return/*#__PURE__*/_jsxs("div",{className:"col-12 col-lg-6 mt-4 pt-0 pt-lg-4 text-center",children:[/*#__PURE__*/_jsx("p",{className:"h1 mb-0",children:"We found your perfect mask"}),/*#__PURE__*/_jsx("p",{className:"mt-2 h4 fw-normal mx-3",dangerouslySetInnerHTML:{__html:"We've got your routine ready! Enter your email to view your results and get 15% OFF your first purchase."}}),/*#__PURE__*/_jsx("div",{className:"col-12 col-lg-8 ms-auto me-auto mt-4",children:/*#__PURE__*/_jsx("div",{className:"form-group"})}),/*#__PURE__*/_jsx("div",{className:"footer-action w-100 pb-2 bg-white mt-4",children:/*#__PURE__*/_jsx("a",{href:"#",className:"d-block text-underline text-black w-100 mt-5 mb-lg-4",onClick:skipEmail,children:"Continue"})})]});};/* harmony default export */ var EmailForm2 = ((/* unused pure expression or super */ null && (EmailForm2_EmailForm)));
;// CONCATENATED MODULE: ./src/UI/components/ResultContent2.js
var ResultContent2_ResultContent=function ResultContent(props){var viewMyResult=props.viewMyResult;return/*#__PURE__*/_jsxs("div",{className:"col-12 col-lg-6 mt-4 pt-0 pt-lg-4 text-center",children:[/*#__PURE__*/_jsxs("p",{className:"h1",children:["Thanks!",/*#__PURE__*/_jsx("br",{}),"Here is your promo code:"]}),/*#__PURE__*/_jsxs("div",{className:"col-12 col-lg-8 ms-auto me-auto mt-2",children:[/*#__PURE__*/_jsx("span",{className:"h1 px-4 py-1 text-primary rounded p-2 bg-light-gray d-inline-block bg-primary-light",children:"MASK15"}),/*#__PURE__*/_jsx("p",{className:"mt-2",children:"No minimum spend, 15% off single full-sized masks only!"}),/*#__PURE__*/_jsx("button",{className:"mt-2 btn btn-lg btn-primary w-100",onClick:viewMyResult,children:"View my results"})]})]});};/* harmony default export */ var ResultContent2 = ((/* unused pure expression or super */ null && (ResultContent2_ResultContent)));
;// CONCATENATED MODULE: ./src/UI/templates/SurveyMask.js
window.getCookie=Utils_getCookie;var SurveyMask=function SurveyMask(){var _useSearchParams=useSearchParams(),_useSearchParams2=_slicedToArray(_useSearchParams,1),searchParams=_useSearchParams2[0];var site=window.site?window.site:'www.sandandsky.com';var pageResult=window.pageResult?window.pageResult:'/pages/survey-result-mask/';var gId=getCookie('_ga');var surveyState='start';var targetRef=useRef();// INITIAL DATA
var initialState=getCookie('surveyPosition')||'start';if(surveyState==='started'&&(getCookie('surveyPosition')==='start'||getCookie('surveyPosition')===null||getCookie('surveyPosition')==='')){// //postMessageData(site, 'SurveyMask', 'started');
initialState='question-1';setCookie('answeredQuestion','');}var initialCurrentQuestion=getCookie('currentQuestion')?parseInt(getCookie('currentQuestion'),10):1;var initialSubmitted=getCookie('quizEmail')?true:false;var answerData=getCookieAnsweredQuestion('getCookieAnsweredQuestionMask')?getCookieAnsweredQuestion('getCookieAnsweredQuestionMask'):{};// INITIAL STATES
var _useState=useState(initialState),_useState2=_slicedToArray(_useState,2),currentPosition=_useState2[0],setPosition=_useState2[1];var _useState3=useState(initialCurrentQuestion),_useState4=_slicedToArray(_useState3,2),currentQuestion=_useState4[0],setQuestion=_useState4[1];var _useState5=useState(answerData),_useState6=_slicedToArray(_useState5,2),currentAnswer=_useState6[0],setAnswer=_useState6[1];var _useState7=useState(initialSubmitted),_useState8=_slicedToArray(_useState7,2),submitted=_useState8[0],setSubmitted=_useState8[1];var _useState9=useState(false),_useState10=_slicedToArray(_useState9,2),redirect=_useState10[0],setRedirect=_useState10[1];var _useState11=useState(''),_useState12=_slicedToArray(_useState11,2),email=_useState12[0],setEmail=_useState12[1];var additionalStep=true;var classes=currentPosition!=='result'?'px-g':'overflow-hidden';var startQuiz=function startQuiz(){// //postMessageData(site, 'SurveyMask', 'started');
setPosition('question-1');};var setFinished=function setFinished(){setCookie('surveyPosition','finished');setPosition('finished');};var clearCookie=function clearCookie(){setCookie('currentQuestion',1);setCookie('surveyPosition','start');setCookie('answeredQuestion','');postMessageCookie(site,'currentQuestion',1);postMessageCookie(site,'surveyPosition','start');postMessageCookie(site,'answeredQuestion','');};var answerAction=function answerAction(question,answers){currentAnswer[question]=answers;setAnswer(decodeAnswers(currentAnswer));setCookieAnsweredQuestion(site,decodeAnswers(currentAnswer));};var skipEmail=function skipEmail(){// gettingResult(true, true);
setSubmitted(true);};var viewMyResult=function viewMyResult(){setRedirect(true);postMessageGaParent();gettingResult(true);};var onSubmit=function onSubmit(emailtoSave){setCookie('quizEmail',emailtoSave);setEmail(emailtoSave);setSubmitted(true);postMessageToParentCookie(site,'quizEmail',email,site);setTimeout(function(){saveData();});if(window.top!==window.self){window.parent.postMessage({'func':'callGaEvent','category':'SurveyMask','action':'submitEmail','label':email},"https://".concat(site));}};var setQuestionState=function setQuestionState(questionIndex){if(questionIndex<=Questions.length){var targetQuestion=Questions[questionIndex];if(targetQuestion&&targetQuestion.rule&&targetQuestion.rule.skipped){var targetAnswer=decodeAnswers(currentAnswer)[targetQuestion.rule.question];if(targetAnswer===targetQuestion.rule.answer){answerAction(questionIndex,'');var targetQuestionIndex=currentQuestion<questionIndex?questionIndex+1:questionIndex-1;setQuestion(targetQuestionIndex);}else{setQuestion(questionIndex);}}else{setQuestion(questionIndex);}}else if(questionIndex>=Questions.length){console.log('finish',currentPosition);postMessageGaParent();if(additionalStep){setFinished();if(submitted)gettingResult(true);}}};var saveData=function saveData(){console.log('email to save',getCookie('quizEmail'));var dataForSaving={};for(var _i=0,_Object$entries=Object.entries(currentAnswer);_i<_Object$entries.length;_i++){var _Object$entries$_i=_slicedToArray(_Object$entries[_i],2),key=_Object$entries$_i[0],value=_Object$entries$_i[1];var idxQ=key-1;if(Questions[idxQ]){var questionText="".concat(key,": ").concat(Questions[idxQ].question);dataForSaving[questionText]=value;}}var _getMaskProductResult=getMaskProductResult(Questions,currentAnswer),productsRecommend=_getMaskProductResult.productsRecommend;var productHandle=[];var productSkus=[];var sku='';productsRecommend.forEach(function(item,index){productHandle.push(productList[item].handle);productSkus.push(productList[item].sku);sku="".concat(sku).concat(index===0?'':',').concat(productList[item].sku);});var data={_ga:gId,questions_answers:dataForSaving,email:getCookie('quizEmail'),sku:sku,quiz_type:'mask'};fetch('https://api.sandandsky.com/surveys',{method:'POST',headers:{'Accept':'application/json','Content-Type':'application/json'},body:JSON.stringify(data)});};var postMessageGaParent=function postMessageGaParent(){if(window.top===window.self)return;var gaAnswers=decodeAnswers(currentAnswer);var keys=Object.keys(gaAnswers);//postMessageData(site, 'SurveyMask', 'completed');
postMessageCookie(site,'surveySubmitNew','true');keys.forEach(function(key,index){var q=Questions[index];var a=gaAnswers[key];var label=q.question;var action=typeof a==='object'?a.join(','):a;//postMessageData(site, 'SurveyMask', action, label);
});};var gettingResult=function gettingResult(){var close=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var save=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var selectedSite=site?site:'dev.sandandsky.com';var _getMaskProductResult2=getMaskProductResult(Questions,currentAnswer),productsRecommend=_getMaskProductResult2.productsRecommend;console.log('currentAnswer',currentAnswer,productsRecommend);if(save)saveData();if(close){var _surveyResultObj;setCookie('surveyPosition','finished');setPosition('finished');postMessageCookie(site,'surveyPosition','finished');var productHandle=[];var productSkus=[];productsRecommend.forEach(function(item,index){productHandle.push(productList[item].handle);productSkus.push(productList[item].sku);});var surveyResultObj=(_surveyResultObj={productsRecommend:productsRecommend,productHandle:productHandle,productSkus:productSkus},_defineProperty(_surveyResultObj,"productHandle",productHandle),_defineProperty(_surveyResultObj,"productSkus",productSkus),_surveyResultObj);var surveyResultJson=JSON.stringify(surveyResultObj);setCookie('surveyResult',surveyResultJson);postMessageCookie(site,'surveyResult',surveyResultJson);setTimeout(function(){setCookie('surveyPosition','result');setPosition('result');postMessageCookie(site,'surveyPosition','result');setCookie('surveyResult',surveyResultJson);postMessageCookie(site,'surveyResult',surveyResultJson);clearCookie();window.location.href="https://".concat(selectedSite).concat(pageResult);},1500);}};return/*#__PURE__*/_jsx("div",{ref:targetRef,className:"survey-mask ".concat(currentPosition==='start'?'cover':classes," ").concat(currentPosition!=='result'&&currentPosition!=='start'?'container':''),children:/*#__PURE__*/_jsxs("div",{className:"row justify-content-center survey-content ".concat(currentPosition==='start'?'survey-content__start pt-4':'align-content-start'," "),children:[currentPosition==='start'&&/*#__PURE__*/_jsx(_Fragment,{children:/*#__PURE__*/_jsxs("div",{className:"survey-mask__start-screen text-center mt-7 mt-lg-3",children:[/*#__PURE__*/_jsx("img",{className:"tooltip",src:"https://imagedelivery.net/ghVX8djKS3R8-n0oGeWHEA/5d327fa8-3567-48a0-177f-0f28bcaa3300/828x"}),/*#__PURE__*/_jsx("h1",{children:"Mask Quiz"}),/*#__PURE__*/_jsx("button",{className:"btn btn-primary text-white",onClick:function onClick(){return startQuiz();},children:"Get Started"})]})}),currentPosition!=='start'&&currentPosition!=='finished'&&currentPosition!=='result'&&/*#__PURE__*/_jsx(_Fragment,{children:/*#__PURE__*/_jsx("div",{className:"text-center position-relative",children:Questions.map(function(item,index){var key="question-".concat(index);if(currentQuestion===index+1){switch(item.type){case'MultipleChoice':return/*#__PURE__*/_jsx(QuestionBox,{currentAnswer:decodeAnswers(currentAnswer),totalQuestions:item.answers.length,totalSteps:Questions.length,answerAction:answerAction,setCurrentQuestion:setQuestionState,currentQuestion:currentQuestion,colSize:"col-lg-8 offset-lg-2 col-xl-6 offset-xl-3",question:item.question,questionNote:item.questionNote,caption:item.caption?item.caption:'',captionClass:item.captionClass?item.captionClass:'',category:item.category,progressBarType:"2",children:/*#__PURE__*/_jsx(MultipleChoice,{answers:item.answers,lastFull:item.lastFull,maxChoose:item.maxChoose,lastDisableForAll:item.lastDisableForAll,btnClass:item.btnClass})},key);default:return/*#__PURE__*/_jsx(QuestionBox,{currentAnswer:decodeAnswers(currentAnswer)// width={width}
// height={height}
,totalQuestions:item.answers.length,answerAction:answerAction,setCurrentQuestion:setQuestionState,currentQuestion:currentQuestion,totalSteps:Questions.length,colSize:"col-lg-8 offset-lg-2 col-xl-6 offset-xl-3",question:item.question,questionNote:item.questionNote,caption:item.caption?item.caption:'',captionClass:item.captionClass?item.captionClass:'',category:item.category,defaultEnabled:item.inputType==='RangeSlider'?true:null,quizType:"mask",progressBarType:"2",children:/*#__PURE__*/_jsx(SingleChoice,{answers:item.answers,buttonType:item.buttonType,inputType:item.inputType,showAllLabel:item.showAllLabel,btnClass:item.btnClass})},key);}}})})}),currentPosition==='finished'&&!submitted&&!redirect&&/*#__PURE__*/_jsxs("div",{className:"col-12 col-lg-6 mt-4 pt-0 pt-lg-4 text-center",children:[/*#__PURE__*/_jsx("p",{className:"h1 mb-0",children:"We found your perfect mask"}),/*#__PURE__*/_jsx("p",{className:"mt-2 h4 fw-normal mx-3",dangerouslySetInnerHTML:{__html:"We've got your routine ready! Enter your email to view your results and get 15% OFF your first purchase."}}),/*#__PURE__*/_jsx("div",{className:"footer-action w-100 pb-2 bg-white mt-4",children:/*#__PURE__*/_jsx("a",{href:"#",className:"d-block text-underline text-black w-100 mt-5 mb-lg-4",onClick:skipEmail,children:"Continue"})})]}),currentPosition==='finished'&&submitted&&!redirect&&/*#__PURE__*/_jsx(ResultContent,{viewMyResult:viewMyResult}),(currentPosition==='finished'||currentPosition==='result')&&redirect&&/*#__PURE__*/_jsxs("div",{className:"question-box analyzing d-flex justify-content-center align-items-center flex-column",children:[/*#__PURE__*/_jsx("p",{className:"question-box__title",children:"Analysing your answers"}),/*#__PURE__*/_jsx(LoaderSvg,{className:"loader mt-0 mb-0"})]})]})});};/* harmony default export */ var templates_SurveyMask = ((/* unused pure expression or super */ null && (SurveyMask)));
;// CONCATENATED MODULE: ./src/App.js
// const ProductDetail = lazy(() => import('./UI/templates/ProductDetail'));
// const ApcRange = lazy(() => import('./UI/templates/ApcRange'));
// const AmazonRange = lazy(() => import('./UI/templates/AmazonRange'));
var App=function App(){return/*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment,{children:/*#__PURE__*/(0,jsx_runtime.jsx)(templates_SurveyResultTemplate,{})});};/* harmony default export */ var src_App = (App);
// EXTERNAL MODULE: ./src/vendor/bootstrap.bundle.js
var bootstrap_bundle = __webpack_require__(256);
;// CONCATENATED MODULE: ./src/index.js
// import '../src/style.scss';
// import Popper from '@popperjs/core';
react_dom.render(/*#__PURE__*/(0,jsx_runtime.jsx)(BrowserRouter,{children:/*#__PURE__*/(0,jsx_runtime.jsx)(src_App,{})}),document.getElementById('root'));
}();
/******/ })()
;
//# sourceMappingURL=skin-quiz-result.js.map